webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* unused harmony export reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var config = {

  pixelRatio: {
    targetFps: 40,
    step: 0.25,
    auto: false,
    start: 1,

    min: 0.5,
    max: 2
  },

  skipEnterButton: false,
  skipIntro: false,
  skipResults: false,
  skipToStage2: false,
  skipToSlowWorld: false,
  skipToSpeedWorld: false,

  controlsMultiplier: 3.5,


  uiUpdateInterval: 34,
  worldScale: 1,
  introScale: 10,

  velocityMin: 3,

  velocityMax: 100,
  velocityOffset: 5,
  swipeAddVelocity: 0.06,
  maxBaseVelocity: 12,

  numRunners: 8,
  maxRunnerOffset: 2,
  runnerOffset: 1.25,
  cpuVel: {
    min: 12,
    max: 50
  },

  introDistance: 0.997,
  startDistance: 0.997,

  totalPx: 3000000,
  numLaps: 1,

  helpModeAvailable: true,
  helpTime: 3000,

  stage0Length: 0.10,
  stage1Length: 0.37,
  stage2Length: 0.388,

  stage1RankLimit: 5,
  breakScale: 1.001 };
var initialConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({}, config);

var reset = function reset(delta) {
  config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({}, initialConfig);
  config.reset = reset;
};
config.reset = reset;

/* harmony default export */ __webpack_exports__["b"] = (config);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/lib/delay-promise.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var delayPromise = function delayPromise(duration) {
  return function () {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        resolve();
      }, duration);
    });
  };
};
/* harmony default export */ var delay_promise_defaultExport = (delayPromise);
// CONCATENATED MODULE: ./src/components/game/loader.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assets", function() { return assets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sizes", function() { return sizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadingManager", function() { return loadingManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "progress", function() { return progress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProgress", function() { return getProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerSize", function() { return registerSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTotalSize", function() { return getTotalSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "load", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadItem", function() { return loadItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "start", function() { return start; });
/* harmony import */ var loader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var loader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(loader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_extension__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_file_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_promise_queue__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_promise_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_promise_queue__);







var THREE = __webpack_require__(0);





var DataLoader = function (_THREE$Loader) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(DataLoader, _THREE$Loader);

  function DataLoader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, DataLoader);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (DataLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(DataLoader)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(DataLoader, [{
    key: 'load',
    value: function load(url, onLoad, onProgress, onError) {
      var scope = this;

      var loader = new THREE.FileLoader(scope.manager);
      loader.load(url, function (text) {
        onLoad(JSON.parse(text));
      }, onProgress, onError);
    }
  }]);

  return DataLoader;
}(THREE.Loader);

var assets = {};
var sizes = {};
var loaders = {
  jpg: THREE.ImageLoader,
  json: DataLoader,
  ttf: DataLoader,
  otf: DataLoader,
  m4a: THREE.AudioLoader,
  mp3: THREE.AudioLoader,
  mp4: THREE.AudioLoader,
  ogg: THREE.AudioLoader,
  png: THREE.ImageLoader,
  three: THREE.ObjectLoader,
  obj: THREE.OBJLoader,
  mtl: THREE.MTLLoader,
  dae: THREE.ColladaLoader,
  two: THREE.JSONLoader,
  wav: THREE.AudioLoader
};

var loadingManager = new THREE.LoadingManager();
/* harmony default export */ __webpack_exports__["default"] = (loadingManager);
var progress = 0;

var getProgress = function getProgress() {
  var loaded = 0;
  var total = 0;
  for (var url in assets) {
    var asset = assets[url];
    loaded += asset.progress.loaded;
    total += asset.progress.total;
  }
  if (total > 0) {
    progress = loaded / total;
    __WEBPACK_IMPORTED_MODULE_6_src_store__["a" /* default */].commit('game/loadProgress', progress);
    if (progress >= 1) {
      __WEBPACK_IMPORTED_MODULE_6_src_store__["a" /* default */].commit('game/loadComplete');
    }
  }
  return progress;
};

var registerSize = function registerSize(url, size) {
  sizes[url] = size;
};

var getTotalSize = function getTotalSize() {
  var size = 0;
  for (var key in assets) {
    size += assets[key].progress.total;
  }
  return size;
};

var load = function load(url, loader, onLoaded) {

  var asset = assets[url];

  if (asset && onLoaded) {
    if (asset.result) {
      onLoaded(asset.result);
    } else {
      asset.onLoaded.push(onLoaded);
    }
    return;
  }

  asset = {
    url: url,
    loader: loader,
    onLoaded: [],
    progress: {
      started: false,
      loaded: 0,
      total: sizes[url] || 0,
      percent: 0
    },
    results: null
  };
  assets[url] = asset;
  if (onLoaded) asset.onLoaded.push(onLoaded);
};

var loadItem = function loadItem(asset) {

  return new loader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {

    var onLoad = function onLoad() {
      for (var _len = arguments.length, results = Array(_len), _key = 0; _key < _len; _key++) {
        results[_key] = arguments[_key];
      }

      if (asset.results === null) asset.results = results;

      if (asset.progress.total > 0) {
        if (asset.progress.loaded < asset.progress.total) {
          asset.progress.loaded = asset.progress.total;
        }
      } else {
        asset.progress.total = asset.progress.loaded;
      }
      asset.progress.percent = 1;

      while (asset.onLoaded.length) {
        var cb = asset.onLoaded.pop();
        cb(asset.results);
      }


      getProgress();
      resolve();
    };

    var onProgress = function onProgress(evt) {
      asset.progress.loaded = evt.loaded;
      if (evt.total > 0) {
        asset.progress.total = evt.total;
      }
      if (asset.progress.total > 0) {
        asset.progress.percent = asset.progress.loaded / asset.progress.total;
      }
    };

    var onError = function onError(err) {
      console.error('loader.js', asset.url, err.target.statusText);
    };

    if (asset.progress.started) {
      if (asset.results !== null) {
        onLoad(asset.results);
      }
      resolve();
      return;
    }

    asset.progress.started = true;
    var ext = __WEBPACK_IMPORTED_MODULE_7_file_extension___default.a(asset.url);
    var loader = asset.loader || new loaders[ext](loadingManager);
    loader.load(asset.url, onLoad, onProgress, onError);
  });
};

var start = function start() {

  var totalSize = getTotalSize();
  console.log('Load Size: ' + Math.round(totalSize / 1000) + 'kb');

  var queue = new __WEBPACK_IMPORTED_MODULE_8_promise_queue___default.a(2, Infinity);

  var _loop = function _loop(key) {
    var asset = assets[key];
    queue.add(function () {
      return loadItem(asset).then(function () {
        return new loader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          setTimeout(function () {
            resolve();
          }, 0);
        });
      });
    });
  };

  for (var key in assets) {
    _loop(key);
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export raf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf_loop__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raf_loop__);


var raf = __WEBPACK_IMPORTED_MODULE_0_raf_loop___default.a();
raf.setMaxListeners(6);
raf.start();

/* harmony default export */ __webpack_exports__["a"] = (raf);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(323)

module.exports = {
  build: {
    env: __webpack_require__(152),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: Object({"NODE_ENV":"production"}).npm_config_report,
  },
  dev: {
    env: __webpack_require__(324),
    port: 8082,
    autoOpenBrowser: true,
    assetsSubDirectory: 'fast/static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false,
  },
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/store/browser/mutations.js
var mutations_namespaceObject = {};
__webpack_require__.d(mutations_namespaceObject, "resize", function() { return resize; });
__webpack_require__.d(mutations_namespaceObject, "setCountry", function() { return setCountry; });
__webpack_require__.d(mutations_namespaceObject, "audioPlayable", function() { return audioPlayable; });
__webpack_require__.d(mutations_namespaceObject, "audioBufferable", function() { return audioBufferable; });

var resize = function resize(state, payload) {
  state.windowWidth = payload.width;
  state.windowHeight = payload.height;
};

var setCountry = function setCountry(state, payload) {
  state.country = payload;
  state.isChina = payload === 'CN';
};

var audioPlayable = function audioPlayable(state, payload) {
  state.audio.playable = payload;
};

var audioBufferable = function audioBufferable(state, payload) {
  state.audio.bufferable = payload;
};
// CONCATENATED MODULE: ./src/store/browser/actions.js
var actions_namespaceObject = {};
__webpack_require__.d(actions_namespaceObject, "getCountry", function() { return getCountry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_lib_userinfo_min__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_lib_userinfo_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_src_lib_userinfo_min__);




var getCountry = function getCountry(_ref) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_1_src_lib_userinfo_min___default.a.getInfo(function (data) {
      commit('setCountry', data.country.code);
      resolve();
    });
  });
};
// CONCATENATED MODULE: ./src/store/browser/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_three_examples_js_Detector_js__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_three_examples_js_Detector_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_three_examples_js_Detector_js__);





var state = {
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  isSafari: /Safari/.test(navigator.userAgent),
  isWechat: /micromessenger/i.test(navigator.userAgent),
  isIOS: /(iOS|iPod|iPad|iPhone)/i.test(navigator.userAgent),
  isMobile: /(iPhone|iPad|iPod|Android)/i.test(navigator.userAgent),
  isWebGl: __WEBPACK_IMPORTED_MODULE_3_three_examples_js_Detector_js___default.a.webgl,
  country: null,
  isChina: true,
  audio: {
    playable: false,
    bufferable: false
  }
};

/* harmony default export */ var browser_defaultExport = ({
  namespaced: true,
  state: state,
  mutations: mutations_namespaceObject,
  actions: actions_namespaceObject,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__
});
// CONCATENATED MODULE: ./src/store/wechat/mutations.js
var wechat_mutations_namespaceObject = {};
__webpack_require__.d(wechat_mutations_namespaceObject, "setUsername", function() { return setUsername; });


var setUsername = function setUsername(state, username) {
  state.username = username;
};
// CONCATENATED MODULE: ./src/store/wechat/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__actions__);
/* harmony import */ var wechat___WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(292);
/* harmony import */ var wechat___WEBPACK_IMPORTED_MODULE_2__getters___default = __webpack_require__.n(wechat___WEBPACK_IMPORTED_MODULE_2__getters__);




var wechat_state = {
  username: null
};

/* harmony default export */ var wechat_defaultExport = ({
  namespaced: true,
  state: wechat_state,
  mutations: wechat_mutations_namespaceObject,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  getters: wechat___WEBPACK_IMPORTED_MODULE_2__getters__
});
// CONCATENATED MODULE: ./src/store/game/mutations.js
var game_mutations_namespaceObject = {};
__webpack_require__.d(game_mutations_namespaceObject, "loadProgress", function() { return loadProgress; });
__webpack_require__.d(game_mutations_namespaceObject, "loadComplete", function() { return loadComplete; });
__webpack_require__.d(game_mutations_namespaceObject, "setRanking", function() { return setRanking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


var loadProgress = function loadProgress(state, progress) {
  state.loading.progress = progress;
};

var loadComplete = function loadComplete(state) {
  state.loading.completed = true;
};

var setRanking = function setRanking(state, ranking) {
  state.ranking = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a(state.ranking, ranking);
  state.ranking.percentile = state.ranking.percentile;
};
// CONCATENATED MODULE: ./src/store/game/actions.js
var game_actions_namespaceObject = {};
__webpack_require__.d(game_actions_namespaceObject, "getRank", function() { return getRank; });
/* harmony import */ var actions___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var actions___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(actions___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_config_api__ = __webpack_require__(100);



var getRank = function getRank(_ref, payload) {
  var commit = _ref.commit;


  return new actions___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

    var url = __WEBPACK_IMPORTED_MODULE_1_src_config_api__["a" /* default */].endpoints.getRank;
    if (!payload.time) return reject();
    url += '?time=' + Math.round(payload.time);
    if (payload.name) url += '&name=' + payload.name;
    fetch(url).then(function (response) {
      return response.json();
    }).then(function (json) {
      commit('setRanking', json.ranking);
      resolve();
    });
  });
};
// CONCATENATED MODULE: ./src/store/game/index.js
/* harmony import */ var game___WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(293);
/* harmony import */ var game___WEBPACK_IMPORTED_MODULE_2__getters___default = __webpack_require__.n(game___WEBPACK_IMPORTED_MODULE_2__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url_search_params_polyfill__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_url_search_params_polyfill__);





var debug = "production" !== 'production';


var urlParams = new window.URLSearchParams(window.location.search);
if (urlParams.get('_debug') !== null) debug = true;

var game_state = {

  debug: debug,

  loading: {
    progress: 0,
    completed: false
  },

  gameState: null,

  ranking: {
    position: null,
    total: null,
    percentile: null
  }
};

/* harmony default export */ var game_defaultExport = ({
  namespaced: true,
  state: game_state,
  mutations: game_mutations_namespaceObject,
  actions: game_actions_namespaceObject,
  getters: game___WEBPACK_IMPORTED_MODULE_2__getters__
});
// CONCATENATED MODULE: ./src/store/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    browser: browser_defaultExport,
    wechat: wechat_defaultExport,
    game: game_defaultExport
  },
  strict: "production" !== 'production'
});

if (false) {
  module.hot.accept(['./browser', './wechat', './game'], function () {
    store.hotUpdate({
      modules: {
        browser: require('./browser'),
        wechat: require('./wechat'),
        game: require('./game')
      }
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTRO", function() { return INTRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAGE0", function() { return STAGE0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAGE1", function() { return STAGE1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAGE2_SLOW", function() { return STAGE2_SLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAGE2_FAST", function() { return STAGE2_FAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAGE2_AIRPORT", function() { return STAGE2_AIRPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "END_NORMAL", function() { return END_NORMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "END_START", function() { return END_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "END_SPEED", function() { return END_SPEED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "END_BIKE", function() { return END_BIKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "END_LINE", function() { return END_LINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESULTS", function() { return RESULTS; });
var INTRO = 0;
var STAGE0 = 1;
var STAGE1 = 2;
var STAGE2_SLOW = 3;
var STAGE2_FAST = 4;
var STAGE2_AIRPORT = 5;
var END_NORMAL = 6;

var END_START = 7;
var END_SPEED = 8;
var END_BIKE = 9;
var END_LINE = 10;

var RESULTS = 11;

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scene */
var THREE = __webpack_require__(0);
var scene = new THREE.Scene();
/* harmony default export */ __webpack_exports__["a"] = (scene);
window.scene = scene;

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camera__ = __webpack_require__(58);
var THREE = __webpack_require__(0);


var listener = new THREE.AudioListener();
/* harmony default export */ __webpack_exports__["a"] = (listener);


__WEBPACK_IMPORTED_MODULE_0__camera__["a" /* default */].add(listener);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/lib/Wagner-master/Wagner.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);



var Wagner_THREE = __webpack_require__(0);

var Wagner_WAGNER = Wagner_WAGNER || {};

Wagner_WAGNER.vertexShadersPath = './vertex-shaders';
Wagner_WAGNER.fragmentShadersPath = './fragment-shaders';
Wagner_WAGNER.assetsPath = './assets';

Wagner_WAGNER.log = function () {};

Wagner_WAGNER.Composer = function (renderer, settings) {

	this.width = 1;
	this.height = 1;

	this.settings = settings || {};
	this.useRGBA = this.settings.useRGBA || false;

	this.renderer = renderer;
	this.copyPass = new Wagner_WAGNER.CopyPass(this.settings);

	this.scene = new Wagner_THREE.Scene();
	this.quad = new Wagner_THREE.Mesh(new Wagner_THREE.PlaneBufferGeometry(1, 1), this.defaultMaterial);
	this.scene.add(this.quad);
	this.camera = new Wagner_THREE.OrthographicCamera(1, 1, 1, 1, -10000, 10000);

	this.front = new Wagner_THREE.WebGLRenderTarget(1, 1, {
		minFilter: this.settings.minFilter !== undefined ? this.settings.minFilter : Wagner_THREE.LinearFilter,
		magFilter: this.settings.magFilter !== undefined ? this.settings.magFilter : Wagner_THREE.LinearFilter,
		wrapS: this.settings.wrapS !== undefined ? this.settings.wrapS : Wagner_THREE.ClampToEdgeWrapping,
		wrapT: this.settings.wrapT !== undefined ? this.settings.wrapT : Wagner_THREE.ClampToEdgeWrapping,
		format: this.useRGBA ? Wagner_THREE.RGBAFormat : Wagner_THREE.RGBFormat,
		type: this.settings.type !== undefined ? this.settings.type : Wagner_THREE.UnsignedByteType,
		stencilBuffer: this.settings.stencilBuffer !== undefined ? this.settings.stencilBuffer : true
	});

	this.back = this.front.clone();

	this.startTime = Date.now();

	this.passes = {};
};

Wagner_WAGNER.Composer.prototype.linkPass = function (id, pass) {

	function WagnerLoadPassException(message) {
		this.message = 'Pass "' + id + '" already loaded.';
		this.name = "WagnerLoadPassException";
		this.toString = function () {
			return this.message;
		};
	}

	if (this.passes[id]) {
		throw new WagnerLoadPassException(id, pass);
	}

	this.passes[id] = pass;
};

Wagner_WAGNER.Composer.prototype.swapBuffers = function () {

	this.output = this.write;
	this.input = this.read;

	var t = this.write;
	this.write = this.read;
	this.read = t;
};

Wagner_WAGNER.Composer.prototype.render = function (scene, camera, keep, output) {

	if (this.copyPass.isLoaded()) {
		if (keep) this.swapBuffers();
		this.renderer.render(scene, camera, output ? output : this.write, true);
		if (!output) this.swapBuffers();
	}
};

Wagner_WAGNER.Composer.prototype.toScreen = function () {

	if (this.copyPass.isLoaded()) {
		this.quad.material = this.copyPass.shader;
		this.quad.material.uniforms.tInput.value = this.read;
		this.quad.material.uniforms.resolution.value.set(this.width, this.height);
		this.renderer.render(this.scene, this.camera);
	}
};

Wagner_WAGNER.Composer.prototype.toTexture = function (t) {

	if (this.copyPass.isLoaded()) {
		this.quad.material = this.copyPass.shader;
		this.quad.material.uniforms.tInput.value = this.read;
		this.renderer.render(this.scene, this.camera, t, false);
	}
};

Wagner_WAGNER.Composer.prototype.pass = function (pass) {

	if (pass instanceof Wagner_WAGNER.Stack) {

		this.passStack(pass);
	} else {

		if (typeof pass === 'string') {
			this.quad.material = this.passes[pass];
		}
		if (pass instanceof Wagner_THREE.ShaderMaterial) {
			this.quad.material = pass;
		}
		if (pass instanceof Wagner_WAGNER.Pass) {
			if (!pass.isLoaded()) return;
			pass.run(this);
			return;
		}

		if (!pass.isSim) this.quad.material.uniforms.tInput.value = this.read;

		this.quad.material.uniforms.resolution.value.set(this.width, this.height);
		this.quad.material.uniforms.time.value = 0.001 * (Date.now() - this.startTime);
		this.renderer.render(this.scene, this.camera, this.write, false);
		this.swapBuffers();
	}
};

Wagner_WAGNER.Composer.prototype.passStack = function (stack) {

	stack.getPasses().forEach(function (pass) {

		this.pass(pass);
	}.bind(this));
};

Wagner_WAGNER.Composer.prototype.reset = function () {

	this.read = this.front;
	this.write = this.back;

	this.output = this.write;
	this.input = this.read;
};

Wagner_WAGNER.Composer.prototype.setSource = function (src) {

	if (this.copyPass.isLoaded()) {
		this.quad.material = this.copyPass.shader;
		this.quad.material.uniforms.tInput.value = src;
		this.renderer.render(this.scene, this.camera, this.write, true);
		this.swapBuffers();
	}
};

Wagner_WAGNER.Composer.prototype.setSize = function (w, h) {

	this.width = w;
	this.height = h;

	this.camera.projectionMatrix.makeOrthographic(w / -2, w / 2, h / 2, h / -2, this.camera.near, this.camera.far);
	this.quad.scale.set(w, h, 1);

	this.front.setSize(w, h);
	this.back.setSize(w, h);
};

Wagner_WAGNER.Composer.prototype.defaultMaterial = new Wagner_THREE.MeshBasicMaterial();

Wagner_WAGNER.loadShader = function (file, callback) {

	var oReq = new XMLHttpRequest();
	oReq.onload = function () {
		var content = oReq.responseText;
		callback(content);
	}.bind(this);
	oReq.onerror = function () {

		function WagnerLoadShaderException(f) {
			this.message = 'Shader "' + f + '" couldn\'t be loaded.';
			this.name = "WagnerLoadShaderException";
			this.toString = function () {
				return this.message;
			};
		}
		throw new WagnerLoadShaderException(file);
	};
	oReq.onabort = function () {

		function WagnerLoadShaderException(f) {
			this.message = 'Shader "' + f + '" load was aborted.';
			this.name = "WagnerLoadShaderException";
			this.toString = function () {
				return this.message;
			};
		}
		throw new WagnerLoadShaderException(file);
	};
	oReq.open('get', file, true);
	oReq.send();
};

Wagner_WAGNER.processShader = function (vertexShaderCode, fragmentShaderCode) {

	Wagner_WAGNER.log('Processing Shader | Performing uniform Reflection...');

	var regExp = /uniform\s+([^\s]+)\s+([^\s]+)\s*;/gi;
	var regExp2 = /uniform\s+([^\s]+)\s+([^\s]+)\s*\[\s*(\w+)\s*\]*\s*;/gi;

	var typesMap = {

		sampler2D: { type: 't', value: function value() {
				return new Wagner_THREE.Texture();
			} },
		samplerCube: { type: 't', value: function value() {} },

		bool: { type: 'b', value: function value() {
				return 0;
			} },
		int: { type: 'i', value: function value() {
				return 0;
			} },
		float: { type: 'f', value: function value() {
				return 0;
			} },

		vec2: { type: 'v2', value: function value() {
				return new Wagner_THREE.Vector2();
			} },
		vec3: { type: 'v3', value: function value() {
				return new Wagner_THREE.Vector3();
			} },
		vec4: { type: 'v4', value: function value() {
				return new Wagner_THREE.Vector4();
			} },

		bvec2: { type: 'v2', value: function value() {
				return new Wagner_THREE.Vector2();
			} },
		bvec3: { type: 'v3', value: function value() {
				return new Wagner_THREE.Vector3();
			} },
		bvec4: { type: 'v4', value: function value() {
				return new Wagner_THREE.Vector4();
			} },

		ivec2: { type: 'v2', value: function value() {
				return new Wagner_THREE.Vector2();
			} },
		ivec3: { type: 'v3', value: function value() {
				return new Wagner_THREE.Vector3();
			} },
		ivec4: { type: 'v4', value: function value() {
				return new Wagner_THREE.Vector4();
			} },

		mat2: { type: 'v2', value: function value() {
				return new Wagner_THREE.Matrix2();
			} },
		mat3: { type: 'v3', value: function value() {
				return new Wagner_THREE.Matrix3();
			} },
		mat4: { type: 'v4', value: function value() {
				return new Wagner_THREE.Matrix4();
			} }

	};

	var arrayTypesMap = {
		float: { type: 'fv', value: function value() {
				return [];
			} },
		vec3: { type: 'v3v', value: function value() {
				return [];
			} }
	};

	var matches;
	var uniforms = {
		resolution: { type: 'v2', value: new Wagner_THREE.Vector2(1, 1), default: true },
		time: { type: 'f', value: Date.now(), default: true },
		tInput: { type: 't', value: new Wagner_THREE.Texture(), default: true }
	};

	var uniformType, uniformName, arraySize;

	while ((matches = regExp.exec(fragmentShaderCode)) !== null) {
		if (matches.index === regExp.lastIndex) {
			regExp.lastIndex++;
		}
		uniformType = matches[1];
		uniformName = matches[2];
		Wagner_WAGNER.log('  > SINGLE', uniformType, uniformName);
		uniforms[uniformName] = {
			type: typesMap[uniformType].type,
			value: typesMap[uniformType].value()
		};
	}

	while ((matches = regExp2.exec(fragmentShaderCode)) !== null) {
		if (matches.index === regExp.lastIndex) {
			regExp.lastIndex++;
		}
		uniformType = matches[1];
		uniformName = matches[2];
		arraySize = matches[3];
		Wagner_WAGNER.log('  > ARRAY', arraySize, uniformType, uniformName);
		uniforms[uniformName] = {
			type: arrayTypesMap[uniformType].type,
			value: arrayTypesMap[uniformType].value()
		};
	}

	Wagner_WAGNER.log('Uniform reflection completed. Compiling...');

	var shader = new Wagner_THREE.ShaderMaterial({
		uniforms: uniforms,
		vertexShader: vertexShaderCode,
		fragmentShader: fragmentShaderCode,
		shading: Wagner_THREE.FlatShading,
		depthWrite: false,
		depthTest: false,
		transparent: true
	});

	Wagner_WAGNER.log('Compiled');

	return shader;
};

Wagner_WAGNER.Pass = function () {

	Wagner_WAGNER.log('Pass constructor');
	this.shader = null;
	this.loaded = null;
	this.params = {};
	this.isSim = false;
};

Wagner_WAGNER.Pass.prototype.loadShader = function (id, c) {

	var self = this;
	var vs = 'varying vec2 vUv; void main() { vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 ); }';
	Wagner_WAGNER.loadShader(Wagner_WAGNER.fragmentShadersPath + '/' + id, function (fs) {
		self.shader = Wagner_WAGNER.processShader(vs, fs);

		if (c) c.apply(self);
	});
};

Wagner_WAGNER.Pass.prototype.mapUniforms = function (uniforms) {

	var params = this.params;

	for (var j in uniforms) {
		if (!uniforms[j].default) {
			(function (id) {
				__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default.a(params, id, {
					get: function get() {
						return uniforms[id].value;
					},
					set: function set(v) {
						uniforms[id].value = v;
					},
					configurable: false
				});
			})(j);
		}
	}
};

Wagner_WAGNER.Pass.prototype.run = function (c) {
	c.pass(this.shader);
};

Wagner_WAGNER.Pass.prototype.isLoaded = function () {

	if (this.loaded === null) {
		if (this.shader instanceof Wagner_THREE.ShaderMaterial) {
			this.loaded = true;
		}
	} else {
		return this.loaded;
	}
};

Wagner_WAGNER.Pass.prototype.getOfflineTexture = function (w, h, useRGBA) {

	var rtTexture = new Wagner_THREE.WebGLRenderTarget(w, h, {
		minFilter: Wagner_THREE.LinearFilter,
		magFilter: Wagner_THREE.LinearFilter,
		format: useRGBA ? Wagner_THREE.RGBAFormat : Wagner_THREE.RGBFormat
	});

	return rtTexture;
};

Wagner_WAGNER.CopyPass = function () {

	Wagner_WAGNER.Pass.call(this);
	Wagner_WAGNER.log('CopyPass constructor');
	this.loadShader('copy-fs.glsl');
};

Wagner_WAGNER.CopyPass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(Wagner_WAGNER.Pass.prototype);

Wagner_WAGNER.GenericPass = function (fragmentShaderSource, c) {

	Wagner_WAGNER.Pass.call(this);
	var self = this;
	Wagner_WAGNER.loadShader(Wagner_WAGNER.vertexShadersPath + '/orto-vs.glsl', function (vs) {
		Wagner_WAGNER.loadShader(fragmentShaderSource, function (fs) {
			self.shader = Wagner_WAGNER.processShader(vs, fs);
			if (c) c.apply(self);
		});
	});
};

Wagner_WAGNER.GenericPass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(Wagner_WAGNER.Pass.prototype);

Wagner_WAGNER.Stack = function (shadersPool) {

	this.passItems = [];
	this.shadersPool = shadersPool;
	this.passes = [];
};

Wagner_WAGNER.Stack.prototype.addPass = function (shaderName, enabled, params, index) {

	var length,
	    passItem = {
		shaderName: shaderName,
		enabled: enabled || false,
		params: params
	};

	this.passItems.push(passItem);
	length = this.passItems.length;

	this.updatePasses();

	if (index) {

		return this.movePassToIndex(this.passItems[length], index);
	} else {

		return length - 1;
	}
};

Wagner_WAGNER.Stack.prototype.removePass = function (index) {

	this.passItems.splice(index, 1);
	this.updatePasses();
};

Wagner_WAGNER.Stack.prototype.enablePass = function (index) {

	this.passItems[index].enabled = true;
	this.updatePasses();
};

Wagner_WAGNER.Stack.prototype.disablePass = function (index) {

	this.passItems[index].enabled = false;
	this.updatePasses();
};

Wagner_WAGNER.Stack.prototype.isPassEnabled = function (index) {

	return this.passItems[index].enabled;
};

Wagner_WAGNER.Stack.prototype.movePassToIndex = function (index, destIndex) {

	this.passItems.splice(destIndex, 0, this.passItems.splice(index, 1)[0]);
	this.updatePasses();
	return destIndex;
};

Wagner_WAGNER.Stack.prototype.reverse = function () {

	this.passItems.reverse();
	this.updatePasses();
};

Wagner_WAGNER.Stack.prototype.updatePasses = function () {

	this.passes = this.shadersPool.getPasses(this.passItems);

	this.passItems.forEach(function (passItem, index) {

		if (passItem.params === undefined) {

			passItem.params = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a(this.passes[index].params));
		}
	}.bind(this));
};

Wagner_WAGNER.Stack.prototype.getPasses = function () {

	return this.passes;
};

Wagner_WAGNER.ShadersPool = function () {

	this.availableShaders = [];
};

Wagner_WAGNER.ShadersPool.prototype.getPasses = function (passItems) {

	var pass,
	    passes = [];

	this.availableShaders.forEach(function (availableShader) {

		availableShader.used = false;
	});

	if (passItems) {

		passItems.forEach(function (passItem, index) {

			if (passItem.enabled) {

				pass = this.getShaderFromPool(passItem.shaderName, passItem.params);

				if (passItem.params) {

					pass.params = this.extendParams(pass.params, passItem.params);
				}

				passes.push(pass);
			}
		}.bind(this));
	}

	return passes;
};

Wagner_WAGNER.ShadersPool.prototype.getShaderFromPool = function (shaderName, params) {

	var pass, shaderItem;

	if (shaderName && Wagner_WAGNER[shaderName]) {

		for (var i = this.availableShaders.length - 1; i >= 0; i--) {

			shaderItem = this.availableShaders[i];

			if (!shaderItem.used && shaderItem.name === shaderName) {

				shaderItem.used = true;
				pass = shaderItem.pass;
				break;
			}
		};

		if (!pass) {

			pass = new Wagner_WAGNER[shaderName](params);

			shaderItem = {
				pass: pass,
				name: shaderName,
				used: true
			};

			this.availableShaders.push(shaderItem);
		}

		return pass;
	}
};

Wagner_WAGNER.ShadersPool.prototype.extendParams = function (target, source) {

	var obj = {},
	    i = 0,
	    il = arguments.length,
	    key;

	for (; i < il; i++) {

		for (key in arguments[i]) {

			if (arguments[i].hasOwnProperty(key)) {

				obj[key] = arguments[i][key];
			}
		}
	}

	return obj;
};

window.WAGNER = Wagner_WAGNER;
/* harmony default export */ var Wagner_defaultExport = (Wagner_WAGNER);
// CONCATENATED MODULE: ./src/lib/Wagner-master/Wagner.base.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(69);
/* harmony import */ var Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);


WAGNER = window.WAGNER;

WAGNER.BlendPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('BlendPass constructor');
	this.loadShader('blend-fs.glsl');

	this.params.mode = 1;
	this.params.opacity = 1;
	this.params.tInput2 = null;
	this.params.resolution2 = new THREE.Vector2();
	this.params.sizeMode = 1;
	this.params.aspectRatio = 1;
	this.params.aspectRatio2 = 1;
};

WAGNER.BlendMode = {
	Normal: 1,
	Dissolve: 2,
	Darken: 3,
	Multiply: 4,
	ColorBurn: 5,
	LinearBurn: 6,
	DarkerColor: 7,
	Lighten: 8,
	Screen: 9,
	ColorDodge: 10,
	LinearDodge: 11,
	LighterColor: 12,
	Overlay: 13,
	SoftLight: 14,
	HardLight: 15,
	VividLight: 16,
	LinearLight: 17,
	PinLight: 18,
	HardMix: 19,
	Difference: 20,
	Exclusion: 21,
	Substract: 22,
	Divide: 23
};

WAGNER.BlendPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.BlendPass.prototype.run = function (c) {

	this.shader.uniforms.mode.value = this.params.mode;
	this.shader.uniforms.opacity.value = this.params.opacity;
	this.shader.uniforms.tInput2.value = this.params.tInput2;
	this.shader.uniforms.sizeMode.value = this.params.sizeMode;
	this.shader.uniforms.aspectRatio.value = this.params.aspectRatio;
	this.shader.uniforms.aspectRatio2.value = this.params.aspectRatio2;
	c.pass(this.shader);
};

WAGNER.InvertPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('InvertPass constructor');
	this.loadShader('invert-fs.glsl');
};

WAGNER.InvertPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.SymetricPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('SymetricPass constructor');
	this.loadShader('symetric-fs.glsl');

	this.params.xReverse = false;
	this.params.yReverse = false;
	this.params.xMirror = false;
	this.params.yMirror = false;
	this.params.mirrorCenter = new THREE.Vector2(0.5, 0.5);
	this.params.angle = 0;
};

WAGNER.SymetricPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.SymetricPass.prototype.run = function (c) {

	this.shader.uniforms.xReverse.value = this.params.xReverse;
	this.shader.uniforms.yReverse.value = this.params.yReverse;
	this.shader.uniforms.xMirror.value = this.params.xMirror;
	this.shader.uniforms.yMirror.value = this.params.yMirror;
	this.shader.uniforms.mirrorCenter.value = this.params.mirrorCenter;
	this.shader.uniforms.angle.value = this.params.angle;

	c.pass(this.shader);
};

WAGNER.SepiaPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('SepiaPass constructor');
	this.loadShader('sepia-fs.glsl');

	this.params.amount = 1;
};

WAGNER.SepiaPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.SepiaPass.prototype.run = function (c) {

	this.shader.uniforms.amount.value = this.params.amount;
	c.pass(this.shader);
};

WAGNER.BrightnessContrastPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('BrightnessContrastPass constructor');
	this.loadShader('brightness-contrast-fs.glsl');

	this.params.brightness = 1;
	this.params.contrast = 1;
};

WAGNER.BrightnessContrastPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.BrightnessContrastPass.prototype.run = function (c) {

	this.shader.uniforms.brightness.value = this.params.brightness;
	this.shader.uniforms.contrast.value = this.params.contrast;

	c.pass(this.shader);
};

WAGNER.Pass.prototype.bindUniform = function (p, s, v, c) {

	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default.a(p, v, {
		get: function get() {
			return s.uniforms[id].value;
		},
		set: c,
		configurable: false
	});
};

WAGNER.NoisePass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('Noise Pass constructor');
	this.loadShader('noise-fs.glsl');

	this.params.amount = 0.1;
	this.params.speed = 0;
};

WAGNER.NoisePass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.NoisePass.prototype.run = function (c) {

	this.shader.uniforms.amount.value = this.params.amount;
	this.shader.uniforms.speed.value = this.params.speed;
	c.pass(this.shader);
};

WAGNER.VignettePass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('Vignette Pass constructor');
	this.loadShader('vignette-fs.glsl');

	this.params.amount = 1;
	this.params.falloff = 0.1;
};

WAGNER.VignettePass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.VignettePass.prototype.run = function (c) {

	this.shader.uniforms.amount.value = this.params.amount;
	this.shader.uniforms.falloff.value = this.params.falloff;
	c.pass(this.shader);
};

WAGNER.Vignette2Pass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('Vignette Pass constructor');
	this.loadShader('vignette2-fs.glsl');

	this.params.boost = 2;
	this.params.reduction = 2;
};

WAGNER.Vignette2Pass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.Vignette2Pass.prototype.run = function (c) {

	this.shader.uniforms.boost.value = this.params.boost;
	this.shader.uniforms.reduction.value = this.params.reduction;
	c.pass(this.shader);
};

WAGNER.DenoisePass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('Denoise Pass constructor');
	this.loadShader('denoise-fs.glsl');

	this.params.exponent = 5;
	this.params.strength = 10;
};

WAGNER.DenoisePass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.DenoisePass.prototype.run = function (c) {

	this.shader.uniforms.exponent.value = this.params.exponent;
	this.shader.uniforms.strength.value = this.params.strength;
	c.pass(this.shader);
};

WAGNER.BoxBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('BoxBlurPass Pass constructor');
	this.loadShader('box-blur2-fs.glsl');
	this.params.delta = new THREE.Vector2(0, 0);
	this.params.taps = 1;
};

WAGNER.BoxBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.BoxBlurPass.prototype.run = function (c) {

	this.shader.uniforms.delta.value.copy(this.params.delta);

	c.pass(this.shader);
};

WAGNER.FullBoxBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('FullBoxBlurPass Pass constructor');
	this.boxPass = new WAGNER.BoxBlurPass();
	this.params.amount = 20;
	this.params.taps = 1;
};

WAGNER.FullBoxBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.FullBoxBlurPass.prototype.isLoaded = function () {

	if (this.boxPass.isLoaded()) {
		this.loaded = true;
	}
	return WAGNER.Pass.prototype.isLoaded.call(this);
};

WAGNER.FullBoxBlurPass.prototype.run = function (c) {

	var s = this.params.amount;
	this.boxPass.params.delta.set(s, 0);
	this.boxPass.params.taps = this.params.taps;
	c.pass(this.boxPass);
	this.boxPass.params.delta.set(0, s);
	c.pass(this.boxPass);
};

WAGNER.ZoomBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('ZoomBlurPass Pass constructor');
	this.loadShader('zoom-blur-fs.glsl');

	this.params.center = new THREE.Vector2(0.5, 0.5);
	this.params.strength = 2;
};

WAGNER.ZoomBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.ZoomBlurPass.prototype.run = function (c) {

	this.shader.uniforms.center.value.copy(this.params.center);
	this.shader.uniforms.strength.value = this.params.strength;
	c.pass(this.shader);
};

WAGNER.MultiPassBloomPass = function (w, h) {

	WAGNER.Pass.call(this);
	WAGNER.log('MultiPassBloomPass Pass constructor');

	this.composer = null;

	this.tmpTexture = this.getOfflineTexture(w, h, true);
	this.blurPass = new WAGNER.FullBoxBlurPass();
	this.blendPass = new WAGNER.BlendPass();
	this.zoomBlur = new WAGNER.ZoomBlurPass();
	this.brightnessContrastPass = new WAGNER.BrightnessContrastPass();

	this.width = w || 512;
	this.height = h || 512;

	this.params.blurAmount = 20;
	this.params.applyZoomBlur = false;
	this.params.zoomBlurStrength = 2;
	this.params.useTexture = false;
	this.params.zoomBlurCenter = new THREE.Vector2(0, 0);
	this.params.blendMode = WAGNER.BlendMode.Screen;
};

WAGNER.MultiPassBloomPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.MultiPassBloomPass.prototype.isLoaded = function () {

	if (this.blurPass.isLoaded() && this.blendPass.isLoaded() && this.zoomBlur.isLoaded()) {
		this.loaded = true;
	}
	return WAGNER.Pass.prototype.isLoaded.call(this);
};

WAGNER.MultiPassBloomPass.prototype.run = function (c) {

	if (!this.composer) {
		this.composer = new WAGNER.Composer(c.renderer, { useRGBA: true });
		this.composer.setSize(this.width, this.height);
	}

	this.composer.reset();

	if (this.params.useTexture === true) {
		this.composer.setSource(this.params.glowTexture);
	} else {
		this.composer.setSource(c.output);
	}

	this.blurPass.params.amount = this.params.blurAmount;
	this.composer.pass(this.blurPass);

	if (this.params.applyZoomBlur) {
		this.zoomBlur.params.center.set(.5 * this.composer.width, .5 * this.composer.height);
		this.zoomBlur.params.strength = this.params.zoomBlurStrength;
		this.composer.pass(this.zoomBlur);
	}

	if (this.params.useTexture === true) {
		this.blendPass.params.mode = WAGNER.BlendMode.Screen;
		this.blendPass.params.tInput = this.params.glowTexture;
		c.pass(this.blendPass);
	}

	this.blendPass.params.mode = this.params.blendMode;
	this.blendPass.params.tInput2 = this.composer.output;
	c.pass(this.blendPass);
};

WAGNER.CGAPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('CGA Pass constructor');
	this.loadShader('cga-fs.glsl', function () {
		this.shader.uniforms.pixelDensity.value = window.devicePixelRatio;
	});
};

WAGNER.CGAPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.SobelEdgeDetectionPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('SobelEdgeDetectionPass Pass constructor');
	this.loadShader('sobel-fs.glsl');
};

WAGNER.SobelEdgeDetectionPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.FreiChenEdgeDetectionPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('FreiChenEdgeDetectionPass Pass constructor');
	this.loadShader('frei-chen-fs.glsl');
};

WAGNER.FreiChenEdgeDetectionPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.DirtPass = function () {

	WAGNER.Pass.call(this);
	this.blendPass = new WAGNER.BlendPass();
	this.dirtTexture = THREE.ImageUtils.loadTexture(WAGNER.assetsPath + '/textures/dirt8.jpg');

	this.params.blendMode = WAGNER.BlendMode.SoftLight;
};

WAGNER.DirtPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.DirtPass.prototype.isLoaded = function () {

	if (this.blendPass.isLoaded()) {
		this.loaded = true;
	}
	return WAGNER.Pass.prototype.isLoaded.call(this);
};

WAGNER.DirtPass.prototype.run = function (c) {

	this.blendPass.params.sizeMode = 1;
	this.blendPass.params.mode = this.params.blendMode;
	this.blendPass.params.tInput2 = this.dirtTexture;
	if (this.dirtTexture.image) {
		this.blendPass.params.resolution2.set(this.dirtTexture.image.width, this.dirtTexture.image.height);
		this.blendPass.params.aspectRatio2 = this.dirtTexture.image.width / this.dirtTexture.image.height;
	}
	this.blendPass.params.aspectRatio = c.read.width / c.read.height;
	c.pass(this.blendPass);
};

WAGNER.GuidedBoxBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('GuidedBoxBlurPass Pass constructor');
	this.loadShader('guided-box-blur2-fs.glsl');

	this.params.tBias = null;
	this.params.delta = new THREE.Vector2(1., 0);
	this.params.invertBiasMap = false;
	this.params.isPacked = 0;
	this.params.from = 0;
	this.params.to = 1;
};

WAGNER.GuidedBoxBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.GuidedBoxBlurPass.prototype.run = function (c) {

	this.shader.uniforms.tBias.value = this.params.tBias, this.shader.uniforms.delta.value.copy(this.params.delta);
	this.shader.uniforms.delta.value.multiplyScalar(.0001);
	this.shader.uniforms.invertBiasMap.value = this.params.invertBiasMap;
	this.shader.uniforms.isPacked.value = this.params.isPacked;
	this.shader.uniforms.from.value = this.params.from;
	this.shader.uniforms.to.value = this.params.to;
	c.pass(this.shader);
};

WAGNER.GuidedFullBoxBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('FullBoxBlurPass Pass constructor');
	this.guidedBoxPass = new WAGNER.GuidedBoxBlurPass();

	this.params.tBias = null;
	this.params.invertBiasMap = false;
	this.params.isPacked = 0;
	this.params.amount = 10;
	this.params.from = 0;
	this.params.to = 1;
	this.params.taps = 1;
};

WAGNER.GuidedFullBoxBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.GuidedFullBoxBlurPass.prototype.isLoaded = function () {

	if (this.guidedBoxPass.isLoaded()) {
		this.loaded = true;
	}
	return WAGNER.Pass.prototype.isLoaded.call(this);
};

WAGNER.GuidedFullBoxBlurPass.prototype.run = function (c) {

	this.guidedBoxPass.params.invertBiasMap = this.params.invertBiasMap;
	this.guidedBoxPass.params.isPacked = this.params.isPacked;
	this.guidedBoxPass.params.tBias = this.params.tBias;
	this.guidedBoxPass.params.from = this.params.from;
	this.guidedBoxPass.params.to = this.params.to;
	var s = this.params.amount;
	for (var j = 0; j < this.params.taps; j++) {
		this.guidedBoxPass.params.delta.set(s, 0);
		c.pass(this.guidedBoxPass);
		this.guidedBoxPass.params.delta.set(0, s);
		c.pass(this.guidedBoxPass);
	}
};

WAGNER.PixelatePass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('PixelatePass Pass constructor');
	this.loadShader('pixelate-fs.glsl');

	this.params.amount = 320;
};

WAGNER.PixelatePass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.PixelatePass.prototype.run = function (c) {

	this.shader.uniforms.amount.value = this.params.amount;
	c.pass(this.shader);
};

WAGNER.RGBSplitPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('RGBSplitPass Pass constructor');
	this.loadShader('rgb-split-fs.glsl', function () {});

	this.params.delta = new THREE.Vector2();
};

WAGNER.RGBSplitPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.RGBSplitPass.prototype.run = function (c) {

	this.shader.uniforms.delta.value.copy(this.params.delta);
	c.pass(this.shader);
};

WAGNER.ChromaticAberrationPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('ChromaticAberrationPass Pass constructor');
	this.loadShader('chromatic-aberration-fs.glsl');
};

WAGNER.ChromaticAberrationPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.BarrelBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('BarrelBlurPass Pass constructor');
	this.loadShader('barrel-blur-fs.glsl');
};

WAGNER.BarrelBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.OldVideoPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('OldVideoPass Pass constructor');
	this.loadShader('old-video-fs.glsl');
};

WAGNER.OldVideoPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.DotScreenPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('DotScreenPass Pass constructor');
	this.loadShader('dot-screen-fs.glsl');
};

WAGNER.DotScreenPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.PoissonDiscBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('PoissonDiscBlurPass Pass constructor');
	this.loadShader('poisson-disc-blur-fs.glsl');
};

WAGNER.PoissonDiscBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.CircularBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('CircularBlurPass Pass constructor');
	this.loadShader('circular-blur-fs.glsl');
};

WAGNER.CircularBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.ToonPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('ToonPass Pass constructor');
	this.loadShader('toon-fs.glsl');
};

WAGNER.ToonPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.FXAAPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('FXAA Pass constructor');
	this.loadShader('fxaa-fs.glsl');
};

WAGNER.FXAAPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.HighPassPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('HighPass Pass constructor');
	this.loadShader('high-pass-fs.glsl');
};

WAGNER.HighPassPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.GrayscalePass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('GrayscalePass Pass constructor');
	this.loadShader('grayscale-fs.glsl');
};

WAGNER.GrayscalePass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.ASCIIPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('ASCIIPass Pass constructor');
	this.loadShader('ascii-fs.glsl', function () {
		this.shader.uniforms.tAscii.value = THREE.ImageUtils.loadTexture(WAGNER.assetsPath + '/ascii/8x16_ascii_font_sorted.gif');
	});
};

WAGNER.ASCIIPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.LEDPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('LEDPass Pass constructor');
	this.loadShader('led-fs.glsl', function () {});

	this.params.pixelSize = 10;
	this.params.tolerance = .25;
	this.params.pixelRadius = .25;
	this.params.luminanceSteps = 100;
	this.params.luminanceBoost = .2;
	this.params.colorBoost = .01;
	this.params.burntOutPercent = 50;
};

WAGNER.LEDPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.LEDPass.prototype.run = function (c) {

	this.shader.uniforms.pixelSize.value = this.params.pixelSize;
	this.shader.uniforms.tolerance.value = this.params.tolerance;
	this.shader.uniforms.pixelRadius.value = this.params.pixelRadius;
	this.shader.uniforms.luminanceSteps.value = this.params.luminanceSteps;
	this.shader.uniforms.luminanceBoost.value = this.params.luminanceBoost;
	this.shader.uniforms.colorBoost.value = this.params.colorBoost;
	this.shader.uniforms.burntOutPercent.value = this.params.burntOutPercent;

	c.pass(this.shader);
};

WAGNER.HalftonePass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('HalftonePass Pass constructor');
	this.loadShader('halftone-fs.glsl', function () {
		this.shader.uniforms.pixelSize.value = 6;
	});
};

WAGNER.HalftonePass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.Halftone2Pass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('Halftone2Pass Pass constructor');
	this.loadShader('halftone2-fs.glsl');

	this.params.amount = 128;
	this.params.smoothness = .25;
};

WAGNER.Halftone2Pass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.Halftone2Pass.prototype.run = function (c) {

	this.shader.uniforms.amount.value = this.params.amount;
	this.shader.uniforms.smoothness.value = this.params.smoothness;

	c.pass(this.shader);
};

WAGNER.HalftoneCMYKPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('HalftoneCMYKPass Pass constructor');
	this.loadShader('halftone-cmyk-fs.glsl', function () {});
};

WAGNER.HalftoneCMYKPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.CrossFadePass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('CrossFadePass Pass constructor');
	this.loadShader('crossfade-fs.glsl');

	this.params.tInput2 = null;
	this.params.tFadeMap = null;
	this.params.amount = 0;
};

WAGNER.CrossFadePass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.CrossFadePass.prototype.run = function (c) {

	this.shader.uniforms.tInput2.value = this.params.tInput2;
	this.shader.uniforms.tFadeMap.value = this.params.tFadeMap;
	this.shader.uniforms.amount.value = this.params.amount;

	c.pass(this.shader);
};

WAGNER.SSAOPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('SSAOPass Pass constructor');
	this.loadShader('ssao-fs.glsl', function (fs) {});

	this.params.texture = null;
	this.params.isPacked = false;
	this.params.onlyOcclusion = false;

	this.blurPass = new WAGNER.FullBoxBlurPass();
	this.blendPass = new WAGNER.BlendPass();
	this.composer = null;
};

WAGNER.SSAOPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.SSAOPass.prototype.run = function (c) {

	if (!this.composer) {
		var s = 4;
		this.composer = new WAGNER.Composer(c.renderer, { useRGBA: true });
		this.composer.setSize(c.width / s, c.height / s);
	}

	this.composer.reset();

	this.composer.setSource(c.output);

	this.shader.uniforms.tDepth.value = this.params.texture;

	this.shader.uniforms.onlyOcclusion.value = this.params.onlyOcclusion;
	this.composer.pass(this.shader);

	this.blurPass.params.amount = .1;
	this.composer.pass(this.blurPass);

	if (this.params.onlyOcclusion) {
		c.setSource(this.composer.output);
	} else {
		this.blendPass.params.mode = WAGNER.BlendMode.Multiply;
		this.blendPass.params.tInput2 = this.composer.output;

		c.pass(this.blendPass);
	}
};

WAGNER.SimpleSSAOPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('SimpleSSAOPass Pass constructor');
	this.loadShader('ssao-simple-fs.glsl', function (fs) {});

	this.params.texture = null;
	this.params.onlyOcclusion = 0;
	this.params.zNear = 1;
	this.params.zFar = 10000;
	this.params.strength = 1;
};

WAGNER.SimpleSSAOPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.SimpleSSAOPass.prototype.run = function (c) {

	this.shader.uniforms.tDepth.value = this.params.texture;

	this.shader.uniforms.zNear.value = this.params.zNear;
	this.shader.uniforms.zFar.value = this.params.zFar;
	this.shader.uniforms.strength.value = this.params.strength;

	c.pass(this.shader);
};

WAGNER.DirectionalBlurPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('Directional Blur Pass constructor');
	this.loadShader('guided-directional-blur-fs.glsl', function (fs) {});

	this.params.tBias = null;
	this.params.delta = .1;
};

WAGNER.DirectionalBlurPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.DirectionalBlurPass.prototype.run = function (c) {

	this.shader.uniforms.tBias.value = this.params.tBias;
	this.shader.uniforms.delta.value = this.params.delta;

	c.pass(this.shader);
};

WAGNER.BleachPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('Bleach Pass constructor');
	this.loadShader('bleach-fs.glsl', function (fs) {});

	this.params.amount = 1;
};

WAGNER.BleachPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.BleachPass.prototype.run = function (c) {

	this.shader.uniforms.amount.value = this.params.amount;

	c.pass(this.shader);
};

WAGNER.DOFPass = function () {

	WAGNER.Pass.call(this);
	WAGNER.log('DOFPass Pass constructor');
	this.loadShader('dof-fs.glsl');

	this.params.focalDistance = 0;
	this.params.aperture = .005;
	this.params.tBias = null;
	this.params.blurAmount = 1;
};

WAGNER.DOFPass.prototype = Wagner_base___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a(WAGNER.Pass.prototype);

WAGNER.DOFPass.prototype.run = function (c) {

	this.shader.uniforms.tBias.value = this.params.tBias;
	this.shader.uniforms.focalDistance.value = this.params.focalDistance;
	this.shader.uniforms.aperture.value = this.params.aperture;
	this.shader.uniforms.blurAmount.value = this.params.blurAmount;

	this.shader.uniforms.delta.value.set(1, 0);
	c.pass(this.shader);

	this.shader.uniforms.delta.value.set(0, 1);
	c.pass(this.shader);
};
// CONCATENATED MODULE: ./src/components/game/renderer.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stats", function() { return stats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderer", function() { return renderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxAnisotropy", function() { return maxAnisotropy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "composerw", function() { return composerw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multiPassBloomPass", function() { return multiPassBloomPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zoomBlurPass", function() { return zoomBlurPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noisePass", function() { return noisePass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vignettePass", function() { return vignettePass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chromaticAberrationPass", function() { return chromaticAberrationPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "boxBlurPass", function() { return boxBlurPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "brightnessPass", function() { return brightnessPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "passes", function() { return passes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderGame", function() { return renderGame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderResults", function() { return renderResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRenderGame", function() { return setRenderGame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRenderResults", function() { return setRenderResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stats_js__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stats_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stats_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scene__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__camera__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__camera_ui__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__result_scene__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_scene__ = __webpack_require__(121);

var renderer_THREE = __webpack_require__(0);
window.THREE = renderer_THREE;














var base = __webpack_require__(16).build.assetsPublicPath;



var stats = new __WEBPACK_IMPORTED_MODULE_1_stats_js___default.a();
stats.setMode(0);
stats.domElement.id = 'stats';

var renderer = new renderer_THREE.WebGLRenderer({
  antialias: true,
  alpha: true,
  premultipliedAlpha: true
});
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.autoClear = false;


var ratio = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].pixelRatio.start;

ratio = Math.min(ratio, window.devicePixelRatio);
renderer.setPixelRatio(ratio);
renderer.setClearColor(0x0A0722, 0);
renderer.shadowMap.enabled = true;

renderer.gammaInput = false;
renderer.gammaOutput = false;

var maxAnisotropy = renderer.getMaxAnisotropy();

window.WAGNER.vertexShadersPath = base + 'static/Wagner-master/vertex-shaders';
window.WAGNER.fragmentShadersPath = base + 'static/Wagner-master/fragment-shaders';
window.WAGNER.assetsPath = base + 'static/Wagner-master/assets';

var composerw = new window.WAGNER.Composer(renderer);
composerw.setSize(ratio * window.innerWidth, ratio * window.innerHeight);

var multiPassBloomPass = new window.WAGNER.MultiPassBloomPass();
multiPassBloomPass.params.blurAmount = 0;
multiPassBloomPass.params.useTexture = false;
multiPassBloomPass.params.blendMode = window.WAGNER.BlendMode.Screen;

var zoomBlurPass = new window.WAGNER.ZoomBlurPass();
zoomBlurPass.params.center.set(0.5 * composerw.width, 0.5 * composerw.height);
zoomBlurPass.params.strength = 0;

var noisePass = new window.WAGNER.NoisePass();
noisePass.params.amount = 0.05;
noisePass.params.speed = 0.3;

var vignettePass = new window.WAGNER.VignettePass();
vignettePass.params.amount = 0.4;
vignettePass.params.falloff = 0.1;

var chromaticAberrationPass = new window.WAGNER.ChromaticAberrationPass();

var boxBlurPass = new window.WAGNER.BoxBlurPass();
boxBlurPass.params.delta = new renderer_THREE.Vector2(100, 0);
boxBlurPass.params.taps = 1;

var brightnessPass = new window.WAGNER.BrightnessContrastPass();
brightnessPass.params.brightness = -0.14;

var passes = [multiPassBloomPass, zoomBlurPass, boxBlurPass, brightnessPass];

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(passes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var pass = _step.value;

    pass.enabled = true;
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

var updateSize = function updateSize() {

  var w = __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.browser.windowWidth;
  var h = __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.browser.windowHeight;

  renderer.setSize(w, h);

  composerw.setSize(w * ratio, h * ratio);
  zoomBlurPass.params.center.set(w / 2, h / 2);
};

__WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.browser.windowWidth;
}, updateSize);

__WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.browser.windowHeight;
}, updateSize);

var renderGame = false;
var renderResults = false;

var setRenderGame = function setRenderGame(shouldRender) {
  renderGame = shouldRender;
};
var setRenderResults = function setRenderResults(shouldRender) {
  renderResults = shouldRender;
};

function update(delta) {

  stats.begin();

  if (renderGame) {
    renderer.autoClearColor = true;
    composerw.reset();
    composerw.render(__WEBPACK_IMPORTED_MODULE_3__scene__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__camera__["a" /* default */]);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(passes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _pass = _step2.value;

        if (_pass.enabled) composerw.pass(_pass);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    composerw.toScreen();

    renderer.clearDepth();
    renderer.render(__WEBPACK_IMPORTED_MODULE_9__ui_scene__["scene"], __WEBPACK_IMPORTED_MODULE_7__camera_ui__["a" /* camera */]);
  }

  if (renderResults) {
    renderer.clearDepth();
    renderer.render(__WEBPACK_IMPORTED_MODULE_8__result_scene__["scene"], __WEBPACK_IMPORTED_MODULE_7__camera_ui__["a" /* camera */]);
  }

  stats.end();
}
__WEBPACK_IMPORTED_MODULE_4__raf__["a" /* default */].on('tick', update);
/* harmony default export */ __webpack_exports__["default"] = (renderer);

if (false) {
  module.hot.accept();
  module.hot.dispose(function () {
    raf.stop();
  });
}

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return service; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_postscribe__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_postscribe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_postscribe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_url_search_params_polyfill__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_url_search_params_polyfill__);






var AnalyticsService = function () {
  function AnalyticsService() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a(this, AnalyticsService);

    this.sendPageview = function (url) {
      window.ga('send', 'pageview', url);
    };

    this.sendEvent = function (category, action, label, value) {
      window.ga('send', 'event', category, action, label, value);
    };

    this.setDimension = function (dimension, value) {
      window.ga('set', dimension, value);
    };

    this.setSource = function (source) {
      if (!source) return;
      window.ga('set', 'dimension1', source);
      _this.sendEvent('source', 'view', source);
    };

    window.ga('create', 'UA-54500344-29', 'auto');
    this.setSource(new window.URLSearchParams(window.location.search).get('_source'));
    this.injectScript();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a(AnalyticsService, [{
    key: 'injectScript',
    value: function injectScript() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var head = document.head || document.getElementsByTagName('head')[0];
        var src = '//www.google-analytics.com/analytics.js';
        __WEBPACK_IMPORTED_MODULE_3_postscribe___default.a(head, '<script src=\'' + src + '\'></script>', {
          afterAsync: function afterAsync() {
            resolve();
          }
        });
      });
    }
  }]);

  return AnalyticsService;
}();

var service = new AnalyticsService();

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/game/lights.js
var lights_namespaceObject = {};
__webpack_require__.d(lights_namespaceObject, "hemiLight", function() { return hemiLight; });
__webpack_require__.d(lights_namespaceObject, "dirLight", function() { return dirLight; });
__webpack_require__.d(lights_namespaceObject, "ptLight2", function() { return ptLight2; });
__webpack_require__.d(lights_namespaceObject, "animColor", function() { return animColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scene__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__camera__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors__ = __webpack_require__(68);
var THREE = __webpack_require__(0);






var hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.5);
hemiLight.color.setHSL(0.6, 1, 0.6);
hemiLight.groundColor.setHSL(1, 1, 0.75);
hemiLight.position.set(0, 5000, 500);
hemiLight.position.multiplyScalar(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].worldScale);
__WEBPACK_IMPORTED_MODULE_0__scene__["a" /* default */].add(hemiLight);

var dirLight = new THREE.DirectionalLight(0xFFFFFF, 0.8);
dirLight.position.set(0, 240, -1000);
__WEBPACK_IMPORTED_MODULE_0__scene__["a" /* default */].add(dirLight);

dirLight.target = new THREE.Object3D();
__WEBPACK_IMPORTED_MODULE_0__scene__["a" /* default */].add(dirLight.target);

dirLight.castShadow = true;
dirLight.shadow.mapSize.width = 2048;
dirLight.shadow.mapSize.height = 2048;
var size = 50;
dirLight.shadow.camera.left = -size;
dirLight.shadow.camera.bottom = -size;
dirLight.shadow.camera.right = size;
dirLight.shadow.camera.top = size;
dirLight.shadow.camera.near = 1;
dirLight.shadow.camera.far = 100000;

var ptLight2 = new THREE.PointLight(0x0011FF, 1, 100);
ptLight2.position.y = 50;

var animColor = function animColor(light, color) {
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var toColor = new THREE.Color(color);
  __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(light.color, time, {
    r: toColor.r,
    g: toColor.g,
    b: toColor.b,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeInOut
  });
};
// CONCATENATED MODULE: ./src/components/game/fog.js
/* harmony import */ var fog___WEBPACK_IMPORTED_MODULE_0__scene__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderer__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__track_tiled_config__ = __webpack_require__(60);
/* harmony import */ var fog___WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
var fog_THREE = __webpack_require__(0);





var far = __WEBPACK_IMPORTED_MODULE_2__track_tiled_config__["tileSize"] * (__WEBPACK_IMPORTED_MODULE_2__track_tiled_config__["numDraw"] - 2) * fog___WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].worldScale;
var fog = new fog_THREE.Fog(__WEBPACK_IMPORTED_MODULE_1__renderer__["default"].getClearColor(), 0, far);
/* harmony default export */ var fog_defaultExport = (fog);
fog___WEBPACK_IMPORTED_MODULE_0__scene__["a" /* default */].fog = fog;
// CONCATENATED MODULE: ./src/components/game/track-tiled/tile.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var tile___WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__listener__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sounds__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scene__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(68);



var tile_THREE = __webpack_require__(0);




__webpack_require__(82);






var Tile = function () {
  function Tile(tileId) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a(this, Tile);

    this.initEmoji = function () {

      if (!_this.tileType.sprites.people) return;

      var positions = _this.peoplePositions;

      var percent = void 0;
      if (_this.tileId === 'start' || _this.tileId === 'finish') {
        percent = 0.15;
      } else {
        percent = 0.25;
      }
      positions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sampleSize(_this.peoplePositions, Math.round(_this.peoplePositions.length * percent));

      for (var posIdx = 0; posIdx < positions.length; posIdx++) {
        var material = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sample(tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"].emojis.materials);
        var pos = positions[posIdx];
        var mesh = new tile_THREE.Sprite(material);
        mesh.position.set(pos[0], 5.2, pos[2]);
        mesh.scale.setScalar(0);
        _this.emojis.push(mesh);
        _this.mesh.add(mesh);

        var s = window.Maf.randomInRange(2.7, 3.2);
        mesh.tween = __WEBPACK_IMPORTED_MODULE_7_gsap__["TweenMax"].to(mesh.scale, 1, {
          x: s,
          y: s,
          z: s,
          ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Elastic"].easeOut,
          delay: 0.7 + Math.random(),
          paused: true
        });
      }
    };

    this.showEmojis = function () {
      if (_this.emojiActive) return;
      _this.emojiActive = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(_this.emojis), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var emoji = _step.value;

          emoji.tween.play();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    };

    this.hideEmojis = function () {
      if (!_this.emojiActive) return;
      _this.emojiActive = false;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(_this.emojis), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var emoji = _step2.value;

          emoji.scale.setScalar(0);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    };

    this.show = function () {
      _this.mesh.visible = true;
    };

    this.hide = function () {};

    this.startSound = function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      for (var key in _this.audio) {
        _this.audio[key].fadeTo(tile___WEBPACK_IMPORTED_MODULE_3__config__["sounds"][key].volume, time);
      }
    };

    this.stopSound = function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      for (var key in _this.audio) {
        _this.audio[key].fadeTo(0, time);
      }
    };

    this.tileId = tileId;
    this.tileType = tile___WEBPACK_IMPORTED_MODULE_3__config__["types"][tileId];
    this.mesh = new tile_THREE.Object3D();
    this.mesh.name = tileId;

    this.emojis = [];
    this.emojiActive = false;

    this.initObjects();
    this.initAudio();
    this.initTrees();
    this.initAirport();
    this.initPeople();
    this.initEmoji();

    this.hide();

    this.stopSound(0);
    return this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a(Tile, [{
    key: 'initObjects',
    value: function initObjects() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(this.tileType.objs), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var key = _step3.value;

          var obj = tile___WEBPACK_IMPORTED_MODULE_3__config__["objects"][key];
          var geometry = obj.geometry;

          var material = void 0;
          if (tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"][obj.texture]) {
            material = tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"][obj.texture].material;
            if (obj.cloneMaterial) {
              material = material.clone();
            }
          } else {
            material = new tile_THREE.MeshPhongMaterial({ transparent: true });
          }

          if (key === 'garage_start') {
            material = tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"].stadium.material;
          }

          var mesh = new tile_THREE.Mesh(geometry, material);
          mesh.name = key;
          if (obj.renderOrder) mesh.renderOrder = obj.renderOrder;
          mesh.scale.setScalar(1);
          mesh.receiveShadow = true;

          this.mesh.add(mesh);

          switch (key) {
            case 'ticker_left':
            case 'ticker_right':
            case 'arrow_curve_left':
            case 'arrow_curve_right':
              mesh.scale.y = 0.75;
              break;
            case 'ribbon_left':
            case 'ribbon_right':
              mesh.position.y = -0.4;
              break;

            case 'stadium_building':
              var stadiumLight = new tile_THREE.PointLight(__WEBPACK_IMPORTED_MODULE_10__colors__["c" /* white */].clone(), 0.8, 70);
              stadiumLight.name = key + '-light';
              stadiumLight.position.set(-19, 54, 0);
              mesh.add(stadiumLight);
              break;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'initAudio',
    value: function initAudio() {
      this.audio = {};
      for (var key in this.tileType.sounds) {
        var sound = this.tileType.sounds[key];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(sound), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var pos = _step4.value;

            var audio = new tile_THREE.PositionalAudio(__WEBPACK_IMPORTED_MODULE_6__listener__["a" /* default */]);
            audio.setBuffer(tile___WEBPACK_IMPORTED_MODULE_3__config__["sounds"][key].buffer);
            audio.setRefDistance(tile___WEBPACK_IMPORTED_MODULE_3__config__["sounds"][key].distance || 10);
            audio.setRolloffFactor(tile___WEBPACK_IMPORTED_MODULE_3__config__["sounds"][key].rollOff || 20);
            audio.setLoop(true);
            audio.setVolume(0.001);

            audio.position.set(pos.x, pos.y, pos.z);
            audio.play();
            this.audio[key] = audio;
            this.mesh.add(audio);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    }
  }, {
    key: 'initAirport',
    value: function initAirport() {
      if (!this.tileType.sprites.airport) return;

      var positions = this.tileType.sprites.airport;
      var material = tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"].airport.material;

      for (var posIdx = 0; posIdx < positions.length; posIdx++) {
        var pos = positions[posIdx];
        var mesh = new tile_THREE.Sprite(material);
        mesh.position.set(pos[0], 0.5, pos[2]);
        mesh.scale.setScalar(1);
        this.mesh.add(mesh);
      }
    }
  }, {
    key: 'initTrees',
    value: function initTrees() {
      if (!this.tileType.sprites.tree) return;

      var positions = this.tileType.sprites.tree;
      positions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sampleSize(positions, Math.round(positions.length * 0.5));

      var material = tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"].tree.material;
      var geometry = new tile_THREE.PlaneGeometry(1, 1);

      var mergedGeometry = new tile_THREE.Geometry();
      var scaleConfig = tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"].tree.scale;
      for (var posIdx = 0; posIdx < positions.length; posIdx++) {
        var scale = window.Maf.randomInRange(scaleConfig.min, scaleConfig.max);
        var pos = positions[posIdx];
        var _mesh = new tile_THREE.Mesh(geometry, material);
        _mesh.position.set(pos[0], scale / 2, pos[2]);
        _mesh.scale.setScalar(scale);
        _mesh.updateMatrix();
        mergedGeometry.merge(_mesh.geometry, _mesh.matrix);
      }

      var mesh = new tile_THREE.Mesh(mergedGeometry, material);
      this.mesh.add(mesh);
    }
  }, {
    key: 'initPeople',
    value: function initPeople() {
      if (!this.tileType.sprites.people) return;

      var positions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(this.tileType.sprites.people);

      if (this.tileId === 'start' || this.tileId === 'finish') {
        positions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sampleSize(positions, Math.round(positions.length * 0.9));
      } else {
        positions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sampleSize(positions, Math.round(positions.length * 0.8));
      }

      positions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.shuffle(positions);

      var geometry = new tile_THREE.PlaneGeometry(1, 1);
      var materials = tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"].people.materials;
      var samplePercent = void 0;
      if (this.tileId === 'start' || this.tileId === 'finish') {
        samplePercent = 0.8;
      } else {
        samplePercent = 0.6;
      }
      materials = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sampleSize(materials, Math.round(materials.length * samplePercent));

      this.peoplePositions = [];

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(materials), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var material = _step5.value;


          var scaleConfig = tile___WEBPACK_IMPORTED_MODULE_3__config__["textures"].people.scale;

          var numPos = Math.ceil(positions.length / materials.length / samplePercent);
          var pos = [];
          for (var i = 0; i < numPos; i++) {
            var p = positions.pop();
            pos.push(p);
            this.peoplePositions.push(p);
          }

          var mergedGeometry = new tile_THREE.Geometry();
          for (var posIdx = 0; posIdx < pos.length; posIdx++) {
            var scale = window.Maf.randomInRange(scaleConfig.min, scaleConfig.max);
            var _p = pos[posIdx];
            var _mesh2 = new tile_THREE.Mesh(geometry, material);
            _mesh2.position.set(_p[0], scale / 2 + _p[1] + 0.2, _p[2]);
            _mesh2.scale.setScalar(scale);
            _mesh2.updateMatrix();
            mergedGeometry.merge(_mesh2.geometry, _mesh2.matrix);
          }

          var mesh = new tile_THREE.Mesh(mergedGeometry, material);
          this.mesh.add(mesh);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }
  }]);

  return Tile;
}();

/* harmony default export */ var tile_defaultExport = (Tile);
// CONCATENATED MODULE: ./src/components/game/track-tiled/index.js
var track_tiled_namespaceObject = {};
__webpack_require__.d(track_tiled_namespaceObject, "conf", function() { return conf; });
__webpack_require__.d(track_tiled_namespaceObject, "mesh", function() { return mesh; });
__webpack_require__.d(track_tiled_namespaceObject, "tiles", function() { return tiles; });
__webpack_require__.d(track_tiled_namespaceObject, "strobeRoads", function() { return strobeRoads; });
__webpack_require__.d(track_tiled_namespaceObject, "loaded", function() { return loaded; });
__webpack_require__.d(track_tiled_namespaceObject, "animatedTextures", function() { return animatedTextures; });
__webpack_require__.d(track_tiled_namespaceObject, "angles", function() { return angles; });
__webpack_require__.d(track_tiled_namespaceObject, "update", function() { return track_tiled_update; });
__webpack_require__.d(track_tiled_namespaceObject, "updateTextures", function() { return track_tiled_updateTextures; });
__webpack_require__.d(track_tiled_namespaceObject, "startSound", function() { return startSound; });
__webpack_require__.d(track_tiled_namespaceObject, "stopSound", function() { return stopSound; });
__webpack_require__.d(track_tiled_namespaceObject, "showStrobe", function() { return showStrobe; });
__webpack_require__.d(track_tiled_namespaceObject, "hideStrobe", function() { return hideStrobe; });
__webpack_require__.d(track_tiled_namespaceObject, "showAllEmojis", function() { return showAllEmojis; });
__webpack_require__.d(track_tiled_namespaceObject, "hideAllEmojis", function() { return hideAllEmojis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_left_pad__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_left_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_left_pad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scene__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__renderer__ = __webpack_require__(34);



var track_tiled_THREE = __webpack_require__(0);
__webpack_require__(122);















var conf = __WEBPACK_IMPORTED_MODULE_8__config__;

var mesh = new track_tiled_THREE.Object3D();
mesh.scale.setScalar(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* config */].worldScale);

__WEBPACK_IMPORTED_MODULE_5__scene__["a" /* default */].add(mesh);

var tiles = [];
var strobeRoads = [];

var track_tiled_initTrack = function initTrack() {

  var nextPosition = [0, 0];
  var currDirection = __WEBPACK_IMPORTED_MODULE_8__config__["direction"].N;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(__WEBPACK_IMPORTED_MODULE_8__config__["layout"]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var tileId = _step.value;

      var tileType = __WEBPACK_IMPORTED_MODULE_8__config__["types"][tileId];
      var tile = new tile_defaultExport(tileId);
      tiles.push(tile);
      mesh.add(tile.mesh);

      tile.mesh.position.x = nextPosition[0] * __WEBPACK_IMPORTED_MODULE_8__config__["tileSize"];
      tile.mesh.position.z = nextPosition[1] * __WEBPACK_IMPORTED_MODULE_8__config__["tileSize"];
      tile.mesh.rotation.y = -currDirection * track_tiled_THREE.Math.DEG2RAD;

      currDirection += tileType.directionChange + 360;
      currDirection %= 360;

      switch (currDirection) {
        case __WEBPACK_IMPORTED_MODULE_8__config__["direction"].N:
          nextPosition[1]--;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__config__["direction"].W:
          nextPosition[0]--;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__config__["direction"].S:
          nextPosition[1]++;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__config__["direction"].E:
          nextPosition[0]++;
          break;
      }

      var strobeNames = ['straightStrobe', 'straightStrobeLeft', 'straightStrobeRight', 'straightStrobeStadium'];
      if (strobeNames.indexOf(tileId) >= 0) {
        var strobes = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.filter(tile.mesh.children, function (child) {
          return child.name === 'strobe_road';
        });
        strobeRoads = strobeRoads.concat(strobes);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(strobeRoads), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var road = _step2.value;

            road.position.y += 0.001;
            road.material.alphaTest = 0.01;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var modelLoader = new track_tiled_THREE.JSONLoader(__WEBPACK_IMPORTED_MODULE_4__loader__["loadingManager"]);
var soundLoader = new track_tiled_THREE.AudioLoader(__WEBPACK_IMPORTED_MODULE_4__loader__["loadingManager"]);
var textureLoader = new track_tiled_THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_4__loader__["loadingManager"]);
var loaded = false;

var checkAllLoaded = function checkAllLoaded() {
  for (var key in __WEBPACK_IMPORTED_MODULE_8__config__["objects"]) {
    if (!__WEBPACK_IMPORTED_MODULE_8__config__["objects"][key].geometry) return;
  }

  for (var _key in __WEBPACK_IMPORTED_MODULE_8__config__["textures"]) {
    var texture = __WEBPACK_IMPORTED_MODULE_8__config__["textures"][_key];
    if (!texture.map) return;
    if (texture.urls && texture.map.length < texture.urls.length) return;
  }

  for (var _key2 in __WEBPACK_IMPORTED_MODULE_8__config__["sounds"]) {
    if (!__WEBPACK_IMPORTED_MODULE_8__config__["sounds"][_key2].buffer) return;
  }

  loaded = true;
  track_tiled_initTrack();
};

var _loop = function _loop(key) {
  var model = __WEBPACK_IMPORTED_MODULE_8__config__["objects"][key];
  __WEBPACK_IMPORTED_MODULE_4__loader__["registerSize"](model.url, model.size);
  __WEBPACK_IMPORTED_MODULE_4__loader__["load"](model.url, modelLoader, function (results) {

    var geometry = new track_tiled_THREE.BufferGeometry().fromGeometry(results[0]);

    model.geometry = geometry;
    model.geometry.computeFaceNormals();
    model.geometry.computeVertexNormals();
    checkAllLoaded();
  });
};

for (var track_tiled_key in __WEBPACK_IMPORTED_MODULE_8__config__["objects"]) {
  _loop(track_tiled_key);
}

var createMaterial = function createMaterial(texture) {

  var config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({
    map: texture.map,
    fog: true,
    transparent: true,
    alphaTest: 0.5
  }, texture.options);

  if (texture.options && texture.options.bumpMap) {
    var src = texture.options.bumpMap === 'self' ? texture.map : texture.options.bumpMap;
    config.bumpMap = src;
  }

  var material = new texture.materialType(config);
  material.map.anisotropy = __WEBPACK_IMPORTED_MODULE_12__renderer__["maxAnisotropy"];
  material.map.wrapS = material.map.wrapT = track_tiled_THREE.RepeatWrapping;

  return material;
};

var track_tiled__loop2 = function _loop2(key) {
  var texture = __WEBPACK_IMPORTED_MODULE_8__config__["textures"][key];

  if (texture.url) {
    __WEBPACK_IMPORTED_MODULE_4__loader__["registerSize"](texture.url, texture.size);
    __WEBPACK_IMPORTED_MODULE_4__loader__["load"](texture.url, textureLoader, function (results) {
      texture.map = results[0];

      var material = createMaterial(texture);
      texture.material = material;

      checkAllLoaded();
    });
  } else {
    texture.map = [];
    texture.materials = [];

    var _loop4 = function _loop4(i) {
      var url = texture.urls[i];
      __WEBPACK_IMPORTED_MODULE_4__loader__["load"](url, textureLoader, function (results) {
        texture.map[i] = results[0];
        var config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({}, texture);
        config.map = results[0];

        var material = createMaterial(config);
        texture.materials[i] = material;
        checkAllLoaded();
      });
    };

    for (var i = 0; i < texture.urls.length; i++) {
      _loop4(i);
    }
  }
};

for (var track_tiled_key in __WEBPACK_IMPORTED_MODULE_8__config__["textures"]) {
  track_tiled__loop2(track_tiled_key);
}

var _loop3 = function _loop3(key) {
  var sound = __WEBPACK_IMPORTED_MODULE_8__config__["sounds"][key];
  __WEBPACK_IMPORTED_MODULE_4__loader__["registerSize"](sound.url, sound.size);
  __WEBPACK_IMPORTED_MODULE_4__loader__["load"](sound.url, soundLoader, function (results) {
    sound.buffer = results[0];
    checkAllLoaded();
  });
};

for (var track_tiled_key in __WEBPACK_IMPORTED_MODULE_8__config__["sounds"]) {
  _loop3(track_tiled_key);
}

var animatedTextures = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_8__config__["textures"], function (texture) {
  return texture.animate !== undefined;
});

var angles = [];
var track_tiled_update = function update(delta) {
  if (!loaded) return;

  var percent = player.state.distance;

  var currPieceIdx = Math.floor(percent * (__WEBPACK_IMPORTED_MODULE_8__config__["layout"].length - 1)) % tiles.length;

  var prevPieceIdx = (currPieceIdx - 1 + tiles.length) % tiles.length;
  tiles[prevPieceIdx].hide();
  tiles[prevPieceIdx].hideEmojis();

  var nextPieceIdx = (currPieceIdx + 3 + tiles.length) % tiles.length;
  tiles[nextPieceIdx].showEmojis();

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_8__config__["numDraw"] - 1; i++) {
    var pieceIdx = (currPieceIdx + i) % tiles.length;
    var tile = tiles[pieceIdx];
    tile.show();
    if (i >= 2) angles[i - 2] = tile.tileType.directionChange;
  }

  track_tiled_updateTextures(delta);
};

var track_tiled_updateTextures = function updateTextures(delta) {
  if (!loaded) return;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(animatedTextures), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _texture = _step3.value;

      var percent = 0.6 + main_state.velocity.percent * 0.5;
      _texture.map.offset.x += _texture.animate * delta * percent;
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
};

var startSound = function startSound(time) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(tiles), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var tile = _step4.value;

      tile.startSound(time);
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
};

var stopSound = function stopSound(time) {
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(tiles), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var tile = _step5.value;

      tile.stopSound(time);
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }
};

var showStrobe = function showStrobe() {
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(strobeRoads), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var road = _step6.value;

      __WEBPACK_IMPORTED_MODULE_11_gsap__["TweenMax"].to(road.material, 1, {
        opacity: 0.4,
        ease: __WEBPACK_IMPORTED_MODULE_11_gsap__["Cubic"].easeOut
      });
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }
};

var hideStrobe = function hideStrobe() {
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(strobeRoads), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var road = _step7.value;

      road.material.opacity = 0;
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }
};

var showAllEmojis = function showAllEmojis() {
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(tiles), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var tile = _step8.value;

      tile.showEmojis();
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }
};

var hideAllEmojis = function hideAllEmojis() {
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(tiles), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      var tile = _step9.value;

      tile.hideEmojis();
    }
  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9.return) {
        _iterator9.return();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }
};
// CONCATENATED MODULE: ./src/components/game/runner/runner.js
/* harmony import */ var runner___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var runner___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(runner___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loader__ = __webpack_require__(3);
/* harmony import */ var runner___WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stages__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__listener__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lerp__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lerp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lerp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__clock__ = __webpack_require__(47);






var runner_THREE = __webpack_require__(0);
__webpack_require__(122);













var base = __webpack_require__(16).build.assetsPublicPath;

var eliteEase = __WEBPACK_IMPORTED_MODULE_9_gsap__["CustomEase"].create('custom', 'M0,0,C0,0,0.02,0.074,0.088,0.136,0.14,0.183,0.129,-0.059,0.332,0.026,0.952,0.286,1,1,1,1');

var models = {
  player: {
    url: __webpack_require__(574),
    size: 91699
  }
};

var runner__loop = function _loop(key) {
  var model = models[key];
  __WEBPACK_IMPORTED_MODULE_5__loader__["registerSize"](model.url, model.size);
  __WEBPACK_IMPORTED_MODULE_5__loader__["load"](model.url, new runner_THREE.JDLoader(__WEBPACK_IMPORTED_MODULE_5__loader__["loadingManager"]), function (results) {
    model.geometry = results[0].geometries[0];
    model.geometry.computeFaceNormals();
    model.geometry.computeVertexNormals();
  });
};

for (var runner_key in models) {
  runner__loop(runner_key);
}

var textures = {
  male1: {
    url: __webpack_require__(208),
    size: 90638
  },
  male2: {
    url: __webpack_require__(209),
    size: 91869
  },
  male3: {
    url: __webpack_require__(210),
    size: 85086
  },
  female1: {
    url: __webpack_require__(211),
    size: 68859
  },
  female2: {
    url: __webpack_require__(212),
    size: 72030
  },
  female3: {
    url: __webpack_require__(213),
    size: 71840
  },
  elite1: {
    url: __webpack_require__(214),
    size: 76078
  },
  elite2: {
    url: __webpack_require__(215),
    size: 56140
  },
  elite3: {
    url: __webpack_require__(216),
    size: 77056
  },
  player1: {
    url: __webpack_require__(217),
    size: 150525
  }
};

var runner__loop2 = function _loop2(key) {
  var texture = textures[key];
  var material = new runner_THREE.MeshPhongMaterial({
    skinning: true,
    transparent: true
  });

  texture.material = material;
  var url = texture.url;
  __WEBPACK_IMPORTED_MODULE_5__loader__["registerSize"](url, texture.size);
  __WEBPACK_IMPORTED_MODULE_5__loader__["load"](url, new runner_THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_5__loader__["loadingManager"]), function (results) {
    texture.material.map = results[0];

    if (texture.bump) {
      texture.material.bumpMap = results[0];
      texture.material.bumpScale = texture.bump;
    }

    texture.material.needsUpdate = true;
  });
};

for (var runner_key in textures) {
  runner__loop2(runner_key);
}

var sounds = {};

var runner__loop3 = function _loop3(key) {
  var sound = sounds[key];
  __WEBPACK_IMPORTED_MODULE_5__loader__["registerSize"](sound.url, sound.size);
  __WEBPACK_IMPORTED_MODULE_5__loader__["load"](sound.url, null, function (results) {
    sound.buffer = results[0];
  });
};

for (var runner_key in sounds) {
  runner__loop3(runner_key);
}

var runner_loaded = false;

var runner_Runner = function () {
  function Runner(config) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a(this, Runner);

    this.checkAllLoaded = function () {
      for (var key in _this.models) {
        if (!models[key].geometry) return false;
      }

      for (var _key in _this.textures) {
        if (!textures[_key].material.map) return false;
      }

      for (var _key2 in _this.state.sounds) {
        if (!_this.state.sounds[_key2].buffer) return false;
      }

      runner_loaded = true;

      _this.init();
      return true;
    };

    this.updateAnimation = function (delta) {
      if (_this.mixer) {
        var weight = _this.state.velocity / runner___WEBPACK_IMPORTED_MODULE_7__config__["a" /* config */].velocityMax * 0.07;
        weight = Math.min(weight, 1.03);
        _this.mixer.timeScale = 0.96 + weight;

        _this.mixer.update(delta / 1000);
      }
    };

    this.update = function (delta) {

      if (!main_state) return;

      if (main_state.stage > __WEBPACK_IMPORTED_MODULE_10__stages__["INTRO"] && _this.state.autoUpdateState) {
        _this.updateState(delta);
      }
      _this.updatePosition();

      _this.updateAnimation(delta);
    };

    this.start = function () {

      if (!_this.state.initialized) _this.init();

      _this.mesh.visible = true;
      _this.isPlaying = true;

      if (_this.model) {
        _this.fadeInAnim('run', 0, Math.random() * 3);
      }
    };

    this.stop = function () {
      _this.isPlaying = false;
    };

    this.reset = function () {
      _this.state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a({}, _this.initialState);
      _this.updatePosition();
      for (var key in _this.actions) {
        var action = _this.actions[key];
        action.play();
        action.fadeOut();
      }
    };

    this.fadeInAnim = function (key, time, delay) {
      var action = _this.actions[key];
      action.startAt(_this.mixer.time - delay);
      action.crossFadeFrom(_this.currAction, time);
      _this.currAction = action;
    };

    this.turnElite = function (idx) {
      _this.state.isElite = true;
      _this.material.map = textures['elite' + (idx + 1)].material.map;
      _this.material.needsUpdate = true;
    };

    this.fadeTo = function (opacity) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_9_gsap__["TweenMax"].to(_this.model.material, time, {
          opacity: opacity,
          ease: __WEBPACK_IMPORTED_MODULE_9_gsap__["Cubic"].easeOut,
          onUpdate: function onUpdate() {
            _this.model.material.needsUpdate = true;
          },
          onComplete: resolve
        });
      });
    };

    this.state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a({
      initialized: false,
      models: models,
      textures: textures,
      isPlayer: false,
      isElite: false,
      isPacer: false,
      type: 'male',
      idx: 0,
      materialIdx: null,
      path: null,
      color: 0xEB0033,
      baseVelocity: 1,
      distance: 1,
      distanceStart: 1,
      currDistance: 1,
      swipeVelocity: 0,
      swipeVelocityMax: 0,
      velocity: 0,
      sps: 0,
      spsMax: 0,
      px: 0,
      offset: 0,
      sounds: sounds,
      minVel: 0,
      maxVel: 0,
      multiplyVelocity: 0,
      addVelocity: 0,
      autoUpdateState: true
    }, config);
    this.initialState = this.state;

    this.state.currDistance = this.state.distance;

    if (this.state.type === 'elite') {
      console.log('Runner-' + this.state.idx + '   ' + this.state.minVel + ' - ' + this.state.maxVel);
    }

    if (this.state.materialIdx === null) {
      this.state.materialIdx = this.state.idx % 3;
    }

    this.mesh = new runner_THREE.Object3D();
    this.mesh.name = 'runner';

    this.audio = {};
    for (var key in this.state.sounds) {
      var audio = void 0;

      if (this.state.sounds[key].positional === false) {
        audio = new runner_THREE.Audio(__WEBPACK_IMPORTED_MODULE_12__listener__["a" /* default */]);
      } else {
        audio = new runner_THREE.PositionalAudio(__WEBPACK_IMPORTED_MODULE_12__listener__["a" /* default */]);
        audio.setRefDistance(this.state.sounds[key].distance || 1);
        audio.position.x = this.state.sounds[key].x || 0;
        audio.position.y = this.state.sounds[key].y || 0;
      }
      audio.setLoop(false);
      this.audio[key] = audio;
      this.mesh.add(this.audio[key]);
    }

    var updateTime = 1000;
    this.lookAtTarget = new runner_THREE.Vector3(0, 0, 0);

    this.updateStateThrottled = __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.throttle(function () {

      var min = Math.max(main_state.velocity.max, _this.state.minVel);
      min = Math.min(min, _this.state.maxVel);

      var vel = main_state.velocity.now * _this.state.multiplyVelocity + _this.state.addVelocity;
      vel = Math.max(vel, _this.state.minVel);
      vel = Math.min(vel, _this.state.maxVel);

      _this.state.minVel = min;
      _this.state.velocity = vel;

      __WEBPACK_IMPORTED_MODULE_9_gsap__["TweenMax"].to(_this.state, updateTime / 1000, {
        minVel: min,
        velocity: vel,
        ease: __WEBPACK_IMPORTED_MODULE_9_gsap__["Linear"].easeNone,
        onUpdate: function onUpdate() {
          _this.state.px += _this.state.velocity * __WEBPACK_IMPORTED_MODULE_15__clock__["state"].delta;
          var progress = _this.state.px / runner___WEBPACK_IMPORTED_MODULE_7__config__["a" /* config */].totalPx;
          _this.state.distance = _this.state.distanceStart + progress * runner___WEBPACK_IMPORTED_MODULE_7__config__["a" /* config */].numLaps;
        }
      });
    }, updateTime);

    this.updatePositionThrottled = __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.throttle(function () {

      var pt1 = _this.state.path.getPointAt(_this.state.distance % 1);


      var pt2 = _this.state.path.getPointAt((_this.state.distance + 0.01) % 1);


      __WEBPACK_IMPORTED_MODULE_9_gsap__["TweenMax"].to(_this.mesh.position, updateTime / 1000, {
        x: pt1.x,
        y: pt1.y,
        z: pt1.z,
        ease: __WEBPACK_IMPORTED_MODULE_9_gsap__["Linear"].easeNone
      });

      __WEBPACK_IMPORTED_MODULE_9_gsap__["TweenMax"].to(_this.lookAtTarget, updateTime / 1000, {
        x: pt2.x,
        y: pt2.y,
        z: pt2.z,
        ease: __WEBPACK_IMPORTED_MODULE_9_gsap__["Linear"].easeNone,
        onUpdate: function onUpdate() {
          _this.mesh.lookAt(_this.lookAtTarget);
        }
      });
    }, updateTime);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a(Runner, [{
    key: 'init',
    value: function init() {
      if (this.state.initialized) return;
      this.state.initialized = true;
      this.initTexture();
      this.initModel();
      this.initAudio();
      this.updatePosition();
    }
  }, {
    key: 'initModel',
    value: function initModel() {
      var geometry = void 0;
      switch (this.state.type) {
        case 'female':
          geometry = models.female.geometry;
          break;
        case 'player':
          geometry = models.player.geometry;
          break;
        default:
          geometry = models.male.geometry;
          break;
      }

      var materialKey = '' + this.state.type + (this.state.materialIdx + 1);
      var material = textures[materialKey].material;

      this.material = material.clone();

      this.model = new runner_THREE.SkinnedMesh(geometry, this.material);

      this.model.scale.setScalar(0.0225);
      if (!this.state.isPlayer) {
        this.model.position.x = this.state.offset;
      }
      this.mesh.add(this.model);

      this.mixer = new runner_THREE.AnimationMixer(this.model);
      var clips = geometry.animations;
      this.actions = {};var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = runner___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(clips), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var clip = _step.value;

          var action = this.mixer.clipAction(clip);
          this.actions[clip.name] = action;
          action.play();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!this.isPlayer) {
        this.currAction = this.actions['ready'];
      } else {
        this.currAction = this.actions['intro'];
        this.currAction.setLoop(runner_THREE.LoopOnce);
      }
      this.mixer.update(0);
    }
  }, {
    key: 'initTexture',
    value: function initTexture() {}
  }, {
    key: 'initAudio',
    value: function initAudio() {
      for (var key in this.audio) {
        var audio = this.audio[key];
        audio.setBuffer(this.state.sounds[key].buffer);
        audio.setVolume(0.001);
        audio.play();
      }
    }
  }, {
    key: 'updateState',
    value: function updateState(delta) {

      var min = Math.max(main_state.velocity.max, this.state.minVel);
      min = Math.min(min, this.state.maxVel);
      this.state.minVel = min;

      var vel = main_state.velocity.now * this.state.multiplyVelocity + this.state.addVelocity;
      vel = Math.max(vel, this.state.minVel);
      vel = Math.min(vel, this.state.maxVel);
      this.state.velocity = vel;

      this.state.px += this.state.velocity * delta;
      var progress = this.state.px / runner___WEBPACK_IMPORTED_MODULE_7__config__["a" /* config */].totalPx;
      this.state.distance = this.state.distanceStart + progress * runner___WEBPACK_IMPORTED_MODULE_7__config__["a" /* config */].numLaps;
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition() {

      this.state.currDistance += (this.state.distance - this.state.currDistance) / 5;

      var pt1 = this.state.path.getPointAt(this.state.currDistance % 1);

      this.mesh.position.set(pt1.x, pt1.y, pt1.z);

      var pt2 = this.state.path.getPointAt((this.state.currDistance + 0.01) % 1);
      this.mesh.lookAt(pt2);
    }
  }]);

  return Runner;
}();

/* harmony default export */ var runner_defaultExport = (runner_Runner);
// CONCATENATED MODULE: ./src/components/game/runner/player.js
/* harmony import */ var player___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var player___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(player___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var player___WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(2);
/* harmony import */ var player___WEBPACK_IMPORTED_MODULE_8__sounds__ = __webpack_require__(59);
/* harmony import */ var player___WEBPACK_IMPORTED_MODULE_9_gsap__ = __webpack_require__(1);
/* harmony import */ var player___WEBPACK_IMPORTED_MODULE_9_gsap___default = __webpack_require__.n(player___WEBPACK_IMPORTED_MODULE_9_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stages__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__camera__ = __webpack_require__(58);







var player_THREE = __webpack_require__(0);








var player_Player = function (_Runner) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(Player, _Runner);

  function Player(config) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, Player);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (Player.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(Player)).call(this, player___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a(config, {
      isPlayer: true,
      type: 'player'
    })));

    _this.updateAnimation = function (delta) {
      if (_this.mixer) {
        _this.mixer.timeScale = 1;
        _this.mixer.update(delta / 1000);
      }
    };

    _this.updateState = function () {
      var vel = main_state.velocity.now;
      _this.state.distance = player___WEBPACK_IMPORTED_MODULE_7__config__["a" /* config */].startDistance + main_state.progress.percent * player___WEBPACK_IMPORTED_MODULE_7__config__["a" /* config */].numLaps;
    };

    _this.start = function () {
      _this.model.visible = false;
    };

    _this.cameraAnchor = new player_THREE.Object3D();
    _this.mesh.add(_this.cameraAnchor);
    _this.cameraAnchor.add(__WEBPACK_IMPORTED_MODULE_12__camera__["a" /* default */]);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(Player, [{
    key: 'updatePosition',
    value: function updatePosition() {

      var pt1 = this.state.path.getPointAt(this.state.distance % 1);
      this.mesh.position.set(pt1.x, pt1.y, pt1.z);

      var pt2 = this.state.path.getPointAt((this.state.distance + 0.014) % 1);
      this.mesh.lookAt(pt2);
    }
  }]);

  return Player;
}(runner_defaultExport);

/* harmony default export */ var player_defaultExport = (player_Player);
// CONCATENATED MODULE: ./src/components/game/runner/runner-morph.js
/* harmony import */ var runner_morph___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var runner_morph___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(runner_morph___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var runner_morph___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var runner_morph___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(runner_morph___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var runner_morph___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var runner_morph___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(runner_morph___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__stages__ = __webpack_require__(26);
/* harmony import */ var runner_morph___WEBPACK_IMPORTED_MODULE_10__raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__listener__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lerp__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lerp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lerp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__clock__ = __webpack_require__(47);





var runner_morph_THREE = __webpack_require__(0);
__webpack_require__(122);













var runner_morph_base = __webpack_require__(16).build.assetsPublicPath;

var runner_morph_eliteEase = __WEBPACK_IMPORTED_MODULE_8_gsap__["CustomEase"].create('custom', 'M0,0,C0,0,0.02,0.074,0.088,0.136,0.14,0.183,0.129,-0.059,0.332,0.026,0.952,0.286,1,1,1,1');

var runner_morph_models = {
  male: {
    url: __webpack_require__(575),
    size: 219295
  },
  female: {
    url: __webpack_require__(576),
    size: 204985
  },
  player: {
    url: __webpack_require__(577),
    size: 103183,
    type: 'jd'
  }
};

var runner_morph__loop = function _loop(key) {
  var model = runner_morph_models[key];
  runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["registerSize"](model.url, model.size);
  if (model.type === 'jd') {
    runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["load"](model.url, new runner_morph_THREE.JDLoader(runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["loadingManager"]), function (results) {
      model.geometry = results[0].geometries[0];
      model.geometry.computeFaceNormals();
      model.geometry.computeVertexNormals();
    });
  } else {
    runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["load"](model.url, new runner_morph_THREE.JSONLoader(runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["loadingManager"]), function (results) {
      model.geometry = results[0];
      model.geometry.computeFaceNormals();
      model.geometry.computeVertexNormals();
    });
  }
};

for (var runner_morph_key in runner_morph_models) {
  runner_morph__loop(runner_morph_key);
}

var runner_morph_textures = {
  male1: {
    url: __webpack_require__(208),
    size: 40160
  },
  male2: {
    url: __webpack_require__(209),
    size: 40270
  },
  male3: {
    url: __webpack_require__(210),
    size: 40451
  },
  female1: {
    url: __webpack_require__(211),
    size: 63260
  },
  female2: {
    url: __webpack_require__(212),
    size: 35650
  },
  female3: {
    url: __webpack_require__(213),
    size: 35076
  },
  elite1: {
    url: __webpack_require__(214),
    size: 39235
  },
  elite2: {
    url: __webpack_require__(215),
    size: 38034
  },
  elite3: {
    url: __webpack_require__(216),
    size: 37502
  },
  player1: {
    url: __webpack_require__(217),
    size: 150525
  }
};

var runner_morph__loop2 = function _loop2(key) {
  var texture = runner_morph_textures[key];
  var material = new runner_morph_THREE.MeshLambertMaterial({
    vertexColors: runner_morph_THREE.FaceColors,
    morphTargets: true,
    transparent: true,
    alphaTest: 0.1
  });

  texture.material = material;
  var url = texture.url;
  runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["registerSize"](url, texture.size);
  runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["load"](url, new runner_morph_THREE.TextureLoader(runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["loadingManager"]), function (results) {
    texture.material.map = results[0];

    if (texture.bump) {
      texture.material.bumpMap = results[0];
      texture.material.bumpScale = texture.bump;
    }

    texture.material.needsUpdate = true;
  });
};

for (var runner_morph_key in runner_morph_textures) {
  runner_morph__loop2(runner_morph_key);
}

var runner_morph_sounds = {};

var runner_morph__loop3 = function _loop3(key) {
  var sound = runner_morph_sounds[key];
  runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["registerSize"](sound.url, sound.size);
  runner_morph___WEBPACK_IMPORTED_MODULE_4__loader__["load"](sound.url, null, function (results) {
    sound.buffer = results[0];
  });
};

for (var runner_morph_key in runner_morph_sounds) {
  runner_morph__loop3(runner_morph_key);
}

var runner_morph_loaded = false;

var runner_morph_Runner = function () {
  function Runner(config) {
    var _this = this;

    runner_morph___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, Runner);

    this.checkAllLoaded = function () {
      for (var key in _this.models) {
        if (!runner_morph_models[key].geometry) return false;
      }

      for (var _key in _this.textures) {
        if (!runner_morph_textures[_key].material.map) return false;
      }

      for (var _key2 in _this.state.sounds) {
        if (!_this.state.sounds[_key2].buffer) return false;
      }

      runner_morph_loaded = true;

      _this.init();
      return true;
    };

    this.updateAnimation = function (delta) {
      if (_this.mixer) {
        var weight = _this.state.velocity / __WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].velocityMax * 0.07;
        weight = Math.min(weight, 1.03);
        _this.mixer.timeScale = 0.96 + weight;

        _this.mixer.update(delta / 1000);
      }
    };

    this.update = function (delta) {

      if (!main_state) return;

      if (main_state.stage > __WEBPACK_IMPORTED_MODULE_9__stages__["INTRO"] && _this.state.autoUpdateState) {
        _this.updateState(delta);
      }
      _this.updatePosition();

      _this.updateAnimation(delta);
    };

    this.start = function () {

      if (!_this.state.initialized) _this.init();

      _this.mesh.visible = true;
      _this.isPlaying = true;

      if (_this.model) {
        _this.fadeInAnim('run', 0, Math.random() * 3);
      }
    };

    this.stop = function () {
      _this.isPlaying = false;
    };

    this.reset = function () {
      _this.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a({}, _this.initialState);
      _this.updatePosition();
      for (var key in _this.actions) {
        var action = _this.actions[key];

        action.play();
        action.fadeOut();
      }
    };

    this.fadeInAnim = function (key, time, delay) {
      var action = _this.actions[key];
      if (!action) return;
      action.startAt(_this.mixer.time - delay);
      action.crossFadeFrom(_this.currAction, time);
      _this.currAction = action;
    };

    this.turnElite = function (idx) {
      _this.state.isElite = true;
      _this.material.map = runner_morph_textures['elite' + (idx + 1)].material.map;
      _this.material.needsUpdate = true;
    };

    this.fadeTo = function (opacity) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      _this.model.visible = true;
      __WEBPACK_IMPORTED_MODULE_8_gsap__["TweenMax"].to(_this.material, time, {
        opacity: opacity,
        ease: __WEBPACK_IMPORTED_MODULE_8_gsap__["Cubic"].easeOut,
        onUpdate: function onUpdate() {
          _this.material.needsUpdate = true;
        },
        onComplete: function onComplete() {
          if (_this.material.opacity === 0) {
            _this.mesh.visible = false;
          }
        }
      });
    };

    this.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a({
      initialized: false,
      models: runner_morph_models,
      textures: runner_morph_textures,
      isPlayer: false,
      isElite: false,
      isPacer: false,
      type: 'male',
      idx: 0,
      materialIdx: null,
      path: null,
      color: 0xEB0033,
      baseVelocity: 1,
      distance: 1,
      distanceStart: 1,
      currDistance: 1,
      swipeVelocity: 0,
      swipeVelocityMax: 0,
      velocity: 0,
      sps: 0,
      spsMax: 0,
      px: 0,
      offset: 0,
      sounds: runner_morph_sounds,
      minVel: 0,
      maxVel: 0,
      multiplyVelocity: 0,
      addVelocity: 0,
      autoUpdateState: true
    }, config);
    this.initialState = this.state;

    this.state.currDistance = this.state.distance;

    if (this.state.materialIdx === null) {
      this.state.materialIdx = this.state.idx % 3;
    }

    this.mesh = new runner_morph_THREE.Object3D();
    this.mesh.name = 'runner';

    this.audio = {};
    for (var key in this.state.sounds) {
      var audio = void 0;

      if (this.state.sounds[key].positional === false) {
        audio = new runner_morph_THREE.Audio(__WEBPACK_IMPORTED_MODULE_11__listener__["a" /* default */]);
      } else {
        audio = new runner_morph_THREE.PositionalAudio(__WEBPACK_IMPORTED_MODULE_11__listener__["a" /* default */]);
        audio.setRefDistance(this.state.sounds[key].distance || 1);
        audio.position.x = this.state.sounds[key].x || 0;
        audio.position.y = this.state.sounds[key].y || 0;
      }
      audio.setLoop(false);
      this.audio[key] = audio;
      this.mesh.add(this.audio[key]);
    }
  }

  runner_morph___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(Runner, [{
    key: 'init',
    value: function init() {
      if (this.state.initialized) return;
      this.state.initialized = true;
      this.initTexture();
      if (runner_morph_models[this.state.type].type === 'jd') {
        this.initJdModel();
      } else {
        this.initModel();
      }
      this.initAudio();
      this.updatePosition();
    }
  }, {
    key: 'initJdModel',
    value: function initJdModel() {
      var geometry = void 0;
      switch (this.state.type) {
        case 'female':
          geometry = runner_morph_models.female.geometry;
          break;
        case 'player':
          geometry = runner_morph_models.player.geometry;
          break;
        default:
          geometry = runner_morph_models.male.geometry;
          break;
      }

      var materialKey = '' + this.state.type + (this.state.materialIdx + 1);
      var material = runner_morph_textures[materialKey].material;

      this.material = material.clone();

      this.model = new runner_morph_THREE.SkinnedMesh(geometry, this.material);
      this.model.castShadow = true;
      var scale = window.Maf.randomInRange(0.0220, 0.0230);
      this.model.scale.setScalar(scale);

      if (!this.state.isPlayer) {
        this.model.position.x = this.state.offset;
      }
      this.model.castShadow = true;
      this.mesh.add(this.model);

      this.mixer = new runner_morph_THREE.AnimationMixer(this.model);
      var clips = geometry.animations;
      this.actions = {};var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = runner_morph___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(clips), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var clip = _step.value;

          var action = this.mixer.clipAction(clip);
          this.actions[clip.name] = action;
          action.play();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!this.isPlayer) {
        this.currAction = this.actions['ready'];
      } else {
        this.currAction = this.actions['intro'];
        this.currAction.setLoop(runner_morph_THREE.LoopOnce);
      }
      this.mixer.update(0);
    }
  }, {
    key: 'initModel',
    value: function initModel() {
      var geometry = void 0;
      switch (this.state.type) {
        case 'female':
          geometry = runner_morph_models.female.geometry;
          break;
        case 'player':
          geometry = runner_morph_models.player.geometry;
          break;
        default:
          geometry = runner_morph_models.male.geometry;
          break;
      }

      var materialKey = '' + this.state.type + (this.state.materialIdx + 1);
      var material = runner_morph_textures[materialKey].material;

      this.material = material.clone();

      this.model = new runner_morph_THREE.SkinnedMesh(geometry, this.material);
      this.model.castShadow = true;
      this.model.scale.setScalar(0.0225);

      if (!this.state.isPlayer) {
        this.model.position.x = this.state.offset;
      }
      this.mesh.add(this.model);

      this.mixer = new runner_morph_THREE.AnimationMixer(this.model);

      var clip = runner_morph_THREE.AnimationClip.CreateFromMorphTargetSequence('gallop', geometry.morphTargets, 30);
      this.actions = {
        run: this.mixer.clipAction(clip)
      };

      if (!this.isPlayer) {
        this.currAction = this.actions['run'];
      } else {}
      this.mixer.update(0);
    }
  }, {
    key: 'initTexture',
    value: function initTexture() {}
  }, {
    key: 'initAudio',
    value: function initAudio() {
      for (var key in this.audio) {
        var audio = this.audio[key];
        audio.setBuffer(this.state.sounds[key].buffer);
        audio.setVolume(0.001);
        audio.play();
      }
    }
  }, {
    key: 'updateState',
    value: function updateState(delta) {

      var min = Math.max(main_state.velocity.now + 1, this.state.minVel);
      min = Math.min(min, this.state.maxVel);
      this.state.minVel = min;

      var vel = main_state.velocity.now * this.state.multiplyVelocity + this.state.addVelocity;
      vel = Math.max(vel, this.state.minVel);
      vel = Math.min(vel, this.state.maxVel);
      this.state.velocity = vel;

      this.state.px += this.state.velocity * delta;
      var progress = this.state.px / __WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].totalPx;
      this.state.distance = this.state.distanceStart + progress * __WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].numLaps;
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition() {

      if (!this.model) return;

      this.state.currDistance += (this.state.distance - this.state.currDistance) / 5;

      var pt1 = this.state.path.getPointAt(this.state.currDistance % 1);
      this.mesh.position.set(pt1.x, pt1.y, pt1.z);

      var pt2 = this.state.path.getPointAt((this.state.currDistance + 0.005) % 1);
      this.mesh.lookAt(pt2);
    }
  }]);

  return Runner;
}();

/* harmony default export */ var runner_morph_defaultExport = (runner_morph_Runner);
// CONCATENATED MODULE: ./src/components/game/objects/sky.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loader__ = __webpack_require__(3);
/* harmony import */ var sky___WEBPACK_IMPORTED_MODULE_1__renderer__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scene__ = __webpack_require__(29);
/* harmony import */ var sky___WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
var sky_THREE = __webpack_require__(0);




var skyboxTextureUrl = __webpack_require__(578);
__WEBPACK_IMPORTED_MODULE_0__loader__["registerSize"](skyboxTextureUrl, 45812);

var sky_textureLoader = new sky_THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_0__loader__["loadingManager"]);

var geometry = new sky_THREE.SphereGeometry(2000, 64, 64);
var material = new sky_THREE.MeshBasicMaterial({
  side: sky_THREE.BackSide,
  fog: false
});

var sky_mesh = new sky_THREE.Mesh(geometry, material);
/* harmony default export */ var sky_defaultExport = (sky_mesh);
sky_mesh.scale.set(2, 1, 2);
sky_mesh.scale.multiplyScalar(sky___WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].worldScale);

__WEBPACK_IMPORTED_MODULE_2__scene__["a" /* default */].add(sky_mesh);

__WEBPACK_IMPORTED_MODULE_0__loader__["load"](skyboxTextureUrl, sky_textureLoader, function (textureResults) {
  var texture = textureResults[0];
  material.map = texture;
  material.needsUpdate = true;
  texture.anisotropy = sky___WEBPACK_IMPORTED_MODULE_1__renderer__["maxAnisotropy"];
  texture.wrapS = texture.wrapT = sky_THREE.RepeatWrapping;
});
// CONCATENATED MODULE: ./src/components/game/objects/buildings.js
/* harmony import */ var buildings___WEBPACK_IMPORTED_MODULE_0__loader__ = __webpack_require__(3);
/* harmony import */ var buildings___WEBPACK_IMPORTED_MODULE_1__renderer__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scene__ = __webpack_require__(29);
var buildings_THREE = __webpack_require__(0);




var buildings_base = __webpack_require__(16).build.assetsPublicPath;
var textureUrl = __webpack_require__(579);
buildings___WEBPACK_IMPORTED_MODULE_0__loader__["registerSize"](textureUrl, 80919);
var modelUrl = __webpack_require__(580);
buildings___WEBPACK_IMPORTED_MODULE_0__loader__["registerSize"](modelUrl, 2428);



var buildings_mesh = new buildings_THREE.Object3D();
buildings_mesh.name = 'buildings';
/* harmony default export */ var buildings_defaultExport = (buildings_mesh);

buildings_mesh.scale.set(3, 1, 3);
buildings_mesh.scale.multiplyScalar(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].worldScale);

var buildings_material = new buildings_THREE.MeshBasicMaterial({
  fog: false,
  transparent: true
});

var buildings_textureLoader = new buildings_THREE.TextureLoader(buildings___WEBPACK_IMPORTED_MODULE_0__loader__["loadingManager"]);
buildings___WEBPACK_IMPORTED_MODULE_0__loader__["load"](textureUrl, buildings_textureLoader, function (results) {
  var texture = results[0];
  buildings_material.map = texture;
  texture.anisotropy = buildings___WEBPACK_IMPORTED_MODULE_1__renderer__["maxAnisotropy"];
  texture.wrapS = texture.wrapT = buildings_THREE.RepeatWrapping;
  buildings_material.needsUpdate = true;
});

var buildings_modelLoader = new buildings_THREE.JSONLoader(buildings___WEBPACK_IMPORTED_MODULE_0__loader__["loadingManager"]);
buildings___WEBPACK_IMPORTED_MODULE_0__loader__["load"](modelUrl, buildings_modelLoader, function (results) {
  var geometry = results[0];
  geometry.computeFaceNormals();
  geometry.computeVertexNormals();
  var model = new buildings_THREE.Mesh(geometry, buildings_material);
  model.scale.setScalar(1);
  buildings_mesh.add(model);
});
// CONCATENATED MODULE: ./src/components/game/runner/vehicle.js
/* harmony import */ var vehicle___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var vehicle___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(vehicle___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var vehicle___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var vehicle___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(vehicle___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_gsap__);
/* harmony import */ var vehicle___WEBPACK_IMPORTED_MODULE_13_lerp__ = __webpack_require__(41);
/* harmony import */ var vehicle___WEBPACK_IMPORTED_MODULE_13_lerp___default = __webpack_require__.n(vehicle___WEBPACK_IMPORTED_MODULE_13_lerp__);









var vehicle_THREE = __webpack_require__(0);







var vehicle_Vehicle = function (_Runner) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default.a(Vehicle, _Runner);

  function Vehicle(config) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a(this, Vehicle);

    var state = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a(config, { autoUpdateState: false });

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (Vehicle.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a(Vehicle)).call(this, state));

    _this.toUser = function () {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -0.5;

      _this.state.distance = _this.state.distanceStart + main_state.progress.percent + offset;
    };

    _this.toUserFront = function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var startOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -0.01;
      var endOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.012;

      if (_this.tween) _this.tween.kill();

      var startDistance = _this.state.distanceStart + main_state.progress.percent + startOffset;

      _this.state.distance = startDistance;
      _this.tween = __WEBPACK_IMPORTED_MODULE_12_gsap__["TweenMax"].to({ val: 0 }, time, {
        val: 1,
        ease: __WEBPACK_IMPORTED_MODULE_12_gsap__["Expo"].easeOut,
        onUpdateParams: ['{self}'],
        onUpdate: function onUpdate(tween) {
          var endDistance = _this.state.distanceStart + main_state.progress.percent + endOffset;
          _this.state.distance = vehicle___WEBPACK_IMPORTED_MODULE_13_lerp___default.a(startDistance, endDistance, tween.target.val);
        }
      });
    };

    _this.catchUpAndPass = function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.6;
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var percentInfront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.003;
      var maxVel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;
      var multiplier = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.02;

      var startDistance = _this.state.distanceStart + main_state.progress.percent - 0.005;
      _this.state.distance = startDistance;

      _this.state.distance = startDistance;
      var tl = new __WEBPACK_IMPORTED_MODULE_12_gsap__["TimelineMax"]();

      var rotStart = new vehicle_THREE.Vector3(0, vehicle_THREE.Math.DEG2RAD * 180, 0);
      var posStart = _this.model.position;

      tl.addLabel('start').to({ val: 0 }, time, {
        val: 1,

        ease: __WEBPACK_IMPORTED_MODULE_12_gsap__["Linear"].easeNone,
        onUpdateParams: ['{self}'],
        onUpdate: function onUpdate(tween) {
          var endDistance = _this.state.distanceStart + main_state.progress.percent + percentInfront;
          _this.state.distance = vehicle___WEBPACK_IMPORTED_MODULE_13_lerp___default.a(startDistance, endDistance, tween.target.val);
        },
        onComplete: function onComplete() {
          _this.state.px = (main_state.progress.percent + percentInfront) * __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].totalPx;
          _this.state.maxVel = maxVel;
          _this.state.autoUpdateState = true;
        }
      }).addLabel('end').to(_this.state, time, {
        delay: 2,
        multiplyVelocity: multiplier,
        ease: __WEBPACK_IMPORTED_MODULE_12_gsap__["Cubic"].easeIn
      }, 'end');
    };

    _this.stop = function (distance) {};

    _this.runToEnd = function (fromDistance) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
      var ease = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_12_gsap__["SlowMo"].ease.config(0.5, 0.8);

      var toDistance = 2.1;
      _this.state.px = fromDistance * __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].totalPx;
      _this.state.distance = fromDistance;
      _this.state.autoUpdateState = false;

      __WEBPACK_IMPORTED_MODULE_12_gsap__["TweenMax"].to(_this.state, time, {
        distance: toDistance,
        ease: ease
      });
    };

    _this.fadeTo = function (opacity) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return new vehicle___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_12_gsap__["TweenMax"].to({ opacity: _this.state.parts[0].material.opacity }, time, {
          opacity: opacity,
          ease: __WEBPACK_IMPORTED_MODULE_12_gsap__["Cubic"].easeOut,
          onUpdateParams: ['{self}'],
          onUpdate: function onUpdate(tween) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = vehicle___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(_this.state.parts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var part = _step.value;

                part.material.opacity = tween.target.opacity;
                part.material.needsUpdate = true;
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          },
          onComplete: resolve
        });
      });
    };

    _this.initialState = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a({}, state);

    _this.model = new vehicle_THREE.Object3D();

    _this.mesh.add(_this.model);
    _this.init();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default.a(Vehicle, [{
    key: 'initModel',
    value: function initModel() {
      var _this2 = this;

      var _loop = function _loop(part) {
        var url = part.model.url;
        var size = part.model.size;
        __WEBPACK_IMPORTED_MODULE_9__loader__["registerSize"](url, size);
        __WEBPACK_IMPORTED_MODULE_9__loader__["load"](url, new vehicle_THREE.JSONLoader(__WEBPACK_IMPORTED_MODULE_9__loader__["loadingManager"]), function (results) {
          part.geometry = results[0];
          part.geometry.computeFaceNormals();
          part.geometry.computeVertexNormals();

          part.material = new vehicle_THREE.MeshBasicMaterial({
            transparent: false,
            map: part.map
          });

          part.model = new vehicle_THREE.Mesh(part.geometry, part.material);
          part.model.scale.setScalar(part.scale * __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].worldScale);
          part.model.position.set(part.x || 0, part.y || 0, part.z || 0);
          part.model.castShadow = true;
          _this2.model.add(part.model);
        });
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {

        for (var _iterator2 = vehicle___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(this.state.parts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var part = _step2.value;

          _loop(part);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: 'initTexture',
    value: function initTexture() {
      var _loop2 = function _loop2(part) {
        var url = part.texture.url;
        var size = part.texture.size;
        __WEBPACK_IMPORTED_MODULE_9__loader__["registerSize"](url, size);
        __WEBPACK_IMPORTED_MODULE_9__loader__["load"](url, new vehicle_THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_9__loader__["loadingManager"]), function (results) {
          part.map = results[0];
          if (part.material) {
            part.material.map = part.map;
            part.material.needsUpdate = true;
          }
        });
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = vehicle___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(this.state.parts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var part = _step3.value;

          _loop2(part);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'initAudio',
    value: function initAudio() {
      var _this3 = this;

      var _loop3 = function _loop3(key) {
        var sound = _this3.state.sounds[key];
        __WEBPACK_IMPORTED_MODULE_9__loader__["registerSize"](sound.url, sound.size);
        __WEBPACK_IMPORTED_MODULE_9__loader__["load"](sound.url, null, function (results) {
          _this3.audio[key].setBuffer(results[0]);
          _this3.audio[key].setRolloffFactor(10);

          _this3.audio[key].setLoop(true);
          _this3.audio[key].setDistanceModel('inverse');
        });
      };

      for (var key in this.state.sounds) {
        _loop3(key);
      }
    }
  }]);

  return Vehicle;
}(runner_defaultExport);

/* harmony default export */ var vehicle_defaultExport = (vehicle_Vehicle);
// CONCATENATED MODULE: ./src/components/game/runner/car.js
/* harmony import */ var car___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var car___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(car___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var car___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(43);
/* harmony import */ var car___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(car___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var car___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var car___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(car___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader__ = __webpack_require__(3);
/* harmony import */ var car___WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(1);
/* harmony import */ var car___WEBPACK_IMPORTED_MODULE_7_gsap___default = __webpack_require__.n(car___WEBPACK_IMPORTED_MODULE_7_gsap__);






var car_THREE = __webpack_require__(0);




var car_base = __webpack_require__(16).build.assetsPublicPath;
var parts = [{
  model: {
    url: __webpack_require__(581),
    size: 172040
  },
  texture: {
    url: __webpack_require__(582),
    size: 65893
  },
  scale: 0.06
}, {
  model: {
    url: __webpack_require__(583),
    size: 124047
  },
  texture: {
    url: __webpack_require__(584),
    size: 14149
  },
  scale: 0.06
}];

var car_sounds = {
  car: {
    url: __webpack_require__(585),
    size: 46101,
    distance: 60
  }
};

var Car = function (_Vehicle) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a(Car, _Vehicle);

  function Car(config) {
    car___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, Car);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (Car.__proto__ || car___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(Car)).call(this, car___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a(config, { parts: parts, sounds: car_sounds, type: 'car' })));

    _this.start = function () {};

    _this.playAnim = function (time) {
      _this.toUserFront(time, -0.01, 0.002);
    };

    _this.model = new car_THREE.Object3D();
    _this.mesh.add(_this.model);
    _this.init();
    _this.model.rotation.y = car_THREE.Math.DEG2RAD * 0;
    return _this;
  }

  return Car;
}(vehicle_defaultExport);

/* harmony default export */ var car_defaultExport = (Car);
// CONCATENATED MODULE: ./src/components/game/runner/bike.js
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(bike___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(bike___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(43);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(bike___WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(bike___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(bike___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(bike___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader__ = __webpack_require__(3);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_8_gsap__ = __webpack_require__(1);
/* harmony import */ var bike___WEBPACK_IMPORTED_MODULE_8_gsap___default = __webpack_require__.n(bike___WEBPACK_IMPORTED_MODULE_8_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lerp__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lerp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lerp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(2);







var bike_THREE = __webpack_require__(0);







var bike_base = __webpack_require__(16).build.assetsPublicPath;
var bike_parts = [{
  model: {
    url: __webpack_require__(586),
    size: 159115
  },
  texture: {
    url: __webpack_require__(218),
    size: 55807
  },
  scale: 0.048
}, {
  model: {
    url: __webpack_require__(587),
    size: 108905
  },
  texture: {
    url: __webpack_require__(588),
    size: 61499
  },
  scale: 0.048
}, {
  model: {
    url: __webpack_require__(589),
    size: 137483
  },
  texture: {
    url: __webpack_require__(590),
    size: 52155
  },
  scale: 0.048
}];

var bike_sounds = {
  bike: {
    url: __webpack_require__(591),
    size: 58005,
    distance: 60
  }
};

var Bike = function (_Vehicle) {
  bike___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(Bike, _Vehicle);

  function Bike(config) {
    bike___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a(this, Bike);

    var _this = bike___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (Bike.__proto__ || bike___WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a(Bike)).call(this, bike___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a(config, { parts: bike_parts, sounds: bike_sounds, type: 'bike' })));

    _this.start = function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = bike___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(_this.model.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var part = _step.value;

          part.position.z = -1.6;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _this.model.position.z = 1.6;
    };

    _this.playAnim = function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.toUserFront(time, -0.015, 0.007);

      var rotStart = new bike_THREE.Vector3(0, bike_THREE.Math.DEG2RAD * 180, 0);
      var posStart = _this.model.position;

      _this.model.rotation.set(rotStart.x, rotStart.y, rotStart.z);
      bike___WEBPACK_IMPORTED_MODULE_8_gsap__["TweenMax"].to(_this.model.rotation, time, {
        x: rotStart.x + bike_THREE.Math.DEG2RAD * -50,

        ease: bike___WEBPACK_IMPORTED_MODULE_8_gsap__["Cubic"].easeIn
      });
    };

    _this.model = new bike_THREE.Object3D();
    _this.mesh.add(_this.model);

    _this.model.rotation.y = bike_THREE.Math.DEG2RAD * 180;
    return _this;
  }

  return Bike;
}(vehicle_defaultExport);

/* harmony default export */ var bike_defaultExport = (Bike);
// CONCATENATED MODULE: ./src/components/game/runner/horse.js
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(horse___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(43);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(horse___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(horse___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(horse___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(44);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(horse___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(horse___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_7__loader__ = __webpack_require__(3);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_8_gsap__ = __webpack_require__(1);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_8_gsap___default = __webpack_require__.n(horse___WEBPACK_IMPORTED_MODULE_8_gsap__);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_9_lerp__ = __webpack_require__(41);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_9_lerp___default = __webpack_require__.n(horse___WEBPACK_IMPORTED_MODULE_9_lerp__);
/* harmony import */ var horse___WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raf__ = __webpack_require__(4);







var horse_THREE = __webpack_require__(0);









var horse_base = __webpack_require__(16).build.assetsPublicPath;
var horse_parts = [{
  model: {
    url: __webpack_require__(592),
    size: 159115
  },
  texture: {
    url: __webpack_require__(218),
    size: 55807
  },
  scale: 0.02
}];

var Horse = function (_Runner) {
  horse___WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a(Horse, _Runner);

  function Horse(config) {
    horse___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a(this, Horse);

    var _this = horse___WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a(this, (Horse.__proto__ || horse___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a(Horse)).call(this, horse___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a(config, { parts: horse_parts, sounds: null, type: 'horse' })));

    _this.fadeInAnim = function () {};

    _this.state.autoUpdateState = true;
    _this.model = new horse_THREE.Object3D();
    _this.mesh.add(_this.model);

    window.horse = _this;

    return _this;
  }

  horse___WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a(Horse, [{
    key: 'initModel',
    value: function initModel() {
      var _this2 = this;

      var part = horse_parts[0];
      var url = part.model.url;
      var size = part.model.size;
      horse___WEBPACK_IMPORTED_MODULE_7__loader__["registerSize"](url, size);
      horse___WEBPACK_IMPORTED_MODULE_7__loader__["load"](url, new horse_THREE.JSONLoader(horse___WEBPACK_IMPORTED_MODULE_7__loader__["loadingManager"]), function (results) {

        console.log('hi');

        part.geometry = results[0];
        part.geometry.computeFaceNormals();
        part.geometry.computeVertexNormals();

        part.material = new horse_THREE.MeshLambertMaterial({
          vertexColors: horse_THREE.FaceColors,
          morphTargets: true
        });

        part.model = new horse_THREE.Mesh(part.geometry, part.material);
        part.model.scale.setScalar(part.scale * horse___WEBPACK_IMPORTED_MODULE_11__config__["a" /* config */].worldScale);
        part.model.position.set(part.x || 0, part.y || 0, part.z || 0);
        _this2.model.add(part.model);

        _this2.mixer = new horse_THREE.AnimationMixer(part.model);
        var clip = horse_THREE.AnimationClip.CreateFromMorphTargetSequence('gallop', part.geometry.morphTargets, 30);
        _this2.mixer.clipAction(clip).setDuration(1).play();
      });
    }
  }, {
    key: 'start',
    value: function start() {}
  }]);

  return Horse;
}(runner_defaultExport);

/* harmony default export */ var horse_defaultExport = (Horse);
// CONCATENATED MODULE: ./src/components/game/effects/confettisShader.js
/* harmony import */ var confettisShader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var confettisShader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(confettisShader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var confettisShader___WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var confettisShader___WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(confettisShader___WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var confettisShader___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var confettisShader___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(confettisShader___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raf__ = __webpack_require__(4);



var confettisShader_THREE = __webpack_require__(0);



var ConfettisShader = function () {
  function ConfettisShader(config) {
    var _this = this;

    confettisShader___WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a(this, ConfettisShader);

    this.state = confettisShader___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({
      confettisNb: 1000,
      sources: [{ x: -1, y: 0, z: 0 }, { x: 1, y: 0, z: 0, delay: 0.5 }],
      timeStep: 1 / 30,
      time: 5,
      started: false,
      colors: false
    }, config);

    this.mesh = new confettisShader_THREE.Object3D();
    this.mesh.name = 'confettis Shader';
    this.mesh.frustumCulled = false;

    this.sources = [];

    this.initShaders();
    this.initConfettisMaterial();

    for (var i = 0; i < this.state.sources.length; i++) {
      var source = this.state.sources[i];

      source.material = this.confettisMaterial.clone();
      source.geometry = this.initConfettisGeometry(source.angle);

      source.mesh = new confettisShader_THREE.Mesh(source.geometry, source.material);
      source.mesh.name = 'confettis Source ' + i;

      source.mesh.position.set(source.x, source.y, source.z);

      this.sources[i] = source;
      this.mesh.add(source.mesh);
    }

    __WEBPACK_IMPORTED_MODULE_3__raf__["a" /* default */].on('tick', function () {
      _this.update();
    });
  }

  confettisShader___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a(ConfettisShader, [{
    key: 'initShaders',
    value: function initShaders() {
      this.vertexShader = __webpack_require__(593);
      this.fragmentShader = __webpack_require__(594);
    }
  }, {
    key: 'randomRange',
    value: function randomRange(min, max) {
      return Math.random() * (max - min) + min;
    }
  }, {
    key: 'initConfettisMaterial',
    value: function initConfettisMaterial() {
      this.shaderAttributes = {
        aAnimation: { type: 'v2', value: null },
        aTranslation: { type: 'v3', value: null },
        aControlPoint0: { type: 'v3', value: null },
        aControlPoint1: { type: 'v3', value: null },
        aAxisAngle: { type: 'v4', value: null },
        aFrontColor: { type: 'c', value: null },
        aBackColor: { type: 'c', value: null }
      };

      this.shaderUniforms = {
        uTime: { type: 'f', value: 0 }
      };

      this.confettisMaterial = new confettisShader_THREE.ShaderMaterial({
        uniforms: this.shaderUniforms,
        vertexShader: this.vertexShader,
        fragmentShader: this.fragmentShader,
        transparent: true
      });
      this.confettisMaterial.side = confettisShader_THREE.DoubleSide;
    }
  }, {
    key: 'initConfettisGeometry',
    value: function initConfettisGeometry(angle) {
      var quads = this.state.confettisNb;
      var triangles = quads * 2;
      var chunkSize = 21845;
      var i = void 0,
          j = void 0;

      var geometry = new confettisShader_THREE.BufferGeometry();
      geometry.setIndex(new confettisShader_THREE.BufferAttribute(new Uint16Array(triangles * 3), 1));

      geometry.addAttribute('aAnimation', new confettisShader_THREE.BufferAttribute(new Float32Array(triangles * 3 * 2), 2));
      geometry.addAttribute('position', new confettisShader_THREE.BufferAttribute(new Float32Array(triangles * 3 * 3), 3));
      geometry.addAttribute('aTranslation', new confettisShader_THREE.BufferAttribute(new Float32Array(triangles * 3 * 3), 3));
      geometry.addAttribute('aControlPoint0', new confettisShader_THREE.BufferAttribute(new Float32Array(triangles * 3 * 3), 3));
      geometry.addAttribute('aControlPoint1', new confettisShader_THREE.BufferAttribute(new Float32Array(triangles * 3 * 3), 3));
      geometry.addAttribute('aAxisAngle', new confettisShader_THREE.BufferAttribute(new Float32Array(triangles * 3 * 4), 4));
      geometry.addAttribute('aFrontColor', new confettisShader_THREE.BufferAttribute(new Float32Array(triangles * 3 * 3), 3));
      geometry.addAttribute('aBackColor', new confettisShader_THREE.BufferAttribute(new Float32Array(triangles * 3 * 3), 3));

      var indices = geometry.index.array;

      for (i = 0; i < indices.length; i++) {
        indices[i] = i % (3 * chunkSize);
      }

      var animation = geometry.attributes.aAnimation.array;

      for (i = 0; i < animation.length; i += 12) {

        var delay = this.randomRange(0, 0);
        var duration = this.randomRange(3, 20);

        for (j = 0; j < 12; j += 2) {
          animation[i + j + 0] = delay;
          animation[i + j + 1] = duration;
        }
      }

      var positions = geometry.attributes.position.array;
      var halfWidth = 0.02;
      var halfHeight = halfWidth * 0.6;
      var a = new confettisShader_THREE.Vector3(-halfWidth, halfHeight, 0);
      var b = new confettisShader_THREE.Vector3(halfWidth, halfHeight, 0);
      var c = new confettisShader_THREE.Vector3(halfWidth, -halfHeight, 0);
      var d = new confettisShader_THREE.Vector3(-halfWidth, -halfHeight, 0);
      var vertices = [a, d, b, d, c, b];
      var v = void 0;

      for (i = 0; i < positions.length; i += 18) {
        v = 0;

        for (j = 0; j < 18; j += 3) {
          positions[i + j + 0] = vertices[v].x;
          positions[i + j + 1] = vertices[v].y;
          positions[i + j + 2] = vertices[v].z;

          v++;
        }
      }

      var translations = geometry.attributes.aTranslation.array;
      var t = new confettisShader_THREE.Vector3();

      for (i = 0; i < translations.length; i += 18) {
        var phi = Math.random() * Math.PI * 2;
        var radius = 4;
        var x1 = this.randomRange(-4, 4);
        var y1 = 0;
        var z1 = this.randomRange(-4, 4);

        t.x = x1 + radius * Math.cos(phi) * Math.random();
        t.z = z1 + radius * Math.sin(phi) * Math.random();

        for (j = 0; j < 18; j += 3) {
          translations[i + j + 0] = t.x;
          translations[i + j + 1] = t.y;
          translations[i + j + 2] = t.z;
        }
      }

      var controlPoints0 = geometry.attributes.aControlPoint0.array;
      var controlPoints1 = geometry.attributes.aControlPoint1.array;
      var cp0 = new confettisShader_THREE.Vector3();
      var cp1 = new confettisShader_THREE.Vector3();

      for (i = 0; i < controlPoints0.length; i += 18) {
        cp0.x = this.randomRange(angle, 0);
        cp0.y = this.randomRange(10, 0);
        cp0.z = this.randomRange(0, 0);

        cp1.x = this.randomRange(-8, 8);
        cp1.y = this.randomRange(20, 10);
        cp1.z = this.randomRange(-8, 8);

        for (j = 0; j < 18; j += 3) {
          controlPoints0[i + j + 0] = cp0.x;
          controlPoints0[i + j + 1] = cp0.y;
          controlPoints0[i + j + 2] = cp0.z;

          controlPoints1[i + j + 0] = cp1.x;
          controlPoints1[i + j + 1] = cp1.y;
          controlPoints1[i + j + 2] = cp1.z;
        }
      }

      var axisAngles = geometry.attributes.aAxisAngle.array;
      var a2 = new confettisShader_THREE.Vector3();

      for (i = 0; i < axisAngles.length; i += 24) {
        a2.x = Math.random();
        a2.y = 0;
        a2.z = Math.random();
        a2.normalize();

        a2.w = Math.PI * this.randomRange(0, 60);

        for (j = 0; j < 24; j += 4) {
          axisAngles[i + j + 0] = a2.x;
          axisAngles[i + j + 1] = a2.y;
          axisAngles[i + j + 2] = a2.z;
          axisAngles[i + j + 3] = a2.w;
        }
      }

      var frontColors = geometry.attributes.aFrontColor.array;
      var backColors = geometry.attributes.aBackColor.array;

      var hue = 0;
      var front = new confettisShader_THREE.Color();
      var back = new confettisShader_THREE.Color();

      for (i = 0; i < frontColors.length; i += 18) {

        if (!this.state.colors) {
          hue = Math.random();
          front.setHSL(hue, 1.0, 0.5);
          back.setHSL(hue, 0.65, 0.5);
        } else {
          var color = this.state.colors[Math.floor(Math.random() * this.state.colors.length)].replace('#', '0x');
          front.setHex(color);
          back.setHex(color);
        }

        for (j = 0; j < 18; j += 3) {
          frontColors[i + j + 0] = front.r;
          frontColors[i + j + 1] = front.g;
          frontColors[i + j + 2] = front.b;

          backColors[i + j + 0] = back.r;
          backColors[i + j + 1] = back.g;
          backColors[i + j + 2] = back.b;
        }
      }

      var offsets = triangles / chunkSize;

      for (i = 0; i < offsets; i++) {
        var offset = {
          start: i * chunkSize * 3,
          index: i * chunkSize * 3,
          count: Math.min(triangles - i * chunkSize, chunkSize) * 3
        };

        geometry.groups.push(offset);
      }

      return geometry;
    }
  }, {
    key: 'update',
    value: function update() {
      if (!this.state.started) return false;

      this.shaderUniforms.uTime.value = this.state.time;
      this.shaderUniforms.uTime.needsUpdate = true;

      this.state.time += this.state.timeStep;

      for (var i = 0; i < this.sources.length; i++) {
        if (this.sources[i].material.uniforms.uTime.value === 0) this.sources[i].material.uniforms.uTime.value = 3;

        if (this.sources[i].delay) {
          if (this.state.time > this.sources[i].delay) this.sources[i].material.uniforms.uTime.value += this.state.timeStep;
        } else {
          this.sources[i].material.uniforms.uTime.value += this.state.timeStep;
        }
      }
    }
  }, {
    key: 'enable',
    value: function enable() {
      this.state.started = true;
    }
  }, {
    key: 'reset',
    value: function reset() {
      for (var i = 0; i < this.sources.length; i++) {
        this.sources[i].material.uniforms.uTime.value = 0;
      }
      this.state.time = 0;
      this.state.started = false;
    }
  }]);

  return ConfettisShader;
}();

/* harmony default export */ var confettisShader_defaultExport = (ConfettisShader);
// CONCATENATED MODULE: ./src/components/game/effects/smoke.js
var smoke_namespaceObject = {};
__webpack_require__.d(smoke_namespaceObject, "mesh", function() { return smoke_mesh; });
__webpack_require__.d(smoke_namespaceObject, "group", function() { return group; });
__webpack_require__.d(smoke_namespaceObject, "emitter", function() { return emitter; });
__webpack_require__.d(smoke_namespaceObject, "update", function() { return smoke_update; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shader_particle_engine__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shader_particle_engine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shader_particle_engine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__track_tiled_config__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clock__ = __webpack_require__(47);
var smoke_THREE = __webpack_require__(0);






var smokeUrl = __webpack_require__(596);
__WEBPACK_IMPORTED_MODULE_2__loader__["registerSize"](smokeUrl, 29328);

var texture = new smoke_THREE.Texture();
__WEBPACK_IMPORTED_MODULE_2__loader__["load"](smokeUrl, new smoke_THREE.ImageLoader(__WEBPACK_IMPORTED_MODULE_2__loader__["loadingManager"]), function (results) {
  texture.image = results[0];
  texture.needsUpdate = true;
});

var smoke_mesh = new smoke_THREE.Object3D();
smoke_mesh.name = 'smoke';

var numParticles = 80;

var group = new __WEBPACK_IMPORTED_MODULE_0_shader_particle_engine__["Group"]({
  texture: {
    value: texture
  },

  depthTest: false,
  depthWrite: false,
  maxParticleCount: numParticles
});

var emitter = new __WEBPACK_IMPORTED_MODULE_0_shader_particle_engine__["Emitter"]({
  particleCount: numParticles,
  duration: null,
  maxAge: {
    value: 2
  },
  position: {
    value: new smoke_THREE.Vector3(0, 0, -240),
    spread: new smoke_THREE.Vector3(180, 180, 20),
    randomise: true
  },

  acceleration: {
    value: new smoke_THREE.Vector3(0, 0, 100),
    spread: new smoke_THREE.Vector3(0, 0, 50)
  },

  velocity: {
    value: new smoke_THREE.Vector3(0, 0, 200),
    spread: new smoke_THREE.Vector3(0, 0, 20)
  },

  angle: {
    value: [0, 90 * smoke_THREE.Math.DEG2RAD],
    spread: [90 * smoke_THREE.Math.DEG2RAD, 90 * smoke_THREE.Math.DEG2RAD]
  },

  color: {
    value: [new smoke_THREE.Color(0xEB0033)]
  },

  opacity: {
    value: [0, 0.3, 0]
  },

  size: {
    value: 150,
    spread: 50
  }

});
emitter.disable();
group.addEmitter(emitter);
group.mesh.renderOrder = 200;
smoke_mesh.add(group.mesh);

var smoke_update = function update() {
  group.tick();
};
// CONCATENATED MODULE: ./src/components/game/effects/speedLines.js
/* harmony import */ var speedLines___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var speedLines___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(speedLines___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var speedLines___WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var speedLines___WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(speedLines___WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var speedLines___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var speedLines___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(speedLines___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var speedLines___WEBPACK_IMPORTED_MODULE_3__raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gsap__);



var speedLines_THREE = __webpack_require__(0);





var speedLines_SpeedLines = function () {
  function SpeedLines(config) {
    var _this = this;

    speedLines___WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a(this, SpeedLines);

    this.update = function () {
      var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      for (var i = 0; i < _this.state.lines; i++) {
        _this.lines[i].material.uniforms.time.value += delta / (1000 / 60);
        _this.lines[i].material.uniforms.velocity.value = main_state.velocity.now;
        _this.lines[i].material.uniforms.opacity.value = _this.opacity;
      }
    };

    this.mesh = new speedLines_THREE.Object3D();
    this.mesh.name = 'VelocityEffectShaders';

    this.state = speedLines___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({
      lines: 100,
      time: 0
    }, config);

    var s = 0.1;
    this.mesh.scale.set(s, s, s);
    this.mesh.position.x = 7;
    this.mesh.position.y = 8;
    this.mesh.position.z = 17;

    this.opacity = 1;

    this.lines = [];

    this.initShaders();
    this.initLinesGeometry();
  }

  speedLines___WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a(SpeedLines, [{
    key: 'NbRand',
    value: function NbRand(min, max) {
      return Math.random() * max + min;
    }
  }, {
    key: 'initShaders',
    value: function initShaders() {
      this.vertexShader = __webpack_require__(597);
      this.fragmentShader = __webpack_require__(598);
    }
  }, {
    key: 'initLinesGeometry',
    value: function initLinesGeometry() {
      var geometry = new speedLines_THREE.BoxGeometry(100, 0.3, 0.01);
      var bufferGeometry = new speedLines_THREE.BufferGeometry().fromGeometry(geometry);

      for (var i = 0; i < this.state.lines; i++) {

        var shaderMaterial = new speedLines_THREE.RawShaderMaterial({
          vertexShader: this.vertexShader,
          fragmentShader: this.fragmentShader,
          transparent: true,
          uniforms: {
            time: { type: 'f', value: 0 },
            ypos: { type: 'f', value: this.NbRand(-10, 10) },
            velocity: { type: 'f', value: this.NbRand(0, 10) },
            velocityMax: { type: 'f', value: __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].velocityMax },
            opacity: { type: 'f', value: 0 }
          },
          depthTest: false,
          depthWrite: false
        });

        this.lines[i] = new speedLines_THREE.Mesh(bufferGeometry, shaderMaterial);
        this.lines[i].rotation.y = Math.PI / 2;

        this.lines[i].position.y += this.NbRand(0, -100);
        this.lines[i].position.z += this.NbRand(0, -100);
        this.lines[i].position.x += this.NbRand(0, -100);

        this.mesh.add(this.lines[i]);
      }
    }
  }, {
    key: 'enable',
    value: function enable() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      __WEBPACK_IMPORTED_MODULE_6_gsap__["TweenMax"].to(this, time, {
        opacity: 1,
        ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Cubic"].easeIn
      });
    }
  }, {
    key: 'disable',
    value: function disable() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      __WEBPACK_IMPORTED_MODULE_6_gsap__["TweenMax"].to(this, time, {
        opacity: 0,
        ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Cubic"].easeIn
      });
    }
  }]);

  return SpeedLines;
}();

/* harmony default export */ var speedLines_defaultExport = (speedLines_SpeedLines);
// CONCATENATED MODULE: ./src/components/game/music.js
var music_namespaceObject = {};
__webpack_require__.d(music_namespaceObject, "data", function() { return data; });
__webpack_require__.d(music_namespaceObject, "default", function() { return music_defaultExport; });
__webpack_require__.d(music_namespaceObject, "loaded", function() { return music_loaded; });
__webpack_require__.d(music_namespaceObject, "checkAllLoaded", function() { return music_checkAllLoaded; });
__webpack_require__.d(music_namespaceObject, "loadAll", function() { return loadAll; });
__webpack_require__.d(music_namespaceObject, "state", function() { return music_state; });
__webpack_require__.d(music_namespaceObject, "play", function() { return play; });
__webpack_require__.d(music_namespaceObject, "stop", function() { return stop; });
__webpack_require__.d(music_namespaceObject, "animRate", function() { return animRate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listener__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader__ = __webpack_require__(3);
/* harmony import */ var music___WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var music___WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(music___WEBPACK_IMPORTED_MODULE_2_gsap__);
var music_THREE = __webpack_require__(0);




var data = {
  stage0: {
    url: __webpack_require__(599),
    size: 157209
  },
  stage1: {
    url: __webpack_require__(600),
    size: 157209
  },
  stage2_fast: {
    url: __webpack_require__(601),
    size: 157209
  },
  airport: {
    url: __webpack_require__(602),
    size: 157209
  },
  end_fast: {
    url: __webpack_require__(603),
    size: 141465
  },
  results: {
    url: __webpack_require__(604),
    size: 157209
  }
};
/* harmony default export */ var music_defaultExport = (data);

var loader = new music_THREE.AudioLoader(__WEBPACK_IMPORTED_MODULE_1__loader__["loadingManager"]);
for (var music_key in data) {
  var _data = data[music_key];

  _data.audio = new music_THREE.Audio(__WEBPACK_IMPORTED_MODULE_0__listener__["a" /* default */]);

  __WEBPACK_IMPORTED_MODULE_1__loader__["registerSize"](_data.url, _data.size);
}

var music_loaded = false;
var music_checkAllLoaded = function checkAllLoaded() {
  for (var _key in data) {
    var _data2 = data[_key];
    if (!_data2.buffer) return false;
  }
  music_loaded = true;

  return true;
};
var loadAll = function loadAll() {
  var _loop = function _loop(_key2) {
    var _data = data[_key2];
    __WEBPACK_IMPORTED_MODULE_1__loader__["load"](_data.url, null, function (results) {
      _data.buffer = results[0];
      _data.audio.setBuffer(results[0]);
      _data.audio.setLoop(true);
      _data.audio.playbackRate = 1;

      _data.audio.setVolume(0.0001);
      _data.audio.play();


      music_checkAllLoaded();
    });
  };

  for (var _key2 in data) {
    _loop(_key2);
  }
};

loadAll();

var music_state = {
  currentId: null,
  playing: false,
  playbackRate: 1
};

var play = function play(id) {

  music_state.playing = true;
  if (music_state.currentId === id) return;
  if (!data.hasOwnProperty(id)) return;

  var prevAudio = null;
  if (music_state.currentId !== null) {
    var prevObj = data[music_state.currentId];
    if (prevObj) prevAudio = prevObj.audio;
  }
  music_state.currentId = id;
  var nextAudio = data[music_state.currentId].audio;

  var prevTime = 0;
  if (prevAudio !== null) {
    prevTime = prevAudio.context.currentTime;
    prevAudio.fadeTo(0, 0.3);
    nextAudio.setPlaybackRate(prevAudio.getPlaybackRate());
  }
  nextAudio.startTime = prevTime;
  nextAudio.fadeTo(0.4, 0.3);
};

var stop = function stop() {
  if (!music_state.playing) return;
  music_state.playing = false;
  for (var _key3 in data) {
    var _data3 = data[_key3];
    _data3.audio.stop();
  }
};

var animRate = function animRate(rate) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (music_state.currentId === null) return;
  music___WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(music_state, time, {
    playbackRate: rate,
    ease: music___WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeIn,
    onUpdateParams: ['{self}'],
    onUpdate: function onUpdate(tween) {
      var audio = data[music_state.currentId].audio;
      audio.setPlaybackRate(music_state.playbackRate);
    }
  });
};
// CONCATENATED MODULE: ./src/components/game/main.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return player; });
/* unused harmony export runners */
/* unused harmony export elites */
/* unused harmony export animFocus */
/* unused harmony export playPrepare */
/* unused harmony export playIntro */
/* unused harmony export playResults */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return main_state; });
/* unused harmony export stopGame */
/* unused harmony export restartGame */
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(main___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lerp__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lerp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lerp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stages__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_router__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_i18n__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__renderer__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__controls__ = __webpack_require__(207);
/* harmony import */ var main___WEBPACK_IMPORTED_MODULE_14__clock__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__camera__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__camera_ui__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scene__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ui_cta__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ui_countdown__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_distance__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_scrollCta__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_scene__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_eyelid__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_dashboard__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__track_tiled_path__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__listener__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__sounds__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__result_scene__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__result_bg__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__result_flag__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__result_cloth__ = __webpack_require__(193);




var main_THREE = __webpack_require__(0);




__webpack_require__(82);
























































var player = new player_defaultExport({
  path: __WEBPACK_IMPORTED_MODULE_30__track_tiled_path__["c" /* path */],
  distance: __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].introDistance
});
__WEBPACK_IMPORTED_MODULE_18__scene__["a" /* default */].add(player.mesh);

dirLight.target = player.mesh;
player.mesh.add(ptLight2);

var speedWorldEase = __WEBPACK_IMPORTED_MODULE_5_gsap__["CustomEase"].create('custom', 'M0,0 C0,0 0.012,0.183 0.042,0.448 0.05,0.522 0.06,0.673 0.074,0.71 0.078,0.721 0.114,0.894 0.154,0.908 0.253,0.916 0.358,0.913 0.5,0.914 0.639,0.914 0.824,0.916 0.852,0.904 0.908,0.886 0.926,0.712 0.93,0.702 0.945,0.665 0.949,0.518 0.958,0.444 0.987,0.179 1,0 1,0');

var offsets = [];
for (var main_i = 0; main_i < __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].numRunners; main_i++) {
  var main_offset = main_i;
  main_offset -= __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].maxRunnerOffset * 2;
  if (main_offset >= 0) {
    main_offset += 1;
  }
  offsets.push(main_offset);
}


var runners = [];
for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].numRunners; _i++) {

  var row = Math.floor(_i / (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].maxRunnerOffset * 2)) + 1;

  var dOffset = row * 0.001;
  var d = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].startDistance - dOffset;

  var _offset = offsets.splice(window.Maf.randomInRange(0, offsets.length), 1)[0];

  var minVel = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].cpuVel.min + (_i + 1) / __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].numRunners * 2;

  var main_maxVel = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].cpuVel.min + (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].cpuVel.max - __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].cpuVel.min) * ((_i + 1) / __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].numRunners);

  var runnerConfig = {
    isPlayer: false,
    idx: _i,
    type: _i % 2 === 0 ? 'male' : 'female',

    path: __WEBPACK_IMPORTED_MODULE_30__track_tiled_path__["b" /* getPath */](_offset),
    distance: d,
    distanceStart: d,
    minVel: minVel,
    maxVel: main_maxVel,

    offset: 0
  };

  var runner = new runner_morph_defaultExport(runnerConfig);
  runner.state.autoUpdateState = true;
  __WEBPACK_IMPORTED_MODULE_18__scene__["a" /* default */].add(runner.mesh);
  runners.push(runner);
}

var maleRunners = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(runners, function (runner) {
  return runner.state.type === 'male';
});
var elites = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(maleRunners, function (runner) {
  return runner.state.maxVel;
});
elites = elites.splice(0, 3);

var car = new car_defaultExport({
  path: __WEBPACK_IMPORTED_MODULE_30__track_tiled_path__["c" /* path */],
  distance: __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length + 0.05
});
car.model.position.x = 5.3 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale;
__WEBPACK_IMPORTED_MODULE_18__scene__["a" /* default */].add(car.mesh);

var bike = new bike_defaultExport({
  path: __WEBPACK_IMPORTED_MODULE_30__track_tiled_path__["c" /* path */],
  distance: __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length + 0.03
});
bike.model.position.x = -3.2 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale;
__WEBPACK_IMPORTED_MODULE_18__scene__["a" /* default */].add(bike.mesh);

__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].add(smoke_mesh);


var confettisShader = new confettisShader_defaultExport({
  confettisNb: 2000,
  sources: [{ x: -1.2, y: 0, z: 0, angle: 5 }, { x: 1.2, y: 0, z: 0, delay: 0.5, angle: -5 }],
  timeStep: 1 / 30,
  colors: ['#4a535a', '#b5c5df', '#1142fe', '#5d409d', '#ef343f', '#3451c9']
});

var main_s = 200;
confettisShader.mesh.scale.set(main_s, main_s, main_s);
confettisShader.mesh.position.y = -100;
__WEBPACK_IMPORTED_MODULE_29__ui_dashboard__["a" /* default */].mesh.add(confettisShader.mesh);

var speedLines = new speedLines_defaultExport({
  lines: 400
});
speedLines.disable();
player.mesh.add(speedLines.mesh);

var animFocus = function animFocus(to) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_11__renderer__["boxBlurPass"].params.delta, time, {
      x: to,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
      onComplete: resolve
    });
  });
};

var main_playPrepare = function playPrepare() {

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    stop();
    __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].heartbeat.audio.play();

    __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].position.z = -100;
    game.renderer.boxBlurPass.params.delta.x = 0;
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].position.z = 0;
      resolve();
    }, 200);
  });
};

var main_playIntro = function playIntro() {

  stop();
  __WEBPACK_IMPORTED_MODULE_11__renderer__["boxBlurPass"].params.delta.x = 100;
  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].rotation.x = main_THREE.Math.DEG2RAD * 94;
  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].fov = 30;
  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].position.y = 2.5 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale;

  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].position.z = 0.53 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale;

  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].updateProjectionMatrix();

  player.model.visible = true;
  player.updatePosition();
  player.actions.intro.reset();
  player.actions.intro.setLoop(main_THREE.LoopOnce);
  player.actions.intro.paused = true;

  player.model.position.set(0, 0, 0.2);
  player.model.rotation.set(main_THREE.Math.DEG2RAD * 0, main_THREE.Math.DEG2RAD * 0, main_THREE.Math.DEG2RAD * -6);

  ptLight2.intensity = 0.7;

  __WEBPACK_IMPORTED_MODULE_26__ui_scrollCta__["hide"]();
  __WEBPACK_IMPORTED_MODULE_27__ui_scene__["hideDashboard"]();

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(runners), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _runner = _step.value;

      _runner.mesh.visible = false;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {

    var tl = new __WEBPACK_IMPORTED_MODULE_5_gsap__["TimelineMax"]({
      onStart: function onStart() {
        __WEBPACK_IMPORTED_MODULE_19__raf__["a" /* default */].on('tick', track_tiled_updateTextures);
      },
      onComplete: function onComplete() {

        __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__["draw"](__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].t('start')).then(function () {

          if (__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].locale !== 'en') __WEBPACK_IMPORTED_MODULE_23__ui_cta__["draw"](__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].t('scrollCta'));
          __WEBPACK_IMPORTED_MODULE_23__ui_cta__["animIn"]();
          __WEBPACK_IMPORTED_MODULE_26__ui_scrollCta__["show"]();
          return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_26__ui_scrollCta__["hide"](0.6);
              __WEBPACK_IMPORTED_MODULE_23__ui_cta__["animOut"](1);
              setTimeout(resolve, 800);
            }, 2500);
          });
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_24__ui_countdown__["play"]();
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_19__raf__["a" /* default */].removeListener('tick', track_tiled_updateTextures);
            resolve();
          }, 3200);
        });
      }
    });

    var introScale = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].introScale;
    var introScaleInvert = 1 / __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].introScale;
    __WEBPACK_IMPORTED_MODULE_19__raf__["a" /* default */].on('tick', player.updateAnimation);
    tl.addLabel('unblur').to(__WEBPACK_IMPORTED_MODULE_11__renderer__["boxBlurPass"].params.delta, 2, {
      x: 0,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
      onStart: function onStart() {
        player.model.scale.multiplyScalar(introScale);
        mesh.scale.multiplyScalar(introScale);
        __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].position.multiplyScalar(introScale);
        fog_defaultExport.far *= introScale;
        hemiLight.position.y *= introScaleInvert;
        ptLight2.far *= introScaleInvert;

        __WEBPACK_IMPORTED_MODULE_28__ui_eyelid__["open"](2);
      },
      onUpdate: function onUpdate() {}
    }).addLabel('adjust-shoe').to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].rotation, 0.2, {
      onStart: function onStart() {},
      onComplete: function onComplete() {
        player.actions.intro.paused = false;
      }
    }).to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].position, 1.5, {
      x: 0.13 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale * introScale,
      y: 2.0 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale * introScale,
      z: 0.3 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale * introScale,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut
    }, '-=0.3').to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].rotation, 1, {}).addLabel('look-up').to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].rotation, 2.0, {
      x: 0,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Power1"].easeOut,
      delay: 0,
      onStart: function onStart() {
        __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].heartbeat.audio.fadeTo(0, 2);

        __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].crowd_start.audio.setVolume(0);
        __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].crowd_start.audio.play();
        __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].crowd_start.audio.fadeTo(1, 2);


        setTimeout(function () {
          player.model.scale.multiplyScalar(introScaleInvert);
          mesh.scale.multiplyScalar(introScaleInvert);
          __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].position.multiplyScalar(introScaleInvert);
          fog_defaultExport.far *= introScaleInvert;
          hemiLight.position.y *= introScale;
          ptLight2.far *= introScale;
        }, 400);
      },
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_19__raf__["a" /* default */].removeListener('tick', player.updateAnimation);
        player.model.visible = false;
        tiles[0].showEmojis();
        tiles[tiles.length - 1].showEmojis();
      }
    }, 'look-up').to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */], 1.5, {
      fov: 60,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut,
      onUpdate: function onUpdate() {
        __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].updateProjectionMatrix();
      }
    }, 'look-up').to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].position, 1, {
      x: 0 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale,
      y: 2.25 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale,
      z: 0 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut
    }, '-=0.3').to(ptLight2, 1, {
      intensity: 1,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeIn
    }, 'look-up').addLabel('look-left').to(player.cameraAnchor.rotation, 1, {
      y: main_THREE.Math.DEG2RAD * 20,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut
    }).addLabel('look-right').to(player.cameraAnchor.rotation, 2, {
      y: main_THREE.Math.DEG2RAD * -20,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut
    }).addLabel('look-forward').to(player.cameraAnchor.rotation, 1, {
      y: main_THREE.Math.DEG2RAD * 0,
      ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut
    });
  });
};

var main_playResults = function playResults() {
  main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["RESULTS"];

  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].stopRun();

  __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_11__renderer__["zoomBlurPass"].params, 1, {
    strength: 0,
    ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
    onComplete: function onComplete() {}
  });

  speedLines.disable();
  emitter.disable();

  confettisShader.enable();


  car.stop();
  bike.stop();

  __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].crowd_finish.audio.play();
  play('results');

  __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__["draw"](__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].t('end'));

  __WEBPACK_IMPORTED_MODULE_12__controls__["destroy"]();
  player.stop();

  setTimeout(function () {
    stopGame();
    __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].crowd_finish.audio.fadeTo(0, 2);


    var query = {
      _duration: Math.round(main_state.duration)
    };
    if (__WEBPACK_IMPORTED_MODULE_8_src_store__["a" /* default */].state.wechat.username) query._name = __WEBPACK_IMPORTED_MODULE_8_src_store__["a" /* default */].state.wechat.username;
    if (__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].locale === 'en') query._locale = 'en';

    if (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].skipResults) return;
    __WEBPACK_IMPORTED_MODULE_9_src_router__["a" /* default */].replace({
      name: 'result',
      params: {
        isAuthor: true
      },
      query: query
    });
  }, 2000);
};

var b4helpFov = 0;
var helpFovTween = void 0;
var helpFocusTween = void 0;
var helpScrollTimeout = void 0;
var main_showHelp = function showHelp() {
  if (!__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].helpModeAvailable) return;

  if (main_state.help) return;
  main_state.help = true;
  showNextHelpMsg();

  clearTimeout(helpScrollTimeout);
  helpScrollTimeout = setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_26__ui_scrollCta__["show"]();
  }, 1000);
  animRate(0.5, 3);

  console.log('showHelp');

  b4helpFov = __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].fov;
  if (helpFovTween) helpFovTween.kill();
  helpFovTween = __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */], 4, {
    fov: 30,
    ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
    onUpdate: function onUpdate() {
      __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].updateProjectionMatrix();
    }
  });

  if (helpFocusTween) helpFocusTween.kill();
  helpFocusTween = __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_11__renderer__["boxBlurPass"].params.delta, 4, {
    x: 5,
    ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut,
    repeat: -1,
    yoyo: true,
    onStart: function onStart() {}
  });
};

var main_hideHelp = function hideHelp() {
  if (!main_state.help) return;
  __WEBPACK_IMPORTED_MODULE_26__ui_scrollCta__["hide"]();
  main_state.help = false;
  animRate(1, 1);

  console.log('hideHelp');

  clearTimeout(helpScrollTimeout);

  helpFovTween.kill();
  helpFovTween = __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */], 1, {
    fov: b4helpFov,
    ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
    onUpdate: function onUpdate() {
      __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].updateProjectionMatrix();
    }
  });

  helpFocusTween.kill();
  helpFocusTween = __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_11__renderer__["boxBlurPass"].params.delta, 1, {
    x: 0,
    ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
    onComplete: function onComplete() {
      if (main_state.stage < __WEBPACK_IMPORTED_MODULE_6__stages__["END_START"]) {}
    }
  });
};

var helpMsgsIdx = 0;
var showNextHelpMsg = function showNextHelpMsg() {
  var msgs = __WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].t('help');
  __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__["draw"](msgs[helpMsgsIdx]);
  helpMsgsIdx++;
  if (helpMsgsIdx >= msgs.length) helpMsgsIdx = 0;
};

var main_state = {
  stage: __WEBPACK_IMPORTED_MODULE_6__stages__["INTRO"],
  startTime: null,
  duration: 0,
  help: false,
  progress: {
    px: 0,
    percent: 0 },
  velocity: {
    now: 0,
    avg: 0,
    max: 0,
    percent: 0
  },
  numInfront: 0,
  stage2: {
    startTime: null,
    duration: null,
    velocity: {
      base: null,
      avg: null
    },
    charge: 0
  }
};
var initialState = main___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({}, main_state);

var main_resetState = function resetState() {
  main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["INTRO"];
  main_state.startTime = null;
  main_state.duration = 0;
  main_state.progress.px = 0;
  main_state.progress.percent = 0;
  main_state.velocity.now = 0;
  main_state.velocity.avg = 0;
  main_state.velocity.max = 0;
  main_state.velocity.percent = 0;
  main_state.stage2.startTime = null;
  main_state.stage2.duration = null;
  main_state.stage2.velocity.base = null;
  main_state.stage2.velocity.avg = null;
  main_state.stage2.charge = 0;
  main_state.help = false;
  __WEBPACK_IMPORTED_MODULE_26__ui_scrollCta__["hide"]();
  animRate(1, 1);
};

var main_updateState = function updateState() {
  main___WEBPACK_IMPORTED_MODULE_14__clock__["state"].delta = main___WEBPACK_IMPORTED_MODULE_14__clock__["clock"].getDelta();
  var now = performance.now();

  main_state.progress.px = __WEBPACK_IMPORTED_MODULE_12__controls__["state"].px;
  main_state.velocity.now = __WEBPACK_IMPORTED_MODULE_12__controls__["state"].velocity;

  main_state.progress.percent = main_state.progress.px / __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].totalPx;
  main_state.duration = now - main_state.startTime;
  main_state.velocity.avg = main_state.progress.px / (main_state.duration / 1000);
  main_state.velocity.max = Math.max(main_state.velocity.now, main_state.velocity.max);
  main_state.velocity.percent = Math.min(main_state.velocity.now / __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].velocityMax, 1);

  if (__WEBPACK_IMPORTED_MODULE_12__controls__["state"].inactive && !main_state.help && main_state.stage < __WEBPACK_IMPORTED_MODULE_6__stages__["END_START"]) {
    main_showHelp();
  } else if (!__WEBPACK_IMPORTED_MODULE_12__controls__["state"].inactive && main_state.help) {
    main_hideHelp();
  }

  var distanceRounded = Math.round(main_state.progress.percent * 42);
  __WEBPACK_IMPORTED_MODULE_25__ui_distance__["play"](distanceRounded);

  main_state.numInfront = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.countBy(runners, function (runner) {
    if (runner.state.isPacer) return false;
    if (runner.state.isElite) return false;
    return runner.state.px > main_state.progress.px;
  }).true || 0;

  if (main_state.stage > __WEBPACK_IMPORTED_MODULE_6__stages__["INTRO"] && main_state.stage < __WEBPACK_IMPORTED_MODULE_6__stages__["RESULTS"]) {
    __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].update(main_state, __WEBPACK_IMPORTED_MODULE_12__controls__, angles);
    __WEBPACK_IMPORTED_MODULE_29__ui_dashboard__["a" /* default */].update(main_state, __WEBPACK_IMPORTED_MODULE_12__controls__, angles);
  }

  switch (main_state.stage) {
    case __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE0"]:
      ptLight2.color.r = __WEBPACK_IMPORTED_MODULE_4_lerp___default.a(__WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */].r, __WEBPACK_IMPORTED_MODULE_7__colors__["b" /* red */].r, main_state.velocity.percent);
      ptLight2.color.g = __WEBPACK_IMPORTED_MODULE_4_lerp___default.a(__WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */].g, __WEBPACK_IMPORTED_MODULE_7__colors__["b" /* red */].g, main_state.velocity.percent);
      ptLight2.color.b = __WEBPACK_IMPORTED_MODULE_4_lerp___default.a(__WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */].b, __WEBPACK_IMPORTED_MODULE_7__colors__["b" /* red */].b, main_state.velocity.percent);

      var vol = Math.max(0, 1 - main_state.progress.percent / __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage0Length);
      __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].crowd_start.audio.setVolume(vol);

      if (main_state.progress.percent >= __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage0Length) {
        play('stage1');
        main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE1"];
        __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].crowd_start.audio.setVolume(0);
      }
      break;

    case __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE1"]:
      ptLight2.color.r = __WEBPACK_IMPORTED_MODULE_4_lerp___default.a(__WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */].r, __WEBPACK_IMPORTED_MODULE_7__colors__["b" /* red */].r, main_state.velocity.percent);
      ptLight2.color.g = __WEBPACK_IMPORTED_MODULE_4_lerp___default.a(__WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */].g, __WEBPACK_IMPORTED_MODULE_7__colors__["b" /* red */].g, main_state.velocity.percent);
      ptLight2.color.b = __WEBPACK_IMPORTED_MODULE_4_lerp___default.a(__WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */].b, __WEBPACK_IMPORTED_MODULE_7__colors__["b" /* red */].b, main_state.velocity.percent);

      if (main_state.progress.percent >= __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length) {

        main_state.airportReady = true;

        __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */], 2.5, {
          controlsMultiplier: __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].controlsMultiplier * 1.2,
          ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut
        });

        main_state.stage2.velocity.base = main_state.velocity.avg;
        main_state.stage2.startTime = now;

        if (main_state.numInfront <= __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1RankLimit) {

          __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_11__renderer__["multiPassBloomPass"].params, 4, {
            blurAmount: 1,
            ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut
          });

          animColor(ptLight2, __WEBPACK_IMPORTED_MODULE_7__colors__["b" /* red */], 1);
          main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE2_FAST"];
          play('stage2_fast');

          for (var _i2 = 0; _i2 < elites.length; _i2++) {
            var elite = elites[_i2];
            elite.state.autoUpdateState = false;
            elite.turnElite(_i2);
          }

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(runners), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _runner2 = _step2.value;

              if (_runner2.state.isElite) continue;
              if (_runner2.state.isPacer) continue;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          showStrobe();
          setTimeout(function () {
            var _loop = function _loop(_i3) {

              var elite = elites[_i3];

              var offset = void 0;
              switch (_i3) {
                case 0:
                  offset = -0.002;
                  break;
                case 1:
                  offset = 0;
                  break;
                case 2:
                  offset = -0.001;
                  break;
              }
              offset -= 1;


              var distance = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].startDistance + player.state.distance + 0.02 + offset;

              var toDistance = 2.5;

              elite.state.px = distance * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].totalPx;

              elite.state.path = __WEBPACK_IMPORTED_MODULE_30__track_tiled_path__["b" /* getPath */]((_i3 - 1) * 1.5);
              elite.state.distance = distance;
              elite.state.currDistance = distance;
              elite.state.minVel = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].velocityMin + 10;
              elite.state.maxVel = 170;
              elite.fadeTo(1, 1);
              elite.state.multiplyVelocity = 1.01;
              main_state.elitesTriggerReady = true;

              elite.tween = __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(elite.state, 70 * 1.5, {
                distance: toDistance,
                onUpdateParams: ['{self}'],
                onUpdate: function onUpdate(tween) {
                  elite.state.px = (tween.target.distance - elite.state.distanceStart) * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].totalPx;
                },
                onComplete: function onComplete() {
                  elite.fadeTo(0, 1).then(function () {
                    elite.mesh.visible = false;
                  });
                }
              });
            };

            for (var _i3 = 0; _i3 < elites.length; _i3++) {
              _loop(_i3);
            }
            __WEBPACK_IMPORTED_MODULE_29__ui_dashboard__["a" /* default */].startStage2();
          }, 10);
        } else {

          main_state.airportReady = true;

          animColor(ptLight2, __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */], 1);
          main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE2_SLOW"];

          __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__["draw"](__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].t('slow')[1]).then(function () {
            __WEBPACK_IMPORTED_MODULE_29__ui_dashboard__["a" /* default */].startStage2();
          });
        }
      }
      break;

    case __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE2_SLOW"]:
    case __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE2_FAST"]:
      if (main_state.elitesTriggerReady && main_state.progress.px >= elites[0].state.px - __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].totalPx * 0.004) {
        main_state.elitesTriggerReady = false;

        var _loop2 = function _loop2(_i4) {
          var elite = elites[_i4];

          var duration = 40;
          switch (_i4) {
            case 0:
              duration -= 0;
              break;
            case 1:
              duration -= 2;
              break;
            case 2:
              duration -= 1;
              break;
          }
          duration *= 1.5;
          __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to({ duration: elite.tween.duration() }, 1, {
            duration: duration,
            onUpdateParams: ['{self}'],
            ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Power1"].easeIn,
            onUpdate: function onUpdate(tween) {
              elite.tween.duration(tween.target.duration);
            },
            onComplete: function onComplete() {}
          });
        };

        for (var _i4 = 0; _i4 < elites.length; _i4++) {
          _loop2(_i4);
        }
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__["draw"](__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].t('fast')[1]);
        }, 200);
      }

      __WEBPACK_IMPORTED_MODULE_11__renderer__["zoomBlurPass"].params.strength = Math.min(main_state.velocity.percent * 0.07, 0.07);
      main_state.stage2.duration = now - main_state.stage2.startTime;
      main_state.stage2.velocity.avg = (main_state.progress.px - __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].totalPx * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length) / (main_state.stage2.duration / 1000);
      main_state.stage2.charge = Math.max(main_state.stage2.velocity.avg / main_state.stage2.velocity.base - 1, 0) / (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].breakScale - 1.0);
      main_state.stage2.charge = Math.min(main_state.stage2.charge, (main_state.progress.percent - __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length) / __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length);
      if (main_state.stage === __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE2_SLOW"]) {
        main_state.stage2.charge = Math.min(main_state.stage2.charge, main_state.numInfront / __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].numRunners);
      }

      if (main_state.airportReady && main_state.progress.percent >= 0.56) {
        main_state.airportReady = false;
        play('airport');
        __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__["draw"](__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].t('airport'));
        __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */], 1, {
          controlsMultiplier: __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].controlsMultiplier * 1.1,
          ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut
        });
        __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_11__renderer__["multiPassBloomPass"].params, 1.5, {
          blurAmount: 2,
          ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeInOut
        });
      }

      if (main_state.progress.percent >= __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length) {
        if (main_state.stage2.charge >= 1) {

          main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["END_START"];

          __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */], 1, {
            controlsMultiplier: __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].controlsMultiplier * 1.15,
            ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut
          });

          car.state.distance = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length - 0.05;
          bike.state.distance = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length - 0.05;

          car.state.currDistance = car.state.distance;
          bike.state.currDistance = bike.state.distance;

          car.model.visible = true;
          bike.model.visible = true;

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(runners), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _runner3 = _step3.value;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__["draw"](__WEBPACK_IMPORTED_MODULE_10_src_i18n__["a" /* default */].t('10kmCta'));

          animColor(ptLight2, __WEBPACK_IMPORTED_MODULE_7__colors__["b" /* red */], 1);
          play('end');

          var _tl = new __WEBPACK_IMPORTED_MODULE_5_gsap__["TimelineMax"]();
          var time = 1;
          _tl.to({}, 1, {}).addLabel('start').to(__WEBPACK_IMPORTED_MODULE_11__renderer__["multiPassBloomPass"].params, time, {
            blurAmount: 3.5,
            ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
            onStart: function onStart() {
              speedLines.enable(time);
              __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].sonic_boom.audio.playPromise();
            }
          }, 'start').to(__WEBPACK_IMPORTED_MODULE_11__renderer__["zoomBlurPass"].params, time, {
            strength: 0.1,
            ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeIn,
            delay: 0
          }, 'start').to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */], 1, {
            delay: 0,
            fov: 97,
            ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeIn,
            onUpdate: function onUpdate() {
              __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].updateProjectionMatrix();
            }
          }, 'start');
        } else {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {

            for (var _iterator4 = main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(elites), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _elite = _step4.value;

              _elite.mesh.visible = false;
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          car.model.visible = true;
          bike.model.visible = true;

          main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["END_NORMAL"];

          car.model.position.x = 6 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale;
          car.state.distance = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length + 0.12;
          car.model.rotation.y = main_THREE.Math.DEG2RAD * -145;

          bike.model.position.x = -5 * __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].worldScale;
          bike.state.distance = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length + 0.18;
          bike.model.rotation.y = main_THREE.Math.DEG2RAD * -45;

          animColor(ptLight2, __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */], 1);
        }
      }
      break;

    case __WEBPACK_IMPORTED_MODULE_6__stages__["END_START"]:

      __WEBPACK_IMPORTED_MODULE_11__renderer__["multiPassBloomPass"].params.strength = Math.min(main_state.velocity.percent * 3.5, 3.5);
      __WEBPACK_IMPORTED_MODULE_11__renderer__["zoomBlurPass"].params.strength = Math.min(main_state.velocity.percent * 0.1, 0.1);

      if (main_state.progress.percent >= __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length + 0.055) {
        car.runToEnd(player.state.distance - 0.012, 20, __WEBPACK_IMPORTED_MODULE_5_gsap__["SlowMo"].ease.config(0.2, 0.8));


        car.audio.car.play();
        emitter.enable();
        main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["END_SPEED"];
      }

      break;

    case __WEBPACK_IMPORTED_MODULE_6__stages__["END_SPEED"]:

      __WEBPACK_IMPORTED_MODULE_11__renderer__["multiPassBloomPass"].params.blurAmount = Math.min(main_state.velocity.percent * 5, 5);
      __WEBPACK_IMPORTED_MODULE_11__renderer__["zoomBlurPass"].params.strength = Math.min(main_state.velocity.percent * 0.2, 0.2);
      smoke_update(main___WEBPACK_IMPORTED_MODULE_14__clock__["state"].delta * (1 - main_state.velocity.percent));

      if (main_state.progress.percent >= __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length + 0.09) {
        main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["END_BIKE"];
        main_state.crowdFinishReady = true;
        play('end_fast');

        bike.runToEnd(player.state.distance - 0.005, 20, __WEBPACK_IMPORTED_MODULE_5_gsap__["SlowMo"].ease.config(0.2, 0.8));

        bike.audio.bike.play();

        var rotStart = new main_THREE.Vector3(0, main_THREE.Math.DEG2RAD * 180, 0);
        __WEBPACK_IMPORTED_MODULE_5_gsap__["TweenMax"].to(bike.model.rotation, 2, {
          x: '-=' + main_THREE.Math.DEG2RAD * 50,
          ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["SlowMo"].ease.config(0.8, 0.5, true)
        });
      }
      break;

    case __WEBPACK_IMPORTED_MODULE_6__stages__["END_BIKE"]:
      __WEBPACK_IMPORTED_MODULE_11__renderer__["multiPassBloomPass"].params.blurAmount = Math.min(main_state.velocity.percent * 6, 6);
      __WEBPACK_IMPORTED_MODULE_11__renderer__["zoomBlurPass"].params.strength = Math.min(main_state.velocity.percent * 0.25, 0.25);
      smoke_update(main___WEBPACK_IMPORTED_MODULE_14__clock__["state"].delta * (1 - main_state.velocity.percent));

      if (main_state.crowdFinishReady && main_state.progress.percent >= 0.95) {
        emitter.disable();
        speedLines.disable();
      }

      if (main_state.crowdFinishReady && main_state.progress.percent >= 0.96) {
        main_state.crowdFinishReady = false;
        __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */].crowd_finish.audio.play();
      }

      if (main_state.progress.percent >= 0.978) {
        main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["END_LINE"];
      }
      break;

    case __WEBPACK_IMPORTED_MODULE_6__stages__["END_LINE"]:

      main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["RESULTS"];

      var tl = new __WEBPACK_IMPORTED_MODULE_5_gsap__["TimelineMax"]();
      var slowMoTime = 3;
      main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["RESULTS"];
      tl.addLabel('reality').to(__WEBPACK_IMPORTED_MODULE_11__renderer__["multiPassBloomPass"].params, 1, {
        blurAmount: 0,
        ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
        onStart: function onStart() {
          __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].stopRun();
          __WEBPACK_IMPORTED_MODULE_12__controls__["stop"](3).then(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].stopRun);
        }
      }, 'reality').to(__WEBPACK_IMPORTED_MODULE_11__renderer__["zoomBlurPass"].params, 1, {
        strength: 0,
        ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut
      }, 'reality').to(__WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */], 1, {
        fov: 60,
        ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Cubic"].easeOut,
        onUpdate: function onUpdate() {
          __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].updateProjectionMatrix();
        },
        onComplete: function onComplete() {

          setTimeout(function () {
            main_playResults();
          }, 700);
        }
      }, 'reality');

      break;

    case __WEBPACK_IMPORTED_MODULE_6__stages__["END_NORMAL"]:
      checkGameEnd();
      break;

    case __WEBPACK_IMPORTED_MODULE_6__stages__["RESULTS"]:
      smoke_update();

      __WEBPACK_IMPORTED_MODULE_48__result_cloth__["update"]();
      break;
  }
};

var checkGameEnd = function checkGameEnd() {
  if (main_state.progress.percent >= 1) {
    main_playResults();
  }
};

var main_updateGame = function updateGame(delta) {
  main_updateState(delta);
  __WEBPACK_IMPORTED_MODULE_12__controls__["update"](delta);

  track_tiled_update(delta);
  player.update(delta);
  car.update(delta);
  bike.update(delta);
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(runners), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var _runner4 = _step5.value;

      _runner4.update(delta);
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  dirLight.position.x = player.mesh.position.x;
  dirLight.position.y = 240 + main_state.progress.percent * 80;

  speedLines.update(delta);
};

var main_startGame = function startGame() {

  main___WEBPACK_IMPORTED_MODULE_14__clock__["clock"].stop();
  main___WEBPACK_IMPORTED_MODULE_14__clock__["clock"].start();

  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].startRun();

  player.model.visible = false;
  player.distance = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].startDistance;

  startSound(0);
  hideStrobe();

  play('stage0');
  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].rotation.x = main_THREE.Math.DEG2RAD * 0;
  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].fov = 60;
  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].updateProjectionMatrix();
  __WEBPACK_IMPORTED_MODULE_28__ui_eyelid__["open"](0);
  __WEBPACK_IMPORTED_MODULE_11__renderer__["boxBlurPass"].params.delta.x = 0;
  main_state.startTime = performance.now();
  main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE0"];
  console.log('startGame');

  __WEBPACK_IMPORTED_MODULE_12__controls__["init"]();
  car.start();
  bike.start();
  player.start();
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(runners), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var _runner5 = _step6.value;

      _runner5.start();
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_19__raf__["a" /* default */].on('tick', main_updateGame);
  __WEBPACK_IMPORTED_MODULE_27__ui_scene__["showDashboard"]();
};

var stopGame = function stopGame() {
  __WEBPACK_IMPORTED_MODULE_19__raf__["a" /* default */].removeListener('tick', main_updateGame);
  __WEBPACK_IMPORTED_MODULE_12__controls__["destroy"]();
};

var main_resetGame = function resetGame() {

  __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].reset();
  __WEBPACK_IMPORTED_MODULE_29__ui_dashboard__["a" /* default */].reset();

  car.stop();
  bike.stop();

  car.model.visible = false;
  bike.model.visible = false;

  __WEBPACK_IMPORTED_MODULE_11__renderer__["multiPassBloomPass"].blurAmount = 0;
  __WEBPACK_IMPORTED_MODULE_11__renderer__["zoomBlurPass"].params.strength = 0;
  __WEBPACK_IMPORTED_MODULE_11__renderer__["setRenderGame"](true);
  __WEBPACK_IMPORTED_MODULE_11__renderer__["setRenderResults"](false);

  emitter.disable();
  speedLines.disable();
  group.tick(10000);
  animColor(ptLight2, __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* blue */], 0);

  __WEBPACK_IMPORTED_MODULE_12__controls__["reset"]();
  __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */].stopRun();
  player.reset();
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(runners), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var _runner6 = _step7.value;

      _runner6.reset();
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  main_resetState();
};

var main_restartGame = function restartGame() {

  player.checkAllLoaded();
  car.checkAllLoaded();
  bike.checkAllLoaded();
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = main___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a(runners), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var _runner7 = _step8.value;

      _runner7.checkAllLoaded();
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  stopGame();
  main_resetGame();
  stop();

  if (!__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].skipIntro) {
    main_playPrepare().then(main_playIntro).then(main_startGame);
  } else {
    main_startGame();

    if (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].skipToSpeedWorld) {
      play('end_fast');

      main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE2_FAST"];
      __WEBPACK_IMPORTED_MODULE_12__controls__["state"].baseVelocity = 30;
      __WEBPACK_IMPORTED_MODULE_12__controls__["state"].px = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].totalPx * (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length - 0.08);
    } else if (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].skipToSlowWorld) {
      main_state.stage = __WEBPACK_IMPORTED_MODULE_6__stages__["STAGE2_SLOW"];
      __WEBPACK_IMPORTED_MODULE_12__controls__["state"].baseVelocity = 8;
      __WEBPACK_IMPORTED_MODULE_12__controls__["state"].px = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].totalPx * (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length + __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage2Length - 0.01);
      runners[0].state.autoUpdateState = false;
      runners[0].state.distance = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].startDistance + 0.99;
    } else if (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].skipToStage2) {
      __WEBPACK_IMPORTED_MODULE_12__controls__["state"].baseVelocity = 13;
      __WEBPACK_IMPORTED_MODULE_12__controls__["state"].px = __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].totalPx * (__WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].stage1Length - 0.01);
    }
  }
};

var game = {
  renderer: __WEBPACK_IMPORTED_MODULE_11__renderer__,
  clock: main___WEBPACK_IMPORTED_MODULE_14__clock__,
  controls: __WEBPACK_IMPORTED_MODULE_12__controls__,

  scene: __WEBPACK_IMPORTED_MODULE_18__scene__["a" /* default */],
  lights: lights_namespaceObject,
  camera: __WEBPACK_IMPORTED_MODULE_15__camera__["a" /* default */],
  loader: __WEBPACK_IMPORTED_MODULE_17__loader__,
  raf: __WEBPACK_IMPORTED_MODULE_19__raf__["a" /* default */],

  uiCamera: __WEBPACK_IMPORTED_MODULE_16__camera_ui__["b" /* default */],
  ui: __WEBPACK_IMPORTED_MODULE_27__ui_scene__,
  text: __WEBPACK_IMPORTED_MODULE_22__ui_text_simple__,
  countdown: __WEBPACK_IMPORTED_MODULE_24__ui_countdown__,
  distance: __WEBPACK_IMPORTED_MODULE_25__ui_distance__,
  cta: __WEBPACK_IMPORTED_MODULE_23__ui_cta__,
  scrollCta: __WEBPACK_IMPORTED_MODULE_26__ui_scrollCta__,
  eyelid: __WEBPACK_IMPORTED_MODULE_28__ui_eyelid__,
  dashboard: __WEBPACK_IMPORTED_MODULE_29__ui_dashboard__["a" /* default */],

  path: __WEBPACK_IMPORTED_MODULE_30__track_tiled_path__["c" /* path */],
  sky: sky_defaultExport,
  buildings: buildings_defaultExport,
  track: track_tiled_namespaceObject,
  player: player,
  runners: runners,
  elites: elites,
  car: car,
  bike: bike,

  smoke: smoke_namespaceObject,
  speedLines: speedLines,
  confettisShader: confettisShader,

  config: __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */],
  state: main_state,
  initialState: initialState,

  restart: main_restartGame,
  stop: stopGame,
  start: main_startGame,
  playIntro: main_playIntro,
  playResults: main_playResults,
  animFocus: animFocus,

  music: music_namespaceObject,
  listener: __WEBPACK_IMPORTED_MODULE_43__listener__["a" /* default */],
  sounds: __WEBPACK_IMPORTED_MODULE_44__sounds__["a" /* default */],

  result: {
    scene: __WEBPACK_IMPORTED_MODULE_45__result_scene__,
    bg: __WEBPACK_IMPORTED_MODULE_46__result_bg__,
    flag: __WEBPACK_IMPORTED_MODULE_47__result_flag__,
    cloth: __WEBPACK_IMPORTED_MODULE_48__result_cloth__
  }

};

/* harmony default export */ __webpack_exports__["a"] = (game);
window.game = game;

/***/ }),
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export i18n */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_search_params_polyfill__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url_search_params_polyfill__);



var messages = __webpack_require__(149);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var urlParams = new window.URLSearchParams(window.location.search);

var defaultLocale = 'zh';
if (navigator.language.indexOf('en') >= 0) defaultLocale = 'en';


var locale = urlParams.get('_locale') || defaultLocale;
console.log('Locale', locale);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: locale,
  messages: messages
});

if (locale !== 'zh') document.title = i18n.t('page_title');

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clock", function() { return clock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__raf__ = __webpack_require__(4);
var THREE = __webpack_require__(0);


var clock = new THREE.Clock();
var state = {
  delta: 0
};
/* harmony default export */ __webpack_exports__["default"] = (clock);

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/btn-blue.5d34f01.png";

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export camera */
/* unused harmony export update */
/* unused harmony export tl */
/* unused harmony export playBreath */
/* unused harmony export playStep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clock__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(40);

var THREE = __webpack_require__(0);







var camera = new THREE.PerspectiveCamera(30, window.innerWidth / window.innerHeight, 0.1, 20000 * __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].worldScale);
/* harmony default export */ __webpack_exports__["a"] = (camera);

var updateAspect = function updateAspect() {
  camera.aspect = __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].state.browser.windowWidth / __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].state.browser.windowHeight;
  camera.updateProjectionMatrix();
};
__WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].state.browser.windowWidth;
}, updateAspect);
__WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].state.browser.windowHeight;
}, updateAspect);

camera.position.y = 2.25 * __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].worldScale;
camera.rotation.y = THREE.Math.DEG2RAD * -180;

var camState = {
  velocityPercent: 0,
  currDirection: 0,
  turnTime: 1.5,

  playBreath: true
};

var angles = {
  curr: 0,
  goal: 0,
  offset: 0
};

var update = function update(state, controls, trackAngles) {
  camState.velocityPercent = state.velocity.percent;
  var timeScale = 0.2 + camState.velocityPercent * 1 * controls.state.multiplier;
  tl.timeScale(timeScale);

  camState.currDirection = trackAngles[0];
  var multiplier = 15 + state.velocity.percent * 10;
  var z = 0;
  switch (camState.currDirection) {
    case 90:
      z = -multiplier;
      break;
    case -90:
      z = multiplier;
      break;
    default:
      z = 0;
      break;
  }
  angles.goal = z;

  var delta = __WEBPACK_IMPORTED_MODULE_3__clock__["state"].delta;

  if (angles.curr > angles.goal) {
    angles.curr -= multiplier / camState.turnTime * delta;
  } else if (angles.curr < angles.goal) {
    angles.curr += multiplier / camState.turnTime * delta;
  }

  camera.rotation.z = (angles.curr + angles.offset) * THREE.Math.DEG2RAD;
};

var tl = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({ paused: true });
camera.rotation.y -= 0.015;
camera.rotation.offset = -0.015;
tl.to(camera.rotation, 0.2, {
  y: '+=' + 0.03,
  offset: '+=' + 0.03,
  repeat: -1,
  yoyo: true,
  ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeInOut,
  onUpdateParams: ['{self}'],
  onUpdate: function onUpdate(tween) {
    angles.offset = tween.target.offset / THREE.Math.DEG2RAD;
  },
  onRepeat: function onRepeat() {
    playStep();
    stepCount += 1;
    if (stepCount >= 4) {
      stepCount = 0;
      playBreath();
    }
  }
});

camera.update = update;
camera.playStep = playStep;
camera.tl = tl;

camera.startRun = function () {
  camera.tl.play();
};
camera.stopRun = function () {
  camera.tl.pause();
};

var stepCount = 0;
var playBreath = function playBreath() {
  var i = Math.round(Math.random() * 3);
  var key = 'breath' + i;
  var audio = __WEBPACK_IMPORTED_MODULE_4__main__["a" /* default */].sounds[key].audio;
  if (!audio) return;
  audio.stop();
  audio.setVolume(__WEBPACK_IMPORTED_MODULE_4__main__["a" /* default */].sounds[key].volume || 1);
  audio.play();
};

var stepDirection = 'L';
var stepIdx = 0;
var playStep = function playStep() {
  if (stepDirection === 'L') stepIdx = Math.round(Math.random() * 2);
  stepDirection = stepDirection === 'L' ? 'R' : 'L';
  var key = 'step' + stepDirection + stepIdx;
  var audio = __WEBPACK_IMPORTED_MODULE_4__main__["a" /* default */].sounds[key].audio;
  if (!audio) return;
  audio.stop();
  audio.setVolume(__WEBPACK_IMPORTED_MODULE_4__main__["a" /* default */].sounds[key].volume || 1);
  audio.play();
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export data */
/* unused harmony export loaded */
/* unused harmony export checkAllLoaded */
/* unused harmony export loadAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listener__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);

var THREE = __webpack_require__(0);




var data = {
  text: {
    url: __webpack_require__(465),
    size: 130713,
    volume: 1
  },

  heartbeat: {
    url: __webpack_require__(466),
    size: 130713,
    volume: 2.5
  },
  countdown: {
    url: __webpack_require__(467),
    size: 130713,
    volume: 1
  },
  crowd_start: {
    url: __webpack_require__(468),
    size: 88727,
    volume: 1,
    loop: true
  },
  crowd_finish: {
    url: __webpack_require__(469),
    size: 166679,
    volume: 1
  },
  sonic_boom: {
    url: __webpack_require__(470),
    size: 130713,
    volume: 2.0
  },
  stepL0: {
    url: __webpack_require__(471),
    size: 10000,
    volume: 1.5
  },
  stepL1: {
    url: __webpack_require__(472),
    size: 10000,
    volume: 1.5
  },
  stepL2: {
    url: __webpack_require__(473),
    size: 10000,
    volume: 1.5
  },
  stepR0: {
    url: __webpack_require__(474),
    size: 10000,
    volume: 1.5
  },
  stepR1: {
    url: __webpack_require__(475),
    size: 10000,
    volume: 1.5
  },
  stepR2: {
    url: __webpack_require__(476),
    size: 10000,
    volume: 1.5
  },
  breath0: {
    url: __webpack_require__(477),
    size: 10000,
    volume: 3.5
  },
  breath1: {
    url: __webpack_require__(478),
    size: 10000,
    volume: 3.5
  },
  breath2: {
    url: __webpack_require__(479),
    size: 10000,
    volume: 3.5
  },
  breath3: {
    url: __webpack_require__(480),
    size: 10000,
    volume: 3.5
  },
  breath4: {
    url: __webpack_require__(481),
    size: 10000,
    volume: 3.5
  }
};
/* harmony default export */ __webpack_exports__["a"] = (data);

var loader = new THREE.AudioLoader(__WEBPACK_IMPORTED_MODULE_2__loader__["loadingManager"]);
for (var key in data) {
  var _data = data[key];

  if (_data.positional === true) {
    _data.audio = new THREE.PositionalAudio(__WEBPACK_IMPORTED_MODULE_1__listener__["a" /* default */]);
    _data.audio.setRefDistance(_data.distance || 1);
  } else {
    _data.audio = new THREE.Audio(__WEBPACK_IMPORTED_MODULE_1__listener__["a" /* default */]);
  }

  __WEBPACK_IMPORTED_MODULE_2__loader__["registerSize"](_data.url, _data.size);
}

var loaded = false;
var checkAllLoaded = function checkAllLoaded() {
  for (var _key in data) {
    var _data2 = data[_key];
    if (!_data2.buffer) return false;
  }
  loaded = true;
  return true;
};
var loadAll = function loadAll() {
  var _loop = function _loop(_key2) {
    var _data = data[_key2];
    __WEBPACK_IMPORTED_MODULE_2__loader__["load"](_data.url, null, function (results) {
      _data.buffer = results[0];
      _data.audio.setBuffer(results[0]);
      _data.audio.setLoop(_data.loop || false);

      _data.audio.setVolume(0.001);
      _data.audio.play();
      _data.audio.stop();
      _data.audio.setVolume(_data.volume || 1);
      checkAllLoaded();
    });
  };

  for (var _key2 in data) {
    _loop(_key2);
  }
};

loadAll();

var fadeTo = function fadeTo(to) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var _audio = this;
  __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to({ volume: this.getVolume() }, time, {
    volume: to,
    ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeIn,
    onStart: function onStart() {
      if (_audio.getVolume() === 0) {
        _audio.stop();
        _audio.play();
      }
    },
    onUpdateParams: ['{self}'],
    onUpdate: function onUpdate(tween) {
      var volume = tween.target.volume;
      _audio.setVolume(volume);
    },
    onComplete: function onComplete() {}
  });
};

THREE.Audio.prototype.fadeTo = fadeTo;
THREE.PositionalAudio.prototype.fadeTo = fadeTo;

THREE.Audio.prototype.playPromise = function () {
  var _this = this;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    _this.onEnded = function () {
      this.isPlaying = false;
      this.onEnded = function () {
        this.isPlaying = false;
      };
      resolve();
    };
    _this.play();
  });
};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/game/track-tiled/spawnSprites.js
var treeSpawnStraight = [[30, 0, -50], [50, 0, -50], [30, 0, -40], [50, 0, -40], [30, 0, -30], [50, 0, -30], [30, 0, -20], [50, 0, -20], [30, 0, -10], [50, 0, -10], [30, 0, 0], [50, 0, 0], [30, 0, 10], [50, 0, 10], [30, 0, 20], [50, 0, 20], [30, 0, 30], [50, 0, 30], [30, 0, 40], [50, 0, 40], [30, 0, 50], [50, 0, 50], [30, 0, 60], [50, 0, 60], [-50, 0, -50], [-30, 0, -50], [-50, 0, -40], [-30, 0, -40], [-50, 0, -30], [-30, 0, -30], [-50, 0, -20], [-30, 0, -20], [-50, 0, -10], [-30, 0, -10], [-50, 0, 0], [-30, 0, 0], [-50, 0, 10], [-30, 0, 10], [-50, 0, 20], [-30, 0, 20], [-50, 0, 30], [-30, 0, 30], [-50, 0, 40], [-30, 0, 40], [-50, 0, 50], [-30, 0, 50], [-50, 0, 60], [-30, 0, 60]];

var peopleSpawnStart = [[12.8096, 0, -59.5276], [12.8096, 0, -56.5276], [13.2384, 0, -54.5276], [13.2384, 0, -52.0], [12.8096, 0, -50.0251], [13.2384, 0, -48.0], [13.2384, 0, -46.0251], [13.2384, 0, -44.5251], [13.2384, 0, -42.5251], [12.8096, 0, -40.5226], [13.2384, 0, -38.0], [13.2384, 0, -36.0], [13.2384, 0, -34.5226], [13.2384, 0, -32.5226], [12.8096, 0, -30.0201], [12.8096, 0, -28.0201], [13.2384, 0, -26.0200], [13.2384, 0, -24.0200], [13.2384, 0, -22.0200], [12.8096, 0, -20.5175], [13.2384, 0, -18.0200], [13.2384, 0, -16.5175], [13.2384, 0, -14.5175], [12.8096, 0, -12.0150], [12.8096, 0, -10.0150], [12.8096, 0, -8.0150], [13.2384, 0, -6.0150], [12.8096, 0, -4.5125], [12.8096, 0, -2.5125], [13.2384, 0, 2.4875], [13.2384, 0, 4.9900], [12.8096, 0, 6.9900], [13.2384, 0, 8.9900], [13.2384, 0, 10.9900], [13.2384, 0, 12.4925], [13.2384, 0, 14.4925], [12.8096, 0, 16.4925], [13.2384, 0, 18.4925], [13.2384, 0, 20.4925], [13.2384, 0, 22.9950], [12.8096, 0, 24.9950], [12.8096, 0, 26.9950], [13.2384, 0, 28.9950], [13.2384, 0, 30.4975], [13.2384, 0, 32.4975], [12.8096, 0, 34.4975], [13.2384, 0, 36.4975], [13.2384, 0, 38.4975], [13.2384, 0, 40.4975], [13.2384, 0, 42.4975], [12.8096, 0, 44], [13.2384, 0, 46.4975], [13.2384, 0, 48.4975], [13.2384, 0, 50], [13.2384, 0, 52.5], [13.2384, 0, 54], [13.2384, 0, 56.5], [13.2384, 0, 58], [13.2384, 0, 60], [-12.8096, 0, -60.5276], [-12.8096, 0, -58.5276], [-13.2384, 0, -54.5276], [-12.8096, 0, -52.0251], [-12.8096, 0, -50.0251], [-13.2384, 0, -48.0251], [-13.2384, 0, -46.0251], [-13.2384, 0, -44.0251], [-12.8096, 0, -42.5226], [-12.8096, 0, -40.5226], [-12.8096, 0, -38.5226], [-12.8096, 0, -36.5226], [-13.2384, 0, -34.5226], [-12.8096, 0, -32.0201], [-12.8096, 0, -30.0201], [-13.2384, 0, -28.0200], [-13.2384, 0, -26.0200], [-13.2384, 0, -24.0200], [-13.2384, 0, -22.5200], [-12.8096, 0, -20.5175], [-13.2384, 0, -18.5175], [-13.2384, 0, -16.5175], [-12.8096, 0, -14.0150], [-12.8096, 0, -12.0150], [-13.2384, 0, -10.0150], [-13.2384, 0, -8.0150], [-13.2384, 0, -6.0150], [-13.2384, 0, -4.0150], [-12.8096, 0, -2.5125], [-13.2384, 0, 0.0], [-13.2384, 0, 2.4875], [-12.8096, 0, 4.9900], [-12.8096, 0, 6.9900], [-13.2384, 0, 8.9900], [-13.2384, 0, 10.9900], [-12.8096, 0, 12.4925], [-12.8096, 0, 14.4925], [-12.8096, 0, 16.4925], [-13.2384, 0, 18.4925], [-13.2384, 0, 20.4925], [-12.8096, 0, 22.9950], [-12.8096, 0, 24.9950], [-13.2384, 0, 26.5], [-13.2384, 0, 28.5], [-13.2384, 0, 30.9950], [-12.8096, 0, 32.4975], [-12.8096, 0, 34.4975], [-13.2384, 0, 36.0], [-13.2384, 0, 38.0], [-13.2384, 0, 40.4975], [-13.2384, 0, 42.4975], [-12.8096, 0, 44], [-12.8096, 0, 46], [-12.8096, 0, 48], [-13.2384, 0, 50], [-13.2384, 0, 52.5], [-13.2384, 0, 54], [-13.2384, 0, 56.5], [-13.2384, 0, 58.5], [-13.2384, 0, 60]];

var airportLightsSpawnStraight = [[-6.5312, 0.4, 59.9123], [-2.4648, 0.4, 59.9123], [1.6016, 0.4, 59.9123], [5.6680, 0.4, 59.9123], [-6.5312, 0.4, 49.0032], [-2.4648, 0.4, 49.0032], [1.6016, 0.4, 49.0032], [5.6680, 0.4, 49.0032], [-6.5312, 0.4, 38.0941], [-2.4648, 0.4, 38.0941], [1.6016, 0.4, 38.0941], [5.6680, 0.4, 38.0941], [-6.5311, 0.4, 27.1850], [-2.4647, 0.4, 27.1850], [1.6017, 0.4, 27.1850], [5.6681, 0.4, 27.1850], [-6.5311, 0.4, 16.2759], [-2.4647, 0.4, 16.2759], [1.6017, 0.4, 16.2759], [5.6681, 0.4, 16.2759], [-6.5311, 0.4, 5.3668], [-2.4647, 0.4, 5.3668], [1.6017, 0.4, 5.3668], [5.6681, 0.4, 5.3668], [-6.5311, 0.4, -5.5423], [-2.4647, 0.4, -5.5423], [1.6017, 0.4, -5.5423], [5.6681, 0.4, -5.5423], [-6.5311, 0.4, -16.4513], [-2.4647, 0.4, -16.4513], [1.6017, 0.4, -16.4513], [5.6681, 0.4, -16.4513], [-6.5312, 0.4, -27.3604], [-2.4648, 0.4, -27.3604], [1.6016, 0.4, -27.3604], [5.6680, 0.4, -27.3604], [-6.5312, 0.4, -38.2695], [-2.4648, 0.4, -38.2695], [1.6016, 0.4, -38.2695], [5.6680, 0.4, -38.2695], [-6.5310, 0.4, -49.1786], [-2.4646, 0.4, -49.1786], [1.6018, 0.4, -49.1786], [5.6682, 0.4, -49.1786]];

var airportLightsSpawnCurveLeft = [[-51.8048, 0.4, 6.14203], [-51.2082, 0.4, 2.10858], [-50.6116, 0.4, -1.92487], [-50.0149, 0.4, -5.95831], [-44.2141, 0.4, 7.83948], [-43.0391, 0.4, 3.93542], [-41.8641, 0.4, 0.0313721], [-40.6891, 0.4, -3.87268], [-37.0688, 0.4, 10.5655], [-35.3482, 0.4, 6.86969], [-33.6276, 0.4, 3.17389], [-31.907, 0.4, -0.521912], [-30.446, 0.4, 14.2402], [-28.2234, 0.4, 10.8231], [-26.0007, 0.4, 7.40594], [-23.7781, 0.4, 3.98883], [-24.4303, 0.4, 18.7808], [-21.7549, 0.4, 15.7054], [-19.0795, 0.4, 12.6301], [-16.4041, 0.4, 9.55475], [-19.1095, 0.4, 24.1014], [-16.0342, 0.4, 21.426], [-12.9589, 0.4, 18.7505], [-9.88365, 0.4, 16.0751], [-14.5692, 0.4, 30.1169], [-11.152, 0.4, 27.8945], [-7.73479, 0.4, 25.6719], [-4.31757, 0.4, 23.4495], [-10.895, 0.4, 36.7391], [-7.19891, 0.4, 35.019], [-3.50284, 0.4, 33.2991], [0.193222, 0.4, 31.579], [-8.16853, 0.4, 43.8845], [-4.26434, 0.4, 42.71], [-0.360138, 0.4, 41.5354], [3.54405, 0.4, 40.3609], [-6.47099, 0.4, 51.475], [-2.43744, 0.4, 50.8789], [1.5961, 0.4, 50.2828], [5.62965, 0.4, 49.6868], [-5.86905, 0.4, 59.6645], [-1.80266, 0.4, 59.5151], [2.26375, 0.4, 59.3658], [6.33015, 0.4, 59.2166]];

var airportLightsSpawnCurveRight = [[51.8048, 0.4, 6.14191], [51.2082, 0.4, 2.10846], [50.6116, 0.4, -1.92499], [50.0149, 0.4, -5.95844], [44.2141, 0.4, 7.83936], [43.0391, 0.4, 3.9353], [41.8641, 0.4, 0.03125], [40.6891, 0.4, -3.8728], [37.0688, 0.4, 10.5654], [35.3482, 0.4, 6.86957], [33.6276, 0.4, 3.17377], [31.907, 0.4, -0.522034], [30.446, 0.4, 14.2401], [28.2234, 0.4, 10.8229], [26.0007, 0.4, 7.40582], [23.7781, 0.4, 3.98871], [24.4303, 0.4, 18.7807], [21.7549, 0.4, 15.7053], [19.0795, 0.4, 12.63], [16.4041, 0.4, 9.55463], [19.1095, 0.4, 24.1013], [16.0342, 0.4, 21.4258], [12.9589, 0.4, 18.7504], [9.88365, 0.4, 16.075], [14.5692, 0.4, 30.1168], [11.152, 0.4, 27.8943], [7.73479, 0.4, 25.6718], [4.31757, 0.4, 23.4493], [10.895, 0.4, 36.739], [7.19891, 0.4, 35.0189], [3.50284, 0.4, 33.299], [-0.193222, 0.4, 31.579], [8.16853, 0.4, 43.8844], [4.26434, 0.4, 42.7099], [0.360138, 0.4, 41.5354], [-3.54405, 0.4, 40.3609], [6.47099, 0.4, 51.4749], [2.43744, 0.4, 50.8789], [-1.5961, 0.4, 50.2828], [-5.62965, 0.4, 49.6868], [5.86905, 0.4, 59.6644], [1.80266, 0.4, 59.5151], [-2.26375, 0.4, 59.3658], [-6.33015, 0.4, 59.2166]];

var peopleSpawnCurveLeft = [[-45.2967, 1.22361, -14.2971], [15.6214, 0, 46.0132], [13.0864, 0, 36.8859], [9.52673, 0, 28.1073], [4.98888, 0, 19.7921], [-0.467934, 0, 12.0488], [-6.77242, 0, 4.97864], [-13.8423, 0, -1.32623], [-21.5853, 0, -6.78344], [-29.9002, 0, -11.3217], [-38.6786, 0, -14.8819], [-33.8464, 0, -13.5306], [-25.2537, 0, -9.42806], [-17.1851, 0, -4.37207], [-9.74594, 0, 1.57136], [-3.03335, 0, 8.32461], [2.86505, 0, 15.7995], [7.87224, 0, 23.8985], [11.9228, 0, 32.5158], [14.964, 0, 41.5389], [16.9559, 0, 50.85]];

var peopleSpawnCurveRight = [[45.2967, 1.22361, -14.2971], [-15.6214, 0, 46.0132], [-13.0864, 0, 36.8859], [-9.52673, 0, 28.1073], [-4.98888, 0, 19.7921], [0.467934, 0, 12.0488], [6.77242, 0, 4.97864], [13.8423, 0, -1.32623], [21.5853, 0, -6.78344], [29.9002, 0, -11.3217], [38.6786, 0, -14.8819], [33.8464, 0, -13.5306], [25.2537, 0, -9.42806], [17.1851, 0, -4.37207], [9.74594, 0, 1.57136], [3.03335, 0, 8.32461], [-2.86505, 0, 15.7995], [-7.87224, 0, 23.8985], [-11.9228, 0, 32.5158], [-14.964, 0, 41.5389], [-16.9559, 0, 50.85]];
var treeSpawnLeft = [[53.3518, 0, 23.1698], [36.4228, 0, -10.0553], [10.0553, 0, -36.4228], [-23.1698, 0, -53.3518], [-60, 0, -59.1852], [25.0139, 0, 32.3773], [12.3171, 0, 7.45854], [-7.45854, 0, -12.3171], [-32.3773, 0, -25.0139], [-60, 0, -29.3889], [27.2014, 0, 46.1887], [56.2685, 0, 41.5849], [18.6655, 0, 19.9179], [44.8873, 0, 6.55724], [2.42929, 0, -2.42929], [23.239, 0, -23.239], [-19.9179, 0, -18.6655], [-6.55724, 0, -44.8873], [-46.1887, 0, -27.2014], [-41.5849, 0, -56.2685]];
var treeSpawnRight = [[-53.3518, 0, 23.1698], [-36.4228, 0, -10.0553], [-10.0553, 0, -36.4228], [23.1698, 0, -53.3518], [60, 0, -59.1852], [-25.0139, 0, 32.3773], [-12.3171, 0, 7.45854], [7.45854, 0, -12.3171], [32.3773, 0, -25.0139], [60, 0, -29.3889], [-27.2014, 0, 46.1887], [-56.2685, 0, 41.5849], [-18.6655, 0, 19.9179], [-44.8873, 0, 6.55724], [-2.42929, 0, -2.42929], [-23.239, 0, -23.239], [19.9179, 0, -18.6655], [6.55724, 0, -44.8873], [46.1887, 0, -27.2014], [41.5849, 0, -56.2685]];
// CONCATENATED MODULE: ./src/components/game/track-tiled/config.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tileSize", function() { return tileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "direction", function() { return direction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sounds", function() { return sounds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textures", function() { return textures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objects", function() { return objects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "types", function() { return types; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "layout", function() { return layout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numDraw", function() { return numDraw; });
var THREE = __webpack_require__(0);

var base = __webpack_require__(16).build.assetsPublicPath;



var tileSize = 120;

var direction = {
  N: 0,
  E: 90,
  S: 180,
  W: 270
};

var sounds = {
  crowd_encourage1: {
    url: __webpack_require__(487),
    size: 83351,
    distance: 70,
    rollOff: 10,
    volume: 0.5
  },
  crowd_encourage2: {
    url: __webpack_require__(488),
    size: 77207,
    distance: 100,
    rollOff: 10,
    volume: 1.3
  }
};

var textures = {
  start_line: {
    url: __webpack_require__(489),
    size: 272,
    materialType: THREE.MeshStandardMaterial,
    options: {
      metalness: 0.0,
      roughness: 0.6
    }
  },
  start_road: {
    url: __webpack_require__(490),
    size: 96473,
    materialType: THREE.MeshPhongMaterial,
    options: {
      shininess: 18
    }
  },
  start_wall: {
    url: __webpack_require__(203),
    size: 3569,
    materialType: THREE.MeshPhongMaterial
  },
  start_wall_mapped: {
    url: __webpack_require__(203),
    size: 3569,
    materialType: THREE.MeshPhongMaterial,
    options: {
      alphaMap: 'self'
    }
  },
  road: {
    url: __webpack_require__(491),
    size: 105422,
    materialType: THREE.MeshPhongMaterial,
    options: {
      shininess: 18
    }
  },
  kerbs: {
    url: __webpack_require__(492),
    size: 77252,

    materialType: THREE.MeshStandardMaterial,
    options: {
      metalness: 0.2,
      roughness: 0.3
    }
  },
  tickers: {
    url: __webpack_require__(204),
    size: 14173,
    materialType: THREE.MeshBasicMaterial,
    animate: -0.0006
  },
  ribbon_end: {
    url: __webpack_require__(204),
    size: 14173,
    materialType: THREE.MeshBasicMaterial
  },
  text: {
    url: __webpack_require__(493),
    size: 22807,
    materialType: THREE.MeshBasicMaterial,
    animate: -0.001
  },
  stadium: {
    url: __webpack_require__(494),
    size: 2235,
    materialType: THREE.MeshStandardMaterial,
    options: {
      metalness: 0.3,
      roughness: 0.8
    }
  },
  crowd: {
    url: __webpack_require__(495),
    size: 27537,
    materialType: THREE.MeshBasicMaterial
  },

  speedworld_road: {
    url: __webpack_require__(496),
    size: 11639,
    materialType: THREE.MeshPhongMaterial
  },

  ribbon: {
    url: __webpack_require__(497),
    size: 7365,
    materialType: THREE.MeshBasicMaterial
  },

  tree: {
    url: __webpack_require__(498),
    size: 74753,
    materialType: THREE.MeshBasicMaterial,
    scale: {
      min: 23,
      max: 25
    }
  },
  airport: {
    url: __webpack_require__(499),
    size: 361,
    materialType: THREE.SpriteMaterial,
    options: {
      blending: THREE.AdditiveBlending
    },
    scale: {
      min: 1,
      max: 1
    },
    useSprite: true
  },
  people: {
    urls: [__webpack_require__(500), __webpack_require__(501), __webpack_require__(502), __webpack_require__(503), __webpack_require__(504), __webpack_require__(505), __webpack_require__(506), __webpack_require__(507), __webpack_require__(508), __webpack_require__(509), __webpack_require__(510), __webpack_require__(511), __webpack_require__(512), __webpack_require__(513), __webpack_require__(514), __webpack_require__(515)],
    size: 2000,
    materialType: THREE.MeshBasicMaterial,
    usePoints: true,
    scale: {
      min: 3.3,
      max: 3.4
    }
  },

  emojis: {
    urls: [__webpack_require__(516), __webpack_require__(517), __webpack_require__(518), __webpack_require__(519), __webpack_require__(520), __webpack_require__(521), __webpack_require__(522)],
    size: 4000,
    materialType: THREE.SpriteMaterial,
    scale: {
      min: 3.5,
      max: 3.6
    }
  }
};

var objects = {
  road_straight: {
    url: __webpack_require__(523),
    size: 793,
    texture: 'road'
  },
  kerbs_straight: {
    url: __webpack_require__(524),
    size: 1666,
    texture: 'kerbs'
  },
  barrier_straight: {
    url: __webpack_require__(525),
    size: 48100,
    texture: 'start_wall_mapped'
  },

  road_curve_right: {
    url: __webpack_require__(526),
    size: 4329,
    texture: 'road'
  },
  kerbs_curve_right: {
    url: __webpack_require__(527),
    size: 8344,
    texture: 'kerbs'
  },
  arrow_curve_right: {
    url: __webpack_require__(528),
    size: 4967,
    texture: 'tickers'
  },

  road_curve_left: {
    url: __webpack_require__(529),
    size: 4357,
    texture: 'road'
  },
  kerbs_curve_left: {
    url: __webpack_require__(530),
    size: 16754,
    texture: 'kerbs'
  },
  arrow_curve_left: {
    url: __webpack_require__(531),
    size: 5021,
    texture: 'tickers'
  },

  start_line: {
    url: __webpack_require__(532),
    size: 938,
    texture: 'start_line'
  },
  road_straight_start: {
    url: __webpack_require__(533),
    size: 787,
    texture: 'start_road'
  },
  kerbs_straight_start: {
    url: __webpack_require__(534),
    size: 1631,
    texture: 'kerbs'
  },
  wall_straight_start: {
    url: __webpack_require__(535),
    size: 12164,
    texture: 'start_wall',
    renderOrder: 100
  },
  arch_start_lighting: {
    url: __webpack_require__(536),
    size: 6419,
    texture: 'tickers'
  },
  arch_start_ticker: {
    url: __webpack_require__(537),
    size: 815,
    texture: 'tickers'
  },
  cage_start: {
    url: __webpack_require__(538),
    size: 64076,
    texture: 'start_wall',
    renderOrder: 100
  },
  stadium_building: {
    url: __webpack_require__(539),
    size: 50892,
    texture: 'stadium'
  },
  stadium_crowd: {
    url: __webpack_require__(540),
    size: 11353,
    texture: 'crowd'
  },
  garage_start: {
    url: __webpack_require__(541),
    size: 15566,
    texture: null
  },
  ribbon_left: {
    url: __webpack_require__(542),
    size: 2826,
    texture: 'ribbon'
  },
  ribbon_right: {
    url: __webpack_require__(543),
    size: 2793,
    texture: 'ribbon'
  },

  strobe_road: {
    url: __webpack_require__(544),
    size: 775,
    texture: 'tickers',
    cloneMaterial: true
  },
  strobe_left: {
    url: __webpack_require__(545),
    size: 55367,
    texture: 'tickers'
  },
  strobe_right: {
    url: __webpack_require__(546),
    size: 54980,
    texture: 'tickers'
  },
  ticker_left: {
    url: __webpack_require__(547),
    size: 1692,
    texture: 'text'
  },
  ticker_right: {
    url: __webpack_require__(548),
    size: 1638,
    texture: 'text'
  },

  speedworld_road: {
    url: __webpack_require__(549),
    size: 751,
    texture: 'speedworld_road'
  }

};

var types = {
  finish: {
    objs: ['start_line', 'road_straight_start', 'kerbs_straight_start', 'wall_straight_start', 'ticker_left', 'ticker_right', 'ribbon_left', 'ribbon_right'],
    sprites: {
      people: peopleSpawnStart
    },
    directionChange: 0
  },

  start: {
    objs: ['road_straight', 'kerbs_straight_start', 'arch_start_lighting', 'arch_start_ticker', 'cage_start', 'stadium_building', 'stadium_crowd', 'garage_start', 'ticker_left', 'ticker_right'],
    sprites: {
      people: peopleSpawnStart
    },
    sounds: {},
    directionChange: 0
  },

  straight: {
    objs: ['barrier_straight', 'road_straight', 'kerbs_straight'],
    sprites: {
      tree: treeSpawnStraight
    },
    directionChange: 0
  },
  straightStrobe: {
    objs: ['barrier_straight', 'road_straight', 'strobe_road', 'kerbs_straight'],
    sprites: {
      tree: treeSpawnStraight
    },
    directionChange: 0
  },
  straightStrobeLeft: {
    objs: ['barrier_straight', 'road_straight', 'strobe_road', 'kerbs_straight', 'strobe_left', 'ticker_left'],
    sprites: {
      tree: treeSpawnStraight
    },
    directionChange: 0
  },
  straightStrobeRight: {
    objs: ['barrier_straight', 'road_straight', 'strobe_road', 'kerbs_straight', 'strobe_right', 'ticker_right'],
    sprites: {
      tree: treeSpawnStraight
    },
    directionChange: 0
  },
  straightStrobeStadium: {
    objs: ['barrier_straight', 'road_straight', 'strobe_road', 'kerbs_straight', 'stadium_building', 'stadium_crowd'],
    sprites: {
      tree: treeSpawnStraight
    },
    directionChange: 0
  },
  straightAirport: {
    objs: ['barrier_straight', 'road_straight', 'kerbs_straight'],
    sprites: {
      tree: treeSpawnStraight,
      airport: airportLightsSpawnStraight
    },
    directionChange: 0
  },

  left: {
    objs: ['road_curve_left', 'kerbs_curve_left', 'arrow_curve_left'],
    sprites: {
      tree: treeSpawnLeft,

      people: peopleSpawnCurveLeft
    },
    sounds: {
      crowd_encourage1: [{
        x: 15,
        y: 2.25,
        z: 15
      }]
    },
    directionChange: -90
  },
  right: {
    objs: ['road_curve_right', 'kerbs_curve_right', 'arrow_curve_right'],
    sprites: {
      tree: treeSpawnRight,

      people: peopleSpawnCurveRight
    },
    sounds: {
      crowd_encourage1: [{
        x: -15,
        y: 2.25,
        z: 15
      }]
    },
    directionChange: 90
  },
  leftAirport: {
    objs: ['road_curve_left', 'kerbs_curve_left', 'arrow_curve_left'],
    sprites: {
      tree: treeSpawnLeft,
      people: peopleSpawnCurveLeft,

      airport: airportLightsSpawnCurveLeft
    },
    sounds: {
      crowd_encourage2: [{
        x: 15,
        y: 2.25,
        z: 15
      }]
    },
    directionChange: -90
  },
  rightAirport: {
    objs: ['road_curve_right', 'kerbs_curve_right', 'arrow_curve_right'],
    sprites: {
      tree: treeSpawnRight,
      people: peopleSpawnCurveRight,

      airport: airportLightsSpawnCurveRight
    },
    sounds: {
      crowd_encourage2: [{
        x: -15,
        y: 2.25,
        z: 15
      }]
    },
    directionChange: 90
  },

  speed_straight: {
    objs: ['speedworld_road', 'kerbs_straight'],
    sprites: {
      tree: treeSpawnStraight
    },
    directionChange: 0
  }

};

var layout = ['start', 'start', 'straight', 'straight', 'straight', 'right', 'straight', 'straight', 'right', 'straight', 'left', 'straight', 'right', 'straight', 'straight', 'straightStrobeRight', 'straightStrobeRight', 'straightStrobeRight', 'straightStrobeRight', 'straightStrobeLeft', 'straightStrobeLeft', 'straightStrobeLeft', 'straightStrobeLeft', 'straightStrobeStadium', 'straightAirport', 'straightAirport', 'rightAirport', 'straightAirport', 'straightAirport', 'straightAirport', 'straightAirport', 'rightAirport', 'straight', 'straight', 'straight', 'straight', 'straight', 'straight', 'straight', 'straight', 'straight', 'finish'];

var numDraw = layout.length / 2 - 1;

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return white; });
var THREE = __webpack_require__(0);
var blue = new THREE.Color(0x0011FF);
var red = new THREE.Color(0xEB0033);
var white = new THREE.Color(0xFFFFFF);

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camera; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return perfectZ; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(120);

var THREE = __webpack_require__(0);



var camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.01, 100000);
/* harmony default export */ __webpack_exports__["b"] = (camera);
var perfectZ = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getDistanceForPerfectProjection */]();
camera.position.z = perfectZ;

var updateAspect = function updateAspect() {
  camera.aspect = __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].state.browser.windowWidth / __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].state.browser.windowHeight;
  camera.updateProjectionMatrix();

  perfectZ = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getDistanceForPerfectProjection */]();
  camera.position.z = perfectZ;
};
__WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].state.browser.windowWidth;
}, updateAspect);
__WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */].state.browser.windowHeight;
}, updateAspect);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var a = function () {
    var root = (typeof self === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default.a(self)) == 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default.a(global)) == 'object' && global.global === global && global || this;

    var Maf = function Maf(obj) {
        if (obj instanceof Maf) return obj;
        if (!(this instanceof Maf)) return new Maf(obj);
        this._wrapped = obj;
    };

    if (typeof exports != 'undefined' && !exports.nodeType) {
        if (typeof module != 'undefined' && !module.nodeType && module.exports) {
            exports = module.exports = Maf;
        }
        exports.Maf = Maf;
    } else {
        root.Maf = Maf;
    }

    Maf.VERSION = '1.0.0';

    Maf.PI = Math.PI;

    Maf.clamp = function (v, minVal, maxVal) {
        return Math.min(maxVal, Math.max(minVal, v));
    };

    Maf.step = function (edge, v) {
        return v < edge ? 0 : 1;
    };

    Maf.smoothStep = function (edge0, edge1, v) {
        var t = Maf.clamp((v - edge0) / (edge1 - edge0), 0.0, 1.0);
        return t * t * (3.0 - 2.0 * t);
    };

    Maf.deg2Rad = function (degrees) {
        return degrees * Math.PI / 180;
    };

    Maf.toRadians = Maf.deg2Rad;

    Maf.rad2Deg = function (radians) {
        return radians * 180 / Math.PI;
    };

    Maf.toDegrees = Maf.rad2Deg;

    Maf.clamp01 = function (v) {
        return Maf.clamp(v, 0, 1);
    };

    Maf.mix = function (x, y, a) {
        if (a <= 0) return x;
        if (a >= 1) return y;
        return x + a * (y - x);
    };

    Maf.lerp = Maf.mix;

    Maf.inverseMix = function (a, b, v) {
        return (v - a) / (b - a);
    };

    Maf.inverseLerp = Maf.inverseMix;

    Maf.mixUnclamped = function (x, y, a) {
        if (a <= 0) return x;
        if (a >= 1) return y;
        return x + a * (y - x);
    };

    Maf.lerpUnclamped = Maf.mixUnclamped;

    Maf.fract = function (v) {
        return v - Math.floor(v);
    };

    Maf.frac = Maf.fract;

    Maf.isPowerOfTwo = function (v) {
        return (v - 1 & v) == 0;
    };

    Maf.closestPowerOfTwo = function (v) {
        return Math.pow(2, Math.round(Math.log(v) / Math.log(2)));
    };

    Maf.nextPowerOfTwo = function (v) {
        return Math.pow(2, Math.ceil(Math.log(v) / Math.log(2)));
    };

    Maf.mod = function (a, n) {
        return (a % n + n) % n;
    };

    Maf.deltaAngle = function (a, b) {
        var d = Maf.mod(b - a, 360);
        if (d > 180) d = Math.abs(d - 360);
        return d;
    };

    Maf.deltaAngleDeg = Maf.deltaAngle;

    Maf.deltaAngleRad = function (a, b) {
        return Maf.toRadians(Maf.deltaAngle(Maf.toDegrees(a), Maf.toDegrees(b)));
    };

    Maf.lerpAngle = function (a, b, t) {
        var angle = Maf.deltaAngle(a, b);
        return Maf.mod(a + Maf.lerp(0, angle, t), 360);
    };

    Maf.lerpAngleDeg = Maf.lerpAngle;

    Maf.lerpAngleRad = function (a, b, t) {
        return Maf.toRadians(Maf.lerpAngleDeg(Maf.toDegrees(a), Maf.toDegrees(b), t));
    };

    Maf.gammaToLinearSpace = function (v) {
        return Math.pow(v, 2.2);
    };

    Maf.linearToGammaSpace = function (v) {
        return Math.pow(v, 1 / 2.2);
    };

    Maf.map = function (from1, to1, from2, to2, v) {
        return from2 + (v - from1) * (to2 - from2) / (to1 - from1);
    };

    Maf.scale = Maf.map;

    Maf.almostIdentity = function (x, m, n) {

        if (x > m) return x;

        var a = 2 * n - m;
        var b = 2 * m - 3 * n;
        var t = x / m;

        return (a * t + b) * t * t + n;
    };

    Maf.impulse = function (k, x) {
        var h = k * x;
        return h * Math.exp(1 - h);
    };

    Maf.cubicPulse = function (c, w, x) {
        x = Math.abs(x - c);
        if (x > w) return 0;
        x /= w;
        return 1 - x * x * (3 - 2 * x);
    };

    Maf.expStep = function (x, k, n) {
        return Math.exp(-k * Math.pow(x, n));
    };

    Maf.parabola = function (x, k) {
        return Math.pow(4 * x * (1 - x), k);
    };

    Maf.powerCurve = function (x, a, b) {
        var k = Math.pow(a + b, a + b) / (Math.pow(a, a) * Math.pow(b, b));
        return k * Math.pow(x, a) * Math.pow(1 - x, b);
    };

    Maf.latLonToCartesian = function (lat, lon) {

        lon += 180;
        lat = Maf.clamp(lat, -85, 85);
        var phi = Maf.toRadians(90 - lat);
        var theta = Maf.toRadians(180 - lon);
        var x = Math.sin(phi) * Math.cos(theta);
        var y = Math.cos(phi);
        var z = Math.sin(phi) * Math.sin(theta);

        return { x: x, y: y, z: z };
    };

    Maf.cartesianToLatLon = function (x, y, z) {
        var n = Math.sqrt(x * x + y * y + z * z);
        return { lat: Math.asin(z / n), lon: Math.atan2(y, x) };
    };

    Maf.randomInRange = function (min, max) {
        return min + Math.random() * (max - min);
    };

    Maf.norm = function (v, minVal, maxVal) {
        return (v - minVal) / (maxVal - minVal);
    };

    Maf.hash = function (n) {
        return Maf.fract((1.0 + Math.cos(n)) * 415.92653);
    };

    Maf.noise2d = function (x, y) {
        var xhash = Maf.hash(x * 37.0);
        var yhash = Maf.hash(y * 57.0);
        return Maf.fract(xhash + yhash);
    };

    Maf.smoothMin = function (a, b, k) {
        var res = Math.exp(-k * a) + Math.exp(-k * b);
        return -Math.log(res) / k;
    };

    Maf.smoothMax = function (a, b, k) {
        return Math.log(Math.exp(a) + Math.exp(b)) / k;
    };

    Maf.almost = function (a, b) {
        return Math.abs(a - b) < .0001;
    };
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12), __webpack_require__(123)(module)))

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var prodConfig = {
  endpoints: {
    getOpenId: 'https://api.nike.com.cn/wx/v3/User/getUserinfo/oa/run',
    shareConfig: 'https://api.nike.com.cn/wx/v3/js/share/oa/run/',
    getRank: 'https://a.nike.com.cn/fast/api/v3/activity/getrank',
    detail: 'https://a.nike.com.cn/fast/api/v3/activity/detail'
  }
};

var devConfig = {
  endpoints: {
    getOpenId: 'https://cn-nike-api.akqa-uat.com/wx/v3/User/getUserinfo/oa/test',
    shareConfig: 'https://cn-nike-api.akqa-uat.com/wx/v3/js/share/oa/test',
    getRank: 'https://cn-nike-a.akqa-uat.com/fast/api/v3/activity/getrank',
    detail: 'https://cn-nike-a.akqa-uat.com/fast/api/v3/activity/detail'
  }
};

var config = void 0;
if (true) {
  config = prodConfig;
  config = devConfig;
} else {
  config = devConfig;
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.4 27.6"><path class="st0" d="M31.9 10.5l-16.5 4.3c-3.4.9-6.1.8-7.6-.4-3.9-2.8-.9-8.6.2-10.3-2 2.1-3.9 4.2-5.4 6.5C.2 14.3-.8 18.2.8 20.7c2.9 4.6 9.7 2.5 14.1.7l40.5-17L38 9"/></svg>'};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDistanceForPerfectProjection; });
/* unused harmony export randSign */
var getDistanceForPerfectProjection = function getDistanceForPerfectProjection() {
  var fov = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.innerHeight;

  var vFov = fov * (Math.PI / 180);
  var z = height / (2 * Math.tan(vFov / 2));
  return z;
};

var randSign = function randSign() {
  return Math.random() < 0.5 ? -1 : 1;
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scene", function() { return scene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showDashboard", function() { return showDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideDashboard", function() { return hideDashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text_simple__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cta__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollCta__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__countdown__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__distance__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eyelid__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboard__ = __webpack_require__(200);

var THREE = __webpack_require__(0);










var scene = new THREE.Scene();
/* harmony default export */ __webpack_exports__["default"] = (scene);

scene.add(__WEBPACK_IMPORTED_MODULE_0__text_simple__["mesh"]);

scene.add(__WEBPACK_IMPORTED_MODULE_1__cta__["mesh"]);
__WEBPACK_IMPORTED_MODULE_1__cta__["mesh"].position.y = -window.innerHeight * 0.22;

scene.add(__WEBPACK_IMPORTED_MODULE_2__scrollCta__["mesh"]);

scene.add(__WEBPACK_IMPORTED_MODULE_3__countdown__["mesh"]);

scene.add(__WEBPACK_IMPORTED_MODULE_5__eyelid__["mesh"]);

var showDashboard = function showDashboard() {
  scene.add(__WEBPACK_IMPORTED_MODULE_6__dashboard__["a" /* default */].mesh);
  __WEBPACK_IMPORTED_MODULE_6__dashboard__["a" /* default */].startStage1();
};

var hideDashboard = function hideDashboard() {
  scene.remove(__WEBPACK_IMPORTED_MODULE_6__dashboard__["a" /* default */].mesh);
};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

THREE.JDLoader = function (a) {
  this.manager = void 0 !== a ? a : THREE.DefaultLoadingManager;
}, THREE.JDLoader.prototype = { constructor: THREE.JDLoader, load: function load(a, b, c, d) {
    var e = this,
        f = this.texturePath && "string" == typeof this.texturePath ? this.texturePath : THREE.Loader.prototype.extractUrlBase(a),
        g = new THREE.FileLoader(this.manager);g.load(a, function (a) {
      e.loadText(a, b, f);
    }, c, d);
  }, loadText: function loadText(a, b, c) {
    var d = JSON.parse(a);if (d) {
      var e = this.parse(d, c);b(e);
    }
  }, setTexturePath: function setTexturePath(a) {
    this.texturePath = a;
  }, parse: function parse(a, b) {
    function i() {
      var b,
          d,
          a = new THREE.Sphere(),
          e = 0,
          f = 0,
          h = 0,
          i = [],
          j = [],
          l = new THREE.Vector3(0, 0, 0),
          m = new THREE.Vector3(0, 0, 0);if (g && g.length) {
        for (b = 0; b < g.length; ++b) {
          g[b].boundingSphere || g[b].computeBoundingSphere(), f += g[b].boundingSphere.radius;
        }if (f > 0) {
          for (b = 0; b < g.length; ++b) {
            d = g[b], j.push(d.boundingSphere.radius), i.push(d.boundingSphere.center), m.copy(d.boundingSphere.center), m.multiplyScalar(d.boundingSphere.radius / f), l.add(m);
          }for (b = 0; b < g.length; ++b) {
            var n = l.distanceTo(i[b]);n >= e && (e = n, h = e + j[b]);
          }a.center = l, a.radius = h;
        }
      }return a;
    }function j(a) {
      if (a && a.skin && a.skin.skinBones.length && a.skin.skinWeights.length) return f;var b = [];b.push(f[0]);var c = f[a.node],
          d = {};return d.name = c.name, d.parent = 0, d.pos = [c.pos[0], c.pos[1], c.pos[2]], d.scl = [c.scl[0], c.scl[1], c.scl[2]], d.rotq = [c.rotq[0], c.rotq[1], c.rotq[2], c.rotq[3]], b.push(d), b;
    }function k() {
      if (e = [], void 0 !== a.materials && 0 !== a.materials.length) {
        var c,
            f,
            g,
            h,
            i,
            j = 0,
            k = 0,
            l = !1;for (j = 0; j < a.materials.length; ++j) {
          var m = a.materials[j];if (g = new THREE.Color(16777215), h = new THREE.Color(1644825), m.diffuse && g.fromArray(m.diffuse), m.specular && h.fromArray(m.specular), i = void 0 !== m.glossiness ? m.glossiness : 40, c = void 0, m.maps) for (var n = 0; n < m.maps.length; ++n) {
            if ("diffuse" == m.maps[n].type && "" != m.maps[n].file) {
              var o = !1,
                  p = m.maps[n].file.substring(m.maps[n].file.lastIndexOf(".") + 1);if (p = p.toLowerCase(), p = "jpg" == p ? "jpeg" : p, void 0 !== m.maps[n].data && ("bmp" == p || "png" == p || "jpeg" == p || "gif" == p)) {
                var q = "",
                    r = m.maps[n].data,
                    s = r.length;for (k = 0; k < s; ++k) {
                  q += String.fromCharCode(r[k]);
                }var t = window.btoa(q),
                    t = "data:image/" + p + ";base64," + t;c = new THREE.Texture();var u = new Image();c.image = u, u.src = t, u.onload = function (a) {
                  return function () {
                    a.needsUpdate = !0;
                  };
                }(c), o = !0;
              }if (!o) {
                var v = new THREE.TextureLoader();v.setCrossOrigin(d.crossOrigin), c = v.load(b + m.maps[n].file);
              }c && "jpeg" != p && (l = !0);break;
            }
          }f = new THREE.MeshPhongMaterial({ color: g.getHex(), specular: h.getHex(), shininess: i, shading: THREE.SmoothShading, skinning: !0 }), c && (f.map = c), void 0 !== m.opacity && (f.opacity = m.opacity, m.opacity < 1 && (f.transparent = !0)), l && (f.transparent = !0), e.push(f);
        }
      }
    }function l() {
      if (f = void 0 !== a.hierarchy ? a.hierarchy.nodes : a.nodes, Array.isArray(f) && f.length > 0) for (var b = 0; b < f.length; ++b) {
        void 0 !== f[b].rot && (f[b].rotq = f[b].rot, f[b].rot = void 0);
      } else f = [];
    }function m(a) {
      var b = new THREE.Matrix4();if (!f || a < 0 || !f[a]) return b;for (var c = a; c >= 0; c = f[c].parent) {
        var d = f[c],
            e = new THREE.Vector3(d.pos[0], d.pos[1], d.pos[2]),
            g = new THREE.Vector3(d.scl[0], d.scl[1], d.scl[2]),
            h = new THREE.Quaternion(d.rotq[0], d.rotq[1], d.rotq[2], d.rotq[3]),
            i = new THREE.Matrix4().compose(e, h, g);b.premultiply(i);
      }return b;
    }function o(b) {
      var c = -1;if (!b || !a.materials) return 0;for (var d = 0; d < b.length; ++d) {
        var e = a.materials[b[d].materialIndex];if (e && e.maps) for (var f = 0; f < e.maps.length; ++f) {
          if ("diffuse" == e.maps[f].type) if (c < 0) c = e.maps[f].uvsIndex;else if (c != e.maps[f].uvsIndex) return c;
        }
      }return c < 0 ? 0 : c;
    }function p() {
      var b = a.model;if (b && b.meshes) for (var c, d, e, h, i, k, l, n, p, q, r, t, v, x, A, B, C, D, E, F, G, r, H, I, J, K, Q, R = 0; R < b.meshes.length; ++R) {
        if (A = 0, i = new THREE.BufferGeometry(), k = b.meshes[R], void 0 == k) return;if (k.name && (i.name = k.name), n = k.verts, void 0 == n) return;if (q = k.vertElement, void 0 == q) return;if (B = k.face, C = q.vertIndices, D = q.normals, E = q.colors, F = q.uvs, G = k.skin, r = k.node, void 0 == r || !(r >= 0 && r < f.length)) return;if (H = f[r], !(H && H.pos && H.rotq && H.scl)) return;if (void 0 == B) return;if (I = B.vertElementIndices, J = B.groups, !I || !J) return;K = m(r), l = C.length;var S = new Float32Array(3 * l);for (p = 0; p < l; ++p) {
          c = 3 * C[p], d = 3 * p, t = new THREE.Vector3(n[c], n[c + 1], n[c + 2]), t.applyMatrix4(K), S[d] = t.x, S[d + 1] = t.y, S[d + 2] = t.z;
        }if (i.addAttribute("position", new THREE.BufferAttribute(S, 3)), void 0 !== D && D.length > 0) {
          var T = new THREE.Matrix3().getNormalMatrix(K),
              U = new Float32Array(D);for (c = 0; c + 2 < D.length; c += 3) {
            v = new THREE.Vector3(D[c], D[c + 1], D[c + 2]), v.applyMatrix3(T).normalize(), U[c] = v.x, U[c + 1] = v.y, U[c + 2] = v.z;
          }i.addAttribute("normal", new THREE.BufferAttribute(U, 3));
        }if (void 0 !== F && F.length > 0) {
          c = o(J), c = c < F.length ? c : 0;var x = new Float32Array(F[c]);i.addAttribute("uv", new THREE.BufferAttribute(x, 2)), F.length > 1 && (c = 0 == c ? 1 : 0, x = new Float32Array(F[c]), i.addAttribute("uv2", new THREE.BufferAttribute(x, 2)));
        }var V = new Uint32Array(I);if (i.setIndex(new THREE.BufferAttribute(V, 1)), i.groups = J, h = n.length / 3, !G && H.parent >= 0) for (G = k.skin = {}, G.skinBones = [], G.skinWeights = [], p = 0; p < h; ++p) {
          G.skinBones.push([r]), G.skinWeights.push([1]);
        }var W = [],
            X = [];Q = 0;var Y, Z;if (G && G.skinBones && G.skinWeights && G.skinBones.length == G.skinWeights.length) for (p = 0; p < h; ++p) {
          Y = new THREE.Vector4(0, 0, 0, 0), Z = new THREE.Vector4(0, 0, 0, 0);var $ = 0;for (e = 0; e < 4; ++e) {
            e < G.skinBones[p].length ? (Y.setComponent(e, G.skinBones[p][e]), Z.setComponent(e, G.skinWeights[p][e]), ++$) : (Y.setComponent(e, 0), Z.setComponent(e, 0));
          }for (; $ < G.skinWeights[p].length;) {
            Z.addScalar(.25 * G.skinWeights[p][$]), ++$;
          }W.push(Y), X.push(Z);
        }if (W.length > 0 && X.length > 0) for (i.addAttribute("skinIndex", new THREE.Float32BufferAttribute(new Float32Array(4 * l), 4)), i.addAttribute("skinWeight", new THREE.Float32BufferAttribute(new Float32Array(4 * l), 4)), p = 0; p < l; ++p) {
          c = C[p], Y = W[c], Z = X[c], i.attributes.skinIndex.setXYZW(p, Y.x, Y.y, Y.z, Y.w), i.attributes.skinWeight.setXYZW(p, Z.x, Z.y, Z.z, Z.w);
        }var _ = j(k);_ && _.length > 0 && (i.bones = _), g.push(i);
      }
    }function q() {
      var b = a.animation;if (b && b.keyframeAnimations && 0 != b.keyframeAnimations.length) {
        var e,
            f,
            h,
            i,
            j,
            c = b.keyframeAnimations.concat(),
            d = [];for (e = 0; e < c.length; e++) {
          f = r(c[e]), f && d.push(f);
        }if (d.length > 0) for (e = 0; e < g.length; ++e) {
          var k = !1;if (g[e] instanceof THREE.Geometry ? k = g[e].skinIndices && g[e].skinIndices.length > 0 && g[e].skinWeights && g[e].skinWeights.length > 0 : g[e] instanceof THREE.BufferGeometry && (k = g[e].attributes.skinIndex && g[e].attributes.skinIndex.count > 0 && g[e].attributes.skinWeight && g[e].attributes.skinWeight.count > 0), k) g[e].animations = d;else for (g[e].animations = [], h = 0; h < d.length; ++h) {
            var l = [];for (i = d[h].tracks.length - 1; i >= 0; --i) {
              j = d[h].tracks[i].name, j != ".bones[" + g[e].name + "].position" && j != ".bones[" + g[e].name + "].quaternion" && j != ".bones[" + g[e].name + "].scale" || l.push(d[h].tracks[i]);
            }l.length > 0 && g[e].animations.push(new THREE.AnimationClip(d[h].name, d[h].duration, l));
          }
        }
      }
    }function r(a) {
      if (!a) return console.error("parseKeyFrameAnimation: no animation"), null;var b = a.fps || 30,
          c = !0,
          d = a.length || -1;"frames" == a.timeline && (c = !1, d /= b);for (var e = function e(a, d, _e, f) {
        if (_e && Array.isArray(_e.times) && Array.isArray(_e.values)) {
          var g = [],
              h = [];if (g = g.concat(_e.times), h = h.concat(_e.values), !c) for (var i = 0; i < g.length; ++i) {
            g[i] /= b;
          }g && 0 != g.length && h && 0 != h.length && f.push(new a(d, g, h));
        }
      }, g = [], h = a.name || "default", i = a.animNodes || [], j = 0; j < i.length; j++) {
        var k = i[j];if (k) {
          var l = "";void 0 !== k.nodeName ? l = k.nodeName : void 0 !== k.nodeIndex && (l = f[k.nodeIndex].name);var m = ".bones[" + l + "]";e(THREE.VectorKeyframeTrack, m + ".position", k.pos, g), e(THREE.VectorKeyframeTrack, m + ".scale", k.scl, g), e(THREE.QuaternionKeyframeTrack, m + ".quaternion", k.rot, g);
        }
      }if (0 === g.length) return null;var n = new THREE.AnimationClip(h, d, g);return n;
    }var c = 0,
        d = this,
        e = [],
        f = [],
        g = [];for (k(), l(), p(), q(), c = 0; c < g.length; ++c) {
      g[c].computeFaceNormals(), g[c].computeBoundingSphere();
    }var h = i();return { geometries: g, materials: e, jd_materials: a.materials, boundingSphere: h };
  } };

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lockup.a6c7195.png";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qrcode.4d9ef57.jpg";

/***/ }),
/* 145 */,
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loading_Loading__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loading_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loading_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_race_Race__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_race_Race___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_race_Race__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_result_Result__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_result_Result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_result_Result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_AnalyticsService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_config_api__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_url_search_params_polyfill__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_url_search_params_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_cookie__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_store__ = __webpack_require__(19);













window.Cookies = __WEBPACK_IMPORTED_MODULE_9_js_cookie___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var base = __dirname;
if (true) {
  base = __WEBPACK_IMPORTED_MODULE_7_src_config___default.a.build.assetsPublicPath;
}

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: base,
  routes: [{
    path: '/',
    name: 'loading',
    component: __WEBPACK_IMPORTED_MODULE_2__components_loading_Loading___default.a
  }, {
    path: '/race',
    name: 'race',
    component: __WEBPACK_IMPORTED_MODULE_3__components_race_Race___default.a
  }, {
    path: '/result',
    name: 'result',
    component: __WEBPACK_IMPORTED_MODULE_4__components_result_Result___default.a
  }, {
    path: '*',
    redirect: '/'
  }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

router.beforeEach(function (to, from, next) {

  if (to.name === 'race') {
    if (!__WEBPACK_IMPORTED_MODULE_10_src_store__["a" /* default */].state.game.loading.completed) {
      return next({ name: 'loading' });
    }
  }

  next();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(301)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  "data-v-3e26e727",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */,
/* 149 */
/***/ (function(module, exports) {

module.exports = {
  zh: {
    page_title: 'NIKE突破速度挑战赛',
    loading: [['你，就是我们一直寻找的', '疾速跑者'], ['你正踏入意大利蒙扎赛车场'], ['即将和BREAKING2运动员', '共同挑战人类极速'], ['PEGASUS 34上脚', '决心燃爆']],
    startCta: '开始挑战',
    volumeCta: '调高⾳量更带感',
    start: '挑战赛即刻开启',
    scrollCta: '疾速滑动屏幕',
    help: ['你敢再慢一点吗'],
    slow: ['', '就这点本事？'],
    fast: ['这速度可差点意思', '厉害！你已接近\nBREAKING 2 运动员'],
    airport: '完成一半赛程',
    '10kmCta': '最后10公里\n不容减速',
    end: '谁说极限遥不可及？',
    result: {
      title: '你创造了新的速度传奇',
      percentile: {
        0: '超越全国',
        1: '的参赛者'
      },
      btn_again: '再跑⼀次',
      btn_share: '先去炫耀',
      share_content: '立即向场外朋友炫耀',
      btn_draw: '抽取定制T恤',
      btn_buy: '入手疾速装备',
      btn_tc: '活动条款'
    },
    share_cta: {
      wechat: ['点击右上角…', '速速炫耀战绩'],
      browser: ['点击底部分享按钮', '果断炫耀']
    },
    share: {
      generic: {
        title: ['我刚在突破速度挑战赛中', '创造了新的传奇'],
        subtitle: '谁都可以质疑极限',
        cta: '你来试试？'
      },
      named: {
        title: ['我刚在突破速度挑战赛中', '创造了新的传奇'],
        subtitle: '谁都可以质疑极限',
        cta: '你来试试？'
      }
    },
    wechat: {
      generic: {
        title: '够胆！F1赛道上飙速马拉松，冲破人类极限',
        desc: '参与并有机会获得定制疾速装备',
        moments: '够胆！F1赛道飙速，冲破人类马拉松极限'
      },
      result: {
        title: '厉害了！我刚刚在F1赛场飙速马拉松！',
        desc: '不服来战',
        moments: '厉害了！我刚刚在F1赛场飙速马拉松'
      }
    },
    unsupported: '扫描或长按识别二维码\n与极限，来场速战速决',
    landscape: '竖起手机后\n再开始挑战'
  },

  en: {
    page_title: 'Nike Feed of Speed',
    loading: [['You are the one', 'we have been searching for'], ['Now entering', 'Monza Circuit, Italy'], ['Challenge human speed limit', 'with the Breaking2 Athletes'], ['Putting on', 'Nike Air Zoom Pegasus 34']],
    startCta: 'Start',
    volumeCta: 'Turn up the Volume',
    start: 'The challenge\nis about to begin',
    scrollCta: 'Scroll to run',
    help: ['Are you really this slow?'],
    slow: ['', 'This is all you\'ve got?'],
    fast: ['', 'Amazing! You are close\nto the Breaking2 athletes'],
    airport: 'Half way there',
    '10kmCta': 'Last 10km\nGo faster!',
    end: 'Who said the limit\nis out of reach',
    result: {
      title: 'You created a new speed record',
      percentile: {
        0: 'You beat',
        1: 'of the competition'
      },
      btn_again: 'Run Again',
      btn_share: '先去炫耀',
      share_content: '',
      btn_draw: 'Win a Gear',
      btn_buy: 'Buy Now',
      btn_tc: 'Terms & Conditions'
    },
    share_cta: {
      wechat: ['点击右上角…', '速速炫耀战绩'],
      browser: ['点击底部分享按钮', '果断炫耀']
    },
    share: {
      generic: {
        title: ['Feed of Speed', 'I just created a new record'],
        subtitle: 'Who said the limit is out of reach',
        cta: 'Take Challenge'
      },
      named: {
        title: ['我刚在突破速度挑战赛中', '创造了新的传奇'],
        subtitle: '谁都可以质疑极限',
        cta: '你来试试？'
      }
    },
    wechat: {
      generic: {
        title: '够胆！F1赛道上飙速马拉松，冲破人类极限',
        desc: '参与并有机会获得定制疾速装备',
        moments: '够胆！F1赛道飙速，冲破人类马拉松极限'
      },
      result: {
        title: '厉害了！我刚刚在F1赛场飙速马拉松！',
        desc: '不服来战',
        moments: '厉害了！我刚刚在F1赛场飙速马拉松'
      }
    },
    unsupported: 'Please Visit this Page\nfrom Your Mobile',
    landscape: '竖起手机后\n再开始挑战'
  }

};

/***/ }),
/* 150 */,
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return service; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_postscribe__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_postscribe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_postscribe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_whatwg_fetch__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_AnalyticsService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_config_api__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_i18n__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_url_search_params_polyfill__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_url_search_params_polyfill__);










var config = __webpack_require__(16);
var base = __dirname;
if (true) {
  base = config.build.assetsPublicPath;
}

var shareImg = __webpack_require__(421);

var ShareService = function () {
  function ShareService(analytics) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a(this, ShareService);

    this.init = function () {
      return _this.injectScript().then(_this.updateConfig).then(_this.enableShare);
    };

    this.updateConfig = function () {

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {

        if (!_this.inWechat) {
          resolve();
          return;
        }

        var configUrl = '' + __WEBPACK_IMPORTED_MODULE_6_src_config_api__["a" /* default */].endpoints.shareConfig;

        if (_this.lastUrl === encodeURIComponent(window.location.href.split('#')[0])) {
          resolve();
          return;
        }

        _this.lastUrl = encodeURIComponent(window.location.href.split('#')[0]);

        var requestUrl = configUrl + '?link=' + _this.lastUrl;

        window.fetch(requestUrl).then(function (response) {
          return response.json();
        }).then(function (json) {
          return _this.handleConfigSuccess(json);
        }).then(function () {
          resolve();
        });
      });
    };

    this.handleConfigSuccess = function (config) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {

        if (!window.wx) return resolve();

        window.wx.config({
          debug: _this.debugEnabled,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems']
        });
        window.wx.ready(resolve);
      });
    };

    this.enableShare = function () {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {

        if (!_this.inWechat) {
          resolve();
          return;
        }

        window.wx.showMenuItems({
          menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook']
        });
        resolve();
      });
    };

    this.disableShare = function () {
      window.wx.hideMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook']
      });
    };

    this.setLink = function (path) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var desc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var moments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var shareImg = arguments[4];

      var base = window.location.origin;
      var link = '' + base + path;
      var img = '' + base + shareImg;

      if (!_this.inWechat) {
        return;
      }

      window.wx.onMenuShareTimeline({
        link: link,
        title: moments,
        imgUrl: img,
        success: function success() {
          __WEBPACK_IMPORTED_MODULE_5_src_api_AnalyticsService__["a" /* service */].sendEvent('share', 'onMenuShareTimeline');
        }
      });

      window.wx.onMenuShareAppMessage({
        link: link,
        title: title,
        desc: desc,
        imgUrl: img,
        success: function success() {
          __WEBPACK_IMPORTED_MODULE_5_src_api_AnalyticsService__["a" /* service */].sendEvent('share', 'onMenuShareAppMessage');
        }
      });
    };

    this.setDefaultLink = function () {
      return _this.setLink('' + base, __WEBPACK_IMPORTED_MODULE_7_src_i18n__["a" /* default */].t('wechat.generic.title'), __WEBPACK_IMPORTED_MODULE_7_src_i18n__["a" /* default */].t('wechat.generic.desc'), __WEBPACK_IMPORTED_MODULE_7_src_i18n__["a" /* default */].t('wechat.generic.moments'), shareImg);
    };

    this.setResultLink = function (duration, username) {

      var link = base + 'result?_duration=' + duration;
      if (username) {
        link += '&_name=username';
      }

      console.log('ShareService.setResultLink', link);

      return _this.setLink(link, __WEBPACK_IMPORTED_MODULE_7_src_i18n__["a" /* default */].t('wechat.result.title'), __WEBPACK_IMPORTED_MODULE_7_src_i18n__["a" /* default */].t('wechat.result.desc'), __WEBPACK_IMPORTED_MODULE_7_src_i18n__["a" /* default */].t('wechat.result.moments'), shareImg);
    };

    this.analytics = analytics;
    this.lastUrl = null;
    this.injected = false;
    this.inWechat = /micromessenger/i.test(navigator.userAgent);


    this.debugEnabled = new window.URLSearchParams(window.location.search).get('_wechatDebug') !== null;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a(ShareService, [{
    key: 'injectScript',
    value: function injectScript() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        if (_this2.injected) {
          resolve();
          return;
        }
        _this2.injected = true;

        if (!_this2.inWechat) {
          resolve();
          return;
        }

        var head = document.head || document.getElementsByTagName('head')[0];
        var src = '//res.wx.qq.com/open/js/jweixin-1.0.0.js';
        __WEBPACK_IMPORTED_MODULE_3_postscribe___default.a(head, '<script src=\'' + src + '\'></script>', {
          afterAsync: function afterAsync() {
            resolve();
          }
        });
      });
    }
  }]);

  return ShareService;
}();

var service = new ShareService();
window.ShareService = service;
/* unused harmony default export */ var _unused_webpack_default_export = (service);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cloth.9f7889b.png";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoe-1.ace5414.png";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoe-2.3a520e3.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoe-3.400a6c0.png";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoe-zoom-title1.929ae8a.png";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoe-zoom-title2.6896ee3.png";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoe-zoom-title3.bc1245b.png";

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/game/result/plane-sprite.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader__ = __webpack_require__(3);

var THREE = __webpack_require__(0);


var PlaneSprite = function PlaneSprite(url, size, w, h) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default.a(this, PlaneSprite);

  __WEBPACK_IMPORTED_MODULE_1__loader__["registerSize"](url, size);

  var geometry = new THREE.PlaneBufferGeometry(w, h);

  var material = new THREE.MeshBasicMaterial({
    side: THREE.DoubleSide,
    transparent: true
  });

  var mesh = new THREE.Mesh(geometry, material);

  var loader = new THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_1__loader__["loadingManager"]);
  __WEBPACK_IMPORTED_MODULE_1__loader__["load"](url, loader, function (results) {
    material.map = results[0];
    material.needsUpdate = true;
  });

  return mesh;
};

/* harmony default export */ var plane_sprite_defaultExport = (PlaneSprite);
// CONCATENATED MODULE: ./src/components/game/result/scene.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scene", function() { return scene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "content", function() { return content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "titles", function() { return titles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shoes", function() { return shoes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startShoesAnim", function() { return startShoesAnim; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorBgResult", function() { return colorBgResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateIn", function() { return animateIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateOut", function() { return animateOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bg__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flag__ = __webpack_require__(192);


var scene_THREE = __webpack_require__(0);



var scene = new scene_THREE.Scene();
/* harmony default export */ __webpack_exports__["default"] = (scene);





scene.add(__WEBPACK_IMPORTED_MODULE_4__bg__["mesh"]);

var content = new scene_THREE.Object3D();
scene.add(content);
content.position.x = -10;

content.add(__WEBPACK_IMPORTED_MODULE_5__flag__["mesh"]);

var titleData = [{
  url: __webpack_require__(187),
  size: 4957,
  x: 9,
  y: -70,
  z: 0
}, {
  url: __webpack_require__(188),
  size: 16266,
  x: 9,
  y: -70,
  z: 0
}, {
  url: __webpack_require__(189),
  size: 13331,
  x: 9,
  y: -70,
  z: 0
}];
var titleOffsets = [window.innerWidth * 1.3, window.innerHeight * 0.2, 0];
var titles = [];
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(titleData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var data = _step.value;

    var title = new plane_sprite_defaultExport(data.url, data.size, 748, 219);
    titles.push(title);
    content.add(title);
    title.scale.setScalar(0.5);
    title.position.x = data.x + titleOffsets[0];
    title.position.y = data.y + titleOffsets[1];
    title.position.z = data.z + titleOffsets[2];

    title.material.depthTest = false;
    title.material.depthWrite = false;
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

var shoeData = [{
  url: __webpack_require__(184),
  size: 53335,
  x: -85,
  y: 15,
  z: 0,
  scale: 0.7
}, {
  url: __webpack_require__(185),
  size: 51171,
  x: 10,
  y: 0,
  z: 0,
  scale: 0.8
}, {
  url: __webpack_require__(186),
  size: 53435,
  x: 110,
  y: -15,
  z: 0,
  scale: 0.9
}];

var offset = [window.innerWidth * 1.2, window.innerHeight * 0.3, 0];
var shoes = [];
var _iteratorNormalCompletion2 = true;
var _didIteratorError2 = false;
var _iteratorError2 = undefined;

try {
  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(shoeData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
    var _data = _step2.value;

    var shoe = new plane_sprite_defaultExport(_data.url, _data.size, 180, 200);
    shoe.scale.setScalar(_data.scale);
    shoes.push(shoe);
    content.add(shoe);
    shoe.position.x = _data.x + offset[0];
    shoe.position.y = _data.y + offset[1];
    shoe.position.z = _data.z + offset[2];
  }
} catch (err) {
  _didIteratorError2 = true;
  _iteratorError2 = err;
} finally {
  try {
    if (!_iteratorNormalCompletion2 && _iterator2.return) {
      _iterator2.return();
    }
  } finally {
    if (_didIteratorError2) {
      throw _iteratorError2;
    }
  }
}

var tl = void 0;

var startShoesAnim = function startShoesAnim() {
  tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();
  tl.to({}, 0.7, {}).to(__WEBPACK_IMPORTED_MODULE_5__flag__["mesh"].position, 0.6, {
    x: 10,
    y: -60,
    delay: 0.7,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  }, '-=0.7').to(titles[0].position, 0.6, {
    x: titleData[0].x,
    y: titleData[0].y,
    z: titleData[0].z,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  }, '-=0.6').to(titles[1].position, 0.6, {
    x: titleData[1].x,
    y: titleData[1].y,
    z: titleData[1].z,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  }, '-=0.5').to(titles[2].position, 0.6, {
    x: titleData[2].x,
    y: titleData[2].y,
    z: titleData[2].z,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  }, '-=0.4').to(shoes[0].position, 0.6, {
    x: shoeData[0].x,
    y: shoeData[0].y,
    z: shoeData[0].z,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  }, '-=0.7').to(shoes[1].position, 0.6, {
    x: shoeData[1].x,
    y: shoeData[1].y,
    z: shoeData[1].z,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  }, '-=0.6').to(shoes[2].position, 0.6, {
    x: shoeData[2].x,
    y: shoeData[2].y,
    z: shoeData[2].z,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  }, '-=0.5');
};

var colorBgResult = function colorBgResult() {
  __WEBPACK_IMPORTED_MODULE_4__bg__["draw"]('#E12D33');
};

var animateIn = function animateIn() {
  startShoesAnim();
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    tl.onComplete = resolve;

    tl.restart();
  });
};

var animateOut = function animateOut() {
  startShoesAnim();
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    tl.onComplete = resolve;
    tl.reverse();
    __WEBPACK_IMPORTED_MODULE_4__bg__["draw"]('rgba(255,255,255,0)', 0.6);
  });
};

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/game/result/GradientWipe.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);






var GradientWipe = function () {
  function GradientWipe() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a(this, GradientWipe);

    this.x = x;
    this.y = y;

    this.canvas = document.createElement('canvas');
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;

    this.ctx = this.canvas.getContext('2d');

    var w = window.innerWidth;
    var h = window.innerHeight;
    this.maxR = Math.pow(w * w + h * h, 0.5);

    this.currColor = 'rgba(255,255,255,0)';

    return this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a(GradientWipe, [{
    key: 'drawGradient',
    value: function drawGradient(toColor, percent) {

      var w = window.innerWidth;
      var h = window.innerHeight;

      this.ctx.clearRect(0, 0, w, h);

      var grd = this.ctx.createRadialGradient(this.x * w, this.y * h, 0, this.x * w, this.y * h, this.maxR * 30);
      grd.addColorStop(0, toColor);
      grd.addColorStop(percent, this.currColor);

      this.ctx.fillStyle = grd;
      this.ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);
    }
  }, {
    key: 'draw',
    value: function draw(color) {
      var _this = this;

      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.2;
      var _onUpdate = arguments[2];


      var w = window.innerWidth;
      var h = window.innerHeight;

      this.canvas.width = w;
      this.canvas.height = h;

      this.ctx = this.canvas.getContext('2d');
      this.ctx.canvas.width = w;
      this.ctx.canvas.height = h;

      this.maxR = Math.pow(w * w + h * h, 0.5);

      if (this.tween) this.tween.kill();

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.tween = __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to({ value: 0 }, time, {
          value: 1,
          ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeIn,
          onUpdateParams: ['{self}'],
          onUpdate: function onUpdate(tween) {
            _this.drawGradient(color, tween.target.value);
            if (_onUpdate) _onUpdate(tween);
          },
          onComplete: function onComplete() {
            _this.currColor = color;
            resolve();
          }
        });
      });
    }
  }]);

  return GradientWipe;
}();

/* harmony default export */ var GradientWipe_defaultExport = (GradientWipe);
// CONCATENATED MODULE: ./src/components/game/result/bg.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gradientWipe", function() { return gradientWipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "draw", function() { return draw; });
var THREE = __webpack_require__(0);


var gradientWipe = new GradientWipe_defaultExport();

var geometry = new THREE.PlaneBufferGeometry(window.innerWidth * 3, window.innerHeight * 3);

var texture = new THREE.Texture(gradientWipe.canvas);
var material = new THREE.MeshBasicMaterial({
  map: texture,
  transparent: true,
  side: THREE.DoubleSide
});

var mesh = new THREE.Mesh(geometry, material);
mesh.name = 'result-bg';
/* harmony default export */ __webpack_exports__["default"] = (mesh);
var s = 1;
mesh.scale.set(s, s, s);

var draw = function draw(color) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.2;

  return gradientWipe.draw(color, time, function () {
    material.needsUpdate = true;
    texture.needsUpdate = true;
  });
};

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloth__ = __webpack_require__(193);
var THREE = __webpack_require__(0);



var mesh = new THREE.Object3D();
/* harmony default export */ __webpack_exports__["default"] = (mesh);
mesh.name = 'flag';

mesh.add(__WEBPACK_IMPORTED_MODULE_0__cloth__["mesh"]);

var offset = [window.innerWidth * 1.2, window.innerHeight * 0.2, 0];

mesh.position.x = 10 + offset[0];
mesh.position.y = -60 + offset[1];
mesh.position.z = 0 + offset[2];

mesh.rotation.z = 14 * THREE.Math.DEG2RAD;

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
var THREE = __webpack_require__(0);
var modifiers = __webpack_require__(463);




var clothUrl = __webpack_require__(183);
__WEBPACK_IMPORTED_MODULE_0__loader__["registerSize"](clothUrl, 155176);

var geometry = new THREE.PlaneGeometry(300, 150, 24, 24);

var material = new THREE.MeshBasicMaterial({
  side: THREE.DoubleSide,
  transparent: true
});
material.depthTest = false;
material.depthWrite = false;

var mesh = new THREE.Mesh(geometry, material);
/* harmony default export */ __webpack_exports__["default"] = (mesh);
mesh.name = 'cloth';


var loader = new THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_0__loader__["loadingManager"]);
__WEBPACK_IMPORTED_MODULE_0__loader__["load"](clothUrl, loader, function (results) {
  material.map = results[0];
  material.needsUpdate = true;
});

var clothModifier = new modifiers.Cloth(2, 0.2);
setTimeout(function () {
  clothModifier.lockXMin(0);
  clothModifier.setForce(0.2, -0.05, -0.05);
});

var modifierStack = new modifiers.ModifierStack(mesh);
modifierStack.addModifier(clothModifier);

var update = function update(delta) {
  modifierStack && modifierStack.apply();
};

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "draw", function() { return draw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_lib_canvas_text_wrapper_js__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_lib_canvas_text_wrapper_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_src_lib_canvas_text_wrapper_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__camera_ui__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sounds__ = __webpack_require__(59);

var THREE = __webpack_require__(0);






var geometry = new THREE.PlaneBufferGeometry(250, 250, 1);

var canvas = document.createElement('canvas');


var texture = new THREE.Texture(canvas);
var material = new THREE.MeshBasicMaterial({
  map: texture,
  transparent: true,
  side: THREE.DoubleSide,
  alphaTest: 0.01
});


var mesh = new THREE.Mesh(geometry, material);

mesh.name = 'textCanvas';

var reset = function reset() {
  if (mesh.tl) {
    mesh.tl.pause(0, true);
    mesh.tl.remove();
  }
  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
};

var draw = function draw(string, fontsize) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    if (!fontsize) fontsize = 50;

    texture.needsUpdate = true;

    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.canvas.width = 512;
    ctx.canvas.height = 512;
    ctx.fillStyle = '#FFFFFF';
    ctx.font = fontsize + 'px FoS';

    __WEBPACK_IMPORTED_MODULE_2_src_lib_canvas_text_wrapper_js__["CanvasTextWrapper"](canvas, string.toUpperCase(), {
      font: ctx.font,
      textAlign: 'center',
      verticalAlign: 'middle',
      paddingY: 10
    });

    mesh.position.z = -__WEBPACK_IMPORTED_MODULE_3__camera_ui__["c" /* perfectZ */];

    mesh.material.opacity = 0;

    if (mesh.tl) {
      mesh.tl.kill();
    }
    var tl = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({ onComplete: function onComplete() {
        resolve();
      } });
    var time = 1.2;
    tl.to(mesh.position, time, {
      z: __WEBPACK_IMPORTED_MODULE_3__camera_ui__["c" /* perfectZ */],
      ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["SlowMo"].ease.config(0.8, 0.4),
      onStart: function onStart() {
        __WEBPACK_IMPORTED_MODULE_4__sounds__["a" /* default */].text.audio.play();
      }
    }).to(mesh.material, time, {
      opacity: 1,
      ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["SlowMo"].ease.config(0.8, 0.4, true),
      onUpdate: function onUpdate() {
        mesh.material.needsUpdate = true;
      }
    }, '-=' + time);
    mesh.tl = tl;
  });
};

/* harmony default export */ __webpack_exports__["default"] = (draw);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "draw", function() { return draw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "drawCanvas", function() { return drawCanvas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateMesh", function() { return animateMesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animIn", function() { return animIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animOut", function() { return animOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raf__ = __webpack_require__(4);

var THREE = __webpack_require__(0);



var geometry = new THREE.PlaneBufferGeometry(120, 120, 1);

var canvas = document.createElement('canvas');
canvas.width = 512;
canvas.height = 512;
var ctx = canvas.getContext('2d');
var texture = new THREE.Texture(canvas);
var material = new THREE.MeshBasicMaterial({
  map: texture,
  transparent: true
});
material.depthTest = false;
material.depthWrite = false;

var mesh = new THREE.Mesh(geometry, material);
mesh.name = 'cta';
mesh.scale.setScalar(1);

var timeline = void 0;

var draw = function draw(string) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    reset();
    drawCanvas(string);

    texture.needsUpdate = true;
  });
};

var drawCanvas = function drawCanvas(string) {
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  var fontSize = 30 * 14 / string.length;
  ctx.font = fontSize + 'px cjnbold';
  var textWidth = ctx.measureText(string).width;

  var x = 0;
  var y = 100;
  var a = 0;
  var w = textWidth + 40;
  var h = fontSize + 20;
  var center = ctx.canvas.width / 2 - w / 2;

  ctx.fillStyle = '#FF0000';
  ctx.beginPath();

  ctx.moveTo(center + a + x, y);
  ctx.lineTo(center + w + a + x, y);
  ctx.lineTo(center + w + x, h + y);
  ctx.lineTo(center + x, h + y);
  ctx.fill();

  ctx.fillStyle = '#FFFFFF';
  ctx.fillText(string, center + a + x + 15, h - 23 + y);
};

var animateMesh = function animateMesh(duration) {
  texture.offset.x = -50;

  timeline = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]();
  if (duration) timeline.duration(duration);
  timeline.to(texture.offset, 1, { x: 0, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeInOut });
  timeline.to(texture.offset, 1, { x: 50, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeInOut }, '+=3');
  timeline.play();
};

var animIn = function animIn() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  texture.offset.x = -50;
  __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(texture.offset, duration, { x: 0, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeOut });
};

var animOut = function animOut() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(texture.offset, duration, { x: 50, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeOut });
};

var reset = function reset() {
  if (timeline) {
    timeline.pause(0, true);
    timeline.remove();
  }

  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
};

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "play", function() { return play; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "show", function() { return show; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hide", function() { return hide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
var THREE = __webpack_require__(0);



var frames = 30;
var fps = 45;

var geometry = new THREE.PlaneBufferGeometry(85, 85);

var canvas = document.createElement('canvas');
canvas.width = 256;
canvas.height = 256;
var ctx = canvas.getContext('2d');

var material = new THREE.MeshBasicMaterial({
  transparent: true,
  opacity: 0,
  alphaTest: 0.1,
  map: new THREE.CanvasTexture(canvas)
});
material.depthTest = false;
material.depthWrite = false;

var mesh = new THREE.Mesh(geometry, material);
/* harmony default export */ __webpack_exports__["default"] = (mesh);
mesh.scale.setScalar(1.5);
mesh.position.x = 10;
mesh.position.y = -25;

var url = __webpack_require__(482);

var play = function play() {
  var time = frames / fps;

  __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to({ x: 0 }, time, {
    x: frames - 1,
    ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["SteppedEase"].config(frames - 1),
    onUpdateParams: ['{self}'],
    repeat: -1,
    onUpdate: function onUpdate(tween) {
      var x = tween.target.x;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, x * 200, 0, 200, 200, 0, 0, 200, 200);
      material.map.needsUpdate = true;
    }
  });
};

var img = new window.Image();

__WEBPACK_IMPORTED_MODULE_0__loader__["registerSize"](url, 11719);
__WEBPACK_IMPORTED_MODULE_0__loader__["load"](url, new THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_0__loader__["loadingManager"]), function () {
  img.onload = function () {
    play();
  };
  img.src = url;
});

var show = function show() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(material, time, {
    opacity: 1,
    ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeIn
  });
};

var hide = function hide() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(material, time, {
    opacity: 0,
    ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeIn
  });
};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sprites", function() { return sprites; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "play", function() { return play; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sounds__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__camera_ui__ = __webpack_require__(81);


var THREE = __webpack_require__(0);





var mesh = new THREE.Object3D();
/* harmony default export */ __webpack_exports__["default"] = (mesh);
mesh.visible = false;

var spriteUrls = [{
  url: __webpack_require__(483),
  size: 520
}, {
  url: __webpack_require__(484),
  size: 1332
}, {
  url: __webpack_require__(485),
  size: 1318
}];

var sprites = [];

var initSprite = function initSprite(data, index) {

  __WEBPACK_IMPORTED_MODULE_2__loader__["registerSize"](data.url, data.size);

  __WEBPACK_IMPORTED_MODULE_2__loader__["load"](data.url, new THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_2__loader__["loadingManager"]), function (results) {

    var spriteMaterial = new THREE.SpriteMaterial({
      map: results[0],

      color: 0xff0000,
      alphaMap: null,
      transparent: true,
      alphaTest: 0.01
    });
    var sprite = new THREE.Sprite(spriteMaterial);
    sprite.scale.setScalar(150);


    sprite.position.y = 0;
    sprite.position.z = __WEBPACK_IMPORTED_MODULE_5__camera_ui__["c" /* perfectZ */];
    sprites[index] = sprite;

    mesh.add(sprite);
  });
};

for (var i = 0; i < spriteUrls.length; i++) {
  initSprite(spriteUrls[i], i);
}

var play = function play() {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    mesh.visible = true;

    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_4__sounds__["a" /* default */].countdown.audio.play();
    }, 300);

    var tl = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]({ onComplete: function onComplete() {
        resolve();
        mesh.visible = false;
      } });

    var _loop = function _loop(sprite) {
      sprite.material.opacity = 1;
      sprite.material.needsUpdate = true;
      sprite.position.z = __WEBPACK_IMPORTED_MODULE_5__camera_ui__["c" /* perfectZ */];

      tl.to(sprite.position, 0.3, { z: 0, ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeInOut });
      tl.to(sprite.position, 0.3, { z: -__WEBPACK_IMPORTED_MODULE_5__camera_ui__["c" /* perfectZ */] * 100, ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeInOut, delay: 0.4 });
      tl.to(sprite.material, 0.3, { opacity: 0, ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeInOut, delay: 0, onUpdate: function onUpdate() {
          sprite.material.needsUpdate = true;
        } }, '-=0.3');
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(sprites), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var sprite = _step.value;

        _loop(sprite);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    tl.to({}, 1.0, {});
    tl.play();
  });
};

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "data", function() { return data; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "play", function() { return play; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
var THREE = __webpack_require__(0);



var mesh = new THREE.Object3D();
/* harmony default export */ __webpack_exports__["default"] = (mesh);

var data = {};

var _loop = function _loop(id) {

  var distance = data[id];

  __WEBPACK_IMPORTED_MODULE_0__loader__["load"](distance.url, new THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_0__loader__["loadingManager"]), function (results) {

    var material = new THREE.SpriteMaterial({
      map: results[0],
      color: 0xff0000,
      transparent: true,
      alphaTest: 0.5,

      opacity: 1
    });

    var sprite = new THREE.Sprite(material);

    distance.sprite = sprite;
    mesh.add(sprite);
  });
};

for (var id in data) {
  _loop(id);
}

var play = function play(id) {

  if (data[id] === undefined) return;

  if (data[id].played) return;
  data[id].played = true;

  var tl = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]();

  var sprite = data[id].sprite;
  sprite.scale.setScalar(Math.max(window.innerWidth, window.innerHeight));

  var mat = sprite.material;
  tl.to(mat, 0, { opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeInOut, onUpdate: function onUpdate() {
      mat.needsUpdate = true;
    } });
  tl.to(mat, 0, { opacity: 0, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Cubic"].easeInOut, onUpdate: function onUpdate() {
      mat.needsUpdate = true;
    }, delay: 1 });

  tl.play();
};

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "topLid", function() { return topLid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bottomLid", function() { return bottomLid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "open", function() { return open; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "close", function() { return close; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_store__ = __webpack_require__(19);

var THREE = __webpack_require__(0);




var frames = 30;
var fps = 30;

var mesh = new THREE.Object3D();
/* harmony default export */ __webpack_exports__["default"] = (mesh);
mesh.name = 'eyelid';

var size = 1024;
var geometry = new THREE.PlaneBufferGeometry(size, size / 2);

var material = new THREE.MeshBasicMaterial({
  transparent: true,
  side: THREE.DoubleSide
});
material.depthTest = false;
material.depthWrite = false;
var url = __webpack_require__(486);
__WEBPACK_IMPORTED_MODULE_1__loader__["registerSize"](url, 19773);
__WEBPACK_IMPORTED_MODULE_1__loader__["load"](url, new THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_1__loader__["loadingManager"]), function (results) {
  material.map = results[0];
  material.needsUpdate = true;
});

var topLid = new THREE.Mesh(geometry, material);
var bottomLid = new THREE.Mesh(geometry, material);
topLid.name = 'topLid';
bottomLid.name = 'bottomLid';
mesh.add(topLid);
mesh.add(bottomLid);

var onResize = function onResize() {
  var scale = {
    x: window.innerWidth / size,
    y: window.innerHeight / (size / 2)
  };
  topLid.scale.set(scale.x, scale.y, 1);
  bottomLid.scale.set(scale.x, scale.y * -1, 1);
};
onResize();
__WEBPACK_IMPORTED_MODULE_3_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_3_src_store__["a" /* default */].state.browser.windowWidth;
}, onResize);
__WEBPACK_IMPORTED_MODULE_3_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_3_src_store__["a" /* default */].state.browser.windowHeight;
}, onResize);

var open = function open() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;


  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(topLid.position, time, {
      y: window.innerHeight * 0.8,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
    });

    __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(bottomLid.position, time, {
      y: -window.innerHeight * 0.8,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut,
      onComplete: function onComplete() {
        mesh.visible = false;
        resolve();
      }
    });
  });
};

var close = function close() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;


  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {

    mesh.visible = true;

    __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(topLid.position, time, {
      y: 0,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
    });

    __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(bottomLid.position, time, {
      y: 0,
      ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut,
      onComplete: resolve
    });
  });
};

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/lib/transformSVGPath.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(0);




function svgToPath(svgPath, config) {
  if (!config) config = {};
  if (!config.autoclose) config.autoclose = false;

  var svgtopath = transformSVGPath(svgPath);
  var newCurrentPoint = svgtopath.currentPath.currentPoint;
  var newCurves = svgtopath.currentPath.curves;
  var newshape = new __WEBPACK_IMPORTED_MODULE_0_three__["Shape"]();
  newshape.currentPoint = newCurrentPoint;
  newshape.curves = newCurves;
  newshape.autoClose = config.autoclose;
  return newshape;
}

var DEGS_TO_RADS = Math.PI / 180,
    UNIT_SIZE = 100;

var DIGIT_0 = 48,
    DIGIT_9 = 57,
    COMMA = 44,
    SPACE = 32,
    PERIOD = 46,
    MINUS = 45;

function transformSVGPath(pathStr) {
  var path = new __WEBPACK_IMPORTED_MODULE_0_three__["ShapePath"]();

  var idx = 1,
      len = pathStr.length,
      activeCmd,
      x = 0,
      y = 0,
      nx = 0,
      ny = 0,
      firstX = null,
      firstY = null,
      x1 = 0,
      x2 = 0,
      y1 = 0,
      y2 = 0,
      rx = 0,
      ry = 0,
      xar = 0,
      laf = 0,
      sf = 0,
      cx,
      cy;

  function eatNum() {
    var sidx,
        c,
        isFloat = false,
        s;

    while (idx < len) {
      c = pathStr.charCodeAt(idx);
      if (c !== COMMA && c !== SPACE) break;
      idx++;
    }
    if (c === MINUS) sidx = idx++;else sidx = idx;

    while (idx < len) {
      c = pathStr.charCodeAt(idx);
      if (DIGIT_0 <= c && c <= DIGIT_9) {
        idx++;
        continue;
      } else if (c === PERIOD) {
        idx++;
        isFloat = true;
        continue;
      }

      s = pathStr.substring(sidx, idx);
      return isFloat ? parseFloat(s) : parseInt(s);
    }

    s = pathStr.substring(sidx);
    return isFloat ? parseFloat(s) : parseInt(s);
  }

  function nextIsNum() {
    var c;

    while (idx < len) {
      c = pathStr.charCodeAt(idx);
      if (c !== COMMA && c !== SPACE) break;
      idx++;
    }
    c = pathStr.charCodeAt(idx);
    return c === MINUS || DIGIT_0 <= c && c <= DIGIT_9;
  }

  var canRepeat;
  activeCmd = pathStr[0];
  while (idx <= len) {
    canRepeat = true;
    switch (activeCmd) {
      case 'M':
        x = eatNum();
        y = eatNum();
        path.moveTo(x, y);
        activeCmd = 'L';
        firstX = x;
        firstY = y;
        break;
      case 'm':
        x += eatNum();
        y += eatNum();
        path.moveTo(x, y);
        activeCmd = 'l';
        firstX = x;
        firstY = y;
        break;
      case 'Z':
      case 'z':
        canRepeat = false;
        if (x !== firstX || y !== firstY) path.lineTo(firstX, firstY);
        break;

      case 'L':
      case 'H':
      case 'V':
        nx = activeCmd === 'V' ? x : eatNum();
        ny = activeCmd === 'H' ? y : eatNum();
        path.lineTo(nx, ny);
        x = nx;
        y = ny;
        break;
      case 'l':
      case 'h':
      case 'v':
        nx = activeCmd === 'v' ? x : x + eatNum();
        ny = activeCmd === 'h' ? y : y + eatNum();
        path.lineTo(nx, ny);
        x = nx;
        y = ny;
        break;

      case 'C':
        x1 = eatNum();y1 = eatNum();
      case 'S':
        if (activeCmd === 'S') {
          x1 = 2 * x - x2;y1 = 2 * y - y2;
        }
        x2 = eatNum();
        y2 = eatNum();
        nx = eatNum();
        ny = eatNum();
        path.bezierCurveTo(x1, y1, x2, y2, nx, ny);
        x = nx;y = ny;
        break;
      case 'c':
        x1 = x + eatNum();
        y1 = y + eatNum();
      case 's':
        if (activeCmd === 's') {
          x1 = 2 * x - x2;
          y1 = 2 * y - y2;
        }
        x2 = x + eatNum();
        y2 = y + eatNum();
        nx = x + eatNum();
        ny = y + eatNum();
        path.bezierCurveTo(x1, y1, x2, y2, nx, ny);
        x = nx;y = ny;
        break;

      case 'Q':
        x1 = eatNum();y1 = eatNum();
      case 'T':
        if (activeCmd === 'T') {
          x1 = 2 * x - x1;
          y1 = 2 * y - y1;
        }
        nx = eatNum();
        ny = eatNum();
        path.quadraticCurveTo(x1, y1, nx, ny);
        x = nx;
        y = ny;
        break;
      case 'q':
        x1 = x + eatNum();
        y1 = y + eatNum();
      case 't':
        if (activeCmd === 't') {
          x1 = 2 * x - x1;
          y1 = 2 * y - y1;
        }
        nx = x + eatNum();
        ny = y + eatNum();
        path.quadraticCurveTo(x1, y1, nx, ny);
        x = nx;y = ny;
        break;

      case 'A':
        rx = eatNum();
        ry = eatNum();
        xar = eatNum() * DEGS_TO_RADS;
        laf = eatNum();
        sf = eatNum();
        nx = eatNum();
        ny = eatNum();
        if (rx !== ry) {
          console.warn("Forcing elliptical arc to be a circular one :(", rx, ry);
        }

        x1 = Math.cos(xar) * (x - nx) / 2 + Math.sin(xar) * (y - ny) / 2;
        y1 = -Math.sin(xar) * (x - nx) / 2 + Math.cos(xar) * (y - ny) / 2;

        var norm = Math.sqrt((rx * rx * ry * ry - rx * rx * y1 * y1 - ry * ry * x1 * x1) / (rx * rx * y1 * y1 + ry * ry * x1 * x1));
        if (laf === sf) norm = -norm;
        x2 = norm * rx * y1 / ry;
        y2 = norm * -ry * x1 / rx;

        cx = Math.cos(xar) * x2 - Math.sin(xar) * y2 + (x + nx) / 2;
        cy = Math.sin(xar) * x2 + Math.cos(xar) * y2 + (y + ny) / 2;

        var u = new __WEBPACK_IMPORTED_MODULE_0_three__["Vector2"](1, 0),
            v = new __WEBPACK_IMPORTED_MODULE_0_three__["Vector2"]((x1 - x2) / rx, (y1 - y2) / ry);
        var startAng = Math.acos(u.dot(v) / u.length() / v.length());
        if (u.x * v.y - u.y * v.x < 0) startAng = -startAng;

        u.x = (-x1 - x2) / rx;
        u.y = (-y1 - y2) / ry;

        var deltaAng = Math.acos(v.dot(u) / v.length() / u.length());

        if (v.x * u.y - v.y * u.x < 0) deltaAng = -deltaAng;
        if (!sf && deltaAng > 0) deltaAng -= Math.PI * 2;
        if (sf && deltaAng < 0) deltaAng += Math.PI * 2;

        path.absarc(cx, cy, rx, startAng, startAng + deltaAng, sf);
        x = nx;
        y = ny;
        break;
      default:
        throw new Error("weird path command: " + activeCmd);
    }

    if (canRepeat && nextIsNum()) continue;
    activeCmd = pathStr[idx++];
  }

  return path;
}
// CONCATENATED MODULE: ./src/components/game/ui/dashboard/map.js
var map_namespaceObject = {};
__webpack_require__.d(map_namespaceObject, "start", function() { return start; });
__webpack_require__.d(map_namespaceObject, "reset", function() { return map_reset; });
__webpack_require__.d(map_namespaceObject, "mesh", function() { return mesh; });
__webpack_require__.d(map_namespaceObject, "default", function() { return map_defaultExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three_meshline__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three_meshline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_three_meshline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__track_tiled_path__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_game_raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_game_stages__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_game_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scene__ = __webpack_require__(121);
var THREE = __webpack_require__(0);











var started = false;
var opacity = { value: 0 };

var path = __WEBPACK_IMPORTED_MODULE_1__track_tiled_path__["a" /* default */];
var points = path.createPointsGeometry();

var meshLine = new __WEBPACK_IMPORTED_MODULE_0_three_meshline__["MeshLine"]();
meshLine.setGeometry(points);
var materialLine = new __WEBPACK_IMPORTED_MODULE_0_three_meshline__["MeshLineMaterial"]({
  lineWidth: 2,
  color: new THREE.Color(0xFFFFFF)
});

var meshPath = new THREE.Mesh(meshLine.geometry, materialLine);
meshPath.name = 'track mesh 1';

meshPath.geometry.drawRange.count = 0;

var meshLineRed = new __WEBPACK_IMPORTED_MODULE_0_three_meshline__["MeshLine"]();
meshLineRed.setGeometry(points);
var materialLineRed = new __WEBPACK_IMPORTED_MODULE_0_three_meshline__["MeshLineMaterial"]({
  lineWidth: 2,
  color: new THREE.Color(0xEB0033)
});

var meshPathRed = new THREE.Mesh(meshLineRed.geometry, materialLineRed);
meshPathRed.name = 'track mesh Red';
meshPathRed.geometry.drawRange.count = 0;

var geometry = new THREE.SphereBufferGeometry(36, 16, 16);
var material = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true });
var sphere = new THREE.Mesh(geometry, material);
sphere.name = 'track point';
sphere.material.opacity = 0;

var Vs = '\n  attribute vec3 position;\n  attribute vec3 normal;\n\n  uniform mat4 projectionMatrix;\n  uniform mat4 modelViewMatrix;\n  uniform float time;\n  uniform float decal;\n\n  varying float vPulse;\n\n  void main () {\n\n    float pulse = mod((time - decal * 250.0)/90.0, 1.0);\n    vPulse = pulse;\n\n    vec4 finalPosition = vec4(vec3(position + pulse * normal * 300.0 ), 1.0 + (0.2 * normal));\n    gl_Position = projectionMatrix * modelViewMatrix * finalPosition;\n  }\n';
var Fs = '\n  precision mediump float;\n\n  varying float vPulse;\n\n  void main() {\n    gl_FragColor = vec4(1.0, 0, 0, 1.0) * (1.0 - vPulse);\n  }\n';
var materialPulse = new THREE.RawShaderMaterial({
  vertexShader: Vs,
  fragmentShader: Fs,
  uniforms: {
    time: { type: 'f', value: 0 },
    decal: { type: 'f', value: 0 }
  },
  shading: THREE.FlatShading,
  transparent: true
});

var geometryPulse = new THREE.SphereBufferGeometry(0.001, 16, 16);
var spherePulse = new THREE.Mesh(geometryPulse, materialPulse);

var spherePulse2 = spherePulse.clone();
spherePulse2.material = spherePulse.material.clone();
spherePulse2.material.uniforms.decal.value = 1;

var spherePulse3 = spherePulse.clone();
spherePulse3.material = spherePulse.material.clone();
spherePulse3.material.uniforms.decal.value = 2;

var update = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.throttle(function () {
  if (!window.game) return false;
  if (!started) return false;

  var pt1 = path.getPointAt(window.game.state.progress.percent % 1);
  var percent = window.game.state.progress.percent % 1;
  if (window.game.state.stage >= __WEBPACK_IMPORTED_MODULE_4_src_components_game_stages__["RESULTS"]) percent = 0.999;

  meshPathRed.geometry.drawRange.count = percent * (meshPathRed.geometry.attributes.counters.count * 3);
  sphere.position.set(pt1.x, pt1.y, pt1.z);

  spherePulse.material.uniforms.time.value++;
  spherePulse2.material.uniforms.time.value++;
  spherePulse3.material.uniforms.time.value++;
}, __WEBPACK_IMPORTED_MODULE_5_src_components_game_config__["a" /* config */].uiUpdateInterval);

setInterval(update, __WEBPACK_IMPORTED_MODULE_5_src_components_game_config__["a" /* config */].uiUpdateInterval);

var start = function start(seconds) {
  started = true;
  var tl = new __WEBPACK_IMPORTED_MODULE_6_gsap__["TimelineMax"]({ onComplete: startPulse });
  tl.to(meshPath.geometry.drawRange, seconds, { count: meshPath.geometry.index.count, ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Cubic"].easeOut });
  tl.to(opacity, seconds, { value: 1, ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Cubic"].easeOut }, '-=' + seconds / 2);
};

var map_reset = function reset(seconds) {
  started = false;
  meshPath.geometry.drawRange.count = 0;
  meshPathRed.geometry.drawRange.count = 0;
  opacity.value = 0;
  stopPulse();
};

var startPulse = function startPulse() {
  sphere.material.opacity = 1;
  sphere.add(spherePulse);
  sphere.add(spherePulse2);
  sphere.add(spherePulse3);
};

var stopPulse = function stopPulse() {
  sphere.material.opacity = 0;
  sphere.children = [];
};

var mesh = new THREE.Object3D();
mesh.name = 'dashboard-map';
mesh.scale.setScalar(0.04 / __WEBPACK_IMPORTED_MODULE_5_src_components_game_config__["a" /* config */].worldScale);
mesh.rotation.set(90 * THREE.Math.DEG2RAD, -90 * THREE.Math.DEG2RAD, 0 * THREE.Math.DEG2RAD);

mesh.add(meshPath);
mesh.add(meshPathRed);
mesh.add(sphere);

/* harmony default export */ var map_defaultExport = (mesh);
// CONCATENATED MODULE: ./src/components/game/ui/dashboard/speedometer.js
var speedometer_namespaceObject = {};
__webpack_require__.d(speedometer_namespaceObject, "dashMat", function() { return dashMat; });
__webpack_require__.d(speedometer_namespaceObject, "basicMat", function() { return basicMat; });
__webpack_require__.d(speedometer_namespaceObject, "start", function() { return speedometer_start; });
__webpack_require__.d(speedometer_namespaceObject, "reset", function() { return speedometer_reset; });
__webpack_require__.d(speedometer_namespaceObject, "toStage1", function() { return toStage1; });
__webpack_require__.d(speedometer_namespaceObject, "toStage2", function() { return toStage2; });
__webpack_require__.d(speedometer_namespaceObject, "mesh", function() { return speedometer_mesh; });
__webpack_require__.d(speedometer_namespaceObject, "default", function() { return speedometer_defaultExport; });
/* harmony import */ var speedometer___WEBPACK_IMPORTED_MODULE_0_three_meshline__ = __webpack_require__(201);
/* harmony import */ var speedometer___WEBPACK_IMPORTED_MODULE_0_three_meshline___default = __webpack_require__.n(speedometer___WEBPACK_IMPORTED_MODULE_0_three_meshline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_game_raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stages__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(2);
var speedometer_THREE = __webpack_require__(0);








var Line = __webpack_require__(552)(speedometer_THREE);
var BasicShader = __webpack_require__(561)(speedometer_THREE);
var normalize = __webpack_require__(205);
var DashShader = __webpack_require__(562)(speedometer_THREE);

var speedometer_started = false;

var curve = new speedometer_THREE.EllipseCurve(0, 0, 60, 60, 210 * speedometer_THREE.Math.DEG2RAD, -30 * speedometer_THREE.Math.DEG2RAD, true, 0);
var speedometer_points = curve.getPoints(200).map(function (item) {
  return [item.x, item.y];
});

speedometer_points = normalize(speedometer_points);

var thicknessBar = 0.1;
var colors = [0x0011FF, 0xEB0033];

var bgGeometry = Line(speedometer_points, { distances: true, closed: false });
var dashMat = new speedometer_THREE.ShaderMaterial(DashShader({
  side: speedometer_THREE.DoubleSide,
  thickness: thicknessBar,
  dashSteps: 20,
  dashDistance: 0.42,
  dashSmooth: 0.01,
  diffuse: new speedometer_THREE.Color(colors[0])
}));
var meshLineBg = new speedometer_THREE.Mesh(bgGeometry, dashMat);
meshLineBg.geometry.drawRange.count = 0;

var speedometer_geometry = Line(speedometer_points, { distances: true, closed: false });
var basicMat = new speedometer_THREE.ShaderMaterial(BasicShader({
  side: speedometer_THREE.DoubleSide,
  diffuse: new speedometer_THREE.Color(colors[0]),
  thickness: thicknessBar
}));
var speedometer_meshLine = new speedometer_THREE.Mesh(speedometer_geometry, basicMat);
speedometer_meshLine.geometry.drawRange.count = 0;

var speedometer_start = function start(seconds) {
  var tl = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]({ onComplete: function onComplete() {
      speedometer_started = true;
    } });
  tl.to(meshLineBg.geometry.drawRange, seconds, { count: meshLineBg.geometry.index.count, ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeOut });
};

var speedometer_reset = function reset(seconds) {
  speedometer_started = false;
  speedometer_meshLine.geometry.drawRange.count = 0;
  meshLineBg.geometry.drawRange.count = 0;
};

var smooth = { size: 0, color: 0 };


var speedometer_update = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.throttle(function () {
  if (!window.game) return false;
  if (!speedometer_started) return false;

  var velMax = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].velocityMax;
  var vel = window.game.state.velocity.now;
  var velPercent = vel / velMax * 100;
  var maxVerts = speedometer_meshLine.geometry.attributes.position.count * 3;
  var vertsStep = maxVerts / 100;


  var sizeToReach = Math.round(vertsStep * velPercent);
  __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(smooth, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].uiUpdateInterval / 1000, { size: sizeToReach, ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Linear"].easeNone });

  speedometer_meshLine.geometry.drawRange.count = smooth.size;

  if (window.game.state.stage > __WEBPACK_IMPORTED_MODULE_5__stages__["STAGE1"]) {
    toStage2();
  } else {
    toStage1();
  }
}, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].uiUpdateInterval);

setInterval(speedometer_update, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].uiUpdateInterval);

var inStage2 = false;
var toStage1 = function toStage1() {
  if (!inStage2) return;
  basicMat.uniforms.diffuse.value.set(colors[0]);
  dashMat.uniforms.diffuse.value.set(colors[0]);
  inStage2 = false;
};

var toStage2 = function toStage2() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.8;

  if (inStage2) return;
  inStage2 = true;
  var toColor = new speedometer_THREE.Color(colors[1]);
  __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(basicMat.uniforms.diffuse.value, time, {
    r: toColor.r,
    g: toColor.g,
    b: toColor.b,
    ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeOut,
    onUpdateParams: ['{self}'],
    onUpdate: function onUpdate(tween) {
      dashMat.uniforms.diffuse.value.r = tween.target.r;
      dashMat.uniforms.diffuse.value.g = tween.target.g;
      dashMat.uniforms.diffuse.value.b = tween.target.b;
    }
  });
};

var speedometer_mesh = new speedometer_THREE.Object3D();
speedometer_mesh.name = 'dashboard-speedometer';
speedometer_mesh.add(meshLineBg);
speedometer_mesh.add(speedometer_meshLine);
speedometer_mesh.scale.multiplyScalar(60);

/* harmony default export */ var speedometer_defaultExport = (speedometer_mesh);
// CONCATENATED MODULE: ./src/components/game/ui/dashboard/chargemeter.js
var chargemeter_namespaceObject = {};
__webpack_require__.d(chargemeter_namespaceObject, "mesh", function() { return chargemeter_mesh; });
__webpack_require__.d(chargemeter_namespaceObject, "default", function() { return chargemeter_defaultExport; });
__webpack_require__.d(chargemeter_namespaceObject, "bars", function() { return bars; });
__webpack_require__.d(chargemeter_namespaceObject, "loaded", function() { return loaded; });
__webpack_require__.d(chargemeter_namespaceObject, "showBar", function() { return showBar; });
__webpack_require__.d(chargemeter_namespaceObject, "hideBar", function() { return hideBar; });
__webpack_require__.d(chargemeter_namespaceObject, "start", function() { return chargemeter_start; });
__webpack_require__.d(chargemeter_namespaceObject, "reset", function() { return chargemeter_reset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_game_raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_game_loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var chargemeter___WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var chargemeter___WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(chargemeter___WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors__ = __webpack_require__(68);
/* harmony import */ var chargemeter___WEBPACK_IMPORTED_MODULE_5__stages__ = __webpack_require__(26);
/* harmony import */ var chargemeter___WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(2);
var chargemeter_THREE = __webpack_require__(0);








var inactive = 0xAAAAAA;
var inactiveColor = new chargemeter_THREE.Color(inactive);
var activeColor = __WEBPACK_IMPORTED_MODULE_4__colors__["b" /* red */].clone();

var chargemeter_mesh = new chargemeter_THREE.Object3D();
/* harmony default export */ var chargemeter_defaultExport = (chargemeter_mesh);
chargemeter_mesh.name = 'dashboard-chargemeter';

var bars = [{
  url: __webpack_require__(564),
  size: 1116
}, {
  url: __webpack_require__(565),
  size: 1215
}, {
  url: __webpack_require__(566),
  size: 1375
}, {
  url: __webpack_require__(567),
  size: 1390
}, {
  url: __webpack_require__(568),
  size: 1192
}];

var _loop = function _loop(key) {
  var bar = bars[key];
  bar.active = false;
  var url = bar.url;
  __WEBPACK_IMPORTED_MODULE_1_src_components_game_loader__["registerSize"](url, bar.size);
  __WEBPACK_IMPORTED_MODULE_1_src_components_game_loader__["load"](url, new chargemeter_THREE.TextureLoader(__WEBPACK_IMPORTED_MODULE_1_src_components_game_loader__["loadingManager"]), function (results) {
    bar.map = results[0];
    checkAllLoaded();
  });
};

for (var key in bars) {
  _loop(key);
}

var loaded = false;
var checkAllLoaded = function checkAllLoaded() {
  for (var key in bars) {
    if (!bars[key].map) return;
  }

  loaded = true;
  init();
};

var init = function init() {
  for (var key in bars) {
    var _bar = bars[key];
    var material = new chargemeter_THREE.MeshBasicMaterial({
      map: _bar.map,
      transparent: true,
      alphaTest: 0.1,
      color: inactive
    });
    var geometry = new chargemeter_THREE.PlaneBufferGeometry(50, 50);
    var _m = new chargemeter_THREE.Mesh(geometry, material);
    _m.name = 'chargemeter-bar' + key;
    chargemeter_mesh.add(_m);

    _bar.material = material;
    _bar.material.opacity = 0;
    _bar.mesh = _m;
  }
};

var showBar = function showBar(i) {
  var bar = bars[i];
  if (bar.active) return;
  if (bar.tween) bar.tween.kill();
  bar.active = true;
  bar.tween = chargemeter___WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(bar.material.color, 0.1, {
    r: activeColor.r,
    g: activeColor.g,
    b: activeColor.b,
    repeat: 4,
    yoyo: true
  });
};

var hideBar = function hideBar(i) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.3;

  var bar = bars[i];
  if (!bar.active) return;
  if (bar.tween) bar.tween.kill();
  bar.active = false;
  bar.tween = chargemeter___WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(bar.material.color, time, {
    r: inactiveColor.r,
    g: inactiveColor.g,
    b: inactiveColor.b
  });
};

var chargemeter_update = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.throttle(function () {

  if (!window.game) return;
  if (!loaded) return;

  var charge = window.game.state.stage2.charge;

  for (var idx = 0; idx < bars.length; idx++) {

    if (window.game.state.stage < chargemeter___WEBPACK_IMPORTED_MODULE_5__stages__["STAGE2_SLOW"]) {
      hideBar(idx, 0);
      continue;
    }

    if (charge > idx / (bars.length - 1)) {
      showBar(idx);
    } else {}
  }
}, chargemeter___WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].uiUpdateInterval);

setInterval(chargemeter_update, chargemeter___WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].uiUpdateInterval);

var chargemeter_start = function start(seconds) {
  var tl = new chargemeter___WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]();
  for (var key in bars) {
    var _bar2 = bars[key];
    tl.to(_bar2.material, seconds / bars.length * key / 2, { opacity: 1, ease: chargemeter___WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeInOut });
  }
};

var chargemeter_reset = function reset(seconds) {
  for (var key in bars) {
    var _bar3 = bars[key];
    _bar3.material.opacity = 0;
  }
};
// CONCATENATED MODULE: ./src/components/game/ui/dashboard/shoe.js
var shoe_namespaceObject = {};
__webpack_require__.d(shoe_namespaceObject, "mesh", function() { return shoe_mesh; });
__webpack_require__.d(shoe_namespaceObject, "default", function() { return shoe_defaultExport; });
__webpack_require__.d(shoe_namespaceObject, "data", function() { return data; });
__webpack_require__.d(shoe_namespaceObject, "loaded", function() { return shoe_loaded; });
__webpack_require__.d(shoe_namespaceObject, "start", function() { return shoe_start; });
__webpack_require__.d(shoe_namespaceObject, "reset", function() { return shoe_reset; });
__webpack_require__.d(shoe_namespaceObject, "glow", function() { return glow; });
__webpack_require__.d(shoe_namespaceObject, "unglow", function() { return unglow; });
/* harmony import */ var shoe___WEBPACK_IMPORTED_MODULE_0_src_components_game_raf__ = __webpack_require__(4);
/* harmony import */ var shoe___WEBPACK_IMPORTED_MODULE_1_src_components_game_loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_game_config__ = __webpack_require__(2);
/* harmony import */ var shoe___WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var shoe___WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(shoe___WEBPACK_IMPORTED_MODULE_4_lodash__);
var shoe_THREE = __webpack_require__(0);






var shoe_mesh = new shoe_THREE.Object3D();
/* harmony default export */ var shoe_defaultExport = (shoe_mesh);
shoe_mesh.name = 'dashboard-shoe';

var data = {
  shoe: {
    url: __webpack_require__(569),
    size: 9652
  },
  glow: {
    url: __webpack_require__(570),
    size: 12872
  }
};

var shoe__loop = function _loop(key) {
  var _data = data[key];
  _data.active = false;
  var url = _data.url;
  shoe___WEBPACK_IMPORTED_MODULE_1_src_components_game_loader__["registerSize"](url, _data.size);
  shoe___WEBPACK_IMPORTED_MODULE_1_src_components_game_loader__["load"](url, new shoe_THREE.TextureLoader(shoe___WEBPACK_IMPORTED_MODULE_1_src_components_game_loader__["loadingManager"]), function (results) {
    _data.map = results[0];
    shoe_checkAllLoaded();
  });
};

for (var shoe_key in data) {
  shoe__loop(shoe_key);
}

var shoe_loaded = false;
var shoe_checkAllLoaded = function checkAllLoaded() {
  for (var key in data) {
    if (!data[key].map) return;
  }

  shoe_loaded = true;
  shoe_init();
};

var shoe_init = function init() {
  for (var key in data) {
    var _data2 = data[key];
    var material = new shoe_THREE.MeshBasicMaterial({
      map: _data2.map,
      transparent: true,
      alphaTest: 0.1
    });
    var geometry = new shoe_THREE.PlaneBufferGeometry(80, 80);
    var plane = new shoe_THREE.Mesh(geometry, material);
    plane.name = 'chargemeter-shoe-' + key;
    shoe_mesh.add(plane);

    _data2.material = material;
    _data2.mesh = plane;
  }
  data.shoe.material.opacity = 0;
  data.glow.material.opacity = 0;
};

var shoe_start = function start(seconds) {
  var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();
  tl.to(data.shoe.material, seconds / 2, { opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut });
  tl.to(data.glow.material, seconds / 4, { opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut }, '-=' + seconds / 4);
  tl.to(data.glow.material, seconds / 4, { opacity: 0, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut });
};

var shoe_reset = function reset(seconds) {
  data.shoe.material.opacity = 0;
  data.glow.material.opacity = 0;
};

var glow = function glow() {
  var glow = data.glow;
  if (glow.active) return;
  glow.active = true;
  if (glow.tween) glow.tween.kill();
  glow.tween = __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(glow.material, 0.7, {
    opacity: 1,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  });
};

var unglow = function unglow() {
  var glow = data.glow;
  if (!glow.active) return;
  glow.active = false;
  glow.tween.kill();
  glow.tween = __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(glow.material, 0.6, {
    opacity: 0,
    ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeOut
  });
};

var shoe_update = shoe___WEBPACK_IMPORTED_MODULE_4_lodash___default.a.throttle(function () {

  if (!window.game.state.stage2) return false;
  if (!shoe_loaded) return;

  var charge = window.game.state.stage2.charge;

  if (charge >= 1) {
    glow();
  } else {
    unglow();
  }
}, __WEBPACK_IMPORTED_MODULE_3_src_components_game_config__["a" /* config */].uiUpdateInterval);

setInterval(shoe_update, __WEBPACK_IMPORTED_MODULE_3_src_components_game_config__["a" /* config */].uiUpdateInterval);
// CONCATENATED MODULE: ./src/components/game/ui/dashboard/counterFg.js
var counterFg_namespaceObject = {};
__webpack_require__.d(counterFg_namespaceObject, "mesh", function() { return counterFg_mesh; });
__webpack_require__.d(counterFg_namespaceObject, "default", function() { return counterFg_defaultExport; });
__webpack_require__.d(counterFg_namespaceObject, "start", function() { return counterFg_start; });
__webpack_require__.d(counterFg_namespaceObject, "reset", function() { return counterFg_reset; });
/* harmony import */ var counterFg___WEBPACK_IMPORTED_MODULE_0_src_components_game_raf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var counterFg___WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var counterFg___WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(counterFg___WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(2);
var counterFg_THREE = __webpack_require__(0);





var counterFg_geometry = new counterFg_THREE.PlaneBufferGeometry(128, 128, 1);
var canvas = document.createElement('canvas');
canvas.width = 128;
canvas.height = 128;
var ctx = canvas.getContext('2d');
var texture = new counterFg_THREE.Texture(canvas);
var counterFg_material = new counterFg_THREE.MeshBasicMaterial({
  map: texture,
  transparent: true
});
counterFg_material.depthTest = false;
counterFg_material.depthWrite = false;

var counterFg_mesh = new counterFg_THREE.Mesh(counterFg_geometry, counterFg_material);
counterFg_mesh.name = 'dashboard-counter';
counterFg_mesh.material.opacity = 0;
counterFg_mesh.scale.setScalar(0.35);
/* harmony default export */ var counterFg_defaultExport = (counterFg_mesh);

var fontSize = 93;
var fontColor = '#FFFFFF';
ctx.font = fontSize + 'px digital';
ctx.fillStyle = fontColor;

var draw = function draw(string) {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  if (parseInt(string) <= 9) string = ' ' + string;
  ctx.fillText(string, 0, fontSize);
  texture.needsUpdate = true;
};

var counterFg_update = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.throttle(function () {
  var vel = window.game.state.velocity.now || 0;
  draw(Math.round(vel / 3));
}, __WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].uiUpdateInterval);

setInterval(counterFg_update, __WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].uiUpdateInterval);

var counterFg_start = function start(seconds) {
  var tl = new counterFg___WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();
  tl.to(counterFg_mesh.material, seconds, { opacity: 1, ease: counterFg___WEBPACK_IMPORTED_MODULE_2_gsap__["Cubic"].easeInOut });
};

var counterFg_reset = function reset(seconds) {
  counterFg_mesh.material.opacity = 0;
};
// CONCATENATED MODULE: ./src/components/game/ui/dashboard/counterBg.js
var counterBg_namespaceObject = {};
__webpack_require__.d(counterBg_namespaceObject, "mesh", function() { return counterBg_mesh; });
__webpack_require__.d(counterBg_namespaceObject, "default", function() { return counterBg_defaultExport; });
__webpack_require__.d(counterBg_namespaceObject, "start", function() { return counterBg_start; });
__webpack_require__.d(counterBg_namespaceObject, "reset", function() { return counterBg_reset; });
__webpack_require__.d(counterBg_namespaceObject, "draw", function() { return counterBg_draw; });
/* harmony import */ var counterBg___WEBPACK_IMPORTED_MODULE_0_src_components_game_raf__ = __webpack_require__(4);
/* harmony import */ var counterBg___WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var counterBg___WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(counterBg___WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader__ = __webpack_require__(3);
/* harmony import */ var counterBg___WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var counterBg___WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(counterBg___WEBPACK_IMPORTED_MODULE_3_gsap__);
var counterBg_THREE = __webpack_require__(0);





var fontUrl = __webpack_require__(571);
__WEBPACK_IMPORTED_MODULE_2__loader__["registerSize"](fontUrl, 1000);

var counterBg_geometry = new counterBg_THREE.PlaneBufferGeometry(128, 128, 1);
var counterBg_canvas = document.createElement('canvas');
counterBg_canvas.width = 128;
counterBg_canvas.height = 128;
var counterBg_ctx = counterBg_canvas.getContext('2d');
var counterBg_texture = new counterBg_THREE.Texture(counterBg_canvas);
var counterBg_material = new counterBg_THREE.MeshBasicMaterial({
  map: counterBg_texture,
  transparent: true
});
counterBg_material.depthTest = false;
counterBg_material.depthWrite = false;
var counterBg_mesh = new counterBg_THREE.Mesh(counterBg_geometry, counterBg_material);
counterBg_mesh.name = 'dashboard-counter-bg';
counterBg_mesh.scale.setScalar(0.35);
counterBg_mesh.material.opacity = 0;
/* harmony default export */ var counterBg_defaultExport = (counterBg_mesh);

var counterBg_start = function start(seconds) {
  var tl = new counterBg___WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]();
  tl.to(counterBg_mesh.material, seconds, { opacity: 1, ease: counterBg___WEBPACK_IMPORTED_MODULE_3_gsap__["Cubic"].easeInOut });
};

var counterBg_reset = function reset(seconds) {
  counterBg_mesh.material.opacity = 0;
};

var counterBg_fontSize = 93;
var alpha = 0.25;
var counterBg_fontColor = '#FFFFFF';
counterBg_ctx.font = counterBg_fontSize + 'px digital';
counterBg_ctx.fillStyle = counterBg_fontColor;

var counterBg_draw = function draw() {
  counterBg_ctx.clearRect(0, 0, counterBg_canvas.width, counterBg_canvas.height);

  counterBg_ctx.font = counterBg_fontSize + 'px digital';
  counterBg_ctx.fillStyle = 'rgba(255, 255, 255, ' + alpha + ')';
  counterBg_ctx.fillText('88', 0, counterBg_fontSize);
  var textWidth = counterBg_ctx.measureText('88').width;

  counterBg_ctx.font = counterBg_fontSize / 2 + 'px digital';
  counterBg_ctx.fillStyle = counterBg_fontColor;
  counterBg_ctx.fillText('km', textWidth, counterBg_fontSize);

  counterBg_texture.needsUpdate = true;
};

__WEBPACK_IMPORTED_MODULE_2__loader__["load"](fontUrl, new counterBg_THREE.FileLoader(__WEBPACK_IMPORTED_MODULE_2__loader__["loadingManager"]), function (results) {
  counterBg_draw();
});
// CONCATENATED MODULE: ./src/components/game/ui/dashboard/index.js
/* unused harmony export update */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_game_clock__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_store__ = __webpack_require__(19);
var dashboard_THREE = __webpack_require__(0);











var dashboard_mesh = new dashboard_THREE.Object3D();
dashboard_mesh.name = 'dashboard';
dashboard_mesh.scale.setScalar(0.75);
dashboard_mesh.position.set(0, -window.innerHeight * 0.5 + 75, 0);

dashboard_mesh.add(mesh);
mesh.position.set(18, -10, 40);

dashboard_mesh.add(speedometer_mesh);
speedometer_mesh.position.set(0, 25, -20);

dashboard_mesh.add(chargemeter_mesh);
chargemeter_mesh.position.set(26, 40, 0);

dashboard_mesh.add(shoe_mesh);
shoe_mesh.position.set(0, 25, 0);

var counter = new dashboard_THREE.Object3D();
counter.add(counterFg_mesh);
counter.add(counterBg_mesh);
dashboard_mesh.add(counter);

var dashboard_startStage1 = function startStage1() {
  counter.position.set(0, 20, 0);
  counter.scale.setScalar(1.4);

  speedometer_start(2);
  setTimeout(function () {
    counterFg_start(1.4);
  }, 600);
  setTimeout(function () {
    counterBg_start(1.4);
  }, 600);

  mesh.position.y = -10;
  setTimeout(function () {
    start(2);
  }, 1600);
};

var dashboard_startStage2 = function startStage2() {
  __WEBPACK_IMPORTED_MODULE_7_gsap__["TweenMax"].to(mesh.position, 0.4, { y: -15, ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Cubic"].easeOut });
  var s = 0.9;
  __WEBPACK_IMPORTED_MODULE_7_gsap__["TweenMax"].to(counter.scale, 0.6, { x: s, y: s, z: s, ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Cubic"].easeOut });
  __WEBPACK_IMPORTED_MODULE_7_gsap__["TweenMax"].to(counter.position, 0.6, { y: '-=35', ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Cubic"].easeOut });
  setTimeout(function () {
    chargemeter_start(1);
  }, 300);
  setTimeout(function () {
    shoe_start(0.8);
  }, 600);
};

var dashboard_reset = function reset() {
  speedometer_reset();
  map_reset();
  counterFg_reset();
  counterBg_reset();

  shoe_reset();
  chargemeter_reset();
};

var turnTime = 1;
var angles = {
  curr: 0,
  goal: 0,
  offset: 0
};
var currDirection = 0;
var dashboard_update = function update(state, controls, trackAngles) {

  if (currDirection === trackAngles[0]) return;
  currDirection = trackAngles[0];

  switch (currDirection) {
    case 0:
      __WEBPACK_IMPORTED_MODULE_7_gsap__["TweenMax"].to(dashboard_mesh.rotation, 0.8, {
        delay: 0.1,
        ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Cubic"].easeOut,
        y: dashboard_THREE.Math.DEG2RAD * 0
      });
      break;
    case 90:
      __WEBPACK_IMPORTED_MODULE_7_gsap__["TweenMax"].to(dashboard_mesh.rotation, 0.8, {
        delay: 0.3,
        ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Cubic"].easeOut,
        y: dashboard_THREE.Math.DEG2RAD * 15
      });
      break;
    case -90:
      __WEBPACK_IMPORTED_MODULE_7_gsap__["TweenMax"].to(dashboard_mesh.rotation, 0.8, {
        delay: 0.3,
        ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Cubic"].easeOut,
        y: dashboard_THREE.Math.DEG2RAD * -15
      });
      break;
  }
};

var onResize = function onResize() {
  dashboard_mesh.position.set(0, -window.innerHeight * 0.5 + 75, 0);
};
__WEBPACK_IMPORTED_MODULE_8_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_8_src_store__["a" /* default */].state.browser.windowWidth;
}, onResize);
__WEBPACK_IMPORTED_MODULE_8_src_store__["a" /* default */].watch(function (state) {
  return __WEBPACK_IMPORTED_MODULE_8_src_store__["a" /* default */].state.browser.windowHeight;
}, onResize);

var obj = {
  mesh: dashboard_mesh,
  map: map_namespaceObject,
  speedometer: speedometer_namespaceObject,
  chargemeter: chargemeter_namespaceObject,
  shoe: shoe_namespaceObject,
  counter: counter,
  counterFg: counterFg_namespaceObject,
  counterBg: counterBg_namespaceObject,
  startStage1: dashboard_startStage1,
  startStage2: dashboard_startStage2,
  reset: dashboard_reset,
  update: dashboard_update
};
/* harmony default export */ __webpack_exports__["a"] = (obj);
window.dashboard = obj;

/***/ }),
/* 201 */,
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return path; });
/* unused harmony export points */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(2);


var THREE = __webpack_require__(0);



var normalize = __webpack_require__(205);

var getPath = function getPath(offset) {
  var path = new THREE.CurvePath();

  var nextPosition = [0, 0];
  var currDirection = __WEBPACK_IMPORTED_MODULE_1__config__["direction"].N;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(__WEBPACK_IMPORTED_MODULE_1__config__["layout"]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var tileId = _step.value;

      var tileType = __WEBPACK_IMPORTED_MODULE_1__config__["types"][tileId];

      var fromDirection = currDirection;
      var fromPosition = [nextPosition[0], nextPosition[1]];

      currDirection += tileType.directionChange + 360;
      currDirection %= 360;

      switch (currDirection) {
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].N:
          nextPosition[1] -= __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"];
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].W:
          nextPosition[0] -= __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"];
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].S:
          nextPosition[1] += __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"];
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].E:
          nextPosition[0] += __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"];
          break;
      }

      var start = [fromPosition[0], fromPosition[1]];
      switch (fromDirection) {
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].N:
          start[1] += __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"] / 2;
          start[0] += offset;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].W:
          start[0] += __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"] / 2;
          start[1] += offset;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].S:
          start[1] -= __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"] / 2;
          start[0] -= offset;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].E:
          start[0] -= __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"] / 2;
          start[1] -= offset;
          break;
      }

      var to = [fromPosition[0], fromPosition[1]];
      switch (currDirection) {
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].N:
          to[1] -= __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"] / 2;
          to[0] += offset;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].W:
          to[0] -= __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"] / 2;
          to[1] += offset;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].S:
          to[1] += __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"] / 2;
          to[0] -= offset;
          break;
        case __WEBPACK_IMPORTED_MODULE_1__config__["direction"].E:
          to[0] += __WEBPACK_IMPORTED_MODULE_1__config__["tileSize"] / 2;
          to[1] -= offset;
          break;
      }

      var fromPt = new THREE.Vector3(start[0], 0, start[1]);
      var toPt = new THREE.Vector3(to[0], 0, to[1]);
      var centerPt = new THREE.Vector3(fromPosition[0], 0, fromPosition[1]);

      if (tileType.directionChange === 0) {
        var curve = new THREE.LineCurve3(fromPt, toPt);
        path.add(curve);
      } else {
        var _curve = new THREE.QuadraticBezierCurve3(fromPt, centerPt, toPt);
        path.add(_curve);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return path;
};

var path = getPath(0);
/* harmony default export */ __webpack_exports__["a"] = (path);

var points = [];
points = normalize(points);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_wall.e210bd0.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tickers.0bbea22.png";

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mc", function() { return mc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stop", function() { return stop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroy", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMultiplier", function() { return setMultiplier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startAuto", function() { return startAuto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hammerjs__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__renderer__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gsap__);








var state = {
  px: 0,
  velocity: 1,

  swipeVelocity: 0,
  baseVelocity: __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].velocityMin,

  multiplier: 1,

  swipes: [],
  sps: 0,

  inactive: false
};
var initialState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a({}, state);

var interval = void 0;

function onSwipe(evt) {
  var now = performance.now();
  state.swipes.push(now);
  state.swipeVelocity += Math.min(Math.abs(evt.overallVelocityY), 35);
  state.baseVelocity += __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].swipeAddVelocity;
  state.baseVelocity = Math.min(state.baseVelocity, __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].maxBaseVelocity);
  resetInactive();
}
var mc = new __WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.Manager(__WEBPACK_IMPORTED_MODULE_3__renderer__["default"].domElement);
mc.add(new __WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.Swipe());

var inactiveInterval = void 0;
var resetInactive = function resetInactive() {
  state.inactive = false;
  clearInterval(inactiveInterval);
  inactiveInterval = setInterval(function () {
    state.inactive = true;
  }, __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].helpTime);
};

var update = function update(delta) {
  var now = performance.now();
  state.swipes = __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.filter(state.swipes, function (time) {
    return time > now - 1000;
  });
  state.sps = Math.min(state.swipes.length, 18);

  if (state.swipeVelocity > 0.001) {
    state.swipeVelocity *= 0.96;
  } else {
    state.swipeVelocity = 0;
  }
  state.swipeVelocity = Math.min(state.swipeVelocity, 120);

  if (state.sps <= 1 && state.baseVelocity > __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].velocityMin) {
    state.baseVelocity *= 0.99;
  }

  state.velocity = state.baseVelocity + state.swipeVelocity * 0.2 + Math.pow(state.sps, 0.75);
  state.velocity *= __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].controlsMultiplier;
  state.px += state.velocity * delta * state.multiplier;
};

var reset = function reset(delta) {
  state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a({}, initialState);
};

var stop = function stop() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_6_gsap__["TweenMax"].to(state, time, {
      multiplier: 0,
      ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Cubic"].easeIn,
      onComplete: resolve
    });
  });
};

var destroy = function destroy() {
  mc.off('swipe', onSwipe);
  clearInterval(state.inactiveInterval);
};

var setMultiplier = function setMultiplier(val) {
  state.multiplier = val;
};

var autoInterval = void 0;
var startAuto = function startAuto() {
  var sps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2.5;

  clearInterval(autoInterval);
  autoInterval = setInterval(function () {
    onSwipe({ overallVelocityY: 20 });
  }, 1000 / sps);
};

var init = function init() {
  destroy();
  reset();
  mc.on('swipe', onSwipe);
  resetInactive();
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/male1.f333dc3.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/male2.92bfe01.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/male3.5e438ab.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/female1.2d65d06.jpg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/female2.4459017.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/female3.3f31912.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/elite1.f7c1343.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/elite2.9f74611.jpg";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/elite3.c8480a5.jpg";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/intro_runner.0c37ef5.jpg";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bike_chassis.ec26c5f.png";

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
console.warn = function () {};


window.THREE = __WEBPACK_IMPORTED_MODULE_0_three__;
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);

__webpack_require__(82);
__webpack_require__(135);
window._ = __webpack_require__(13);








__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"](__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('browser/getCountry');

window.Vue = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */];
window.store = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */];
window.router = __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */];
window.i18n = __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */];

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ (function(module, exports) {



THREE.KeyFrameAnimation = function (data) {

  this.root = data.node;
  this.data = THREE.AnimationHandler.init(data);
  this.hierarchy = THREE.AnimationHandler.parse(this.root);
  this.currentTime = 0;
  this.timeScale = 0.001;
  this.isPlaying = false;
  this.isPaused = true;
  this.loop = true;

  for (var h = 0, hl = this.hierarchy.length - 1; h < hl; h++) {

    var keys = this.data.hierarchy[h].keys,
        sids = this.data.hierarchy[h].sids,
        obj = this.hierarchy[h];

    if (keys.length && sids) {

      for (var s = 0; s < sids.length; s++) {

        var sid = sids[s],
            next = this.getNextKeyWith(sid, h, 0);

        if (next) {

          next.apply(sid);
        }
      }

      obj.matrixAutoUpdate = false;
      this.data.hierarchy[h].node.updateMatrix();
      obj.matrixWorldNeedsUpdate = true;
    }
  }
};

THREE.KeyFrameAnimation.prototype = {

  constructor: THREE.KeyFrameAnimation,

  play: function play(startTime) {

    this.currentTime = startTime !== undefined ? startTime : 0;

    if (this.isPlaying === false) {

      this.isPlaying = true;

      var h,
          hl = this.hierarchy.length - 1,
          object,
          node;

      for (h = 0; h < hl; h++) {

        object = this.hierarchy[h];
        node = this.data.hierarchy[h];

        if (node.animationCache === undefined) {

          node.animationCache = {};
          node.animationCache.prevKey = null;
          node.animationCache.nextKey = null;
          node.animationCache.originalMatrix = object.matrix;
        }

        var keys = this.data.hierarchy[h].keys;

        if (keys.length > 1) {

          node.animationCache.prevKey = keys[0];
          node.animationCache.nextKey = keys[1];

          this.startTime = Math.min(keys[0].time, this.startTime);
          this.endTime = Math.max(keys[keys.length - 1].time, this.endTime);
        }
      }

      this.update(0);
    }

    this.isPaused = false;
  },

  stop: function stop() {

    this.isPlaying = false;
    this.isPaused = false;

    for (var h = 0; h < this.data.hierarchy.length; h++) {

      var obj = this.hierarchy[h];
      var node = this.data.hierarchy[h];

      if (node.animationCache !== undefined) {

        var original = node.animationCache.originalMatrix;

        original.copy(obj.matrix);
        obj.matrix = original;

        delete node.animationCache;
      }
    }
  },

  update: function update(delta) {

    if (this.isPlaying === false) return;

    this.currentTime += delta * this.timeScale;

    var duration = this.data.length;

    if (this.loop === true && this.currentTime > duration) {

      this.currentTime %= duration;
    }

    this.currentTime = Math.min(this.currentTime, duration);

    for (var h = 0, hl = this.hierarchy.length - 1; h < hl; h++) {

      var object = this.hierarchy[h];
      var node = this.data.hierarchy[h];

      var keys = node.keys,
          animationCache = node.animationCache;

      if (keys.length) {

        var prevKey = animationCache.prevKey;
        var nextKey = animationCache.nextKey;

        if (nextKey.time <= this.currentTime) {

          while (nextKey.time < this.currentTime && nextKey.index > prevKey.index) {

            prevKey = nextKey;
            nextKey = keys[prevKey.index + 1];
          }

          animationCache.prevKey = prevKey;
          animationCache.nextKey = nextKey;
        }

        if (nextKey.time >= this.currentTime) {

          prevKey.interpolate(nextKey, this.currentTime);
        } else {

          prevKey.interpolate(nextKey, nextKey.time);
        }

        this.data.hierarchy[h].node.updateMatrix();
        object.matrixWorldNeedsUpdate = true;
      }
    }
  },

  getNextKeyWith: function getNextKeyWith(sid, h, key) {

    var keys = this.data.hierarchy[h].keys;
    key = key % keys.length;

    for (; key < keys.length; key++) {

      if (keys[key].hasTarget(sid)) {

        return keys[key];
      }
    }

    return keys[0];
  },

  getPrevKeyWith: function getPrevKeyWith(sid, h, key) {

    var keys = this.data.hierarchy[h].keys;
    key = key >= 0 ? key : key + keys.length;

    for (; key >= 0; key--) {

      if (keys[key].hasTarget(sid)) {

        return keys[key];
      }
    }

    return keys[keys.length - 1];
  }

};

/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */,
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landscape_warning_LandscapeWarning__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landscape_warning_LandscapeWarning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_landscape_warning_LandscapeWarning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_unsupported_Desktop__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_unsupported_Desktop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_unsupported_Desktop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_unsupported_WebGl__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_unsupported_WebGl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_unsupported_WebGl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_debug_Debug__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_debug_Debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_debug_Debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_game_main_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_build_fontSubsetData__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_build_fontSubsetData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_src_build_fontSubsetData__);



var THREE = __webpack_require__(0);







window.game = __WEBPACK_IMPORTED_MODULE_6__components_game_main_js__["a" /* default */];



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    LandscapeWarning: __WEBPACK_IMPORTED_MODULE_2__components_landscape_warning_LandscapeWarning___default.a,
    Desktop: __WEBPACK_IMPORTED_MODULE_3__components_unsupported_Desktop___default.a,
    WebGl: __WEBPACK_IMPORTED_MODULE_4__components_unsupported_WebGl___default.a,
    Debug: __WEBPACK_IMPORTED_MODULE_5__components_debug_Debug___default.a
  },
  data: function data() {
    return {
      flatMessages: __WEBPACK_IMPORTED_MODULE_7_src_build_fontSubsetData___default.a
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]('game', ['debug'])),
  mounted: function mounted() {
    window.addEventListener('resize', this.onResize);
    window.addEventListener('orientationchange', this.onOrientationChange);
    this.init();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({
    init: function init() {
      var container = this.$refs.container;
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
      container.appendChild(__WEBPACK_IMPORTED_MODULE_6__components_game_main_js__["a" /* default */].renderer.renderer.domElement);
    },
    onResize: function onResize() {
      this.resize({ width: window.innerWidth, height: window.innerHeight });
    },
    onOrientationChange: function onOrientationChange() {
      this.resize({ width: window.innerWidth, height: window.innerHeight });
    }
  }, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]('browser', ['getCountry']), __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */]('browser', ['resize']))
});

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  "data-v-3202e776",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landscape-warning',
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]('browser', ['isMobile'])),
  mounted: function mounted() {}
});

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isMobile) ? _c('div', {
    attrs: {
      "id": "landscape-warning"
    }
  }, [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$t('landscape')))])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(258)
    }
  })])
}]}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon.a07716f.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(260)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  "data-v-259fff53",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_AnalyticsService_js__ = __webpack_require__(39);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'unsupported-desktop',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({
    show: function show() {
      return !this.isMobile;
    }
  }, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
    isMobile: function isMobile(state) {
      return state.browser.isMobile;
    }
  })),
  mounted: function mounted() {
    if (!this.show) return;
    __WEBPACK_IMPORTED_MODULE_2_src_api_AnalyticsService_js__["a" /* service */].sendEvent('unsupported', 'desktop');
  }
});

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    attrs: {
      "id": "unsupported-desktop"
    }
  }, [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$t('unsupported')))]), _c('img', {
    staticClass: "lockup",
    attrs: {
      "src": __webpack_require__(143)
    }
  })]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144)
    }
  })])
}]}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(280)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  "data-v-61ae1860",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'webgl',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
    isWebGl: function isWebGl(state) {
      return state.browser.isWebGl;
    }
  })),
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isWebGl) ? _c('div', {
    attrs: {
      "id": "webgl"
    }
  }, [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$t('unsupported')))])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144)
    }
  })])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(284)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  "data-v-68d92b28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_game_stages__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_game_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_game_renderer__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_game_controls__ = __webpack_require__(207);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'debug',
  data: function data() {
    return {
      progress: 0,
      velocity: 0,
      charge: null,
      STAGES: __WEBPACK_IMPORTED_MODULE_4_src_components_game_stages__,
      stage: 0,
      stage2: {
        velocity: {
          base: null,
          avg: null
        },
        charge: 0
      },
      breakScale: __WEBPACK_IMPORTED_MODULE_5_src_components_game_config__["b" /* default */].breakScale,
      fps: 0,
      pixelRatio: 0,
      numInfront: 0,
      duration: 0,
      baseVelocity: 0,
      bloom: 0,
      zoom: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default.a({
    stageLabel: function stageLabel() {
      var stages = ['INTRO', 'STAGE0', 'STAGE1', 'STAGE2_SLOW', 'STAGE2_FAST', 'STAGE2_AIRPORT', 'END_NORMAL', 'END_CUTSCENE', 'END_SPEED', 'RESULTS'];
      return stages[this.stage];
    }
  }, __WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */]({
    debug: function debug(state) {
      return state.game.debug;
    }
  })),
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_6_src_components_game_renderer__["stats"]) {
      this.$refs.performance.appendChild(__WEBPACK_IMPORTED_MODULE_6_src_components_game_renderer__["stats"].domElement);
    }
    this.interval = setInterval(this.update, 50);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    update: function update() {
      this.progress = __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["c" /* state */].progress.percent;
      this.velocity = __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["c" /* state */].velocity.now;
      this.baseVelocity = __WEBPACK_IMPORTED_MODULE_7_src_components_game_controls__["state"].baseVelocity;
      this.charge = __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["c" /* state */].stage2.progress;
      this.stage = __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["c" /* state */].stage;
      this.stage2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a({}, __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["c" /* state */].stage2);

      this.duration = __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["c" /* state */].duration;
      this.numInfront = __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["c" /* state */].numInfront;
      this.bloom = __WEBPACK_IMPORTED_MODULE_6_src_components_game_renderer__["multiPassBloomPass"].params.blurAmount;
      this.zoom = __WEBPACK_IMPORTED_MODULE_6_src_components_game_renderer__["zoomBlurPass"].params.strength;
    }
  }

});

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
!function (a, b) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : a.UserInfo = b();
}(this, function () {
  var a = "//api.userinfo.io/userinfos",
      b = function () {
    for (var a = 3, b = document.createElement("div"), c = b.all || []; b.innerHTML = "<!--[if gt IE " + ++a + "]><br><![endif]-->", c[0];) {}return a > 4 ? a : !a;
  }();return { getInfo: function getInfo(c, d) {
      var e = 8 === b || 9 === b;if (e && window.XDomainRequest) {
        var f = new XDomainRequest();f.onerror = function () {
          d && d({ message: "Error with HTTP status code: " + f.status });
        }, f.onload = function () {
          c && c(JSON.parse(f.responseText));
        }, f.open("GET", a, !0), f.send();
      } else {
        var g;g = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP"), g.onreadystatechange = function () {
          if (4 == g.readyState) if (200 == g.status) c && c(JSON.parse(g.responseText));else {
            var a;a = null !== g.responseText && "" !== g.responseText ? JSON.parse(g.responseText) : { message: "Error with HTTP status code: " + g.status }, d && d(a);
          }
        }, g.open("GET", a, !0), g.setRequestHeader("X-Userinfo-Client-Id", "userinfo-js:1.1.2-SNAPSHOT"), g.send();
      }
    } };
});

/***/ }),
/* 289 */
/***/ (function(module, exports) {



/***/ }),
/* 290 */,
/* 291 */
/***/ (function(module, exports) {



/***/ }),
/* 292 */
/***/ (function(module, exports) {



/***/ }),
/* 293 */
/***/ (function(module, exports) {



/***/ }),
/* 294 */,
/* 295 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(296)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  "data-v-0e063d0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProgressBar__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingText__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LoadingText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_game_loader_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_game_main__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_api_ShareService__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_api_AnalyticsService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_game_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_assets_swoosh_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_assets_swoosh_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_src_assets_swoosh_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_i18n__ = __webpack_require__(42);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_3__ProgressBar___default.a,
    LoadingText: __WEBPACK_IMPORTED_MODULE_4__LoadingText___default.a,
    SwooshIcon: __WEBPACK_IMPORTED_MODULE_10_src_assets_swoosh_svg___default.a
  },
  data: function data() {
    return {
      updateTime: 100,
      showProgress: 0,
      startTime: Date.now(),
      minTime: 1000,
      loadCompleted: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */]({
    loadProgress: function loadProgress(state) {
      return state.game.loading.progress;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    window.loading = this;

    __WEBPACK_IMPORTED_MODULE_8_src_api_AnalyticsService__["a" /* service */].sendPageview('/');

    __WEBPACK_IMPORTED_MODULE_7_src_api_ShareService__["a" /* service */].init().then(function () {
      __WEBPACK_IMPORTED_MODULE_7_src_api_ShareService__["a" /* service */].setDefaultLink();
    });

    if (document.readyState === 'complete') {
      this.onDocumentReady();
    } else {
      document.onreadystatechange = function () {
        if (document.readyState === 'complete') {
          _this.onDocumentReady();
        }
      };
    }
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    onDocumentReady: function onDocumentReady() {
      var _this2 = this;

      setTimeout(function () {
        _this2.update();
        __WEBPACK_IMPORTED_MODULE_6_src_components_game_main__["a" /* default */].loader.start();
      }, 60);
    },
    update: function update() {
      var _this3 = this;

      this.interval = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_5_src_components_game_loader_js__["getProgress"]();

        var actualProgress = Math.round(_this3.loadProgress * 100) / 100;
        var maxProgress = (Date.now() - _this3.startTime) / _this3.minTime;
        maxProgress = Math.min(maxProgress, 1);

        var showProgress = Math.min(actualProgress, maxProgress);
        _this3.showProgress = Math.min(showProgress, 1);


        if (_this3.loadProgress >= 1 && showProgress >= 0.98) {
          clearInterval(_this3.interval);
          _this3.onComplete();
        }
      }, this.updateTime * 2);
    },
    onComplete: function onComplete() {
      var _this4 = this;

      this.showProgress = 1;
      var duration = Date.now() - this.startTime;
      console.log('##### LOADED ##### ' + Math.round(duration) + 'ms');
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        _this4.loadCompleted = true;
        if (__WEBPACK_IMPORTED_MODULE_9_src_components_game_config__["a" /* config */].skipEnterButton) {
          _this4.next();
        }
      });
    },
    next: function next() {
      var route = {
        name: 'race'
      };

      this.$router.replace(route);
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(299)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  "data-v-6be66ee4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_animated_number_AnimatedNumber__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_animated_number_AnimatedNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_components_animated_number_AnimatedNumber__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'progress-bar',
  components: {
    AnimatedNumber: __WEBPACK_IMPORTED_MODULE_0_src_components_animated_number_AnimatedNumber___default.a
  },
  props: ['progress', 'time'],
  data: function data() {
    return {
      transform: 'translateX(-100%)',
      background: 'background: linear-gradient(to left, #1A3FED 0%, #EC201E 100%)',
      progressLabel: 0
    };
  },
  computed: {
    transition: function transition() {
      var time = this.time || 100;
      var t = 'all ' + time + 'ms linear 0s';
      return t;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.enabled = true;

    this.update = function () {

      if (!_this.enabled) return;

      var translate = 0;
      if (_this.progress >= 1) {
        translate = 0;
      } else {
        translate = 100 - _this.progress * 100;
      }
      translate = Math.round(translate * 2.4) / 2.4;
      _this.transform = 'translateX(-' + translate + '%)';

      _this.background = 'linear-gradient(to left, #EC201E 0%, #1A3FED ' + _this.progress * 100 + '%)';

      _this.progressLabel = Math.floor(_this.progress * 100);
    };

    this.interval = setInterval(this.update, this.time);
  },
  beforeDestroy: function beforeDestroy() {
    this.enabled = false;
    clearInterval(this.interval);
  }

});

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_left_pad__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_left_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_left_pad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'animated-number',
  props: {
    number: {},
    time: {},
    fixed: {
      default: 0
    },
    pad: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      displayNumber: '0'
    };
  },
  mounted: function mounted() {
    this.update(0, this.number);
  },

  methods: {
    update: function update(from, to) {
      var _this = this;
      var time = this.time || 0;

      var tweeningNumber = { value: from };

      __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(tweeningNumber, time / 1000, {
        value: to,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Linear"].easeNone,
        onUpdateParams: [tweeningNumber],
        onUpdate: function onUpdate(num) {
          _this.displayNumber = __WEBPACK_IMPORTED_MODULE_0_left_pad___default.a(num.value.toFixed(_this.fixed), _this.pad, '0');
        }
      });
    }
  },
  watch: {
    number: function number(newVal, oldVal) {
      this.update(oldVal, newVal);
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "animated-number"
  }, [_vm._v(_vm._s(_vm.displayNumber))])
},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      transform: _vm.transform,
      transition: _vm.transition,
      background: _vm.background
    })
  })]), _c('div', {
    staticClass: "label"
  }, [_c('animated-number', {
    attrs: {
      "number": _vm.progressLabel,
      "time": _vm.time
    }
  }), _c('span', [_vm._v("%")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(306)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  "data-v-7286eb47",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_i18n__ = __webpack_require__(42);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading-text',
  components: {},
  props: ['completed'],
  data: function data() {
    return {
      textIndex: 1,
      text: this.$t('loading'),
      locale: __WEBPACK_IMPORTED_MODULE_0_src_i18n__["a" /* default */].locale
    };
  },

  computed: {},
  mounted: function mounted() {
    this.interval = setInterval(this.nextText, 3000);
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    nextText: function nextText() {
      this.textIndex++;
      if (this.textIndex > this.text.length) this.textIndex = 1;
    }
  },
  watch: {
    completed: function completed(val) {
      if (!val) return;
      clearInterval(this.interval);
      this.textIndex = 0;
    }
  }
});

/***/ }),
/* 308 */,
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "loading-text"
  }, [_c('li', {
    class: {
      'active': _vm.textIndex === 0
    }
  }, [(_vm.locale === 'en') ? _c('img', {
    attrs: {
      "src": __webpack_require__(143)
    }
  }) : _vm._e(), (_vm.locale !== 'en') ? _c('img', {
    attrs: {
      "src": __webpack_require__(310)
    }
  }) : _vm._e()]), _vm._l((_vm.text), function(lines, index) {
    return _c('li', {
      class: {
        'active': _vm.textIndex === (index + 1)
      }
    }, _vm._l((lines), function(line) {
      return _c('p', [_vm._v(_vm._s(line))])
    }))
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lockup.2713744.png";

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(325)
var prodEnv = __webpack_require__(152)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/share2.7931ae8.jpg";

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "pad-top"
  }), _c('transition', {
    attrs: {
      "name": "swoosh"
    }
  }, [(!_vm.loadCompleted) ? _c('swoosh-icon', {
    staticClass: "swoosh"
  }) : _vm._e()], 1), _c('loading-text', {
    attrs: {
      "completed": _vm.loadCompleted
    }
  }), _c('div', {
    staticClass: "bottom"
  }, [_c('transition', {
    attrs: {
      "name": "load-section"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadCompleted),
      expression: "!loadCompleted"
    }]
  }, [_c('progress-bar', {
    attrs: {
      "time": _vm.updateTime,
      "progress": _vm.showProgress
    }
  })], 1)]), _c('transition', {
    attrs: {
      "name": "load-section"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadCompleted),
      expression: "loadCompleted"
    }]
  }, [_c('button', {
    staticClass: "start",
    on: {
      "click": _vm.next
    }
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(57)
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('startCta')))])])])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "lines"
  }, [_c('ul', [_c('li', {
    staticClass: "lines-bg"
  }), _c('li', {
    staticClass: "lines-bg"
  })])]), _c('div', {
    staticClass: "overlay"
  })])
}]}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  "data-v-115ee960",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_MuteButton__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_MuteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_MuteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_api_AnalyticsService__ = __webpack_require__(39);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'race',
  components: {
    MuteButton: __WEBPACK_IMPORTED_MODULE_2__ui_MuteButton___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]('game', {
    stage: function stage(state) {
      return state.stage;
    }
  })),
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4_src_api_AnalyticsService__["a" /* service */].sendPageview('/race');

    window.race = this;
    __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["a" /* default */].restart();
  },

  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3_src_components_game_main__["a" /* default */].stop();
  },
  methods: {},
  watch: {}
});

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  "data-v-b3c81b72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_game_listener__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_volume_ico_headphone_svg__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_volume_ico_headphone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_volume_ico_headphone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_volume_ico_volume_svg__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_volume_ico_volume_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_volume_ico_volume_svg__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mute-button',
  components: {
    HeadphoneIcon: __WEBPACK_IMPORTED_MODULE_1_assets_volume_ico_headphone_svg___default.a,
    VolumeIcon: __WEBPACK_IMPORTED_MODULE_2_assets_volume_ico_volume_svg___default.a
  },
  props: [],
  data: function data() {
    return {
      isMuted: false,
      force: false
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.force = true;
      setTimeout(function () {
        _this.force = false;
      }, 5000);
    }, 200);
  },

  methods: {
    toggle: function toggle() {
      this.isMuted = !this.isMuted;
      if (this.isMuted) {
        __WEBPACK_IMPORTED_MODULE_0_src_components_game_listener__["a" /* default */].setMasterVolume(0);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_src_components_game_listener__["a" /* default */].setMasterVolume(1);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 306.6"><path class="st0" d="M226.2 12.7c-59.8-9.4-109.9 9.4-150.3 53.8-24.2 26.6-38.1 58.3-42.9 94-.8 5.7-2.7 10.8-8.2 14.8C15 182.6 11.2 194 9 205.5c-3.1 16.4-2.4 32.9 5.3 48 3.1 6 8.4 10.9 12.8 16.3.9 1.1 2.5 2 2.8 3.2 1.7 7.7 7.9 10 14.1 12.7 2.3 1 4.4 2.9 5.9 4.9 2.5 3.3 5.1 5.6 9.6 5.5 7.8-.1 15.6 0 23.3 0 11.5 0 14.5-3 14.5-14.3v-121c0-10.1-3.3-13.4-13.4-13.6-7-.1-14-.4-21-.2-3.5.1-7 .9-10.5 1.4 9.5-55.6 63.8-122.1 146.3-122h2.6c82.6 0 136.8 66.4 146.3 122-3.4-.5-6.9-1.3-10.5-1.4-7-.1-14 .1-21 .2-10.1.1-13.4 3.4-13.4 13.6v121c0 11.3 3 14.3 14.5 14.3 7.8 0 15.6-.1 23.3 0 4.4.1 7.1-2.2 9.6-5.5 1.5-2 3.6-4 5.9-4.9 6.2-2.6 12.4-5 14.1-12.7.3-1.2 1.9-2.1 2.8-3.2 4.3-5.4 9.7-10.3 12.8-16.3 7.7-15.2 8.5-31.6 5.3-48-2.2-11.5-6-22.9-15.8-30.2-5.5-4-7.4-9.1-8.2-14.8-4.7-35.7-18.7-67.5-42.9-94-40.4-44.4-90.5-63.1-150.3-53.8h52.4z"/></svg>'};

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.7 85.6"><path class="st0" d="M43.6 0h27.6v85.6H43.6V0zM0 0h27.6v85.6H0V0zm87.1 0h27.6v85.6H87.1V0z"/></svg>'};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mute-button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('headphone-icon', {
    staticClass: "headphone"
  }), _c('ul', {
    staticClass: "volume",
    class: {
      'active': !_vm.isMuted
    }
  }, [_c('li', {
    staticClass: "bar"
  }), _c('li', {
    staticClass: "bar"
  }), _c('li', {
    staticClass: "bar"
  })])], 1), _c('div', {
    staticClass: "cta",
    class: {
      'active': _vm.isMuted || _vm.force
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('volumeCta')))])])])
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "race"
    }
  }, [_c('mute-button')], 1)
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  "data-v-d2f75040",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_finish_time_FinishTime__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_finish_time_FinishTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_src_components_finish_time_FinishTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_reveal_text_RevealText__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_reveal_text_RevealText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_components_reveal_text_RevealText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_assets_swoosh_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_assets_swoosh_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_src_assets_swoosh_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_assets_result_btn_share_bg_svg__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_assets_result_btn_share_bg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_src_assets_result_btn_share_bg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_assets_result_ico_share_svg__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_assets_result_ico_share_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_src_assets_result_ico_share_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_assets_result_ico_replay_svg__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_assets_result_ico_replay_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_src_assets_result_ico_replay_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_api_ShareService__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_tc_Tc__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_tc_Tc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_src_components_tc_Tc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_i18n__ = __webpack_require__(42);






















var base = void 0;
if (true) {
  base = __webpack_require__(16).build.assetsPublicPath;
} else {
  base = require('src/../config').dev.assetsPublicPath;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'result',
  components: {
    SwooshIcon: __WEBPACK_IMPORTED_MODULE_5_src_assets_swoosh_svg___default.a,
    ShareIcon: __WEBPACK_IMPORTED_MODULE_7_src_assets_result_ico_share_svg___default.a,
    ReplayIcon: __WEBPACK_IMPORTED_MODULE_8_src_assets_result_ico_replay_svg___default.a,
    FinishTime: __WEBPACK_IMPORTED_MODULE_3_src_components_finish_time_FinishTime___default.a,
    RevealText: __WEBPACK_IMPORTED_MODULE_4_src_components_reveal_text_RevealText___default.a,
    ShareBtnBg: __WEBPACK_IMPORTED_MODULE_6_src_assets_result_btn_share_bg_svg___default.a,
    Tc: __WEBPACK_IMPORTED_MODULE_11_src_components_tc_Tc___default.a
  },
  data: function data() {
    return {
      revealed: false,
      percentile: '00',
      showShare: false,
      showTc: false,
      show: false,
      anim: {
        text: false,
        button: false,
        time: false,
        share: false
      },
      locale: __WEBPACK_IMPORTED_MODULE_13_src_i18n__["a" /* default */].locale
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({
    isAuthor: function isAuthor() {
      return this.$route.params.isAuthor || false;
    }
  }, __WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */]({
    total: function total(state) {
      return state.game.ranking.total;
    },
    username: function username(state) {
      return state.route.query._name;
    },
    duration: function duration(state) {
      return state.route.query._duration;
    },
    gameLoaded: function gameLoaded(state) {
      return state.game.loading.completed;
    },
    windowWidth: function windowWidth(state) {
      return state.browser.windowWidth;
    },
    windowHeight: function windowHeight(state) {
      return state.browser.windowHeight;
    }
  })),

  mounted: function mounted() {
    var _this = this;

    window.result = this;

    if (this.duration === null) return this.toHome();

    var urls = [__webpack_require__(183), __webpack_require__(184), __webpack_require__(185), __webpack_require__(186), __webpack_require__(187), __webpack_require__(188), __webpack_require__(189)];
    for (var url in __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].loader.assets) {
      if (urls.indexOf(url) < 0) {
        delete __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].loader.assets[url];
      }
    }
    __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].loader.start();

    if (this.isAuthor) {
      __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendPageview('/results');
      this.getRank({ time: this.duration, name: this.username }).then(function () {
        _this.revealed = true;
        _this.percentile = _this.$store.state.game.ranking.percentile || 0;
      });

      __WEBPACK_IMPORTED_MODULE_9_src_api_ShareService__["a" /* service */].setResultLink(this.duration, this.username);
    } else {
      __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendPageview('/sharedResults');

      __WEBPACK_IMPORTED_MODULE_9_src_api_ShareService__["a" /* service */].init().then(function () {
        __WEBPACK_IMPORTED_MODULE_9_src_api_ShareService__["a" /* service */].setDefaultLink();
      });
    }

    if (this.gameLoaded) {
      this.show = true;
      this.playSeq();
    }

    this.positionScene();
  },


  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].raf.removeListener('tick', __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].result.cloth.update);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({
    positionScene: function positionScene() {
      var pos = {
        x: 0,
        y: 0,
        z: 0
      };
      var scale = 1;

      var aspectRatio = this.windowWidth / this.windowHeight;

      if (aspectRatio < 13 / 9) {
        if (this.isAuthor) {
          pos.y = -this.windowHeight * 0.08;
        } else {
          pos.y = -this.windowHeight * 0.06;
        }

        scale = 0.93;
        if (this.windowHeight <= 570) {
          scale = 0.75;
        }
      } else {
        pos.x = -10 + this.windowWidth * 0.25;
        pos.y = this.windowWidth * 0.08;
        scale = 0.8;
      }

      __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].result.scene.content.position.set(pos.x, pos.y, pos.z);
      __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].result.scene.content.scale.setScalar(scale);
    },
    playSeq: function playSeq() {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].raf.on('tick', __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].result.cloth.update);
        __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].renderer.setRenderResults(true);
        __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].result.scene.colorBgResult();
        __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].result.scene.animateIn().then(function () {
          __WEBPACK_IMPORTED_MODULE_12_src_components_game_main__["a" /* default */].renderer.setRenderGame(false);
        });
      });
    },
    toHome: function toHome() {
      var link = '' + window.location.origin + base;
      setTimeout(function () {
        window.location = link;
      }, 100);
    },
    toReplay: function toReplay() {
      if (this.isAuthor && this.gameLoaded) {
        __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendEvent('button-replay', 'tap');

        window.location = window.location.origin + base;
      } else {
        __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendEvent('button-newgame', 'tap');
        this.toHome();
      }
    },
    toShare: function toShare() {
      __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendPageview('/shareCta');
      __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendEvent('button-share', 'tap');
      this.showShare = true;
    },
    toTc: function toTc() {
      __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendEvent('button-tc', 'tap');
      this.showTc = true;
    },
    toDraw: function toDraw() {
      var link = 'https://www.nike.com/events-registration/event?id=82446&cp=cn_brs_080617_u_ZPS_RN_NRC_wc_BY_GC';
      __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendEvent('button-draw', 'tap');
      setTimeout(function () {
        window.location = link;
      }, 100);
    },
    toBuy: function toBuy() {
      var link = 'http://store.nike.com/cn/zh_cn/pw/轻质-跑步-鞋类/8yzZntaZoi3?cp=cn_brs_080617_u_ZPS_RN_NRC_wc_BY_GC';
      __WEBPACK_IMPORTED_MODULE_10_src_api_AnalyticsService__["a" /* service */].sendEvent('button-buy', 'tap');
      setTimeout(function () {
        window.location = link;
      }, 100);
    }
  }, __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */]('game', ['getRank'])),
  watch: {
    gameLoaded: function gameLoaded(val) {
      if (val) {
        this.show = true;
        this.playSeq();
      }
    },
    windowWidth: function windowWidth(val) {
      this.positionScene();
    },
    windowHeight: function windowHeight(val) {
      this.positionScene();
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(443)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  "data-v-558221c7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_animated_number_AnimatedNumber__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_animated_number_AnimatedNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_components_animated_number_AnimatedNumber__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'share',
  components: {
    AnimatedNumber: __WEBPACK_IMPORTED_MODULE_0_src_components_animated_number_AnimatedNumber___default.a
  },
  props: ['time'],
  data: function data() {
    return {};
  },

  computed: {
    min: function min() {
      return Math.floor(this.time / 1000 / 60);
    },
    sec: function sec() {
      return Math.floor(this.time / 1000 % 60);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  methods: {}
});

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finish-time"
  }, [_vm._m(0), _c('div', {
    staticClass: "overlay"
  }, [_c('span', [_c('animated-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.min),
      expression: "min"
    }],
    attrs: {
      "time": 800,
      "pad": 2,
      "number": _vm.min
    }
  })], 1), _c('span', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('span', [_c('animated-number', {
    attrs: {
      "time": 800,
      "pad": 2,
      "number": _vm.sec
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "underlay"
  }, [_c('span', [_vm._v("00")]), _c('span', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('span', [_vm._v("00")])])
}]}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  "data-v-d4003d8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_baffle__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_baffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_baffle__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reveal-text',
  props: {
    characters: {
      default: '0123456789'
    },
    text: {
      default: '00'
    },
    reveal: {
      default: false
    },
    time: {
      default: 1000
    }
  },
  data: function data() {
    return {
      b: null
    };
  },

  mounted: function mounted() {

    this.b = __WEBPACK_IMPORTED_MODULE_1_baffle___default.a(this.$refs.container, {
      characters: this.characters,
      speed: 75
    });
    this.b.start();
    this.check();
  },
  methods: {
    check: function check() {
      if (this.reveal) {
        this.show();
      } else {
        this.hide();
      }
    },
    show: function show() {
      this.b.reveal(this.time);
    },
    hide: function hide() {
      this.b.start();
    }
  },
  watch: {
    reveal: function reveal() {
      this.check();
    },
    text: function text(val) {
      this.b.text(function (currentText) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a(val);
      });
      this.check();
    }
  }
});

/***/ }),
/* 449 */,
/* 450 */,
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    ref: "container",
    staticClass: "reveal-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 169.5"><path class="st0" d="M2 1v137l198.1 29.5L398 138.7V1S1.6 1.4 2 1z"/></svg>'};

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 277.6 308"><circle class="st0" cx="231.8" cy="45.1" r="42.3"/><circle class="st0" cx="231.8" cy="263.4" r="42.3"/><circle class="st0" cx="44.9" cy="154.9" r="42.3"/><path class="st0" d="M66.7 183.01l13.35-23.123 156.4 90.3-13.35 23.123zm-10.876-51.273l156.4-90.3 13.35 23.123-156.4 90.3z"/></svg>'};

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 277.6 308"><path class="st0" d="M209.5 105l-35.4-1.8c-2.4-.1-5.1.4-6-2.6-.8-2.6 1.4-4 2.9-5.4 3.8-3.6 7.4-7.4 11.4-10.6 3.4-2.8 2.4-4-.8-5.7-28.5-15.4-57.2-15.1-85.4.2C63.3 97 46.6 133 52.7 170.4c5.7 35.1 34.4 64 70.3 70.8 55.2 10.5 106.5-34.5 102.7-90.6-.5-7.1 1.3-10.1 8-12.1 11.6-3.6 22.9-8.2 34.2-12.7 3.3-1.3 4-.5 4.6 2.6 15.2 72.7-35.9 147.8-109.1 159.9C88.2 300.8 20.3 254.4 5 180-7.2 121.3 23.6 58.6 78.1 32.4c46.7-22.5 92.1-18.8 135.8 8.7 3.5 2.2 4.9 1.6 6.8-1.5 3.1-4.9 6.5-9.6 9.7-14.4 1.1-1.6 2.2-2.9 4.3-2.4 2.1.5 2.6 2.2 2.9 4.1 4.4 24.6 8.8 49.2 13.3 73.8.9 4.7-.5 6.7-5.5 6.4-12-.8-24-1.2-36-1.8l.1-.3z"/></svg>'};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(456)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  "data-v-d2d73ec0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_assets_swoosh_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_assets_swoosh_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_assets_swoosh_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_assets_close_icon_svg__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_assets_close_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_src_assets_close_icon_svg__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tc',
  props: ['active'],
  components: {
    SwooshIcon: __WEBPACK_IMPORTED_MODULE_0_src_assets_swoosh_svg___default.a,
    CloseIcon: __WEBPACK_IMPORTED_MODULE_1_src_assets_close_icon_svg___default.a
  },
  computed: {},
  mounted: function mounted() {},

  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path class="st0" d="M14.8 14.8l19 19m-19 0l19-19"/></svg>'};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    attrs: {
      "id": "tc"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "swoosh"
  }, [_c('swoosh-icon')], 1), _vm._m(0), _vm._m(1), _c('p', [_vm._v("本次活动时间，自2017年6月8日0时开始至7月5日24时结束。在活动开始前或者活动结束后参与活动均属无效。 ")]), _c('p', [_vm._v("用户只需以尽快速度滑动屏幕，完成线上比赛，即可获得“突破速度挑战赛”定制T恤抽奖机会。")]), _vm._m(2), _c('p', [_vm._v("活动奖品：“突破速度挑战赛”定制T恤一件（共20件）")]), _c('p', [_vm._v("用户完成比赛后，即可点击进入抽奖参与页面，留下个人联系方式。")]), _c('p', [_vm._v("我们将于7月6日抽取20名获奖者，每位获奖者将获赠“突破速度挑战赛”定制T恤一件。届时，我们将致电联系中奖者一一告知中奖信息及领奖方式。")]), _c('h3', [_vm._v("关于以上所有奖品：")]), _vm._m(3), _vm._m(4), _vm._m(5)]), _c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('CloseIcon')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('p', [_vm._v("NIKE“突破速度挑战赛”")]), _c('p', [_vm._v("线上活动须知")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(57)
    }
  }), _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("活动规则")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(57)
    }
  }), _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("奖品说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("中奖者留下的个人信息需真实准确，并保持手机畅通。若因客观原因无法顺利联系到获奖者，此获奖资格将作废。")]), _c('li', [_vm._v("获奖资格不得转让，亦不能兑换现金或者其他等价物。本次活动的奖品不设调换。但主办方保留在法律允许的范围内，如因奖品无法提供或者主办方自主判决的其他原因不能提供的情况下，替换其他相同或者更高金额的奖品的权利。获奖者应负责上述未明确列明由主办方承担的其他税费。")]), _c('li', [_vm._v("如果获奖者拒绝接受奖品，不符合参与条件或者有违反本次活动《活动须知》的情况，主办方有权立即取消获奖者的中奖资格，并另行选择获奖者。")]), _c('li', [_vm._v("在法律允许的范围内，主办方有权对获奖者是否符合参与及中奖资格进行独立判断，并做出最终决定。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(57)
    }
  }), _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("其他")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("本次活动由耐克体育（中国）有限公司主办。")]), _c('li', [_vm._v("未经主办方许可，参加者不得利用本次参加事宜或参加活动本身进行任何形式的商业性或非商业性的市场开发或宣传活动等。")]), _c('li', [_vm._v("参加者同意主办方可以为组织本次活动的目的收集并且授权第三方使用其个人信息。")]), _c('li', [_vm._v("主办方不对因网络传输原因而导致参加者提交的信息丢失或错误承担任何责任。如遇不可抗力，包括但不限于自然灾害、天气原因、罢工、网络故障、政府临时管制、恐怖活动等因素导致本次活动因故无法进行时，主办方有权在法律允许的范围内决定取消、终止、修改或暂停本次活动。届时，主办方将另行通知相关事宜。")]), _c('li', [_vm._v("在法律允许的范围内，耐克体育（中国）有限公司拥有对本次活动的最终解释权。")]), _c('li', [_c('span', [_vm._v("参加者的个人信息保护：通过本次活动收集的个人信息均适用耐克的个人信息保护政策，你可以阅读")]), _c('a', {
    attrs: {
      "href": "http://help-zh-cn.nike.com/app/answers/detail/article/privacy-policy/a_id/16423/p/3897"
    }
  }, [_vm._v("《耐克网络隐私政策》")]), _c('span', [_vm._v("获取更多信息。")])])])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "result"
    }
  }, [(_vm.show) ? _c('div', {
    class: {
      isAuthor: _vm.isAuthor, isViewer: !_vm.isAuthor
    },
    attrs: {
      "id": "result"
    }
  }, [(_vm.isAuthor === true) ? _c('button', {
    staticClass: "replay",
    on: {
      "click": _vm.toReplay
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('replay-icon', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('result.btn_again')))])], 1)]) : _vm._e(), _c('div', {
    staticClass: "top"
  }, [_c('swoosh-icon', {
    staticClass: "swoosh head"
  }), _c('h2', {
    staticClass: "title"
  }, [(_vm.isAuthor === true) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('result.title')))])]) : _vm._e(), (_vm.isAuthor === false) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('share.generic.title')[0]))]), _c('p', [_vm._v(_vm._s(_vm.$t('share.generic.title')[1]))])]) : _vm._e()]), _c('finish-time', {
    attrs: {
      "time": _vm.duration
    }
  }), (_vm.isAuthor === true) ? _c('div', {
    staticClass: "percentile"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('result.percentile[0]')))]), _c('span', {
    staticClass: "big"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(57)
    }
  }), _c('reveal-text', {
    attrs: {
      "text": _vm.percentile,
      "reveal": _vm.revealed
    }
  }), _c('span', {
    staticClass: "percent"
  }, [_vm._v("%")])], 1), _c('span', [_vm._v(_vm._s(_vm.$t('result.percentile[1]')))])]) : _vm._e(), (_vm.isAuthor === true) ? _c('div', {
    staticClass: "label share-content"
  }, [_vm._v(_vm._s(_vm.$t('result.share_content')))]) : _vm._e()], 1), _c('div', {
    staticClass: "hero"
  }), _c('div', {
    staticClass: "bottom"
  }, [(_vm.isAuthor === false) ? _c('h2', {
    staticClass: "cta-copy"
  }, [_vm._v(_vm._s(_vm.$t('share.generic.subtitle')))]) : _vm._e(), (_vm.isAuthor === true) ? _c('div', {
    staticClass: "buttons buttons-two"
  }, [(_vm.locale !== 'en') ? _c('button', {
    staticClass: "draw",
    on: {
      "click": _vm.toDraw
    }
  }, [_c('div', {
    staticClass: "bg"
  }), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('result.btn_draw')))])])]) : _vm._e(), _c('button', {
    staticClass: "buy",
    on: {
      "click": _vm.toBuy
    }
  }, [_c('div', {
    staticClass: "bg"
  }), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('result.btn_buy')))])])])]) : _c('div', {
    staticClass: "buttons buttons-one"
  }, [_c('button', {
    staticClass: "home",
    on: {
      "click": _vm.toHome
    }
  }, [_c('div', {
    staticClass: "bg"
  }), _c('div', {
    staticClass: "content"
  }, [(_vm.username) ? _c('span', [_vm._v(_vm._s(_vm.$t('share.named.cta')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('share.generic.cta')))])])])]), (_vm.isAuthor === true && _vm.locale !== 'en') ? _c('div', {
    staticClass: "tc-button",
    on: {
      "click": _vm.toTc
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('span', [_vm._v("i")])]), _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('result.btn_tc')))])])]) : _vm._e()]), _c('tc', {
    attrs: {
      "active": _vm.showTc
    },
    on: {
      "close": function($event) {
        _vm.showTc = false
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 461 */,
/* 462 */,
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);



!function (t, e) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default.a(exports)) && "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default.a(module))) module.exports = e();else if ("function" == typeof define && __webpack_require__(145)) define([], e);else {
    var i = e();for (var n in i) {
      ("object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default.a(exports)) ? exports : t)[n] = i[n];
    }
  }
}(this, function () {
  return function (t) {
    function e(n) {
      if (i[n]) return i[n].exports;var o = i[n] = { exports: {}, id: n, loaded: !1 };return t[n].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
    }var i = {};return e.m = t, e.c = i, e.p = "", e(0);
  }([function (t, e, i) {
    t.exports = i(1);
  }, function (t, e, i) {
    "use strict";
    function n(t) {
      for (var i in t) {
        e.hasOwnProperty(i) || (e[i] = t[i]);
      }
    }Object.defineProperty(e, "__esModule", { value: !0 }), n(i(2)), n(i(11)), n(i(12)), n(i(14)), n(i(6)), n(i(13)), n(i(7)), n(i(15)), n(i(18)), n(i(19)), n(i(21)), n(i(24)), n(i(25)), n(i(26)), n(i(27)), n(i(28)), n(i(29)), n(i(30));
  }, function (t, e, i) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var n = i(3),
        o = function () {
      function t(t) {
        this.baseMesh = new n.ThreeMesh(), this.baseMesh.setMesh(t), this.baseMesh.analyzeGeometry(), this.stack = new Array();
      }return Object.defineProperty(t.prototype, "uvsAndColorUpdate", { set: function set(t) {
          this.baseMesh.uvsAndColorUpdate = t;
        }, enumerable: !0, configurable: !0 }), t.prototype.addModifier = function (t) {
        t.setModifiable(this.baseMesh), this.stack.push(t);
      }, t.prototype.removeModifier = function (t) {
        var e = this.stack.indexOf(t);e > -1 && this.stack.splice(e, 1);
      }, t.prototype.apply = function () {
        this.baseMesh.resetGeometry();for (var t = 0; t < this.stack.length; t++) {
          this.stack[t].apply();
        }this.baseMesh.postApply();
      }, t.prototype.collapse = function () {
        this.apply(), this.baseMesh.collapseGeometry(), this.stack.length = 0;
      }, t.prototype.reset = function () {
        this.baseMesh.resetGeometry();
      }, t.prototype.clear = function () {
        this.stack.length = 0;
      }, t;
    }();e.ModifierStack = o;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(4),
        r = i(8),
        s = i(9),
        c = i(10),
        u = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;return e.uvsAndColorUpdate = !1, e;
      }return n(e, t), e.prototype.setMesh = function (t) {
        this.mesh = t;for (var e = this.mesh.geometry, i = new c.Dictionary(), n = e.vertices, r = n.length, u = e.faces, h = u.length, a = 0; a < r; a++) {
          var f = new o.ThreeVertex();f.setVertex(n[a]), this.vertices.push(f), i.setVal(n[a], f);
        }for (var a = 0; a < h; a++) {
          var p = new s.FaceProxy(),
              l = n[u[a].a],
              y = n[u[a].b],
              d = n[u[a].c];p.addVertex(i.getVal(l)), p.addVertex(i.getVal(y)), p.addVertex(i.getVal(d)), this.faces.push(p);
        }
      }, e.prototype.postApply = function () {
        var t = this.mesh.geometry;if (t.verticesNeedUpdate = !0, t.normalsNeedUpdate = !0, this.uvsAndColorUpdate) try {
          t.colorsNeedUpdate = !0, t.uvsNeedUpdate = !0, t.groupsNeedUpdate = !0, t.elementsNeedUpdate = !0, t.lineDistancesNeedUpdate = !0;
        } catch (t) {}
      }, e.prototype.updateMeshPosition = function (t) {
        this.mesh.position.x += t.x, this.mesh.position.y += t.y, this.mesh.position.z += t.z;
      }, e;
    }(r.MeshProxy);e.ThreeMesh = u;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(5),
        r = function (t) {
      function e() {
        return t.call(this) || this;
      }return n(e, t), e.prototype.setVertex = function (t) {
        this.vertor = t, this.ox = this.vertor.x, this.oy = this.vertor.y, this.oz = this.vertor.z;
      }, Object.defineProperty(e.prototype, "x", { get: function get() {
          return this.vertor.x;
        }, set: function set(t) {
          this.vertor.x = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "y", { get: function get() {
          return this.vertor.y;
        }, set: function set(t) {
          this.vertor.y = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "z", { get: function get() {
          return this.vertor.z;
        }, set: function set(t) {
          this.vertor.z = t;
        }, enumerable: !0, configurable: !0 }), e;
    }(o.VertexProxy);e.ThreeVertex = r;
  }, function (t, e, i) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var n = i(6),
        o = i(7),
        r = function () {
      function t() {}return t.prototype.setVertex = function (t) {}, t.prototype.setRatios = function (t, e, i) {
        this._ratioX = t, this._ratioY = e, this._ratioZ = i;
      }, t.prototype.setOriginalPosition = function (t, e, i) {
        this.ox = t, this.oy = e, this.oz = i;
      }, Object.defineProperty(t.prototype, "x", { get: function get() {
          return 0;
        }, set: function set(t) {}, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "y", { get: function get() {
          return 0;
        }, set: function set(t) {}, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "z", { get: function get() {
          return 0;
        }, set: function set(t) {}, enumerable: !0, configurable: !0 }), t.prototype.getValue = function (t) {
        switch (t) {case o.ModConstant.X:
            return this.x;case o.ModConstant.Y:
            return this.y;case o.ModConstant.Z:
            return this.z;}return 0;
      }, t.prototype.setValue = function (t, e) {
        switch (t) {case o.ModConstant.X:
            this.x = e;break;case o.ModConstant.Y:
            this.y = e;break;case o.ModConstant.Z:
            this.z = e;}
      }, Object.defineProperty(t.prototype, "ratioX", { get: function get() {
          return this._ratioX;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "ratioY", { get: function get() {
          return this._ratioY;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "ratioZ", { get: function get() {
          return this._ratioZ;
        }, enumerable: !0, configurable: !0 }), t.prototype.getRatio = function (t) {
        switch (t) {case o.ModConstant.X:
            return this._ratioX;case o.ModConstant.Y:
            return this._ratioY;case o.ModConstant.Z:
            return this._ratioZ;}return -1;
      }, Object.defineProperty(t.prototype, "originalX", { get: function get() {
          return this.ox;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "originalY", { get: function get() {
          return this.oy;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "originalZ", { get: function get() {
          return this.oz;
        }, enumerable: !0, configurable: !0 }), t.prototype.getOriginalValue = function (t) {
        switch (t) {case o.ModConstant.X:
            return this.ox;case o.ModConstant.Y:
            return this.oy;case o.ModConstant.Z:
            return this.oz;}return 0;
      }, t.prototype.reset = function () {
        this.x = this.ox, this.y = this.oy, this.z = this.oz;
      }, t.prototype.collapse = function () {
        this.ox = this.x, this.oy = this.y, this.oz = this.z;
      }, Object.defineProperty(t.prototype, "vector", { get: function get() {
          return new n.Vector3(this.x, this.y, this.z);
        }, set: function set(t) {
          this.x = t.x, this.y = t.y, this.z = t.z;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "ratioVector", { get: function get() {
          return new n.Vector3(this.ratioX, this.ratioY, this.ratioZ);
        }, enumerable: !0, configurable: !0 }), t;
    }();e.VertexProxy = r;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t(t, e, i) {
        this.x = t, this.y = e, this.z = i;
      }return t.prototype.clone = function () {
        return new t(this.x, this.y, this.z);
      }, t.prototype.equals = function (t) {
        return this.x == t.x && this.y == t.y && this.z == t.z;
      }, t.prototype.zero = function () {
        this.x = this.y = this.z = 0;
      }, t.prototype.negate = function () {
        return new t(-this.x, -this.y, -this.z);
      }, t.prototype.add = function (e) {
        return new t(this.x + e.x, this.y + e.y, this.z + e.z);
      }, t.prototype.subtract = function (e) {
        return new t(this.x - e.x, this.y - e.y, this.z - e.z);
      }, t.prototype.multiplyScalar = function (e) {
        return new t(this.x * e, this.y * e, this.z * e);
      }, t.prototype.multiply = function (e) {
        return new t(this.x * e.x, this.y * e.y, this.z * e.z);
      }, t.prototype.divide = function (e) {
        var i = 1 / e;return new t(this.x * i, this.y * i, this.z * i);
      }, t.prototype.normalize = function () {
        var t = this.x * this.x + this.y * this.y + this.z * this.z;if (t > 0) {
          var e = 1 / Math.sqrt(t);this.x *= e, this.y *= e, this.z *= e;
        }
      }, Object.defineProperty(t.prototype, "magnitude", { get: function get() {
          return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
        }, set: function set(t) {
          this.normalize(), this.x *= t, this.y *= t, this.z *= t;
        }, enumerable: !0, configurable: !0 }), t.prototype.toString = function () {
        return "[" + this.x + " , " + this.y + " , " + this.z + "]";
      }, t.sum = function (t, e) {
        return t.add(e);
      }, t.dot = function (t, e) {
        return t.x * e.x + t.y * e.y + t.z * e.z;
      }, t.cross = function (e, i) {
        return new t(e.y * i.z - e.z * i.y, e.z * i.x - e.x * i.z, e.x * i.y - e.y * i.x);
      }, t.distance = function (t, e) {
        var i = t.x - e.x,
            n = t.y - e.y,
            o = t.z - e.z;return Math.sqrt(i * i + n * n + o * o);
      }, t;
    }();i.ZERO = new i(0, 0, 0), e.Vector3 = i;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t() {}return t;
    }();i.NONE = 0, i.X = 1, i.Y = 2, i.Z = 4, i.LEFT = -1, i.RIGHT = 1, e.ModConstant = i;
  }, function (t, e, i) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var n = i(7),
        o = function () {
      function t() {
        this.uvsAndColorUpdate = !1, this.vertices = new Array(), this.faces = new Array();
      }return t.prototype.setMesh = function (t) {}, t.prototype.updateMeshPosition = function (t) {}, t.prototype.getVertices = function () {
        return this.vertices;
      }, t.prototype.getFaces = function () {
        return this.faces;
      }, t.prototype.analyzeGeometry = function () {
        for (var t, e = this.getVertices().length, i = 0; i < e; i++) {
          t = this.getVertices()[i], 0 == i ? (this._minX = this._maxX = t.x, this._minY = this._maxY = t.y, this._minZ = this._maxZ = t.z) : (this._minX = Math.min(this._minX, t.x), this._minY = Math.min(this._minY, t.y), this._minZ = Math.min(this._minZ, t.z), this._maxX = Math.max(this._maxX, t.x), this._maxY = Math.max(this._maxY, t.y), this._maxZ = Math.max(this._maxZ, t.z)), t.setOriginalPosition(t.x, t.y, t.z);
        }this._width = this._maxX - this._minX, this._height = this._maxY - this._minY, this._depth = this._maxZ - this._minZ;var o = Math.max(this._width, Math.max(this._height, this._depth)),
            r = Math.min(this._width, Math.min(this._height, this._depth));o == this._width && r == this._height ? (this._minAxis = n.ModConstant.Y, this._midAxis = n.ModConstant.Z, this._maxAxis = n.ModConstant.X) : o == this._width && r == this._depth ? (this._minAxis = n.ModConstant.Z, this._midAxis = n.ModConstant.Y, this._maxAxis = n.ModConstant.X) : o == this._height && r == this._width ? (this._minAxis = n.ModConstant.X, this._midAxis = n.ModConstant.Z, this._maxAxis = n.ModConstant.Y) : o == this._height && r == this._depth ? (this._minAxis = n.ModConstant.Z, this._midAxis = n.ModConstant.X, this._maxAxis = n.ModConstant.Y) : o == this._depth && r == this._width ? (this._minAxis = n.ModConstant.X, this._midAxis = n.ModConstant.Y, this._maxAxis = n.ModConstant.Z) : o == this._depth && r == this._height && (this._minAxis = n.ModConstant.Y, this._midAxis = n.ModConstant.X, this._maxAxis = n.ModConstant.Z);for (var i = 0; i < e; i++) {
          t = this.getVertices()[i], t.setRatios((t.x - this._minX) / this._width, (t.y - this._minY) / this._height, (t.z - this._minZ) / this._depth);
        }
      }, t.prototype.resetGeometry = function () {
        for (var t = this.getVertices().length, e = 0; e < t; e++) {
          var i = this.getVertices()[e];i.reset();
        }
      }, t.prototype.collapseGeometry = function () {
        for (var t = this.getVertices().length, e = 0; e < t; e++) {
          var i = this.getVertices()[e];i.collapse();
        }this.analyzeGeometry();
      }, Object.defineProperty(t.prototype, "minX", { get: function get() {
          return this._minX;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "minY", { get: function get() {
          return this._minY;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "minZ", { get: function get() {
          return this._minZ;
        }, enumerable: !0, configurable: !0 }), t.prototype.getMin = function (t) {
        switch (t) {case n.ModConstant.X:
            return this._minX;case n.ModConstant.Y:
            return this._minY;case n.ModConstant.Z:
            return this._minZ;}return -1;
      }, Object.defineProperty(t.prototype, "maxX", { get: function get() {
          return this._maxX;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "maxY", { get: function get() {
          return this._maxY;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "maxZ", { get: function get() {
          return this._maxZ;
        }, enumerable: !0, configurable: !0 }), t.prototype.getMax = function (t) {
        switch (t) {case n.ModConstant.X:
            return this._maxX;case n.ModConstant.Y:
            return this._maxY;case n.ModConstant.Z:
            return this._maxZ;}return -1;
      }, Object.defineProperty(t.prototype, "maxAxis", { get: function get() {
          return this._maxAxis;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "midAxis", { get: function get() {
          return this._midAxis;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "minAxis", { get: function get() {
          return this._minAxis;
        }, enumerable: !0, configurable: !0 }), t.prototype.getSize = function (t) {
        switch (t) {case n.ModConstant.X:
            return this._width;case n.ModConstant.Y:
            return this._height;case n.ModConstant.Z:
            return this._depth;}return -1;
      }, Object.defineProperty(t.prototype, "width", { get: function get() {
          return this._width;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "height", { get: function get() {
          return this._height;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "depth", { get: function get() {
          return this._depth;
        }, enumerable: !0, configurable: !0 }), t.prototype.postApply = function () {}, t;
    }();e.MeshProxy = o;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t() {
        this._vertices = [];
      }return t.prototype.addVertex = function (t) {
        this._vertices.push(t);
      }, Object.defineProperty(t.prototype, "vertices", { get: function get() {
          return this._vertices;
        }, enumerable: !0, configurable: !0 }), t;
    }();e.FaceProxy = i;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t() {
        this.dic = {};
      }return t.prototype.setVal = function (t, e) {
        var i = this.getKey(t);this.dic[i] = e;
      }, t.prototype.getVal = function (t) {
        var e = this.getKey(t);return this.dic[e];
      }, t.prototype.getKey = function (t) {
        if ("object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default.a(t))) {
          if (t.id) return t.id;var e = "d_" + Math.floor(Math.random() * Math.pow(10, 10));return t.id = e, e;
        }return t + "";
      }, t;
    }();e.Dictionary = i;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t(t) {
        void 0 === t && (t = 0), this.v = t;
      }return Object.defineProperty(t.prototype, "value", { get: function get() {
          return this.v;
        }, set: function set(t) {
          this.v = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "phasedValue", { get: function get() {
          return Math.sin(this.v);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "absPhasedValue", { get: function get() {
          return Math.abs(this.phasedValue);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "normValue", { get: function get() {
          return (this.phasedValue + 1) / 2;
        }, enumerable: !0, configurable: !0 }), t;
    }();e.Phase = i;
  }, function (t, e, i) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var n = i(13),
        o = function () {
      function t(t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 1), this._start = t, this._end = e;
      }return Object.defineProperty(t.prototype, "start", { get: function get() {
          return this._start;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "end", { get: function get() {
          return this._end;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "size", { get: function get() {
          return this._end - this._start;
        }, enumerable: !0, configurable: !0 }), t.prototype.move = function (t) {
        this._start += t, this._end += t;
      }, t.prototype.isIn = function (t) {
        return t >= this._start && t <= this._end;
      }, t.prototype.normalize = function (t) {
        return n.XMath.normalize(this._start, this._end, t);
      }, t.prototype.toRange = function (t) {
        return n.XMath.toRange(this._start, this._end, t);
      }, t.prototype.trim = function (t) {
        return n.XMath.trim(this._start, this._end, t);
      }, t.prototype.interpolate = function (t, e) {
        return this.toRange(e.normalize(t));
      }, t.prototype.toString = function () {
        return "[" + this.start + " - " + this.end + "]";
      }, t;
    }();e.Range = o;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t() {}return t.normalize = function (e, i, n) {
        var o,
            r = i - e;return o = 0 == r ? 1 : t.trim(0, 1, (n - e) / i);
      }, t.toRange = function (t, e, i) {
        var n,
            o = e - t;return n = 0 == o ? 0 : t + (e - t) * i;
      }, t.inInRange = function (t, e, i, n) {
        return void 0 === n && (n = !1), n ? i >= t && i <= e : i > t && i < e;
      }, t.sign = function (t, e) {
        return void 0 === e && (e = 0), 0 == t ? e : t > 0 ? 1 : -1;
      }, t.trim = function (t, e, i) {
        return Math.min(e, Math.max(t, i));
      }, t.wrap = function (t, e, i) {
        return i < t ? i + (e - t) : i >= e ? i - (e - t) : i;
      }, t.degToRad = function (t) {
        return t / 180 * Math.PI;
      }, t.radToDeg = function (t) {
        return t / Math.PI * 180;
      }, t.presicion = function (t, e) {
        var i = Math.pow(10, e);return Math.round(t * i) / i;
      }, t.uceil = function (t) {
        return t < 0 ? Math.floor(t) : Math.ceil(t);
      }, t;
    }();i.PI = 3.1415, e.XMath = i;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t(t, e) {
        this.x = t, this.y = e;
      }return t.prototype.clone = function () {
        return new t(this.x, this.y);
      }, t.prototype.equals = function (t) {
        return this.x == t.x && this.y == t.y;
      }, t.prototype.zero = function () {
        this.x = this.y;
      }, t.prototype.negate = function () {
        return new t(-this.x, -this.y);
      }, t.prototype.add = function (e) {
        return new t(this.x + e.x, this.y + e.y);
      }, t.prototype.subtract = function (e) {
        return new t(this.x - e.x, this.y - e.y);
      }, t.prototype.multiplyScalar = function (e) {
        return new t(this.x * e, this.y * e);
      }, t.prototype.multiply = function (e) {
        return new t(this.x * e.x, this.y * e.y);
      }, t.prototype.divide = function (e) {
        var i = 1 / e;return new t(this.x * i, this.y * i);
      }, t.prototype.normalize = function () {
        var t = this.x * this.x + this.y * this.y;if (t > 0) {
          var e = 1 / Math.sqrt(t);this.x *= e, this.y *= e;
        }
      }, Object.defineProperty(t.prototype, "magnitude", { get: function get() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        }, set: function set(t) {
          this.normalize(), this.x *= t, this.y *= t;
        }, enumerable: !0, configurable: !0 }), t.prototype.toString = function () {
        return "[" + this.x + " , " + this.y + "]";
      }, t.sum = function (t, e) {
        return t.add(e);
      }, t.dot = function (t, e) {
        return t.x * e.x + t.y * e.y;
      }, t.distance = function (t, e) {
        var i = t.x - e.x,
            n = t.y - e.y;return Math.sqrt(i * i + n * n);
      }, t;
    }();i.ZERO = new i(0, 0), e.Vector2 = i;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(7),
        r = i(16),
        s = i(14),
        c = i(17),
        u = function (t) {
      function e(e, i, n) {
        void 0 === e && (e = 0), void 0 === i && (i = .5), void 0 === n && (n = 0);var r = t.call(this) || this;return r._constraint = o.ModConstant.NONE, r.switchAxes = !1, r._force = e, r._offset = i, r.angle = n, r;
      }return n(e, t), e.prototype.setModifiable = function (e) {
        t.prototype.setModifiable.call(this, e), this.max = this.switchAxes ? e.midAxis : e.maxAxis, this.min = e.minAxis, this.mid = this.switchAxes ? e.maxAxis : e.midAxis, this.width = e.getSize(this.max), this.height = e.getSize(this.mid), this.origin = e.getMin(this.max), this._diagAngle = Math.atan(this.width / this.height);
      }, Object.defineProperty(e.prototype, "force", { get: function get() {
          return this._force;
        }, set: function set(t) {
          this._force = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "constraint", { get: function get() {
          return this._constraint;
        }, set: function set(t) {
          this._constraint = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "offset", { get: function get() {
          return this._offset;
        }, set: function set(t) {
          this._offset = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "diagAngle", { get: function get() {
          return this._diagAngle;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "angle", { get: function get() {
          return this._angle;
        }, set: function set(t) {
          this._angle = t, this.m1 = new c.Matrix(1, 0, 0, 1), this.m1.rotate(this._angle), this.m2 = new c.Matrix(1, 0, 0, 1), this.m2.rotate(-this._angle);
        }, enumerable: !0, configurable: !0 }), e.prototype.apply = function () {
        if (0 != this.force) for (var t = this.mod.getVertices(), e = t.length, i = this.origin + this.width * this.offset, n = this.width / Math.PI / this.force, r = 2 * Math.PI * (this.width / (n * Math.PI * 2)), c = 0; c < e; c++) {
          var u = t[c],
              h = u.getValue(this.max),
              a = u.getValue(this.mid),
              f = u.getValue(this.min),
              p = this.m1.transformPoint(new s.Vector2(h, a));h = p.x, a = p.y;var l = (h - this.origin) / this.width;if (this.constraint == o.ModConstant.LEFT && l <= this.offset || this.constraint == o.ModConstant.RIGHT && l >= this.offset) ;else {
            var y = Math.PI / 2 - r * this.offset + r * l,
                d = Math.sin(y) * (n + f),
                _ = Math.cos(y) * (n + f);f = d - n, h = i - _;
          }var v = this.m2.transformPoint(new s.Vector2(h, a));h = v.x, a = v.y, u.setValue(this.max, h), u.setValue(this.mid, a), u.setValue(this.min, f);
        }
      }, e;
    }(r.Modifier);e.Bend = u;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t() {}return t.prototype.setModifiable = function (t) {
        this.mod = t;
      }, t.prototype.getVertices = function () {
        return this.mod.getVertices();
      }, t;
    }();e.Modifier = i;
  }, function (t, e, i) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var n = i(14),
        o = function () {
      function t(t, e, i, n) {
        this.m = [t, e, i, n];
      }return t.prototype.dispose = function () {
        return this.m.length = 0, this;
      }, t.prototype.reset = function () {
        return this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this;
      }, t.prototype.rotate = function (t) {
        var e = Math.cos(t),
            i = Math.sin(t);return this.m[0] = e, this.m[1] = -i, this.m[2] = i, this.m[3] = e, this;
      }, t.prototype.scale = function (t, e) {
        return this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, void 0 !== t && (this.m[0] = t, this.m[3] = t), void 0 !== e && (this.m[3] = e), this;
      }, t.prototype.multiply = function (e) {
        return t.mult(this, e);
      }, t.prototype.transformPoint = function (e) {
        var i = t.transform(this, [e.x, e.y]);return new n.Vector2(i[0], i[1]);
      }, t.prototype.transformPointSelf = function (e) {
        var i = t.transform(this, [e.x, e.y]);return e.x = i[0], e.y = i[1], e;
      }, t.prototype.clone = function () {
        var e = this.m;return new t(e[0], e[1], e[2], e[3]);
      }, t.transform = function (t, e) {
        var i = t.m,
            n = e[0],
            o = e[1];return e[0] = i[0] * n + i[1] * o, e[1] = i[2] * n + i[3] * o, e;
      }, t.mult = function (t, e) {
        var i = t.m,
            n = e.m,
            o = i[0],
            r = i[1],
            s = i[2],
            c = i[3];return i[0] = o * n[0] + r * n[2], i[1] = o * n[1] + r * n[3], i[2] = s * n[0] + c * n[2], i[3] = s * n[1] + c * n[3], t;
      }, t;
    }();e.Matrix = o;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(6),
        r = i(16),
        s = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;return e._center = o.Vector3.ZERO, e._r = 0, e._a = .01, e._u = o.Vector3.ZERO, e;
      }return n(e, t), Object.defineProperty(e.prototype, "center", { get: function get() {
          return this._center;
        }, set: function set(t) {
          this._center = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "radius", { get: function get() {
          return this._r;
        }, set: function set(t) {
          this._r = Math.max(0, t);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "a", { get: function get() {
          return this._a;
        }, set: function set(t) {
          this._a = Math.max(0, t);
        }, enumerable: !0, configurable: !0 }), e.prototype.apply = function () {
        for (var t = this.mod.getVertices(), e = 0, i = t; e < i.length; e++) {
          var n = i[e],
              o = n;this._u.x = o.x - this._center.x, this._u.y = o.y - this._center.y, this._u.z = o.z - this._center.z, this._u.magnitude += this._r * Math.exp(-this._u.magnitude * this._a), o.x = this._u.x + this._center.x, o.y = this._u.y + this._center.y, o.z = this._u.z + this._center.z;
        }
      }, e;
    }(r.Modifier);e.Bloat = s;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(12),
        r = i(6),
        s = i(20),
        c = i(16),
        u = function (t) {
      function e(e, i) {
        void 0 === e && (e = 0), void 0 === i && (i = 0);var n = t.call(this) || this;return n.bv = new r.Vector3(0, 1, 0), n.range = new o.Range(0, 1), n.angle = i, n._offset = e, n;
      }return n(e, t), e.prototype.apply = function () {
        for (var t = this.mod.getVertices(), e = t.length, i = new r.Vector3(0, 0, -(this.mod.minZ + this.mod.depth * this.offset)), n = 0; n < e; n++) {
          var o = t[n],
              c = o.vector;if (c = c.add(i), c.z >= 0 && this.range.isIn(o.ratioY)) {
            var u = this.angle,
                h = s.Matrix4.rotationMatrix(this.bv.x, this.bv.y, this.bv.z, u);s.Matrix4.multiplyVector(h, c);
          }var a = i.negate();c = c.add(a), o.x = c.x, o.y = c.y, o.z = c.z;
        }
      }, Object.defineProperty(e.prototype, "offset", { get: function get() {
          return this._offset;
        }, set: function set(t) {
          this._offset = t;
        }, enumerable: !0, configurable: !0 }), e;
    }(c.Modifier);e.Break = u;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t(t, e, i, n, o, r, s, c, u, h, a, f, p, l, y, d) {
        void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === o && (o = 0), void 0 === r && (r = 1), void 0 === s && (s = 0), void 0 === c && (c = 0), void 0 === u && (u = 0), void 0 === h && (h = 0), void 0 === a && (a = 1), void 0 === f && (f = 0), void 0 === p && (p = 0), void 0 === l && (l = 0), void 0 === y && (y = 0), void 0 === d && (d = 1), this.n11 = t, this.n12 = e, this.n13 = i, this.n14 = n, this.n21 = o, this.n22 = r, this.n23 = s, this.n24 = c, this.n31 = u, this.n32 = h, this.n33 = a, this.n34 = f, this.n41 = p, this.n42 = l, this.n43 = y, this.n44 = d;
      }return t.translationMatrix = function (e, i, n) {
        var o = new t();return o.n14 = e, o.n24 = i, o.n34 = n, o;
      }, t.scaleMatrix = function (e, i, n) {
        var o = new t();return o.n11 = e, o.n22 = i, o.n33 = n, o;
      }, t.rotationMatrix = function (e, i, n, o, r) {
        void 0 === r && (r = null);var s;s = r ? r : new t();var c = Math.cos(o),
            u = Math.sin(o),
            h = 1 - c,
            a = e * i * h,
            f = i * n * h,
            p = e * n * h,
            l = u * n,
            y = u * i,
            d = u * e;return s.n11 = c + e * e * h, s.n12 = -l + a, s.n13 = y + p, s.n14 = 0, s.n21 = l + a, s.n22 = c + i * i * h, s.n23 = -d + f, s.n24 = 0, s.n31 = -y + p, s.n32 = d + f, s.n33 = c + n * n * h, s.n34 = 0, s;
      }, t.prototype.calculateMultiply = function (t, e) {
        var i = t.n11,
            n = e.n11,
            o = t.n21,
            r = e.n21,
            s = t.n31,
            c = e.n31,
            u = t.n12,
            h = e.n12,
            a = t.n22,
            f = e.n22,
            p = t.n32,
            l = e.n32,
            y = t.n13,
            d = e.n13,
            _ = t.n23,
            v = e.n23,
            b = t.n33,
            m = e.n33,
            x = t.n14,
            g = e.n14,
            M = t.n24,
            O = e.n24,
            P = t.n34,
            w = e.n34;this.n11 = i * n + u * r + y * c, this.n12 = i * h + u * f + y * l, this.n13 = i * d + u * v + y * m, this.n14 = i * g + u * O + y * w + x, this.n21 = o * n + a * r + _ * c, this.n22 = o * h + a * f + _ * l, this.n23 = o * d + a * v + _ * m, this.n24 = o * g + a * O + _ * w + M, this.n31 = s * n + p * r + b * c, this.n32 = s * h + p * f + b * l, this.n33 = s * d + p * v + b * m, this.n34 = s * g + p * O + b * w + P;
      }, t.multiply = function (e, i) {
        var n = new t();return n.calculateMultiply(e, i), n;
      }, t.multiplyVector = function (t, e) {
        var i = e.x,
            n = e.y,
            o = e.z;e.x = i * t.n11 + n * t.n12 + o * t.n13 + t.n14, e.y = i * t.n21 + n * t.n22 + o * t.n23 + t.n24, e.z = i * t.n31 + n * t.n32 + o * t.n33 + t.n34;
      }, t;
    }();e.Matrix4 = i;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(7),
        r = i(10),
        s = i(16),
        c = i(22),
        u = i(23),
        h = function (t) {
      function e(e, i) {
        void 0 === e && (e = 1), void 0 === i && (i = 0);var n = t.call(this) || this;return n._forceX = 0, n._forceY = 0, n._forceZ = 0, n._lookUp = new r.Dictionary(), n._rigidity = e, n.friction = i, n;
      }return n(e, t), e.prototype.setBounds = function (t, e, i, n, o, r) {
        void 0 === t && (t = Number.NEGATIVE_INFINITY), void 0 === e && (e = Number.POSITIVE_INFINITY), void 0 === i && (i = Number.NEGATIVE_INFINITY), void 0 === n && (n = Number.POSITIVE_INFINITY), void 0 === o && (o = Number.NEGATIVE_INFINITY), void 0 === r && (r = Number.POSITIVE_INFINITY), this._useBounds = !0, this._boundsMinX = t, this._boundsMaxX = e, this._boundsMinY = i, this._boundsMaxY = n, this._boundsMinZ = o, this._boundsMaxZ = r;
      }, e.prototype.clearBounds = function () {
        this._useBounds = !1;
      }, Object.defineProperty(e.prototype, "verletVertices", { get: function get() {
          return this._vertices;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "friction", { get: function get() {
          return 100 * (this._friction - 1);
        }, set: function set(t) {
          t < 0 && (t = 0), this._friction = t / 100 + 1;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "rigidity", { get: function get() {
          return this._rigidity;
        }, set: function set(t) {
          var e,
              i,
              n = this._connections.length;for (t > 1 ? t = 1 : t < 0 && (t = 0), this._rigidity = t, e = .5 * t; i = this._connections[--n];) {
            i.rigidity = e;
          }
        }, enumerable: !0, configurable: !0 }), e.prototype.setForce = function (t, e, i) {
        this._forceX = t, this._forceY = e, this._forceZ = i;
      }, Object.defineProperty(e.prototype, "forceX", { get: function get() {
          return this._forceX;
        }, set: function set(t) {
          this._forceX = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "forceY", { get: function get() {
          return this._forceY;
        }, set: function set(t) {
          this._forceY = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "forceZ", { get: function get() {
          return this._forceZ;
        }, set: function set(t) {
          this._forceZ = t;
        }, enumerable: !0, configurable: !0 }), e.prototype.unlockAll = function () {
        for (var t, e = this._vertices.length; t = this._vertices[--e];) {
          t.mobileX = !0, t.mobileY = !0, t.mobileZ = !0;
        }
      }, e.prototype.lockXMin = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 7), this.lockSet(this.mod.minX, "x", t, e);
      }, e.prototype.lockXMax = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 7), this.lockSet(this.mod.maxX, "x", t, e);
      }, e.prototype.lockYMin = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 7), this.lockSet(this.mod.minY, "y", t, e);
      }, e.prototype.lockYMax = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 7), this.lockSet(this.mod.maxY, "y", t, e);
      }, e.prototype.lockZMin = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 7), this.lockSet(this.mod.minZ, "z", t, e);
      }, e.prototype.lockZMax = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 7), this.lockSet(this.mod.maxZ, "z", t, e);
      }, e.prototype.lockSet = function (t, e, i, n) {
        void 0 === i && (i = 0), void 0 === n && (n = 7);for (var r, s = this._vertices.length; r = this._vertices[--s];) {
          Math.abs(r[e] - t) <= i && (n & o.ModConstant.X && (r.mobileX = !1), n & o.ModConstant.Y && (r.mobileY = !1), n & o.ModConstant.Z && (r.mobileZ = !1));
        }
      }, e.prototype.setModifiable = function (e) {
        t.prototype.setModifiable.call(this, e), this.initVerletVertices(), this.initVerletConnections(), this.rigidity = this._rigidity;
      }, e.prototype.apply = function () {
        var t, e, i;for (t = this._connections.length; e = this._connections[--t];) {
          e.update();
        }for (t = this._vertices.length; i = this._vertices[--t];) {
          i.mobileX && (i.x += this._forceX), i.mobileY && (i.y += this._forceY), i.mobileZ && (i.z += this._forceZ), i.velocityX /= this._friction, i.velocityY /= this._friction, i.velocityZ /= this._friction, this._useBounds && (i.x < this._boundsMinX ? i.x = this._boundsMinX : i.x > this._boundsMaxX && (i.x = this._boundsMaxX), i.y < this._boundsMinY ? i.y = this._boundsMinY : i.y > this._boundsMaxY && (i.y = this._boundsMaxY), i.z < this._boundsMinZ ? i.z = this._boundsMinZ : i.z > this._boundsMaxZ && (i.z = this._boundsMaxZ)), i.update();
        }
      }, e.prototype.initVerletVertices = function () {
        var t,
            e,
            i = this.mod.getVertices(),
            n = i.length;for (this._vertices = []; t = i[--n];) {
          e = new u.VerletVertex(t), this._vertices.push(e), this._lookUp.setVal(t, e);
        }
      }, e.prototype.initVerletConnections = function () {
        var t,
            e,
            i,
            n = this.mod.getFaces(),
            o = n.length;this._connections = [];for (var r = 0; r < o; r++) {
          t = n[r], e = t.vertices, i = e.length;for (var s = 0; s < i - 1; s++) {
            this.createConnection(this._lookUp.getVal(e[s]), this._lookUp.getVal(e[s + 1])), s > 1 && this.createConnection(this._lookUp.getVal(e[0]), this._lookUp.getVal(e[s]));
          }this.createConnection(this._lookUp.getVal(e[i - 1]), this._lookUp.getVal(e[0]));
        }
      }, e.prototype.createConnection = function (t, e) {
        var i = t.distanceTo(e),
            n = new c.VerletConnection(t, e, i, this._rigidity);this._connections.push(n);
      }, e;
    }(s.Modifier);e.Cloth = h;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t(t, e, i, n) {
        void 0 === n && (n = .5), this._rigidity = .5, this._v1 = t, this._v2 = e, this._strictDistance = i, this._rigidity = n;
      }return Object.defineProperty(t.prototype, "rigidity", { get: function get() {
          return this._rigidity;
        }, set: function set(t) {
          this._rigidity = t;
        }, enumerable: !0, configurable: !0 }), t.prototype.update = function () {
        var t,
            e,
            i,
            n,
            o = this._v1.x,
            r = this._v2.x,
            s = this._v1.y,
            c = this._v2.y,
            u = this._v1.z,
            h = this._v2.z,
            a = r - o,
            f = c - s,
            p = h - u,
            l = Math.sqrt(a * a + f * f + p * p);l != this._strictDistance && (t = (this._strictDistance - l) / l * this._rigidity, e = t * a, i = t * f, n = t * p, this._v1.mobileX && this._v2.mobileX || (e *= 2), this._v1.mobileY && this._v2.mobileY || (i *= 2), this._v1.mobileZ && this._v2.mobileZ || (n *= 2), this._v1.mobileX && (this._v1.x -= e), this._v1.mobileY && (this._v1.y -= i), this._v1.mobileZ && (this._v1.z -= n), this._v2.mobileX && (this._v2.x += e), this._v2.mobileY && (this._v2.y += i), this._v2.mobileZ && (this._v2.z += n));
      }, t;
    }();e.VerletConnection = i;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t(t) {
        this.mobileX = !0, this.mobileY = !0, this.mobileZ = !0, this._v = t, this.setPosition(this._v.x, this._v.y, this._v.z);
      }return t.prototype.setPosition = function (t, e, i) {
        this._x = this._oldX = t, this._y = this._oldY = e, this._z = this._oldZ = i, this._v.x = t, this._v.y = e, this._v.z = i;
      }, t.prototype.update = function () {
        var t, e, i;this.mobileX && (t = this.x, this.x += this.velocityX, this._oldX = t), this.mobileY && (e = this.y, this.y += this.velocityY, this._oldY = e), this.mobileZ && (i = this.z, this.z += this.velocityZ, this._oldZ = i);
      }, Object.defineProperty(t.prototype, "x", { get: function get() {
          return this._x;
        }, set: function set(t) {
          this._x = t, this.mobileX || (this._oldX = t), this._v.x = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "y", { get: function get() {
          return this._y;
        }, set: function set(t) {
          this._y = t, this.mobileY || (this._oldY = t), this._v.y = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "z", { get: function get() {
          return this._z;
        }, set: function set(t) {
          this._z = t, this.mobileZ || (this._oldZ = t), this._v.z = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "velocityX", { get: function get() {
          return this._x - this._oldX;
        }, set: function set(t) {
          this._oldX = this._x - t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "velocityY", { get: function get() {
          return this._y - this._oldY;
        }, set: function set(t) {
          this._oldY = this._y - t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "velocityZ", { get: function get() {
          return this._z - this._oldZ;
        }, set: function set(t) {
          this._oldZ = this._z - t;
        }, enumerable: !0, configurable: !0 }), t.prototype.distanceTo = function (t) {
        return Math.sqrt((this.x - t.x) * (this.x - t.x) + (this.y - t.y) * (this.y - t.y) + (this.z - t.z) * (this.z - t.z));
      }, t;
    }();e.VerletVertex = i;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(7),
        r = i(16),
        s = function (t) {
      function e(e) {
        void 0 === e && (e = 0);var i = t.call(this) || this;return i.axc = o.ModConstant.NONE, i.start = 0, i.end = 0, i.frc = e, i;
      }return n(e, t), Object.defineProperty(e.prototype, "force", { get: function get() {
          return this.frc;
        }, set: function set(t) {
          this.frc = t;
        }, enumerable: !0, configurable: !0 }), e.prototype.constraintAxes = function (t) {
        this.axc = t;
      }, e.prototype.setFalloff = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 1), this.start = t, this.end = e;
      }, e.prototype.apply = function () {
        for (var t = this.mod.getVertices(), e = t.length, i = 0; i < e; i++) {
          var n = t[i],
              o = Math.random() * this.force - this.force / 2,
              r = n.getRatio(this.mod.maxAxis);this.start < this.end ? (r < this.start && (r = 0), r > this.end && (r = 1)) : this.start > this.end ? (r = 1 - r, r > this.start && (r = 0), r < this.end && (r = 1)) : r = 1, 1 & this.axc || (n.x += o * r), this.axc >> 1 & 1 || (n.y += o * r), this.axc >> 2 & 1 || (n.z += o * r);
        }
      }, e;
    }(r.Modifier);e.Noise = s;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(6),
        r = i(16),
        s = function (t) {
      function e(e, i, n) {
        void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0);var r = t.call(this) || this;return r.pivot = new o.Vector3(e, i, n), r;
      }return n(e, t), e.prototype.setMeshCenter = function () {
        var t = -(this.mod.minX + this.mod.width / 2),
            e = -(this.mod.minY + this.mod.height / 2),
            i = -(this.mod.minZ + this.mod.depth / 2);this.pivot = new o.Vector3(t, e, i);
      }, e.prototype.apply = function () {
        for (var t = this.mod.getVertices(), e = t.length, i = 0; i < e; i++) {
          var n = t[i];n.vector = n.vector.add(this.pivot);
        }var o = this.pivot.clone();this.mod.updateMeshPosition(o.negate());
      }, e;
    }(r.Modifier);e.Pivot = s;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(7),
        r = i(13),
        s = i(16),
        c = function (t) {
      function e(e) {
        void 0 === e && (e = 0);var i = t.call(this) || this;return i._offset = .5, i._constraint = o.ModConstant.NONE, i._power = 1, i._falloff = 1, i._inverseFalloff = !1, i._oneSide = !1, i._swapAxes = !1, i._force = e, i;
      }return n(e, t), e.prototype.setModifiable = function (e) {
        t.prototype.setModifiable.call(this, e), this._skewAxis = this._skewAxis || e.maxAxis;
      }, e.prototype.apply = function () {
        for (var t = this.mod.getVertices(), e = t.length, i = 0; i < e; i++) {
          var n = t[i];if (!(this._constraint == o.ModConstant.LEFT && n.getRatio(this._skewAxis) <= this._offset || this._constraint == o.ModConstant.RIGHT && n.getRatio(this._skewAxis) > this._offset)) {
            var s = n.getRatio(this._skewAxis) - this._offset;this._oneSide && (s = Math.abs(s));var c = n.getRatio(this.displaceAxis);this._inverseFalloff && (c = 1 - c);var u = this._falloff + c * (1 - this._falloff),
                h = Math.pow(Math.abs(s), this._power) * r.XMath.sign(s, 1),
                a = n.getValue(this.displaceAxis) + this.force * h * u;n.setValue(this.displaceAxis, a);
          }
        }
      }, Object.defineProperty(e.prototype, "displaceAxis", { get: function get() {
          switch (this._skewAxis) {case o.ModConstant.X:
              return this._swapAxes ? o.ModConstant.Z : o.ModConstant.Y;case o.ModConstant.Y:
              return this._swapAxes ? o.ModConstant.Z : o.ModConstant.X;case o.ModConstant.Z:
              return this._swapAxes ? o.ModConstant.Y : o.ModConstant.X;default:
              return 0;}
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "force", { get: function get() {
          return this._force;
        }, set: function set(t) {
          this._force = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "constraint", { get: function get() {
          return this._constraint;
        }, set: function set(t) {
          this._constraint = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "offset", { get: function get() {
          return this._offset;
        }, set: function set(t) {
          this._offset = r.XMath.trim(0, 1, t);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "power", { get: function get() {
          return this._power;
        }, set: function set(t) {
          this._power = Math.max(1, t);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "falloff", { get: function get() {
          return this._falloff;
        }, set: function set(t) {
          this._falloff = r.XMath.trim(0, 1, t);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "oneSide", { get: function get() {
          return this._oneSide;
        }, set: function set(t) {
          this._oneSide = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "skewAxis", { get: function get() {
          return this._skewAxis;
        }, set: function set(t) {
          this._skewAxis = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "swapAxes", { get: function get() {
          return this._swapAxes;
        }, set: function set(t) {
          this._swapAxes = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "inverseFalloff", { get: function get() {
          return this._inverseFalloff;
        }, set: function set(t) {
          this._inverseFalloff = t;
        }, enumerable: !0, configurable: !0 }), e;
    }(s.Modifier);e.Skew = c;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(20),
        r = i(6),
        s = i(16),
        c = function (t) {
      function e(e) {
        var i = t.call(this) || this;return i.start = 0, i.end = 1, i._vector = new r.Vector3(1, 0, 1), i._vector2 = new r.Vector3(0, 1, 0), i.frc = e, i.pow = 1, i;
      }return n(e, t), e.prototype.setFalloff = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 1), this.start = t, this.end = e;
      }, Object.defineProperty(e.prototype, "force", { get: function get() {
          return this.frc;
        }, set: function set(t) {
          this.frc = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "power", { get: function get() {
          return this.pow;
        }, set: function set(t) {
          this.pow = t;
        }, enumerable: !0, configurable: !0 }), e.prototype.apply = function () {
        for (var t = this.mod.getVertices(), e = t.length, i = 0; i < e; i++) {
          var n = t[i],
              r = n.ratioVector.multiply(this._vector2),
              s = this.frc * Math.pow(r.magnitude, this.pow),
              c = o.Matrix4.scaleMatrix(1 + s * this._vector.x, 1 + s * this._vector.y, 1 + s * this._vector.z),
              u = n.vector;o.Matrix4.multiplyVector(c, u), n.vector = u;
        }
      }, e;
    }(s.Modifier);e.Taper = c;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(20),
        r = i(6),
        s = i(16),
        c = function (t) {
      function e(e) {
        void 0 === e && (e = 0);var i = t.call(this) || this;return i._vector = new r.Vector3(0, 1, 0), i.center = r.Vector3.ZERO, i._angle = e, i;
      }return n(e, t), Object.defineProperty(e.prototype, "angle", { get: function get() {
          return this._angle;
        }, set: function set(t) {
          this._angle = t;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "vector", { get: function get() {
          return this._vector;
        }, set: function set(t) {
          this._vector = t;
        }, enumerable: !0, configurable: !0 }), e.prototype.apply = function () {
        this._vector.normalize();for (var t = new r.Vector3(this.mod.maxX / 2, this.mod.maxY / 2, this.mod.maxZ / 2), e = -r.Vector3.dot(this._vector, this.center), i = 0; i < this.mod.getVertices().length; i++) {
          var n = this.mod.getVertices()[i],
              o = r.Vector3.dot(new r.Vector3(n.x, n.y, n.z), this._vector) + e;this.twistPoint(n, o / t.magnitude * this._angle);
        }
      }, e.prototype.twistPoint = function (t, e) {
        var i = o.Matrix4.translationMatrix(t.x, t.y, t.z);i = o.Matrix4.multiply(o.Matrix4.rotationMatrix(this._vector.x, this._vector.y, this._vector.z, e), i), t.x = i.n14, t.y = i.n24, t.z = i.n34;
      }, e;
    }(s.Modifier);e.Twist = c;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(20),
        r = i(6),
        s = i(16),
        c = function (t) {
      function e() {
        var e = t.call(this) || this;return e.steerVector = new r.Vector3(0, 1, 0), e.rollVector = new r.Vector3(0, 0, 1), e.speed = 0, e.turn = 0, e.roll = 0, e;
      }return n(e, t), e.prototype.setModifiable = function (e) {
        t.prototype.setModifiable.call(this, e), this._radius = e.width / 2;
      }, e.prototype.apply = function () {
        this.roll += this.speed;var t,
            e = this.mod.getVertices(),
            i = e.length;if (0 != this.turn) {
          var n = o.Matrix4.rotationMatrix(this.steerVector.x, this.steerVector.y, this.steerVector.z, this.turn),
              r = this.rollVector.clone();o.Matrix4.multiplyVector(n, r), t = o.Matrix4.rotationMatrix(r.x, r.y, r.z, this.roll);
        } else t = o.Matrix4.rotationMatrix(this.rollVector.x, this.rollVector.y, this.rollVector.z, this.roll);for (var s = 0; s < i; s++) {
          var c = e[s],
              u = c.vector.clone();0 != this.turn && o.Matrix4.multiplyVector(n, u), o.Matrix4.multiplyVector(t, u), c.x = u.x, c.y = u.y, c.z = u.z;
        }
      }, Object.defineProperty(e.prototype, "step", { get: function get() {
          return this._radius * this.speed / Math.PI;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "perimeter", { get: function get() {
          return 2 * this._radius * Math.PI;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "radius", { get: function get() {
          return this._radius;
        }, enumerable: !0, configurable: !0 }), e;
    }(s.Modifier);e.Wheel = c;
  }, function (t, e, i) {
    "use strict";
    var n = this && this.__extends || function () {
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };return function (e, i) {
        function n() {
          this.constructor = e;
        }t(e, i), e.prototype = null === i ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default.a(i) : (n.prototype = i.prototype, new n());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = i(16),
        r = i(31),
        s = function (t) {
      function e() {
        var e = t.call(this) || this;return e.eventEmitter = new r.EventEmitter(), e;
      }return n(e, t), e.prototype.apply = function () {
        for (var t = this.mod.getVertices(), e = t.length, i = 0; i < e; i++) {
          var n = t[i];this.renderVector && this.renderVector(n, i, e);
        }this.dispatchEvent("CHANGE");
      }, e.prototype.addEventListener = function (t, e) {
        this.eventEmitter.on(t, e);
      }, e.prototype.dispatchEvent = function (t) {
        return this.eventEmitter.emit(t);
      }, e.prototype.hasEventListener = function (t) {
        return this.eventEmitter.has(t);
      }, e.prototype.removeEventListener = function (t, e) {
        this.eventEmitter.off(t, e);
      }, e;
    }(o.Modifier);e.UserDefined = s;
  }, function (t, e) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = function () {
      function t() {}return t.prototype.on = function (t, e) {
        return n || (n = {}), n[t] || (n[t] = []), n[t].push(e), e;
      }, t.prototype.emit = function (t) {
        for (var e = [], i = 1; i < arguments.length; i++) {
          e[i - 1] = arguments[i];
        }var o = !1;if (t && n) {
          var r = n[t];if (!r) return o;r = r.slice();var s,
              c = r.length,
              u = Array.prototype.slice.call(arguments);for (u.shift(); c--;) {
            var s = r[c];o = o || s.apply(null, u);
          }
        }return !!o;
      }, t.prototype.one = function (t, e) {
        var i = this,
            n = Array.prototype.slice.call(arguments, 2),
            o = function o() {
          i.off(t, o), e.apply(null, n);
        };this.on(t, o);
      }, t.prototype.has = function (t) {
        return !(!n || !n[t]);
      }, t.prototype.off = function (t, e) {
        if (n && n[t]) for (var i = n[t], o = 0, r = i.length; o < r; o++) {
          if (i[o].toString() == e.toString()) {
            1 == r ? delete n[t] : i.splice(o, 1);break;
          }
        }
      }, t.prototype.offAll = function (t) {
        t ? n && delete n[t] : n = null;
      }, t;
    }();e.EventEmitter = i;var n;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(123)(module)))

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {(function (root) {

  function CanvasTextWrapper(canvas, text, options) {
    'use strict';

    var defaults = {
      font: '18px Arial, sans-serif',
      sizeToFill: false,
      maxFontSizeToFill: false,
      lineHeight: 1,
      allowNewLine: true,
      lineBreak: 'auto',
      textAlign: 'left',
      verticalAlign: 'top',
      justifyLines: false,
      paddingX: 0,
      paddingY: 0,
      fitParent: false,
      strokeText: false,
      renderHDPI: true,
      textDecoration: 'none'
    };

    var opts = {};

    for (var key in defaults) {
      opts[key] = options.hasOwnProperty(key) ? options[key] : defaults[key];
    }

    var context = canvas.getContext('2d');
    context.font = opts.font;
    context.textBaseline = 'bottom';

    var scale = 1;
    var devicePixelRatio = typeof global !== 'undefined' ? global.devicePixelRatio : root.devicePixelRatio;

    if (opts.renderHDPI && devicePixelRatio > 1) {
      var tempCtx = {};

      for (var key in context) {
        tempCtx[key] = context[key];
      }

      var canvasWidth = canvas.width;
      var canvasHeight = canvas.height;
      scale = devicePixelRatio;

      canvas.width = canvasWidth * scale;
      canvas.height = canvasHeight * scale;
      canvas.style.width = canvasWidth * scale * 0.5 + 'px';
      canvas.style.height = canvasHeight * scale * 0.5 + 'px';

      for (var key in tempCtx) {
        try {
          context[key] = tempCtx[key];
        } catch (e) {}
      }

      context.scale(scale, scale);
    }

    var EL_WIDTH = (!opts.fitParent ? canvas.width : canvas.parentNode.clientWidth) / scale;
    var EL_HEIGHT = (!opts.fitParent ? canvas.height : canvas.parentNode.clientHeight) / scale;
    var MAX_TXT_WIDTH = EL_WIDTH - opts.paddingX * 2;
    var MAX_TXT_HEIGHT = EL_HEIGHT - opts.paddingY * 2;

    var fontSize = opts.font.match(/\d+(px|em|%)/g) ? +opts.font.match(/\d+(px|em|%)/g)[0].match(/\d+/g) : 18;
    var textBlockHeight = 0;
    var lines = [];
    var newLineIndexes = [];
    var textPos = { x: 0, y: 0 };
    var lineHeight = 0;
    var fontParts;

    setFont(fontSize);
    setLineHeight();
    validate();
    render();

    function setFont(fontSize) {
      if (!fontParts) fontParts = !opts.sizeToFill ? opts.font.split(/\b\d+px\b/i) : context.font.split(/\b\d+px\b/i);
      context.font = fontParts[0] + fontSize + 'px' + fontParts[1];
    }

    function setLineHeight() {
      if (!isNaN(opts.lineHeight)) {
        lineHeight = fontSize * opts.lineHeight;
      } else if (opts.lineHeight.toString().indexOf('px') !== -1) {
        lineHeight = parseInt(opts.lineHeight);
      } else if (opts.lineHeight.toString().indexOf('%') !== -1) {
        lineHeight = parseInt(opts.lineHeight) / 100 * fontSize;
      }
    }

    function render() {
      if (opts.sizeToFill) {
        var wordsCount = text.trim().split(/\s+/).length;
        var newFontSize = 0;
        var fontSizeHasLimit = opts.maxFontSizeToFill !== false;

        do {
          if (fontSizeHasLimit) {
            if (++newFontSize <= opts.maxFontSizeToFill) {
              adjustFontSize(newFontSize);
            } else {
              break;
            }
          } else {
            adjustFontSize(++newFontSize);
          }
        } while (textBlockHeight < MAX_TXT_HEIGHT && lines.join(' ').split(/\s+/).length == wordsCount);

        adjustFontSize(--newFontSize);
      } else {
        wrap();
      }

      if (opts.justifyLines && opts.lineBreak === 'auto') {
        justify();
      }

      setVertAlign();
      setHorizAlign();
      drawText();
    }

    function adjustFontSize(size) {
      setFont(size);
      lineHeight = size;
      wrap();
    }

    function wrap() {
      if (opts.allowNewLine) {
        var newLines = text.trim().split('\n');
        for (var i = 0, idx = 0; i < newLines.length - 1; i++) {
          idx += newLines[i].trim().split(/\s+/).length;
          newLineIndexes.push(idx);
        }
      }

      var words = text.trim().split(/\s+/);
      checkLength(words);
      breakText(words);

      textBlockHeight = lines.length * lineHeight;
    }

    function checkLength(words) {
      var testString, tokenLen, sliced, leftover;

      words.forEach(function (word, index) {
        testString = '';
        tokenLen = context.measureText(word).width;

        if (tokenLen > MAX_TXT_WIDTH) {
          for (var k = 0; context.measureText(testString + word[k]).width <= MAX_TXT_WIDTH && k < word.length; k++) {
            testString += word[k];
          }

          sliced = word.slice(0, k);
          leftover = word.slice(k);
          words.splice(index, 1, sliced, leftover);
        }
      });
    }

    function breakText(words) {
      lines = [];
      for (var i = 0, j = 0; i < words.length; j++) {
        lines[j] = '';

        if (opts.lineBreak === 'auto') {
          if (context.measureText(lines[j] + words[i]).width > MAX_TXT_WIDTH) {
            break;
          } else {
            while (context.measureText(lines[j] + words[i]).width <= MAX_TXT_WIDTH && i < words.length) {

              lines[j] += words[i] + ' ';
              i++;

              if (opts.allowNewLine) {
                for (var k = 0; k < newLineIndexes.length; k++) {
                  if (newLineIndexes[k] === i) {
                    j++;
                    lines[j] = '';
                    break;
                  }
                }
              }
            }
          }
          lines[j] = lines[j].trim();
        } else {
          lines[j] = words[i];
          i++;
        }
      }
    }

    function justify() {
      var maxLen, longestLineIndex, tokenLen;
      for (var i = 0; i < lines.length; i++) {
        tokenLen = context.measureText(lines[i]).width;

        if (!maxLen || tokenLen > maxLen) {
          maxLen = tokenLen;
          longestLineIndex = i;
        }
      }

      var numWords, spaceLength, numOfSpaces, num, filler;
      var delimiter = '\u200A';
      for (i = 0; i < lines.length; i++) {
        if (i === longestLineIndex) continue;

        numWords = lines[i].trim().split(/\s+/).length;
        if (numWords <= 1) continue;

        lines[i] = lines[i].trim().split(/\s+/).join(delimiter);

        spaceLength = context.measureText(delimiter).width;
        numOfSpaces = (maxLen - context.measureText(lines[i]).width) / spaceLength;
        num = numOfSpaces / (numWords - 1);

        filler = '';
        for (var j = 0; j < num; j++) {
          filler += delimiter;
        }

        lines[i] = lines[i].trim().split(delimiter).join(filler);
      }
    }

    function underline(text, x, y) {
      var width = context.measureText(text).width;

      switch (context.textAlign) {
        case 'center':
          x -= width / 2;
          break;
        case 'right':
          x -= width;
          break;
      }

      context.beginPath();
      context.moveTo(x, y);
      context.lineTo(x + width, y);
      context.stroke();
    }

    function drawText() {
      for (var i = 0; i < lines.length; i++) {
        textPos.y = parseInt(textPos.y) + lineHeight;
        context.fillText(lines[i], textPos.x, textPos.y);

        if (opts.strokeText) {
          context.strokeText(lines[i], textPos.x, textPos.y);
        }

        if (opts.textDecoration.toLocaleLowerCase() === 'underline') {
          underline(lines[i], textPos.x, textPos.y);
        }
      }
    }

    function setHorizAlign() {
      context.textAlign = opts.textAlign;

      if (opts.textAlign == 'center') {
        textPos.x = EL_WIDTH / 2;
      } else if (opts.textAlign == 'right') {
        textPos.x = EL_WIDTH - opts.paddingX;
      } else {
        textPos.x = opts.paddingX;
      }
    }

    function setVertAlign() {
      if (opts.verticalAlign == 'middle') {
        textPos.y = (EL_HEIGHT - textBlockHeight) / 2;
      } else if (opts.verticalAlign == 'bottom') {
        textPos.y = EL_HEIGHT - textBlockHeight - opts.paddingY;
      } else {
        textPos.y = opts.paddingY;
      }
    }

    function validate() {
      if (typeof text !== 'string') throw new TypeError('The second parameter must be a String.');

      if (isNaN(fontSize)) throw new TypeError('Cannot parse "font".');

      if (isNaN(lineHeight)) throw new TypeError('Cannot parse "lineHeight".');

      if (opts.textAlign.toLocaleLowerCase() !== 'left' && opts.textAlign.toLocaleLowerCase() !== 'center' && opts.textAlign.toLocaleLowerCase() !== 'right') throw new TypeError('Property "textAlign" must be set to either "left", "center", or "right".');

      if (opts.verticalAlign.toLocaleLowerCase() !== 'top' && opts.verticalAlign.toLocaleLowerCase() !== 'middle' && opts.verticalAlign.toLocaleLowerCase() !== 'bottom') throw new TypeError('Property "verticalAlign" must be set to either "top", "middle", or "bottom".');

      if (typeof opts.justifyLines !== 'boolean') throw new TypeError('Property "justifyLines" must be a Boolean.');

      if (isNaN(opts.paddingX)) throw new TypeError('Property "paddingX" must be a Number.');

      if (isNaN(opts.paddingY)) throw new TypeError('Property "paddingY" must be a Number.');

      if (typeof opts.fitParent !== 'boolean') throw new TypeError('Property "fitParent" must be a Boolean.');

      if (opts.lineBreak.toLocaleLowerCase() !== 'auto' && opts.lineBreak.toLocaleLowerCase() !== 'word') throw new TypeError('Property "lineBreak" must be set to either "auto" or "word".');

      if (typeof opts.sizeToFill !== 'boolean') throw new TypeError('Property "sizeToFill" must be a Boolean.');

      if (typeof opts.strokeText !== 'boolean') throw new TypeError('Property "strokeText" must be a Boolean.');

      if (typeof opts.renderHDPI !== 'boolean') throw new TypeError('Property "renderHDPI" must be a Boolean.');

      if (opts.textDecoration.toLocaleLowerCase() !== 'none' && opts.textDecoration.toLocaleLowerCase() !== 'underline') throw new TypeError('Property "textDecoration" must be set to either "none" or "underline".');
    }
  }

  if ('module' in root && 'exports' in module) {
    module.exports = CanvasTextWrapper;
  } else {
    root.CanvasTextWrapper = CanvasTextWrapper;
  }
})(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(37)(module)))

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/text.2938174eb.mp3";

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/heartbeat.eb097c186.mp3";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/countdown2.e5895e1a3.mp3";

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/crowd_start.c8f2a4f94.mp3";

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/crowd_finish.34a5950cd.mp3";

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/transition2.409699944.mp3";

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stepL1.f88ec82c5.mp3";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stepL2.c8131f169.mp3";

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stepL3.a2f3f4373.mp3";

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stepR1.7e4b83861.mp3";

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stepR2.0473f6146.mp3";

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stepR3.972a655e4.mp3";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/breathing1.d3181dad2.mp3";

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/breathing3.665b5ce07.mp3";

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/breathing4.56827869a.mp3";

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/breathing5.b6c313c32.mp3";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/breathing6.74e2098dc.mp3";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scroll-spritesheet.b45f7b0.png";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.4455819.png";

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.1046bda.png";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.5827a96.png";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eyelid.5ae128e.png";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/crowd_encourage1.5dfd59d04.mp3";

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/crowd_encourage2.203776b53.mp3";

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_line.7947a12.png";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_road.ddc1582.png";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/road.b80d400.png";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kerbs.8752d7a.png";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/text.e8efc4a.png";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stadium.f0214b5.png";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/crowd.48d1ffa.png";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/speedworld_road.402b0c5.png";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ribbon.9bb95d2.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tree.fc7d7bd.png";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/airport.285e0fb.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_00.6f2b590.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_01.56b7297.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_02.2a1076f.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_03.5b64466.png";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_04.716f7fa.png";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_05.e6007f1.png";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_06.e2cb938.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_07.0873c10.png";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_08.4ff7cfe.png";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_09.bcd85af.png";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_10.640241c.png";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_11.a0578e7.png";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_12.d2506d3.png";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_13.6de29c3.png";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_14.5396142.png";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/people_15.94e09a7.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/addoil.89ecb48.png";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/clapping.ff8115f.png";

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fire.ebd5ae7.png";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/heartshape.164fab6.png";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lightning.40a6d92.png";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/muscle.f123af2.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/thumbsup.90ca0ef.png";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/sn_road_00.c96dbac.json";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/sn_kerbs_00.3337a98.json";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/barrier_straight.18190c6.json";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/road_curve_right.b74bc4a.json";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/kerbs_curve_right.be07b02.json";

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/arrow_curve_right.2acf2ec.json";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/road_curve_left.3b4768b.json";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/kerbs_curve_left.6050740.json";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/arrow_curve_left.455ea0b.json";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/start_line.ff987d8.json";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/road_straight_start_0.19cadea.json";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/kerbs_straight_start_0.cb486ea.json";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/wall_straight_start_0.94e2fbf.json";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/arch_start_lighting.41f422d.json";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/arch_start_ticker.0bd1a3f.json";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/cage_start.971df84.json";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/stadium_building.7af3035.json";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/stadium_crowd.15dafb9.json";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/garage_start.b0976a4.json";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/ribbon_left.2e4ad03.json";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/ribbon_right.039ea88.json";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/strobe_road.34d6e8b.json";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/strobe_left.c6840ac.json";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/strobe_right.ced22e5.json";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/ticker_left.247b260.json";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/ticker_right.8a987ca.json";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/speedworld_road.d30a951.json";

/***/ }),
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var number = __webpack_require__(563);
var assign = __webpack_require__(206);

module.exports = function (THREE) {
  return function (opt) {
    opt = opt || {};

    var ret = assign({
      transparent: true,
      uniforms: {
        thickness: { type: 'f', value: number(opt.thickness, 0.1) },
        opacity: { type: 'f', value: number(opt.opacity, 1.0) },
        diffuse: { type: 'c', value: new THREE.Color(opt.diffuse) },
        dashSteps: { type: 'f', value: number(opt.dashSteps, 12.0) },
        dashDistance: { type: 'f', value: number(opt.dashDistance, 0.2) },
        dashSmooth: { type: 'f', value: number(opt.dashSmooth, 0.01) }
      },
      vertexShader: ['uniform float thickness;', 'attribute float lineMiter;', 'attribute vec2 lineNormal;', 'attribute float lineDistance;', 'varying float lineU;', 'void main() {', 'lineU = lineDistance;', 'vec3 pointPos = position.xyz + vec3(lineNormal * thickness/2.0 * lineMiter, 0.0);', 'gl_Position = projectionMatrix * modelViewMatrix * vec4( pointPos, 1.0 );', '}'].join('\n'),
      fragmentShader: ['varying float lineU;', 'uniform float opacity;', 'uniform vec3 diffuse;', 'uniform float dashSteps;', 'uniform float dashSmooth;', 'uniform float dashDistance;', 'void main() {', 'float lineUMod = mod(lineU, 1.0/dashSteps) * dashSteps;', 'float dash = smoothstep(dashDistance, dashDistance+dashSmooth, length(lineUMod-0.5));', 'gl_FragColor = vec4(diffuse * vec3(dash), opacity * dash);', '}'].join('\n')
    }, opt);

    delete ret.thickness;
    delete ret.opacity;
    delete ret.diffuse;

    var threeVers = (parseInt(THREE.REVISION, 10) || 0) | 0;
    if (threeVers < 72) {
      ret.attributes = {
        lineMiter: { type: 'f', value: 0 },
        lineDistance: { type: 'f', value: 0 },
        lineNormal: { type: 'v2', value: new THREE.Vector2() }
      };
    }

    return ret;
  };
};

/***/ }),
/* 563 */,
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0.bd15531.png";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.74d251e.png";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.f215230.png";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.2711db4.png";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.8aa0092.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoe.e153bac.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoe-active.b7ee2b3.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a71497ada34fc06ff0d694c43d4ea949.ttf";

/***/ }),
/* 572 */,
/* 573 */,
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/leg2.efa93f6.jd";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/male.38c178a.json";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/female.79c02ae.json";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/intro_runner.bf2a773.jd";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sky.16e8e7f.jpg";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/buildings.366c507.png";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/buildings.a51739d.json";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/car_body.2b61f23.json";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car_body.93bd7ed.png";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/car_wheels.a7ca42e.json";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car_wheels.0a6ba6c.png";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/car1.d95b31115.mp3";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/bike_chassis.e619ad4.json";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/bike_wheels.9f0066d.json";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bike_wheels.1c3c0df.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/bike_rider.d929d13.json";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bike_rider.4c0da5f.png";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/bike3.ef611c3ba.mp3";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/models/horse.883fd33.json";

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "// delay and duration are used to calculate animation progress (0-1) for each vertex\nattribute vec2 aAnimation;\n// movement delta\nattribute vec3 aTranslation;\n// first control point for cubic bezier path\nattribute vec3 aControlPoint0;\n// second control point for cubic bezier path\nattribute vec3 aControlPoint1;\n// arbitrary normalized axis (x, y, z) and rotation (w) for quaternian rotation\nattribute vec4 aAxisAngle;\n// front vertex color\nattribute vec3 aFrontColor;\n// back vertex color\nattribute vec3 aBackColor;\n\n// time passed from the cpu\nuniform float uTime;\n\nvarying vec3 vFrontColor;\nvarying vec3 vBackColor;\nvarying float vTime;\n\nvec3 rotateVector(vec4 q, vec3 v)\n{\n    return v + 2.0 * cross(q.xyz, cross(q.xyz, v) + q.w * v);\n}\n\nvec4 quatFromAxisAngle(vec3 axis, float angle)\n{\n    float halfAngle = angle * 0.5;\n\n    return vec4(axis.xyz * sin(halfAngle), cos(halfAngle));\n}\n\nvec3 cubicBezier(vec3 p0, vec3 p1, vec3 c0, vec3 c1, float t)\n{\n    vec3 tp;\n    float tn = 1.0 - t;\n\n    tp.xyz = tn * tn * tn * p0.xyz + 3.0 * tn * tn * t * c0.xyz + 3.0 * tn * t * t * c1.xyz + t * t * t * p1.xyz;\n\n    return tp;\n}\n\n// t = time, b = begin value, c = change in value, d = duration\nfloat easeOutCubic(float t, float b, float c, float d) {\n    return c * ((t = t / d - 1.0) * t * t + 1.0) + b;\n}\nfloat easeOutQuart(float t, float b, float c, float d) {\n    return -c * ((t = t / d - 1.0) * t * t * t - 1.0) + b;\n}\nfloat easeOutQuint(float t, float b, float c, float d) {\n    return c * ((t = t / d - 1.0) * t * t * t * t + 1.0) + b;\n}\n\nvoid main()\n{\n\n    // determine progress based on time, duration and delay\n    float tDelay = aAnimation.x;\n    float tDuration = aAnimation.y;\n    float tTime = clamp(uTime - tDelay, 0.0, tDuration);\n    float tProgress = easeOutQuart(tTime, 0.0, 1.0, tDuration);\n    vTime = tProgress;\n\n    vec3 tPosition = position;\n    vec4 tQuat = quatFromAxisAngle(aAxisAngle.xyz, aAxisAngle.w * tProgress);\n\n    // calculate rotation (before translation)\n    tPosition = rotateVector(tQuat, tPosition);\n\n    // calculate position on bezier curve\n    vec3 tp0 = tPosition;\n    vec3 tp1 = tPosition + aTranslation;\n    vec3 tc0 = tPosition + aControlPoint0;\n    vec3 tc1 = tPosition + aControlPoint1;\n    tPosition = cubicBezier(tp0, tp1, tc0, tc1, tProgress);\n\n    // pass colors to fragment shader\n    vFrontColor = aFrontColor;\n    vBackColor = aBackColor;\n\n    // determine screen position\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(tPosition, 1.0);\n}"

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = "varying vec3 vFrontColor;\nvarying vec3 vBackColor;\nvarying float vTime;\n\nvoid main()\n{\n    float opacity;\n    float startingPointAnim = 0.95;\n    float lengthAnim = 0.97 - startingPointAnim;\n    float percentageAnim = lengthAnim / 100.0;\n    float animCompletionPercent;\n\n    if (vTime > 0.95) {\n\n        // get percentage completion\n        animCompletionPercent = (vTime - startingPointAnim) / percentageAnim;\n        opacity = 1.0 - (animCompletionPercent / 100.0);\n    } else if (vTime < 0.10) {\n        opacity = 0.0;\n    } else {\n        opacity = 1.0;\n    }\n\n    if (gl_FrontFacing)\n    {\n        gl_FragColor = vec4(vFrontColor, 1.0) * opacity;\n    }\n    else\n    {\n        gl_FragColor = vec4(vBackColor, 1.0) * opacity;\n    }\n\n}"

/***/ }),
/* 595 */,
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smoke.dc425c8.jpg";

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "// glDisable(GL_CULL_FACE);\n// glEnable(GL_BLEND);\n// glBlendFunc(GL_SRC_ALPHA, GL_ONE_MINUS_SRC_ALPHA);\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 projectionMatrix;\nuniform mat4 modelViewMatrix;\nuniform float time;\nuniform float ypos;\nuniform float velocity;\nuniform float velocityMax;\nuniform float opacity;\n\nvarying float vTime;\nvarying float vVelocity;\nvarying float vOpacity;\nvarying float vX;\n\nvoid main () {\n  vTime = time;\n  vOpacity = opacity;\n\n  vVelocity = velocity / velocityMax;\n\n  float maxX = 400.0;\n\n  float x = position.x + mod(time * 6.0 - (ypos * 100.0), maxX);\n\n  vX = x / (position.x + maxX);\n\n  float y = position.y - 20.0 - ypos;\n  float z = position.z - 40.0 - ypos;\n\n  vec4 finalPosition = vec4(x, y, z, 1.0);\n  gl_Position = projectionMatrix * modelViewMatrix * finalPosition;\n}"

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "precision mediump float;\n\nvarying float vTime;\nvarying float vVelocity;\nvarying float vOpacity;\nvarying float vX;\n\n// glDisable(GL_CULL_FACE);\n// glEnable(GL_BLEND);\n// glBlendFunc(GL_SRC_ALPHA, GL_ONE_MINUS_SRC_ALPHA);\n\nvoid main() {\n  // float alpha = clamp( - vX + ((vVelocity / 40.0)) , 0.0, 1.0) * vOpacity;\n  float alpha = clamp( 0.7 - vX + vVelocity, 0.0, 0.8) * vOpacity;\n  // float alpha = clamp( - 0.8 + ((vVelocity / 40.0)) , 0.0, 0.7) * vOpacity;\n  // float alpha = 1.0;\n  // gl_FragColor = vec4(0.921569, 0, 0.2, alpha) * alpha;\n  gl_FragColor = vec4(0.78039216, 0.29019608, 0.68235294, alpha) * alpha;\n}"

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stage0.324673407.mp3";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stage1.76878e075.mp3";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/stage2_fast.a4413100d.mp3";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/airport.14be5d465.mp3";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/end_fast.ebace19f6.mp3";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/sound/results.e615d43aa.mp3";

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug"
  }, [_c('div', {
    ref: "performance",
    staticClass: "performance"
  }), (false) ? _c('ul') : _vm._e(), _c('ul', [_c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("STAGE")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.stageLabel))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("PROGRESS")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.floor(_vm.progress * 100)) + "%")])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("VELOCITY")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.round(_vm.velocity)))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("BASE VELOCITY")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.round(_vm.baseVelocity)))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("NUM INFRONT")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.numInfront))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("PACE")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.round(Math.round(3000000 / _vm.velocity / 1000 / 60 * 100) / 100 * 60)))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("DURATION")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(Math.round(_vm.duration / 1000)))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("BLOOM")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.bloom))])]), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("ZOOM")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.zoom))])])])])
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(607)
var messages = __webpack_require__(149)

var flatData = flatten(messages)

var dataString
for (var prop in flatData) {
  dataString += flatData[prop]
}

dataString = dataString.replace(/(\r\n|\n|\r|\[|\]|\s')/gm, '')

dataString = dataString.replace(/(.)(?=.*\1)/g, "");

var alphabet = 'abcdefghijklmnopqrstuvwxyz'
var digits = '0123456789'
dataString += alphabet
dataString += alphabet.toUpperCase()
dataString += digits

module.exports = dataString
// return dataString


/***/ }),
/* 607 */,
/* 608 */,
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    ref: "container",
    attrs: {
      "id": "game-container"
    }
  }), _c('router-view'), _c('desktop'), _c('web-gl'), (_vm.debug) ? _c('debug') : _vm._e(), _c('div', {
    staticClass: "fonts"
  }, [_c('p', {
    staticClass: "tradegothic"
  }, [_vm._v("abcdefghijklmnopqrstuvwxyz")]), _c('p', {
    staticClass: "digital"
  }, [_vm._v("0123456789")]), _c('p', {
    staticClass: "cjnbold"
  }, [_vm._v(_vm._s(_vm.flatMessages))]), _c('p', {
    staticClass: "fos"
  }, [_vm._v(_vm._s(_vm.flatMessages) + "PEGASUS")])])], 1)
},staticRenderFns: []}

/***/ })
],[219]);


// WEBPACK FOOTER //
// static/js/app.26aa3bc3cba913e9c73a.js